
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequiref139"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequiref139"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("lVQGa", function(module, exports) {

$parcel$export(module.exports, "encode", () => $ff77c8cf93acccbb$export$c564cdbbe6da493, (v) => $ff77c8cf93acccbb$export$c564cdbbe6da493 = v);
// encode.js
var $ff77c8cf93acccbb$export$c564cdbbe6da493;
$ff77c8cf93acccbb$export$c564cdbbe6da493 = $ff77c8cf93acccbb$var$encode;

var $f2IWs = parcelRequire("f2IWs");
var $ff77c8cf93acccbb$require$EncodeBuffer = $f2IWs.EncodeBuffer;
function $ff77c8cf93acccbb$var$encode(input, options) {
    var encoder = new $ff77c8cf93acccbb$require$EncodeBuffer(options);
    encoder.write(input);
    return encoder.read();
}

});
parcelRegister("f2IWs", function(module, exports) {

$parcel$export(module.exports, "EncodeBuffer", () => $af39e76a63078159$export$9547582b1f5d6363, (v) => $af39e76a63078159$export$9547582b1f5d6363 = v);
// encode-buffer.js
var $af39e76a63078159$export$9547582b1f5d6363;
$af39e76a63078159$export$9547582b1f5d6363 = $af39e76a63078159$var$EncodeBuffer;

var $hVzVX = parcelRequire("hVzVX");
var $af39e76a63078159$require$preset = $hVzVX.preset;

var $crMK8 = parcelRequire("crMK8");
var $af39e76a63078159$require$FlexEncoder = $crMK8.FlexEncoder;
$af39e76a63078159$require$FlexEncoder.mixin($af39e76a63078159$var$EncodeBuffer.prototype);
function $af39e76a63078159$var$EncodeBuffer(options) {
    if (!(this instanceof $af39e76a63078159$var$EncodeBuffer)) return new $af39e76a63078159$var$EncodeBuffer(options);
    if (options) {
        this.options = options;
        if (options.codec) {
            var codec = this.codec = options.codec;
            if (codec.bufferish) this.bufferish = codec.bufferish;
        }
    }
}
$af39e76a63078159$var$EncodeBuffer.prototype.codec = $af39e76a63078159$require$preset;
$af39e76a63078159$var$EncodeBuffer.prototype.write = function(input) {
    this.codec.encode(this, input);
};

});
parcelRegister("hVzVX", function(module, exports) {

$parcel$export(module.exports, "preset", () => $d0d3a237fd442f07$export$f5ab8217e0edff04, (v) => $d0d3a237fd442f07$export$f5ab8217e0edff04 = v);
// write-core.js
var $d0d3a237fd442f07$export$f5ab8217e0edff04;

var $bhJdc = parcelRequire("bhJdc");
var $d0d3a237fd442f07$require$ExtBuffer = $bhJdc.ExtBuffer;

var $kf9sO = parcelRequire("kf9sO");

var $a4cEb = parcelRequire("a4cEb");

var $exLMk = parcelRequire("exLMk");
$exLMk.install({
    addExtPacker: $d0d3a237fd442f07$var$addExtPacker,
    getExtPacker: $d0d3a237fd442f07$var$getExtPacker,
    init: $d0d3a237fd442f07$var$init
});
$d0d3a237fd442f07$export$f5ab8217e0edff04 = $d0d3a237fd442f07$var$init.call($exLMk.preset);
function $d0d3a237fd442f07$var$getEncoder(options) {
    var writeType = $a4cEb.getWriteType(options);
    return encode;
    function encode(encoder, value) {
        var func = writeType[typeof value];
        if (!func) throw new Error('Unsupported type "' + typeof value + '": ' + value);
        func(encoder, value);
    }
}
function $d0d3a237fd442f07$var$init() {
    var options = this.options;
    this.encode = $d0d3a237fd442f07$var$getEncoder(options);
    if (options && options.preset) $kf9sO.setExtPackers(this);
    return this;
}
function $d0d3a237fd442f07$var$addExtPacker(etype, Class, packer) {
    packer = $exLMk.filter(packer);
    var name = Class.name;
    if (name && name !== "Object") {
        var packers = this.extPackers || (this.extPackers = {});
        packers[name] = extPacker;
    } else {
        // fallback for IE
        var list = this.extEncoderList || (this.extEncoderList = []);
        list.unshift([
            Class,
            extPacker
        ]);
    }
    function extPacker(value) {
        if (packer) value = packer(value);
        return new $d0d3a237fd442f07$require$ExtBuffer(value, etype);
    }
}
function $d0d3a237fd442f07$var$getExtPacker(value) {
    var packers = this.extPackers || (this.extPackers = {});
    var c = value.constructor;
    var e = c && c.name && packers[c.name];
    if (e) return e;
    // fallback for IE
    var list = this.extEncoderList || (this.extEncoderList = []);
    var len = list.length;
    for(var i = 0; i < len; i++){
        var pair = list[i];
        if (c === pair[0]) return pair[1];
    }
}

});
parcelRegister("bhJdc", function(module, exports) {

$parcel$export(module.exports, "ExtBuffer", () => $83745a5cfdb5c210$export$fa671ba1f40b711c, (v) => $83745a5cfdb5c210$export$fa671ba1f40b711c = v);
// ext-buffer.js
var $83745a5cfdb5c210$export$fa671ba1f40b711c;
$83745a5cfdb5c210$export$fa671ba1f40b711c = $83745a5cfdb5c210$var$ExtBuffer;

var $78TVd = parcelRequire("78TVd");
function $83745a5cfdb5c210$var$ExtBuffer(buffer, type) {
    if (!(this instanceof $83745a5cfdb5c210$var$ExtBuffer)) return new $83745a5cfdb5c210$var$ExtBuffer(buffer, type);
    this.buffer = $78TVd.from(buffer);
    this.type = type;
}

});
parcelRegister("78TVd", function(module, exports) {
// bufferish.js

var $5334a8b009816885$var$Buffer = module.exports.global = (parcelRequire("8x05Z"));
var $5334a8b009816885$var$hasBuffer = module.exports.hasBuffer = $5334a8b009816885$var$Buffer && !!$5334a8b009816885$var$Buffer.isBuffer;
var $5334a8b009816885$var$hasArrayBuffer = module.exports.hasArrayBuffer = "undefined" !== typeof ArrayBuffer;

var $5334a8b009816885$var$isArray = module.exports.isArray = (parcelRequire("767Wy"));
module.exports.isArrayBuffer = $5334a8b009816885$var$hasArrayBuffer ? $5334a8b009816885$var$isArrayBuffer : $5334a8b009816885$var$_false;
var $5334a8b009816885$var$isBuffer = module.exports.isBuffer = $5334a8b009816885$var$hasBuffer ? $5334a8b009816885$var$Buffer.isBuffer : $5334a8b009816885$var$_false;
var $5334a8b009816885$var$isView = module.exports.isView = $5334a8b009816885$var$hasArrayBuffer ? ArrayBuffer.isView || $5334a8b009816885$var$_is("ArrayBuffer", "buffer") : $5334a8b009816885$var$_false;
module.exports.alloc = $5334a8b009816885$var$alloc;
module.exports.concat = $5334a8b009816885$var$concat;
module.exports.from = $5334a8b009816885$var$from;

var $5334a8b009816885$var$BufferArray = module.exports.Array = (parcelRequire("5WZQ0"));

var $5334a8b009816885$var$BufferBuffer = module.exports.Buffer = (parcelRequire("183sb"));

var $5334a8b009816885$var$BufferUint8Array = module.exports.Uint8Array = (parcelRequire("6x2by"));

var $5334a8b009816885$var$BufferProto = module.exports.prototype = (parcelRequire("VLC7O"));
/**
 * @param value {Array|ArrayBuffer|Buffer|String}
 * @returns {Buffer|Uint8Array|Array}
 */ function $5334a8b009816885$var$from(value) {
    if (typeof value === "string") return $5334a8b009816885$var$fromString.call(this, value);
    else return $5334a8b009816885$var$auto(this).from(value);
}
/**
 * @param size {Number}
 * @returns {Buffer|Uint8Array|Array}
 */ function $5334a8b009816885$var$alloc(size) {
    return $5334a8b009816885$var$auto(this).alloc(size);
}
/**
 * @param list {Array} array of (Buffer|Uint8Array|Array)s
 * @param [length]
 * @returns {Buffer|Uint8Array|Array}
 */ function $5334a8b009816885$var$concat(list, length) {
    if (!length) {
        length = 0;
        Array.prototype.forEach.call(list, dryrun);
    }
    var ref = this !== module.exports && this || list[0];
    var result = $5334a8b009816885$var$alloc.call(ref, length);
    var offset = 0;
    Array.prototype.forEach.call(list, append);
    return result;
    function dryrun(buffer) {
        length += buffer.length;
    }
    function append(buffer) {
        offset += $5334a8b009816885$var$BufferProto.copy.call(buffer, result, offset);
    }
}
var $5334a8b009816885$var$_isArrayBuffer = $5334a8b009816885$var$_is("ArrayBuffer");
function $5334a8b009816885$var$isArrayBuffer(value) {
    return value instanceof ArrayBuffer || $5334a8b009816885$var$_isArrayBuffer(value);
}
/**
 * @private
 */ function $5334a8b009816885$var$fromString(value) {
    var expected = value.length * 3;
    var that = $5334a8b009816885$var$alloc.call(this, expected);
    var actual = $5334a8b009816885$var$BufferProto.write.call(that, value);
    if (expected !== actual) that = $5334a8b009816885$var$BufferProto.slice.call(that, 0, actual);
    return that;
}
function $5334a8b009816885$var$auto(that) {
    return $5334a8b009816885$var$isBuffer(that) ? $5334a8b009816885$var$BufferBuffer : $5334a8b009816885$var$isView(that) ? $5334a8b009816885$var$BufferUint8Array : $5334a8b009816885$var$isArray(that) ? $5334a8b009816885$var$BufferArray : $5334a8b009816885$var$hasBuffer ? $5334a8b009816885$var$BufferBuffer : $5334a8b009816885$var$hasArrayBuffer ? $5334a8b009816885$var$BufferUint8Array : $5334a8b009816885$var$BufferArray;
}
function $5334a8b009816885$var$_false() {
    return false;
}
function $5334a8b009816885$var$_is(name, key) {
    /* jshint eqnull:true */ name = "[object " + name + "]";
    return function(value) {
        return value != null && ({}).toString.call(key ? value[key] : value) === name;
    };
}

});
parcelRegister("8x05Z", function(module, exports) {
/* globals Buffer */ 
var $6ZWSX = parcelRequire("6ZWSX");
var $63617ac26589f1b6$require$Buffer = $6ZWSX.Buffer;
module.exports = $63617ac26589f1b6$var$c("undefined" !== typeof $63617ac26589f1b6$require$Buffer && $63617ac26589f1b6$require$Buffer) || $63617ac26589f1b6$var$c(module.exports.Buffer) || $63617ac26589f1b6$var$c("undefined" !== typeof window && window.Buffer) || module.exports.Buffer;
function $63617ac26589f1b6$var$c(B) {
    return B && B.isBuffer && B;
}

});
parcelRegister("6ZWSX", function(module, exports) {

$parcel$export(module.exports, "Buffer", () => $51861dfc7ca9d588$export$a143d493d941bafc, (v) => $51861dfc7ca9d588$export$a143d493d941bafc = v);
$parcel$export(module.exports, "INSPECT_MAX_BYTES", () => $51861dfc7ca9d588$export$f99ded8fe4b79145, (v) => $51861dfc7ca9d588$export$f99ded8fe4b79145 = v);
/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */ /* eslint-disable no-proto */ var $51861dfc7ca9d588$export$a143d493d941bafc;
var $51861dfc7ca9d588$export$e4cf37d7f6fb9e0a;
var $51861dfc7ca9d588$export$f99ded8fe4b79145;
var $51861dfc7ca9d588$export$599f31c3813fae4d;
"use strict";

var $kuxul = parcelRequire("kuxul");

var $9NvM5 = parcelRequire("9NvM5");
const $51861dfc7ca9d588$var$customInspectSymbol = typeof Symbol === "function" && typeof Symbol["for"] === "function" // eslint-disable-line dot-notation
 ? Symbol["for"]("nodejs.util.inspect.custom") // eslint-disable-line dot-notation
 : null;
$51861dfc7ca9d588$export$a143d493d941bafc = $51861dfc7ca9d588$var$Buffer;
$51861dfc7ca9d588$export$e4cf37d7f6fb9e0a = $51861dfc7ca9d588$var$SlowBuffer;
$51861dfc7ca9d588$export$f99ded8fe4b79145 = 50;
const $51861dfc7ca9d588$var$K_MAX_LENGTH = 0x7fffffff;
$51861dfc7ca9d588$export$599f31c3813fae4d = $51861dfc7ca9d588$var$K_MAX_LENGTH;
/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Print warning and recommend using `buffer` v4.x which has an Object
 *               implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * We report that the browser does not support typed arrays if the are not subclassable
 * using __proto__. Firefox 4-29 lacks support for adding new properties to `Uint8Array`
 * (See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438). IE 10 lacks support
 * for __proto__ and has a buggy typed array implementation.
 */ $51861dfc7ca9d588$var$Buffer.TYPED_ARRAY_SUPPORT = $51861dfc7ca9d588$var$typedArraySupport();
if (!$51861dfc7ca9d588$var$Buffer.TYPED_ARRAY_SUPPORT && typeof console !== "undefined" && typeof console.error === "function") console.error("This browser lacks typed array (Uint8Array) support which is required by `buffer` v5.x. Use `buffer` v4.x if you require old browser support.");
function $51861dfc7ca9d588$var$typedArraySupport() {
    // Can typed array instances can be augmented?
    try {
        const arr = new Uint8Array(1);
        const proto = {
            foo: function() {
                return 42;
            }
        };
        Object.setPrototypeOf(proto, Uint8Array.prototype);
        Object.setPrototypeOf(arr, proto);
        return arr.foo() === 42;
    } catch (e) {
        return false;
    }
}
Object.defineProperty($51861dfc7ca9d588$var$Buffer.prototype, "parent", {
    enumerable: true,
    get: function() {
        if (!$51861dfc7ca9d588$var$Buffer.isBuffer(this)) return undefined;
        return this.buffer;
    }
});
Object.defineProperty($51861dfc7ca9d588$var$Buffer.prototype, "offset", {
    enumerable: true,
    get: function() {
        if (!$51861dfc7ca9d588$var$Buffer.isBuffer(this)) return undefined;
        return this.byteOffset;
    }
});
function $51861dfc7ca9d588$var$createBuffer(length) {
    if (length > $51861dfc7ca9d588$var$K_MAX_LENGTH) throw new RangeError('The value "' + length + '" is invalid for option "size"');
    // Return an augmented `Uint8Array` instance
    const buf = new Uint8Array(length);
    Object.setPrototypeOf(buf, $51861dfc7ca9d588$var$Buffer.prototype);
    return buf;
}
/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */ function $51861dfc7ca9d588$var$Buffer(arg, encodingOrOffset, length) {
    // Common case.
    if (typeof arg === "number") {
        if (typeof encodingOrOffset === "string") throw new TypeError('The "string" argument must be of type string. Received type number');
        return $51861dfc7ca9d588$var$allocUnsafe(arg);
    }
    return $51861dfc7ca9d588$var$from(arg, encodingOrOffset, length);
}
$51861dfc7ca9d588$var$Buffer.poolSize = 8192 // not used by this implementation
;
function $51861dfc7ca9d588$var$from(value, encodingOrOffset, length) {
    if (typeof value === "string") return $51861dfc7ca9d588$var$fromString(value, encodingOrOffset);
    if (ArrayBuffer.isView(value)) return $51861dfc7ca9d588$var$fromArrayView(value);
    if (value == null) throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
    if ($51861dfc7ca9d588$var$isInstance(value, ArrayBuffer) || value && $51861dfc7ca9d588$var$isInstance(value.buffer, ArrayBuffer)) return $51861dfc7ca9d588$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof SharedArrayBuffer !== "undefined" && ($51861dfc7ca9d588$var$isInstance(value, SharedArrayBuffer) || value && $51861dfc7ca9d588$var$isInstance(value.buffer, SharedArrayBuffer))) return $51861dfc7ca9d588$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof value === "number") throw new TypeError('The "value" argument must not be of type number. Received type number');
    const valueOf = value.valueOf && value.valueOf();
    if (valueOf != null && valueOf !== value) return $51861dfc7ca9d588$var$Buffer.from(valueOf, encodingOrOffset, length);
    const b = $51861dfc7ca9d588$var$fromObject(value);
    if (b) return b;
    if (typeof Symbol !== "undefined" && Symbol.toPrimitive != null && typeof value[Symbol.toPrimitive] === "function") return $51861dfc7ca9d588$var$Buffer.from(value[Symbol.toPrimitive]("string"), encodingOrOffset, length);
    throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
}
/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/ $51861dfc7ca9d588$var$Buffer.from = function(value, encodingOrOffset, length) {
    return $51861dfc7ca9d588$var$from(value, encodingOrOffset, length);
};
// Note: Change prototype *after* Buffer.from is defined to workaround Chrome bug:
// https://github.com/feross/buffer/pull/148
Object.setPrototypeOf($51861dfc7ca9d588$var$Buffer.prototype, Uint8Array.prototype);
Object.setPrototypeOf($51861dfc7ca9d588$var$Buffer, Uint8Array);
function $51861dfc7ca9d588$var$assertSize(size) {
    if (typeof size !== "number") throw new TypeError('"size" argument must be of type number');
    else if (size < 0) throw new RangeError('The value "' + size + '" is invalid for option "size"');
}
function $51861dfc7ca9d588$var$alloc(size, fill, encoding) {
    $51861dfc7ca9d588$var$assertSize(size);
    if (size <= 0) return $51861dfc7ca9d588$var$createBuffer(size);
    if (fill !== undefined) // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpreted as a start offset.
    return typeof encoding === "string" ? $51861dfc7ca9d588$var$createBuffer(size).fill(fill, encoding) : $51861dfc7ca9d588$var$createBuffer(size).fill(fill);
    return $51861dfc7ca9d588$var$createBuffer(size);
}
/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/ $51861dfc7ca9d588$var$Buffer.alloc = function(size, fill, encoding) {
    return $51861dfc7ca9d588$var$alloc(size, fill, encoding);
};
function $51861dfc7ca9d588$var$allocUnsafe(size) {
    $51861dfc7ca9d588$var$assertSize(size);
    return $51861dfc7ca9d588$var$createBuffer(size < 0 ? 0 : $51861dfc7ca9d588$var$checked(size) | 0);
}
/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */ $51861dfc7ca9d588$var$Buffer.allocUnsafe = function(size) {
    return $51861dfc7ca9d588$var$allocUnsafe(size);
};
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */ $51861dfc7ca9d588$var$Buffer.allocUnsafeSlow = function(size) {
    return $51861dfc7ca9d588$var$allocUnsafe(size);
};
function $51861dfc7ca9d588$var$fromString(string, encoding) {
    if (typeof encoding !== "string" || encoding === "") encoding = "utf8";
    if (!$51861dfc7ca9d588$var$Buffer.isEncoding(encoding)) throw new TypeError("Unknown encoding: " + encoding);
    const length = $51861dfc7ca9d588$var$byteLength(string, encoding) | 0;
    let buf = $51861dfc7ca9d588$var$createBuffer(length);
    const actual = buf.write(string, encoding);
    if (actual !== length) // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    buf = buf.slice(0, actual);
    return buf;
}
function $51861dfc7ca9d588$var$fromArrayLike(array) {
    const length = array.length < 0 ? 0 : $51861dfc7ca9d588$var$checked(array.length) | 0;
    const buf = $51861dfc7ca9d588$var$createBuffer(length);
    for(let i = 0; i < length; i += 1)buf[i] = array[i] & 255;
    return buf;
}
function $51861dfc7ca9d588$var$fromArrayView(arrayView) {
    if ($51861dfc7ca9d588$var$isInstance(arrayView, Uint8Array)) {
        const copy = new Uint8Array(arrayView);
        return $51861dfc7ca9d588$var$fromArrayBuffer(copy.buffer, copy.byteOffset, copy.byteLength);
    }
    return $51861dfc7ca9d588$var$fromArrayLike(arrayView);
}
function $51861dfc7ca9d588$var$fromArrayBuffer(array, byteOffset, length) {
    if (byteOffset < 0 || array.byteLength < byteOffset) throw new RangeError('"offset" is outside of buffer bounds');
    if (array.byteLength < byteOffset + (length || 0)) throw new RangeError('"length" is outside of buffer bounds');
    let buf;
    if (byteOffset === undefined && length === undefined) buf = new Uint8Array(array);
    else if (length === undefined) buf = new Uint8Array(array, byteOffset);
    else buf = new Uint8Array(array, byteOffset, length);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(buf, $51861dfc7ca9d588$var$Buffer.prototype);
    return buf;
}
function $51861dfc7ca9d588$var$fromObject(obj) {
    if ($51861dfc7ca9d588$var$Buffer.isBuffer(obj)) {
        const len = $51861dfc7ca9d588$var$checked(obj.length) | 0;
        const buf = $51861dfc7ca9d588$var$createBuffer(len);
        if (buf.length === 0) return buf;
        obj.copy(buf, 0, 0, len);
        return buf;
    }
    if (obj.length !== undefined) {
        if (typeof obj.length !== "number" || $51861dfc7ca9d588$var$numberIsNaN(obj.length)) return $51861dfc7ca9d588$var$createBuffer(0);
        return $51861dfc7ca9d588$var$fromArrayLike(obj);
    }
    if (obj.type === "Buffer" && Array.isArray(obj.data)) return $51861dfc7ca9d588$var$fromArrayLike(obj.data);
}
function $51861dfc7ca9d588$var$checked(length) {
    // Note: cannot use `length < K_MAX_LENGTH` here because that fails when
    // length is NaN (which is otherwise coerced to zero.)
    if (length >= $51861dfc7ca9d588$var$K_MAX_LENGTH) throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + $51861dfc7ca9d588$var$K_MAX_LENGTH.toString(16) + " bytes");
    return length | 0;
}
function $51861dfc7ca9d588$var$SlowBuffer(length) {
    if (+length != length) length = 0;
    return $51861dfc7ca9d588$var$Buffer.alloc(+length);
}
$51861dfc7ca9d588$var$Buffer.isBuffer = function isBuffer(b) {
    return b != null && b._isBuffer === true && b !== $51861dfc7ca9d588$var$Buffer.prototype // so Buffer.isBuffer(Buffer.prototype) will be false
    ;
};
$51861dfc7ca9d588$var$Buffer.compare = function compare(a, b) {
    if ($51861dfc7ca9d588$var$isInstance(a, Uint8Array)) a = $51861dfc7ca9d588$var$Buffer.from(a, a.offset, a.byteLength);
    if ($51861dfc7ca9d588$var$isInstance(b, Uint8Array)) b = $51861dfc7ca9d588$var$Buffer.from(b, b.offset, b.byteLength);
    if (!$51861dfc7ca9d588$var$Buffer.isBuffer(a) || !$51861dfc7ca9d588$var$Buffer.isBuffer(b)) throw new TypeError('The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array');
    if (a === b) return 0;
    let x = a.length;
    let y = b.length;
    for(let i = 0, len = Math.min(x, y); i < len; ++i)if (a[i] !== b[i]) {
        x = a[i];
        y = b[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
$51861dfc7ca9d588$var$Buffer.isEncoding = function isEncoding(encoding) {
    switch(String(encoding).toLowerCase()){
        case "hex":
        case "utf8":
        case "utf-8":
        case "ascii":
        case "latin1":
        case "binary":
        case "base64":
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return true;
        default:
            return false;
    }
};
$51861dfc7ca9d588$var$Buffer.concat = function concat(list, length) {
    if (!Array.isArray(list)) throw new TypeError('"list" argument must be an Array of Buffers');
    if (list.length === 0) return $51861dfc7ca9d588$var$Buffer.alloc(0);
    let i;
    if (length === undefined) {
        length = 0;
        for(i = 0; i < list.length; ++i)length += list[i].length;
    }
    const buffer = $51861dfc7ca9d588$var$Buffer.allocUnsafe(length);
    let pos = 0;
    for(i = 0; i < list.length; ++i){
        let buf = list[i];
        if ($51861dfc7ca9d588$var$isInstance(buf, Uint8Array)) {
            if (pos + buf.length > buffer.length) {
                if (!$51861dfc7ca9d588$var$Buffer.isBuffer(buf)) buf = $51861dfc7ca9d588$var$Buffer.from(buf);
                buf.copy(buffer, pos);
            } else Uint8Array.prototype.set.call(buffer, buf, pos);
        } else if (!$51861dfc7ca9d588$var$Buffer.isBuffer(buf)) throw new TypeError('"list" argument must be an Array of Buffers');
        else buf.copy(buffer, pos);
        pos += buf.length;
    }
    return buffer;
};
function $51861dfc7ca9d588$var$byteLength(string, encoding) {
    if ($51861dfc7ca9d588$var$Buffer.isBuffer(string)) return string.length;
    if (ArrayBuffer.isView(string) || $51861dfc7ca9d588$var$isInstance(string, ArrayBuffer)) return string.byteLength;
    if (typeof string !== "string") throw new TypeError('The "string" argument must be one of type string, Buffer, or ArrayBuffer. Received type ' + typeof string);
    const len = string.length;
    const mustMatch = arguments.length > 2 && arguments[2] === true;
    if (!mustMatch && len === 0) return 0;
    // Use a for loop to avoid recursion
    let loweredCase = false;
    for(;;)switch(encoding){
        case "ascii":
        case "latin1":
        case "binary":
            return len;
        case "utf8":
        case "utf-8":
            return $51861dfc7ca9d588$var$utf8ToBytes(string).length;
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return len * 2;
        case "hex":
            return len >>> 1;
        case "base64":
            return $51861dfc7ca9d588$var$base64ToBytes(string).length;
        default:
            if (loweredCase) return mustMatch ? -1 : $51861dfc7ca9d588$var$utf8ToBytes(string).length // assume utf8
            ;
            encoding = ("" + encoding).toLowerCase();
            loweredCase = true;
    }
}
$51861dfc7ca9d588$var$Buffer.byteLength = $51861dfc7ca9d588$var$byteLength;
function $51861dfc7ca9d588$var$slowToString(encoding, start, end) {
    let loweredCase = false;
    // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
    // property of a typed array.
    // This behaves neither like String nor Uint8Array in that we set start/end
    // to their upper/lower bounds if the value passed is out of range.
    // undefined is handled specially as per ECMA-262 6th Edition,
    // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
    if (start === undefined || start < 0) start = 0;
    // Return early if start > this.length. Done here to prevent potential uint32
    // coercion fail below.
    if (start > this.length) return "";
    if (end === undefined || end > this.length) end = this.length;
    if (end <= 0) return "";
    // Force coercion to uint32. This will also coerce falsey/NaN values to 0.
    end >>>= 0;
    start >>>= 0;
    if (end <= start) return "";
    if (!encoding) encoding = "utf8";
    while(true)switch(encoding){
        case "hex":
            return $51861dfc7ca9d588$var$hexSlice(this, start, end);
        case "utf8":
        case "utf-8":
            return $51861dfc7ca9d588$var$utf8Slice(this, start, end);
        case "ascii":
            return $51861dfc7ca9d588$var$asciiSlice(this, start, end);
        case "latin1":
        case "binary":
            return $51861dfc7ca9d588$var$latin1Slice(this, start, end);
        case "base64":
            return $51861dfc7ca9d588$var$base64Slice(this, start, end);
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return $51861dfc7ca9d588$var$utf16leSlice(this, start, end);
        default:
            if (loweredCase) throw new TypeError("Unknown encoding: " + encoding);
            encoding = (encoding + "").toLowerCase();
            loweredCase = true;
    }
}
// This property is used by `Buffer.isBuffer` (and the `is-buffer` npm package)
// to detect a Buffer instance. It's not possible to use `instanceof Buffer`
// reliably in a browserify context because there could be multiple different
// copies of the 'buffer' package in use. This method works even for Buffer
// instances that were created from another copy of the `buffer` package.
// See: https://github.com/feross/buffer/issues/154
$51861dfc7ca9d588$var$Buffer.prototype._isBuffer = true;
function $51861dfc7ca9d588$var$swap(b, n, m) {
    const i = b[n];
    b[n] = b[m];
    b[m] = i;
}
$51861dfc7ca9d588$var$Buffer.prototype.swap16 = function swap16() {
    const len = this.length;
    if (len % 2 !== 0) throw new RangeError("Buffer size must be a multiple of 16-bits");
    for(let i = 0; i < len; i += 2)$51861dfc7ca9d588$var$swap(this, i, i + 1);
    return this;
};
$51861dfc7ca9d588$var$Buffer.prototype.swap32 = function swap32() {
    const len = this.length;
    if (len % 4 !== 0) throw new RangeError("Buffer size must be a multiple of 32-bits");
    for(let i = 0; i < len; i += 4){
        $51861dfc7ca9d588$var$swap(this, i, i + 3);
        $51861dfc7ca9d588$var$swap(this, i + 1, i + 2);
    }
    return this;
};
$51861dfc7ca9d588$var$Buffer.prototype.swap64 = function swap64() {
    const len = this.length;
    if (len % 8 !== 0) throw new RangeError("Buffer size must be a multiple of 64-bits");
    for(let i = 0; i < len; i += 8){
        $51861dfc7ca9d588$var$swap(this, i, i + 7);
        $51861dfc7ca9d588$var$swap(this, i + 1, i + 6);
        $51861dfc7ca9d588$var$swap(this, i + 2, i + 5);
        $51861dfc7ca9d588$var$swap(this, i + 3, i + 4);
    }
    return this;
};
$51861dfc7ca9d588$var$Buffer.prototype.toString = function toString() {
    const length = this.length;
    if (length === 0) return "";
    if (arguments.length === 0) return $51861dfc7ca9d588$var$utf8Slice(this, 0, length);
    return $51861dfc7ca9d588$var$slowToString.apply(this, arguments);
};
$51861dfc7ca9d588$var$Buffer.prototype.toLocaleString = $51861dfc7ca9d588$var$Buffer.prototype.toString;
$51861dfc7ca9d588$var$Buffer.prototype.equals = function equals(b) {
    if (!$51861dfc7ca9d588$var$Buffer.isBuffer(b)) throw new TypeError("Argument must be a Buffer");
    if (this === b) return true;
    return $51861dfc7ca9d588$var$Buffer.compare(this, b) === 0;
};
$51861dfc7ca9d588$var$Buffer.prototype.inspect = function inspect() {
    let str = "";
    const max = $51861dfc7ca9d588$export$f99ded8fe4b79145;
    str = this.toString("hex", 0, max).replace(/(.{2})/g, "$1 ").trim();
    if (this.length > max) str += " ... ";
    return "<Buffer " + str + ">";
};
if ($51861dfc7ca9d588$var$customInspectSymbol) $51861dfc7ca9d588$var$Buffer.prototype[$51861dfc7ca9d588$var$customInspectSymbol] = $51861dfc7ca9d588$var$Buffer.prototype.inspect;
$51861dfc7ca9d588$var$Buffer.prototype.compare = function compare(target, start, end, thisStart, thisEnd) {
    if ($51861dfc7ca9d588$var$isInstance(target, Uint8Array)) target = $51861dfc7ca9d588$var$Buffer.from(target, target.offset, target.byteLength);
    if (!$51861dfc7ca9d588$var$Buffer.isBuffer(target)) throw new TypeError('The "target" argument must be one of type Buffer or Uint8Array. Received type ' + typeof target);
    if (start === undefined) start = 0;
    if (end === undefined) end = target ? target.length : 0;
    if (thisStart === undefined) thisStart = 0;
    if (thisEnd === undefined) thisEnd = this.length;
    if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) throw new RangeError("out of range index");
    if (thisStart >= thisEnd && start >= end) return 0;
    if (thisStart >= thisEnd) return -1;
    if (start >= end) return 1;
    start >>>= 0;
    end >>>= 0;
    thisStart >>>= 0;
    thisEnd >>>= 0;
    if (this === target) return 0;
    let x = thisEnd - thisStart;
    let y = end - start;
    const len = Math.min(x, y);
    const thisCopy = this.slice(thisStart, thisEnd);
    const targetCopy = target.slice(start, end);
    for(let i = 0; i < len; ++i)if (thisCopy[i] !== targetCopy[i]) {
        x = thisCopy[i];
        y = targetCopy[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function $51861dfc7ca9d588$var$bidirectionalIndexOf(buffer, val, byteOffset, encoding, dir) {
    // Empty buffer means no match
    if (buffer.length === 0) return -1;
    // Normalize byteOffset
    if (typeof byteOffset === "string") {
        encoding = byteOffset;
        byteOffset = 0;
    } else if (byteOffset > 0x7fffffff) byteOffset = 0x7fffffff;
    else if (byteOffset < -2147483648) byteOffset = -2147483648;
    byteOffset = +byteOffset // Coerce to Number.
    ;
    if ($51861dfc7ca9d588$var$numberIsNaN(byteOffset)) // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : buffer.length - 1;
    // Normalize byteOffset: negative offsets start from the end of the buffer
    if (byteOffset < 0) byteOffset = buffer.length + byteOffset;
    if (byteOffset >= buffer.length) {
        if (dir) return -1;
        else byteOffset = buffer.length - 1;
    } else if (byteOffset < 0) {
        if (dir) byteOffset = 0;
        else return -1;
    }
    // Normalize val
    if (typeof val === "string") val = $51861dfc7ca9d588$var$Buffer.from(val, encoding);
    // Finally, search either indexOf (if dir is true) or lastIndexOf
    if ($51861dfc7ca9d588$var$Buffer.isBuffer(val)) {
        // Special case: looking for empty string/buffer always fails
        if (val.length === 0) return -1;
        return $51861dfc7ca9d588$var$arrayIndexOf(buffer, val, byteOffset, encoding, dir);
    } else if (typeof val === "number") {
        val = val & 0xFF // Search for a byte value [0-255]
        ;
        if (typeof Uint8Array.prototype.indexOf === "function") {
            if (dir) return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset);
            else return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset);
        }
        return $51861dfc7ca9d588$var$arrayIndexOf(buffer, [
            val
        ], byteOffset, encoding, dir);
    }
    throw new TypeError("val must be string, number or Buffer");
}
function $51861dfc7ca9d588$var$arrayIndexOf(arr, val, byteOffset, encoding, dir) {
    let indexSize = 1;
    let arrLength = arr.length;
    let valLength = val.length;
    if (encoding !== undefined) {
        encoding = String(encoding).toLowerCase();
        if (encoding === "ucs2" || encoding === "ucs-2" || encoding === "utf16le" || encoding === "utf-16le") {
            if (arr.length < 2 || val.length < 2) return -1;
            indexSize = 2;
            arrLength /= 2;
            valLength /= 2;
            byteOffset /= 2;
        }
    }
    function read(buf, i) {
        if (indexSize === 1) return buf[i];
        else return buf.readUInt16BE(i * indexSize);
    }
    let i;
    if (dir) {
        let foundIndex = -1;
        for(i = byteOffset; i < arrLength; i++)if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
            if (foundIndex === -1) foundIndex = i;
            if (i - foundIndex + 1 === valLength) return foundIndex * indexSize;
        } else {
            if (foundIndex !== -1) i -= i - foundIndex;
            foundIndex = -1;
        }
    } else {
        if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength;
        for(i = byteOffset; i >= 0; i--){
            let found = true;
            for(let j = 0; j < valLength; j++)if (read(arr, i + j) !== read(val, j)) {
                found = false;
                break;
            }
            if (found) return i;
        }
    }
    return -1;
}
$51861dfc7ca9d588$var$Buffer.prototype.includes = function includes(val, byteOffset, encoding) {
    return this.indexOf(val, byteOffset, encoding) !== -1;
};
$51861dfc7ca9d588$var$Buffer.prototype.indexOf = function indexOf(val, byteOffset, encoding) {
    return $51861dfc7ca9d588$var$bidirectionalIndexOf(this, val, byteOffset, encoding, true);
};
$51861dfc7ca9d588$var$Buffer.prototype.lastIndexOf = function lastIndexOf(val, byteOffset, encoding) {
    return $51861dfc7ca9d588$var$bidirectionalIndexOf(this, val, byteOffset, encoding, false);
};
function $51861dfc7ca9d588$var$hexWrite(buf, string, offset, length) {
    offset = Number(offset) || 0;
    const remaining = buf.length - offset;
    if (!length) length = remaining;
    else {
        length = Number(length);
        if (length > remaining) length = remaining;
    }
    const strLen = string.length;
    if (length > strLen / 2) length = strLen / 2;
    let i;
    for(i = 0; i < length; ++i){
        const parsed = parseInt(string.substr(i * 2, 2), 16);
        if ($51861dfc7ca9d588$var$numberIsNaN(parsed)) return i;
        buf[offset + i] = parsed;
    }
    return i;
}
function $51861dfc7ca9d588$var$utf8Write(buf, string, offset, length) {
    return $51861dfc7ca9d588$var$blitBuffer($51861dfc7ca9d588$var$utf8ToBytes(string, buf.length - offset), buf, offset, length);
}
function $51861dfc7ca9d588$var$asciiWrite(buf, string, offset, length) {
    return $51861dfc7ca9d588$var$blitBuffer($51861dfc7ca9d588$var$asciiToBytes(string), buf, offset, length);
}
function $51861dfc7ca9d588$var$base64Write(buf, string, offset, length) {
    return $51861dfc7ca9d588$var$blitBuffer($51861dfc7ca9d588$var$base64ToBytes(string), buf, offset, length);
}
function $51861dfc7ca9d588$var$ucs2Write(buf, string, offset, length) {
    return $51861dfc7ca9d588$var$blitBuffer($51861dfc7ca9d588$var$utf16leToBytes(string, buf.length - offset), buf, offset, length);
}
$51861dfc7ca9d588$var$Buffer.prototype.write = function write(string, offset, length, encoding) {
    // Buffer#write(string)
    if (offset === undefined) {
        encoding = "utf8";
        length = this.length;
        offset = 0;
    // Buffer#write(string, encoding)
    } else if (length === undefined && typeof offset === "string") {
        encoding = offset;
        length = this.length;
        offset = 0;
    // Buffer#write(string, offset[, length][, encoding])
    } else if (isFinite(offset)) {
        offset = offset >>> 0;
        if (isFinite(length)) {
            length = length >>> 0;
            if (encoding === undefined) encoding = "utf8";
        } else {
            encoding = length;
            length = undefined;
        }
    } else throw new Error("Buffer.write(string, encoding, offset[, length]) is no longer supported");
    const remaining = this.length - offset;
    if (length === undefined || length > remaining) length = remaining;
    if (string.length > 0 && (length < 0 || offset < 0) || offset > this.length) throw new RangeError("Attempt to write outside buffer bounds");
    if (!encoding) encoding = "utf8";
    let loweredCase = false;
    for(;;)switch(encoding){
        case "hex":
            return $51861dfc7ca9d588$var$hexWrite(this, string, offset, length);
        case "utf8":
        case "utf-8":
            return $51861dfc7ca9d588$var$utf8Write(this, string, offset, length);
        case "ascii":
        case "latin1":
        case "binary":
            return $51861dfc7ca9d588$var$asciiWrite(this, string, offset, length);
        case "base64":
            // Warning: maxLength not taken into account in base64Write
            return $51861dfc7ca9d588$var$base64Write(this, string, offset, length);
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return $51861dfc7ca9d588$var$ucs2Write(this, string, offset, length);
        default:
            if (loweredCase) throw new TypeError("Unknown encoding: " + encoding);
            encoding = ("" + encoding).toLowerCase();
            loweredCase = true;
    }
};
$51861dfc7ca9d588$var$Buffer.prototype.toJSON = function toJSON() {
    return {
        type: "Buffer",
        data: Array.prototype.slice.call(this._arr || this, 0)
    };
};
function $51861dfc7ca9d588$var$base64Slice(buf, start, end) {
    if (start === 0 && end === buf.length) return $kuxul.fromByteArray(buf);
    else return $kuxul.fromByteArray(buf.slice(start, end));
}
function $51861dfc7ca9d588$var$utf8Slice(buf, start, end) {
    end = Math.min(buf.length, end);
    const res = [];
    let i = start;
    while(i < end){
        const firstByte = buf[i];
        let codePoint = null;
        let bytesPerSequence = firstByte > 0xEF ? 4 : firstByte > 0xDF ? 3 : firstByte > 0xBF ? 2 : 1;
        if (i + bytesPerSequence <= end) {
            let secondByte, thirdByte, fourthByte, tempCodePoint;
            switch(bytesPerSequence){
                case 1:
                    if (firstByte < 0x80) codePoint = firstByte;
                    break;
                case 2:
                    secondByte = buf[i + 1];
                    if ((secondByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0x1F) << 0x6 | secondByte & 0x3F;
                        if (tempCodePoint > 0x7F) codePoint = tempCodePoint;
                    }
                    break;
                case 3:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | thirdByte & 0x3F;
                        if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) codePoint = tempCodePoint;
                    }
                    break;
                case 4:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    fourthByte = buf[i + 3];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | fourthByte & 0x3F;
                        if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) codePoint = tempCodePoint;
                    }
            }
        }
        if (codePoint === null) {
            // we did not generate a valid codePoint so insert a
            // replacement char (U+FFFD) and advance only 1 byte
            codePoint = 0xFFFD;
            bytesPerSequence = 1;
        } else if (codePoint > 0xFFFF) {
            // encode to utf16 (surrogate pair dance)
            codePoint -= 0x10000;
            res.push(codePoint >>> 10 & 0x3FF | 0xD800);
            codePoint = 0xDC00 | codePoint & 0x3FF;
        }
        res.push(codePoint);
        i += bytesPerSequence;
    }
    return $51861dfc7ca9d588$var$decodeCodePointsArray(res);
}
// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
const $51861dfc7ca9d588$var$MAX_ARGUMENTS_LENGTH = 0x1000;
function $51861dfc7ca9d588$var$decodeCodePointsArray(codePoints) {
    const len = codePoints.length;
    if (len <= $51861dfc7ca9d588$var$MAX_ARGUMENTS_LENGTH) return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
    ;
    // Decode in chunks to avoid "call stack size exceeded".
    let res = "";
    let i = 0;
    while(i < len)res += String.fromCharCode.apply(String, codePoints.slice(i, i += $51861dfc7ca9d588$var$MAX_ARGUMENTS_LENGTH));
    return res;
}
function $51861dfc7ca9d588$var$asciiSlice(buf, start, end) {
    let ret = "";
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i] & 0x7F);
    return ret;
}
function $51861dfc7ca9d588$var$latin1Slice(buf, start, end) {
    let ret = "";
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i]);
    return ret;
}
function $51861dfc7ca9d588$var$hexSlice(buf, start, end) {
    const len = buf.length;
    if (!start || start < 0) start = 0;
    if (!end || end < 0 || end > len) end = len;
    let out = "";
    for(let i = start; i < end; ++i)out += $51861dfc7ca9d588$var$hexSliceLookupTable[buf[i]];
    return out;
}
function $51861dfc7ca9d588$var$utf16leSlice(buf, start, end) {
    const bytes = buf.slice(start, end);
    let res = "";
    // If bytes.length is odd, the last 8 bits must be ignored (same as node.js)
    for(let i = 0; i < bytes.length - 1; i += 2)res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256);
    return res;
}
$51861dfc7ca9d588$var$Buffer.prototype.slice = function slice(start, end) {
    const len = this.length;
    start = ~~start;
    end = end === undefined ? len : ~~end;
    if (start < 0) {
        start += len;
        if (start < 0) start = 0;
    } else if (start > len) start = len;
    if (end < 0) {
        end += len;
        if (end < 0) end = 0;
    } else if (end > len) end = len;
    if (end < start) end = start;
    const newBuf = this.subarray(start, end);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(newBuf, $51861dfc7ca9d588$var$Buffer.prototype);
    return newBuf;
};
/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */ function $51861dfc7ca9d588$var$checkOffset(offset, ext, length) {
    if (offset % 1 !== 0 || offset < 0) throw new RangeError("offset is not uint");
    if (offset + ext > length) throw new RangeError("Trying to access beyond buffer length");
}
$51861dfc7ca9d588$var$Buffer.prototype.readUintLE = $51861dfc7ca9d588$var$Buffer.prototype.readUIntLE = function readUIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    return val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readUintBE = $51861dfc7ca9d588$var$Buffer.prototype.readUIntBE = function readUIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset + --byteLength];
    let mul = 1;
    while(byteLength > 0 && (mul *= 0x100))val += this[offset + --byteLength] * mul;
    return val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readUint8 = $51861dfc7ca9d588$var$Buffer.prototype.readUInt8 = function readUInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 1, this.length);
    return this[offset];
};
$51861dfc7ca9d588$var$Buffer.prototype.readUint16LE = $51861dfc7ca9d588$var$Buffer.prototype.readUInt16LE = function readUInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 2, this.length);
    return this[offset] | this[offset + 1] << 8;
};
$51861dfc7ca9d588$var$Buffer.prototype.readUint16BE = $51861dfc7ca9d588$var$Buffer.prototype.readUInt16BE = function readUInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 2, this.length);
    return this[offset] << 8 | this[offset + 1];
};
$51861dfc7ca9d588$var$Buffer.prototype.readUint32LE = $51861dfc7ca9d588$var$Buffer.prototype.readUInt32LE = function readUInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return (this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16) + this[offset + 3] * 0x1000000;
};
$51861dfc7ca9d588$var$Buffer.prototype.readUint32BE = $51861dfc7ca9d588$var$Buffer.prototype.readUInt32BE = function readUInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return this[offset] * 0x1000000 + (this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3]);
};
$51861dfc7ca9d588$var$Buffer.prototype.readBigUInt64LE = $51861dfc7ca9d588$var$defineBigIntMethod(function readBigUInt64LE(offset) {
    offset = offset >>> 0;
    $51861dfc7ca9d588$var$validateNumber(offset, "offset");
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $51861dfc7ca9d588$var$boundsError(offset, this.length - 8);
    const lo = first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24;
    const hi = this[++offset] + this[++offset] * 256 + this[++offset] * 2 ** 16 + last * 2 ** 24;
    return BigInt(lo) + (BigInt(hi) << BigInt(32));
});
$51861dfc7ca9d588$var$Buffer.prototype.readBigUInt64BE = $51861dfc7ca9d588$var$defineBigIntMethod(function readBigUInt64BE(offset) {
    offset = offset >>> 0;
    $51861dfc7ca9d588$var$validateNumber(offset, "offset");
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $51861dfc7ca9d588$var$boundsError(offset, this.length - 8);
    const hi = first * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    const lo = this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last;
    return (BigInt(hi) << BigInt(32)) + BigInt(lo);
});
$51861dfc7ca9d588$var$Buffer.prototype.readIntLE = function readIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readIntBE = function readIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, byteLength, this.length);
    let i = byteLength;
    let mul = 1;
    let val = this[offset + --i];
    while(i > 0 && (mul *= 0x100))val += this[offset + --i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readInt8 = function readInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 1, this.length);
    if (!(this[offset] & 0x80)) return this[offset];
    return (0xff - this[offset] + 1) * -1;
};
$51861dfc7ca9d588$var$Buffer.prototype.readInt16LE = function readInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 2, this.length);
    const val = this[offset] | this[offset + 1] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readInt16BE = function readInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 2, this.length);
    const val = this[offset + 1] | this[offset] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readInt32LE = function readInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16 | this[offset + 3] << 24;
};
$51861dfc7ca9d588$var$Buffer.prototype.readInt32BE = function readInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return this[offset] << 24 | this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3];
};
$51861dfc7ca9d588$var$Buffer.prototype.readBigInt64LE = $51861dfc7ca9d588$var$defineBigIntMethod(function readBigInt64LE(offset) {
    offset = offset >>> 0;
    $51861dfc7ca9d588$var$validateNumber(offset, "offset");
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $51861dfc7ca9d588$var$boundsError(offset, this.length - 8);
    const val = this[offset + 4] + this[offset + 5] * 256 + this[offset + 6] * 2 ** 16 + (last << 24 // Overflow
    );
    return (BigInt(val) << BigInt(32)) + BigInt(first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24);
});
$51861dfc7ca9d588$var$Buffer.prototype.readBigInt64BE = $51861dfc7ca9d588$var$defineBigIntMethod(function readBigInt64BE(offset) {
    offset = offset >>> 0;
    $51861dfc7ca9d588$var$validateNumber(offset, "offset");
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $51861dfc7ca9d588$var$boundsError(offset, this.length - 8);
    const val = (first << 24) + // Overflow
    this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    return (BigInt(val) << BigInt(32)) + BigInt(this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last);
});
$51861dfc7ca9d588$var$Buffer.prototype.readFloatLE = function readFloatLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return $9NvM5.read(this, offset, true, 23, 4);
};
$51861dfc7ca9d588$var$Buffer.prototype.readFloatBE = function readFloatBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return $9NvM5.read(this, offset, false, 23, 4);
};
$51861dfc7ca9d588$var$Buffer.prototype.readDoubleLE = function readDoubleLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 8, this.length);
    return $9NvM5.read(this, offset, true, 52, 8);
};
$51861dfc7ca9d588$var$Buffer.prototype.readDoubleBE = function readDoubleBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 8, this.length);
    return $9NvM5.read(this, offset, false, 52, 8);
};
function $51861dfc7ca9d588$var$checkInt(buf, value, offset, ext, max, min) {
    if (!$51861dfc7ca9d588$var$Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance');
    if (value > max || value < min) throw new RangeError('"value" argument is out of bounds');
    if (offset + ext > buf.length) throw new RangeError("Index out of range");
}
$51861dfc7ca9d588$var$Buffer.prototype.writeUintLE = $51861dfc7ca9d588$var$Buffer.prototype.writeUIntLE = function writeUIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $51861dfc7ca9d588$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let mul = 1;
    let i = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUintBE = $51861dfc7ca9d588$var$Buffer.prototype.writeUIntBE = function writeUIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $51861dfc7ca9d588$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let i = byteLength - 1;
    let mul = 1;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUint8 = $51861dfc7ca9d588$var$Buffer.prototype.writeUInt8 = function writeUInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 1, 0xff, 0);
    this[offset] = value & 0xff;
    return offset + 1;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUint16LE = $51861dfc7ca9d588$var$Buffer.prototype.writeUInt16LE = function writeUInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUint16BE = $51861dfc7ca9d588$var$Buffer.prototype.writeUInt16BE = function writeUInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUint32LE = $51861dfc7ca9d588$var$Buffer.prototype.writeUInt32LE = function writeUInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset + 3] = value >>> 24;
    this[offset + 2] = value >>> 16;
    this[offset + 1] = value >>> 8;
    this[offset] = value & 0xff;
    return offset + 4;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUint32BE = $51861dfc7ca9d588$var$Buffer.prototype.writeUInt32BE = function writeUInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
function $51861dfc7ca9d588$var$wrtBigUInt64LE(buf, value, offset, min, max) {
    $51861dfc7ca9d588$var$checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    return offset;
}
function $51861dfc7ca9d588$var$wrtBigUInt64BE(buf, value, offset, min, max) {
    $51861dfc7ca9d588$var$checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset + 7] = lo;
    lo = lo >> 8;
    buf[offset + 6] = lo;
    lo = lo >> 8;
    buf[offset + 5] = lo;
    lo = lo >> 8;
    buf[offset + 4] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset + 3] = hi;
    hi = hi >> 8;
    buf[offset + 2] = hi;
    hi = hi >> 8;
    buf[offset + 1] = hi;
    hi = hi >> 8;
    buf[offset] = hi;
    return offset + 8;
}
$51861dfc7ca9d588$var$Buffer.prototype.writeBigUInt64LE = $51861dfc7ca9d588$var$defineBigIntMethod(function writeBigUInt64LE(value, offset = 0) {
    return $51861dfc7ca9d588$var$wrtBigUInt64LE(this, value, offset, BigInt(0), BigInt("0xffffffffffffffff"));
});
$51861dfc7ca9d588$var$Buffer.prototype.writeBigUInt64BE = $51861dfc7ca9d588$var$defineBigIntMethod(function writeBigUInt64BE(value, offset = 0) {
    return $51861dfc7ca9d588$var$wrtBigUInt64BE(this, value, offset, BigInt(0), BigInt("0xffffffffffffffff"));
});
$51861dfc7ca9d588$var$Buffer.prototype.writeIntLE = function writeIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        $51861dfc7ca9d588$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = 0;
    let mul = 1;
    let sub = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeIntBE = function writeIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        $51861dfc7ca9d588$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = byteLength - 1;
    let mul = 1;
    let sub = 0;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeInt8 = function writeInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 1, 0x7f, -128);
    if (value < 0) value = 0xff + value + 1;
    this[offset] = value & 0xff;
    return offset + 1;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeInt16LE = function writeInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeInt16BE = function writeInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeInt32LE = function writeInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    this[offset + 2] = value >>> 16;
    this[offset + 3] = value >>> 24;
    return offset + 4;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeInt32BE = function writeInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    if (value < 0) value = 0xffffffff + value + 1;
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeBigInt64LE = $51861dfc7ca9d588$var$defineBigIntMethod(function writeBigInt64LE(value, offset = 0) {
    return $51861dfc7ca9d588$var$wrtBigUInt64LE(this, value, offset, -BigInt("0x8000000000000000"), BigInt("0x7fffffffffffffff"));
});
$51861dfc7ca9d588$var$Buffer.prototype.writeBigInt64BE = $51861dfc7ca9d588$var$defineBigIntMethod(function writeBigInt64BE(value, offset = 0) {
    return $51861dfc7ca9d588$var$wrtBigUInt64BE(this, value, offset, -BigInt("0x8000000000000000"), BigInt("0x7fffffffffffffff"));
});
function $51861dfc7ca9d588$var$checkIEEE754(buf, value, offset, ext, max, min) {
    if (offset + ext > buf.length) throw new RangeError("Index out of range");
    if (offset < 0) throw new RangeError("Index out of range");
}
function $51861dfc7ca9d588$var$writeFloat(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -340282346638528860000000000000000000000);
    $9NvM5.write(buf, value, offset, littleEndian, 23, 4);
    return offset + 4;
}
$51861dfc7ca9d588$var$Buffer.prototype.writeFloatLE = function writeFloatLE(value, offset, noAssert) {
    return $51861dfc7ca9d588$var$writeFloat(this, value, offset, true, noAssert);
};
$51861dfc7ca9d588$var$Buffer.prototype.writeFloatBE = function writeFloatBE(value, offset, noAssert) {
    return $51861dfc7ca9d588$var$writeFloat(this, value, offset, false, noAssert);
};
function $51861dfc7ca9d588$var$writeDouble(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -179769313486231570000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000);
    $9NvM5.write(buf, value, offset, littleEndian, 52, 8);
    return offset + 8;
}
$51861dfc7ca9d588$var$Buffer.prototype.writeDoubleLE = function writeDoubleLE(value, offset, noAssert) {
    return $51861dfc7ca9d588$var$writeDouble(this, value, offset, true, noAssert);
};
$51861dfc7ca9d588$var$Buffer.prototype.writeDoubleBE = function writeDoubleBE(value, offset, noAssert) {
    return $51861dfc7ca9d588$var$writeDouble(this, value, offset, false, noAssert);
};
// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
$51861dfc7ca9d588$var$Buffer.prototype.copy = function copy(target, targetStart, start, end) {
    if (!$51861dfc7ca9d588$var$Buffer.isBuffer(target)) throw new TypeError("argument should be a Buffer");
    if (!start) start = 0;
    if (!end && end !== 0) end = this.length;
    if (targetStart >= target.length) targetStart = target.length;
    if (!targetStart) targetStart = 0;
    if (end > 0 && end < start) end = start;
    // Copy 0 bytes; we're done
    if (end === start) return 0;
    if (target.length === 0 || this.length === 0) return 0;
    // Fatal error conditions
    if (targetStart < 0) throw new RangeError("targetStart out of bounds");
    if (start < 0 || start >= this.length) throw new RangeError("Index out of range");
    if (end < 0) throw new RangeError("sourceEnd out of bounds");
    // Are we oob?
    if (end > this.length) end = this.length;
    if (target.length - targetStart < end - start) end = target.length - targetStart + start;
    const len = end - start;
    if (this === target && typeof Uint8Array.prototype.copyWithin === "function") // Use built-in when available, missing from IE11
    this.copyWithin(targetStart, start, end);
    else Uint8Array.prototype.set.call(target, this.subarray(start, end), targetStart);
    return len;
};
// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
$51861dfc7ca9d588$var$Buffer.prototype.fill = function fill(val, start, end, encoding) {
    // Handle string cases:
    if (typeof val === "string") {
        if (typeof start === "string") {
            encoding = start;
            start = 0;
            end = this.length;
        } else if (typeof end === "string") {
            encoding = end;
            end = this.length;
        }
        if (encoding !== undefined && typeof encoding !== "string") throw new TypeError("encoding must be a string");
        if (typeof encoding === "string" && !$51861dfc7ca9d588$var$Buffer.isEncoding(encoding)) throw new TypeError("Unknown encoding: " + encoding);
        if (val.length === 1) {
            const code = val.charCodeAt(0);
            if (encoding === "utf8" && code < 128 || encoding === "latin1") // Fast path: If `val` fits into a single byte, use that numeric value.
            val = code;
        }
    } else if (typeof val === "number") val = val & 255;
    else if (typeof val === "boolean") val = Number(val);
    // Invalid ranges are not set to a default, so can range check early.
    if (start < 0 || this.length < start || this.length < end) throw new RangeError("Out of range index");
    if (end <= start) return this;
    start = start >>> 0;
    end = end === undefined ? this.length : end >>> 0;
    if (!val) val = 0;
    let i;
    if (typeof val === "number") for(i = start; i < end; ++i)this[i] = val;
    else {
        const bytes = $51861dfc7ca9d588$var$Buffer.isBuffer(val) ? val : $51861dfc7ca9d588$var$Buffer.from(val, encoding);
        const len = bytes.length;
        if (len === 0) throw new TypeError('The value "' + val + '" is invalid for argument "value"');
        for(i = 0; i < end - start; ++i)this[i + start] = bytes[i % len];
    }
    return this;
};
// CUSTOM ERRORS
// =============
// Simplified versions from Node, changed for Buffer-only usage
const $51861dfc7ca9d588$var$errors = {};
function $51861dfc7ca9d588$var$E(sym, getMessage, Base) {
    $51861dfc7ca9d588$var$errors[sym] = class NodeError extends Base {
        constructor(){
            super();
            Object.defineProperty(this, "message", {
                value: getMessage.apply(this, arguments),
                writable: true,
                configurable: true
            });
            // Add the error code to the name to include it in the stack trace.
            this.name = `${this.name} [${sym}]`;
            // Access the stack to generate the error message including the error code
            // from the name.
            this.stack // eslint-disable-line no-unused-expressions
            ;
            // Reset the name to the actual name.
            delete this.name;
        }
        get code() {
            return sym;
        }
        set code(value) {
            Object.defineProperty(this, "code", {
                configurable: true,
                enumerable: true,
                value: value,
                writable: true
            });
        }
        toString() {
            return `${this.name} [${sym}]: ${this.message}`;
        }
    };
}
$51861dfc7ca9d588$var$E("ERR_BUFFER_OUT_OF_BOUNDS", function(name) {
    if (name) return `${name} is outside of buffer bounds`;
    return "Attempt to access memory outside buffer bounds";
}, RangeError);
$51861dfc7ca9d588$var$E("ERR_INVALID_ARG_TYPE", function(name, actual) {
    return `The "${name}" argument must be of type number. Received type ${typeof actual}`;
}, TypeError);
$51861dfc7ca9d588$var$E("ERR_OUT_OF_RANGE", function(str, range, input) {
    let msg = `The value of "${str}" is out of range.`;
    let received = input;
    if (Number.isInteger(input) && Math.abs(input) > 2 ** 32) received = $51861dfc7ca9d588$var$addNumericalSeparator(String(input));
    else if (typeof input === "bigint") {
        received = String(input);
        if (input > BigInt(2) ** BigInt(32) || input < -(BigInt(2) ** BigInt(32))) received = $51861dfc7ca9d588$var$addNumericalSeparator(received);
        received += "n";
    }
    msg += ` It must be ${range}. Received ${received}`;
    return msg;
}, RangeError);
function $51861dfc7ca9d588$var$addNumericalSeparator(val) {
    let res = "";
    let i = val.length;
    const start = val[0] === "-" ? 1 : 0;
    for(; i >= start + 4; i -= 3)res = `_${val.slice(i - 3, i)}${res}`;
    return `${val.slice(0, i)}${res}`;
}
// CHECK FUNCTIONS
// ===============
function $51861dfc7ca9d588$var$checkBounds(buf, offset, byteLength) {
    $51861dfc7ca9d588$var$validateNumber(offset, "offset");
    if (buf[offset] === undefined || buf[offset + byteLength] === undefined) $51861dfc7ca9d588$var$boundsError(offset, buf.length - (byteLength + 1));
}
function $51861dfc7ca9d588$var$checkIntBI(value, min, max, buf, offset, byteLength) {
    if (value > max || value < min) {
        const n = typeof min === "bigint" ? "n" : "";
        let range;
        if (byteLength > 3) {
            if (min === 0 || min === BigInt(0)) range = `>= 0${n} and < 2${n} ** ${(byteLength + 1) * 8}${n}`;
            else range = `>= -(2${n} ** ${(byteLength + 1) * 8 - 1}${n}) and < 2 ** ` + `${(byteLength + 1) * 8 - 1}${n}`;
        } else range = `>= ${min}${n} and <= ${max}${n}`;
        throw new $51861dfc7ca9d588$var$errors.ERR_OUT_OF_RANGE("value", range, value);
    }
    $51861dfc7ca9d588$var$checkBounds(buf, offset, byteLength);
}
function $51861dfc7ca9d588$var$validateNumber(value, name) {
    if (typeof value !== "number") throw new $51861dfc7ca9d588$var$errors.ERR_INVALID_ARG_TYPE(name, "number", value);
}
function $51861dfc7ca9d588$var$boundsError(value, length, type) {
    if (Math.floor(value) !== value) {
        $51861dfc7ca9d588$var$validateNumber(value, type);
        throw new $51861dfc7ca9d588$var$errors.ERR_OUT_OF_RANGE(type || "offset", "an integer", value);
    }
    if (length < 0) throw new $51861dfc7ca9d588$var$errors.ERR_BUFFER_OUT_OF_BOUNDS();
    throw new $51861dfc7ca9d588$var$errors.ERR_OUT_OF_RANGE(type || "offset", `>= ${type ? 1 : 0} and <= ${length}`, value);
}
// HELPER FUNCTIONS
// ================
const $51861dfc7ca9d588$var$INVALID_BASE64_RE = /[^+/0-9A-Za-z-_]/g;
function $51861dfc7ca9d588$var$base64clean(str) {
    // Node takes equal signs as end of the Base64 encoding
    str = str.split("=")[0];
    // Node strips out invalid characters like \n and \t from the string, base64-js does not
    str = str.trim().replace($51861dfc7ca9d588$var$INVALID_BASE64_RE, "");
    // Node converts strings with length < 2 to ''
    if (str.length < 2) return "";
    // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
    while(str.length % 4 !== 0)str = str + "=";
    return str;
}
function $51861dfc7ca9d588$var$utf8ToBytes(string, units) {
    units = units || Infinity;
    let codePoint;
    const length = string.length;
    let leadSurrogate = null;
    const bytes = [];
    for(let i = 0; i < length; ++i){
        codePoint = string.charCodeAt(i);
        // is surrogate component
        if (codePoint > 0xD7FF && codePoint < 0xE000) {
            // last char was a lead
            if (!leadSurrogate) {
                // no lead yet
                if (codePoint > 0xDBFF) {
                    // unexpected trail
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                } else if (i + 1 === length) {
                    // unpaired lead
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                }
                // valid lead
                leadSurrogate = codePoint;
                continue;
            }
            // 2 leads in a row
            if (codePoint < 0xDC00) {
                if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                leadSurrogate = codePoint;
                continue;
            }
            // valid surrogate pair
            codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000;
        } else if (leadSurrogate) // valid bmp char, but last char was a lead
        {
            if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
        }
        leadSurrogate = null;
        // encode utf8
        if (codePoint < 0x80) {
            if ((units -= 1) < 0) break;
            bytes.push(codePoint);
        } else if (codePoint < 0x800) {
            if ((units -= 2) < 0) break;
            bytes.push(codePoint >> 0x6 | 0xC0, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x10000) {
            if ((units -= 3) < 0) break;
            bytes.push(codePoint >> 0xC | 0xE0, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x110000) {
            if ((units -= 4) < 0) break;
            bytes.push(codePoint >> 0x12 | 0xF0, codePoint >> 0xC & 0x3F | 0x80, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else throw new Error("Invalid code point");
    }
    return bytes;
}
function $51861dfc7ca9d588$var$asciiToBytes(str) {
    const byteArray = [];
    for(let i = 0; i < str.length; ++i)// Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF);
    return byteArray;
}
function $51861dfc7ca9d588$var$utf16leToBytes(str, units) {
    let c, hi, lo;
    const byteArray = [];
    for(let i = 0; i < str.length; ++i){
        if ((units -= 2) < 0) break;
        c = str.charCodeAt(i);
        hi = c >> 8;
        lo = c % 256;
        byteArray.push(lo);
        byteArray.push(hi);
    }
    return byteArray;
}
function $51861dfc7ca9d588$var$base64ToBytes(str) {
    return $kuxul.toByteArray($51861dfc7ca9d588$var$base64clean(str));
}
function $51861dfc7ca9d588$var$blitBuffer(src, dst, offset, length) {
    let i;
    for(i = 0; i < length; ++i){
        if (i + offset >= dst.length || i >= src.length) break;
        dst[i + offset] = src[i];
    }
    return i;
}
// ArrayBuffer or Uint8Array objects from other contexts (i.e. iframes) do not pass
// the `instanceof` check but they should be treated as of that type.
// See: https://github.com/feross/buffer/issues/166
function $51861dfc7ca9d588$var$isInstance(obj, type) {
    return obj instanceof type || obj != null && obj.constructor != null && obj.constructor.name != null && obj.constructor.name === type.name;
}
function $51861dfc7ca9d588$var$numberIsNaN(obj) {
    // For IE11 support
    return obj !== obj // eslint-disable-line no-self-compare
    ;
}
// Create lookup table for `toString('hex')`
// See: https://github.com/feross/buffer/issues/219
const $51861dfc7ca9d588$var$hexSliceLookupTable = function() {
    const alphabet = "0123456789abcdef";
    const table = new Array(256);
    for(let i = 0; i < 16; ++i){
        const i16 = i * 16;
        for(let j = 0; j < 16; ++j)table[i16 + j] = alphabet[i] + alphabet[j];
    }
    return table;
}();
// Return not function with Error if BigInt not supported
function $51861dfc7ca9d588$var$defineBigIntMethod(fn) {
    return typeof BigInt === "undefined" ? $51861dfc7ca9d588$var$BufferBigIntNotDefined : fn;
}
function $51861dfc7ca9d588$var$BufferBigIntNotDefined() {
    throw new Error("BigInt not supported");
}

});
parcelRegister("kuxul", function(module, exports) {

$parcel$export(module.exports, "toByteArray", () => $eeb0961446aae8e3$export$d622b2ad8d90c771, (v) => $eeb0961446aae8e3$export$d622b2ad8d90c771 = v);
$parcel$export(module.exports, "fromByteArray", () => $eeb0961446aae8e3$export$6100ba28696e12de, (v) => $eeb0961446aae8e3$export$6100ba28696e12de = v);
var $eeb0961446aae8e3$export$a48f0734ac7c2329;
var $eeb0961446aae8e3$export$d622b2ad8d90c771;
var $eeb0961446aae8e3$export$6100ba28696e12de;
"use strict";
$eeb0961446aae8e3$export$a48f0734ac7c2329 = $eeb0961446aae8e3$var$byteLength;
$eeb0961446aae8e3$export$d622b2ad8d90c771 = $eeb0961446aae8e3$var$toByteArray;
$eeb0961446aae8e3$export$6100ba28696e12de = $eeb0961446aae8e3$var$fromByteArray;
var $eeb0961446aae8e3$var$lookup = [];
var $eeb0961446aae8e3$var$revLookup = [];
var $eeb0961446aae8e3$var$Arr = typeof Uint8Array !== "undefined" ? Uint8Array : Array;
var $eeb0961446aae8e3$var$code = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";
for(var $eeb0961446aae8e3$var$i = 0, $eeb0961446aae8e3$var$len = $eeb0961446aae8e3$var$code.length; $eeb0961446aae8e3$var$i < $eeb0961446aae8e3$var$len; ++$eeb0961446aae8e3$var$i){
    $eeb0961446aae8e3$var$lookup[$eeb0961446aae8e3$var$i] = $eeb0961446aae8e3$var$code[$eeb0961446aae8e3$var$i];
    $eeb0961446aae8e3$var$revLookup[$eeb0961446aae8e3$var$code.charCodeAt($eeb0961446aae8e3$var$i)] = $eeb0961446aae8e3$var$i;
}
// Support decoding URL-safe base64 strings, as Node.js does.
// See: https://en.wikipedia.org/wiki/Base64#URL_applications
$eeb0961446aae8e3$var$revLookup["-".charCodeAt(0)] = 62;
$eeb0961446aae8e3$var$revLookup["_".charCodeAt(0)] = 63;
function $eeb0961446aae8e3$var$getLens(b64) {
    var len = b64.length;
    if (len % 4 > 0) throw new Error("Invalid string. Length must be a multiple of 4");
    // Trim off extra bytes after placeholder bytes are found
    // See: https://github.com/beatgammit/base64-js/issues/42
    var validLen = b64.indexOf("=");
    if (validLen === -1) validLen = len;
    var placeHoldersLen = validLen === len ? 0 : 4 - validLen % 4;
    return [
        validLen,
        placeHoldersLen
    ];
}
// base64 is 4/3 + up to two characters of the original data
function $eeb0961446aae8e3$var$byteLength(b64) {
    var lens = $eeb0961446aae8e3$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $eeb0961446aae8e3$var$_byteLength(b64, validLen, placeHoldersLen) {
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $eeb0961446aae8e3$var$toByteArray(b64) {
    var tmp;
    var lens = $eeb0961446aae8e3$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    var arr = new $eeb0961446aae8e3$var$Arr($eeb0961446aae8e3$var$_byteLength(b64, validLen, placeHoldersLen));
    var curByte = 0;
    // if there are placeholders, only get up to the last complete 4 chars
    var len = placeHoldersLen > 0 ? validLen - 4 : validLen;
    var i;
    for(i = 0; i < len; i += 4){
        tmp = $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i)] << 18 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 1)] << 12 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 2)] << 6 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 3)];
        arr[curByte++] = tmp >> 16 & 0xFF;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 2) {
        tmp = $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i)] << 2 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 1)] >> 4;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 1) {
        tmp = $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i)] << 10 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 1)] << 4 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 2)] >> 2;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    return arr;
}
function $eeb0961446aae8e3$var$tripletToBase64(num) {
    return $eeb0961446aae8e3$var$lookup[num >> 18 & 0x3F] + $eeb0961446aae8e3$var$lookup[num >> 12 & 0x3F] + $eeb0961446aae8e3$var$lookup[num >> 6 & 0x3F] + $eeb0961446aae8e3$var$lookup[num & 0x3F];
}
function $eeb0961446aae8e3$var$encodeChunk(uint8, start, end) {
    var tmp;
    var output = [];
    for(var i = start; i < end; i += 3){
        tmp = (uint8[i] << 16 & 0xFF0000) + (uint8[i + 1] << 8 & 0xFF00) + (uint8[i + 2] & 0xFF);
        output.push($eeb0961446aae8e3$var$tripletToBase64(tmp));
    }
    return output.join("");
}
function $eeb0961446aae8e3$var$fromByteArray(uint8) {
    var tmp;
    var len = uint8.length;
    var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
    ;
    var parts = [];
    var maxChunkLength = 16383 // must be multiple of 3
    ;
    // go through the array every three bytes, we'll deal with trailing stuff later
    for(var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength)parts.push($eeb0961446aae8e3$var$encodeChunk(uint8, i, i + maxChunkLength > len2 ? len2 : i + maxChunkLength));
    // pad the end with zeros, but make sure to not forget the extra bytes
    if (extraBytes === 1) {
        tmp = uint8[len - 1];
        parts.push($eeb0961446aae8e3$var$lookup[tmp >> 2] + $eeb0961446aae8e3$var$lookup[tmp << 4 & 0x3F] + "==");
    } else if (extraBytes === 2) {
        tmp = (uint8[len - 2] << 8) + uint8[len - 1];
        parts.push($eeb0961446aae8e3$var$lookup[tmp >> 10] + $eeb0961446aae8e3$var$lookup[tmp >> 4 & 0x3F] + $eeb0961446aae8e3$var$lookup[tmp << 2 & 0x3F] + "=");
    }
    return parts.join("");
}

});

parcelRegister("9NvM5", function(module, exports) {

$parcel$export(module.exports, "read", () => $7221566bd4d49f44$export$aafa59e2e03f2942, (v) => $7221566bd4d49f44$export$aafa59e2e03f2942 = v);
$parcel$export(module.exports, "write", () => $7221566bd4d49f44$export$68d8715fc104d294, (v) => $7221566bd4d49f44$export$68d8715fc104d294 = v);
/*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */ var $7221566bd4d49f44$export$aafa59e2e03f2942;
var $7221566bd4d49f44$export$68d8715fc104d294;
$7221566bd4d49f44$export$aafa59e2e03f2942 = function(buffer, offset, isLE, mLen, nBytes) {
    var e, m;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var nBits = -7;
    var i = isLE ? nBytes - 1 : 0;
    var d = isLE ? -1 : 1;
    var s = buffer[offset + i];
    i += d;
    e = s & (1 << -nBits) - 1;
    s >>= -nBits;
    nBits += eLen;
    for(; nBits > 0; e = e * 256 + buffer[offset + i], i += d, nBits -= 8);
    m = e & (1 << -nBits) - 1;
    e >>= -nBits;
    nBits += mLen;
    for(; nBits > 0; m = m * 256 + buffer[offset + i], i += d, nBits -= 8);
    if (e === 0) e = 1 - eBias;
    else if (e === eMax) return m ? NaN : (s ? -1 : 1) * Infinity;
    else {
        m = m + Math.pow(2, mLen);
        e = e - eBias;
    }
    return (s ? -1 : 1) * m * Math.pow(2, e - mLen);
};
$7221566bd4d49f44$export$68d8715fc104d294 = function(buffer, value, offset, isLE, mLen, nBytes) {
    var e, m, c;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var rt = mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0;
    var i = isLE ? 0 : nBytes - 1;
    var d = isLE ? 1 : -1;
    var s = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0;
    value = Math.abs(value);
    if (isNaN(value) || value === Infinity) {
        m = isNaN(value) ? 1 : 0;
        e = eMax;
    } else {
        e = Math.floor(Math.log(value) / Math.LN2);
        if (value * (c = Math.pow(2, -e)) < 1) {
            e--;
            c *= 2;
        }
        if (e + eBias >= 1) value += rt / c;
        else value += rt * Math.pow(2, 1 - eBias);
        if (value * c >= 2) {
            e++;
            c /= 2;
        }
        if (e + eBias >= eMax) {
            m = 0;
            e = eMax;
        } else if (e + eBias >= 1) {
            m = (value * c - 1) * Math.pow(2, mLen);
            e = e + eBias;
        } else {
            m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen);
            e = 0;
        }
    }
    for(; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8);
    e = e << mLen | m;
    eLen += mLen;
    for(; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8);
    buffer[offset + i - d] |= s * 128;
};

});



parcelRegister("767Wy", function(module, exports) {
var $52af415c3a3d4253$var$toString = {}.toString;
module.exports = Array.isArray || function(arr) {
    return $52af415c3a3d4253$var$toString.call(arr) == "[object Array]";
};

});

parcelRegister("5WZQ0", function(module, exports) {
// bufferish-array.js

var $78TVd = parcelRequire("78TVd");
var $45525636c846f665$var$exports = module.exports = $45525636c846f665$var$alloc(0);
$45525636c846f665$var$exports.alloc = $45525636c846f665$var$alloc;
$45525636c846f665$var$exports.concat = $78TVd.concat;
$45525636c846f665$var$exports.from = $45525636c846f665$var$from;
/**
 * @param size {Number}
 * @returns {Buffer|Uint8Array|Array}
 */ function $45525636c846f665$var$alloc(size) {
    return new Array(size);
}
/**
 * @param value {Array|ArrayBuffer|Buffer|String}
 * @returns {Array}
 */ function $45525636c846f665$var$from(value) {
    if (!$78TVd.isBuffer(value) && $78TVd.isView(value)) // TypedArray to Uint8Array
    value = $78TVd.Uint8Array.from(value);
    else if ($78TVd.isArrayBuffer(value)) // ArrayBuffer to Uint8Array
    value = new Uint8Array(value);
    else if (typeof value === "string") // String to Array
    return $78TVd.from.call($45525636c846f665$var$exports, value);
    else if (typeof value === "number") throw new TypeError('"value" argument must not be a number');
    // Array-like to Array
    return Array.prototype.slice.call(value);
}

});

parcelRegister("183sb", function(module, exports) {
// bufferish-buffer.js

var $78TVd = parcelRequire("78TVd");
var $0d293799ebb24a32$var$Buffer = $78TVd.global;
var $0d293799ebb24a32$var$exports = module.exports = $78TVd.hasBuffer ? $0d293799ebb24a32$var$alloc(0) : [];
$0d293799ebb24a32$var$exports.alloc = $78TVd.hasBuffer && $0d293799ebb24a32$var$Buffer.alloc || $0d293799ebb24a32$var$alloc;
$0d293799ebb24a32$var$exports.concat = $78TVd.concat;
$0d293799ebb24a32$var$exports.from = $0d293799ebb24a32$var$from;
/**
 * @param size {Number}
 * @returns {Buffer|Uint8Array|Array}
 */ function $0d293799ebb24a32$var$alloc(size) {
    return new $0d293799ebb24a32$var$Buffer(size);
}
/**
 * @param value {Array|ArrayBuffer|Buffer|String}
 * @returns {Buffer}
 */ function $0d293799ebb24a32$var$from(value) {
    if (!$78TVd.isBuffer(value) && $78TVd.isView(value)) // TypedArray to Uint8Array
    value = $78TVd.Uint8Array.from(value);
    else if ($78TVd.isArrayBuffer(value)) // ArrayBuffer to Uint8Array
    value = new Uint8Array(value);
    else if (typeof value === "string") // String to Buffer
    return $78TVd.from.call($0d293799ebb24a32$var$exports, value);
    else if (typeof value === "number") throw new TypeError('"value" argument must not be a number');
    // Array-like to Buffer
    if ($0d293799ebb24a32$var$Buffer.from && $0d293799ebb24a32$var$Buffer.from.length !== 1) return $0d293799ebb24a32$var$Buffer.from(value); // node v6+
    else return new $0d293799ebb24a32$var$Buffer(value); // node v4
}

});

parcelRegister("6x2by", function(module, exports) {
// bufferish-uint8array.js

var $78TVd = parcelRequire("78TVd");
var $4c178516000e1aa2$var$exports = module.exports = $78TVd.hasArrayBuffer ? $4c178516000e1aa2$var$alloc(0) : [];
$4c178516000e1aa2$var$exports.alloc = $4c178516000e1aa2$var$alloc;
$4c178516000e1aa2$var$exports.concat = $78TVd.concat;
$4c178516000e1aa2$var$exports.from = $4c178516000e1aa2$var$from;
/**
 * @param size {Number}
 * @returns {Buffer|Uint8Array|Array}
 */ function $4c178516000e1aa2$var$alloc(size) {
    return new Uint8Array(size);
}
/**
 * @param value {Array|ArrayBuffer|Buffer|String}
 * @returns {Uint8Array}
 */ function $4c178516000e1aa2$var$from(value) {
    if ($78TVd.isView(value)) {
        // TypedArray to ArrayBuffer
        var byteOffset = value.byteOffset;
        var byteLength = value.byteLength;
        value = value.buffer;
        if (value.byteLength !== byteLength) {
            if (value.slice) value = value.slice(byteOffset, byteOffset + byteLength);
            else {
                // Android 4.1 does not have ArrayBuffer.prototype.slice
                value = new Uint8Array(value);
                if (value.byteLength !== byteLength) // TypedArray to ArrayBuffer to Uint8Array to Array
                value = Array.prototype.slice.call(value, byteOffset, byteOffset + byteLength);
            }
        }
    } else if (typeof value === "string") // String to Uint8Array
    return $78TVd.from.call($4c178516000e1aa2$var$exports, value);
    else if (typeof value === "number") throw new TypeError('"value" argument must not be a number');
    return new Uint8Array(value);
}

});

parcelRegister("VLC7O", function(module, exports) {
// bufferish-proto.js
/* jshint eqnull:true */ 
var $ddfiz = parcelRequire("ddfiz");
exports.copy = copy;
exports.slice = slice;
exports.toString = toString;
exports.write = gen("write");

var $78TVd = parcelRequire("78TVd");
var Buffer = $78TVd.global;
var isBufferShim = $78TVd.hasBuffer && "TYPED_ARRAY_SUPPORT" in Buffer;
var brokenTypedArray = isBufferShim && !Buffer.TYPED_ARRAY_SUPPORT;
/**
 * @param target {Buffer|Uint8Array|Array}
 * @param [targetStart] {Number}
 * @param [start] {Number}
 * @param [end] {Number}
 * @returns {Buffer|Uint8Array|Array}
 */ function copy(target, targetStart, start, end) {
    var thisIsBuffer = $78TVd.isBuffer(this);
    var targetIsBuffer = $78TVd.isBuffer(target);
    if (thisIsBuffer && targetIsBuffer) // Buffer to Buffer
    return this.copy(target, targetStart, start, end);
    else if (!brokenTypedArray && !thisIsBuffer && !targetIsBuffer && $78TVd.isView(this) && $78TVd.isView(target)) {
        // Uint8Array to Uint8Array (except for minor some browsers)
        var buffer = start || end != null ? slice.call(this, start, end) : this;
        target.set(buffer, targetStart);
        return buffer.length;
    } else // other cases
    return $ddfiz.copy.call(this, target, targetStart, start, end);
}
/**
 * @param [start] {Number}
 * @param [end] {Number}
 * @returns {Buffer|Uint8Array|Array}
 */ function slice(start, end) {
    // for Buffer, Uint8Array (except for minor some browsers) and Array
    var f = this.slice || !brokenTypedArray && this.subarray;
    if (f) return f.call(this, start, end);
    // Uint8Array (for minor some browsers)
    var target = $78TVd.alloc.call(this, end - start);
    copy.call(this, target, 0, start, end);
    return target;
}
/**
 * Buffer.prototype.toString()
 *
 * @param [encoding] {String} ignored
 * @param [start] {Number}
 * @param [end] {Number}
 * @returns {String}
 */ function toString(encoding, start, end) {
    var f = !isBufferShim && $78TVd.isBuffer(this) ? this.toString : $ddfiz.toString;
    return f.apply(this, arguments);
}
/**
 * @private
 */ function gen(method) {
    return wrap;
    function wrap() {
        var f = this[method] || $ddfiz[method];
        return f.apply(this, arguments);
    }
}

});
parcelRegister("ddfiz", function(module, exports) {

$parcel$export(module.exports, "copy", () => $99e85b3aa0ff6c3b$export$784d13d8ee351f07, (v) => $99e85b3aa0ff6c3b$export$784d13d8ee351f07 = v);
$parcel$export(module.exports, "toString", () => $99e85b3aa0ff6c3b$export$f84e8e69fd4488a5, (v) => $99e85b3aa0ff6c3b$export$f84e8e69fd4488a5 = v);
$parcel$export(module.exports, "write", () => $99e85b3aa0ff6c3b$export$68d8715fc104d294, (v) => $99e85b3aa0ff6c3b$export$68d8715fc104d294 = v);
// buffer-lite.js
var $99e85b3aa0ff6c3b$export$784d13d8ee351f07;
var $99e85b3aa0ff6c3b$export$f84e8e69fd4488a5;
var $99e85b3aa0ff6c3b$export$68d8715fc104d294;
var $99e85b3aa0ff6c3b$var$MAXBUFLEN = 8192;
$99e85b3aa0ff6c3b$export$784d13d8ee351f07 = $99e85b3aa0ff6c3b$var$copy;
$99e85b3aa0ff6c3b$export$f84e8e69fd4488a5 = $99e85b3aa0ff6c3b$var$toString;
$99e85b3aa0ff6c3b$export$68d8715fc104d294 = $99e85b3aa0ff6c3b$var$write;
/**
 * Buffer.prototype.write()
 *
 * @param string {String}
 * @param [offset] {Number}
 * @returns {Number}
 */ function $99e85b3aa0ff6c3b$var$write(string, offset) {
    var buffer = this;
    var index = offset || (offset |= 0);
    var length = string.length;
    var chr = 0;
    var i = 0;
    while(i < length){
        chr = string.charCodeAt(i++);
        if (chr < 128) buffer[index++] = chr;
        else if (chr < 0x800) {
            // 2 bytes
            buffer[index++] = 0xC0 | chr >>> 6;
            buffer[index++] = 0x80 | chr & 0x3F;
        } else if (chr < 0xD800 || chr > 0xDFFF) {
            // 3 bytes
            buffer[index++] = 0xE0 | chr >>> 12;
            buffer[index++] = 0x80 | chr >>> 6 & 0x3F;
            buffer[index++] = 0x80 | chr & 0x3F;
        } else {
            // 4 bytes - surrogate pair
            chr = (chr - 0xD800 << 10 | string.charCodeAt(i++) - 0xDC00) + 0x10000;
            buffer[index++] = 0xF0 | chr >>> 18;
            buffer[index++] = 0x80 | chr >>> 12 & 0x3F;
            buffer[index++] = 0x80 | chr >>> 6 & 0x3F;
            buffer[index++] = 0x80 | chr & 0x3F;
        }
    }
    return index - offset;
}
/**
 * Buffer.prototype.toString()
 *
 * @param [encoding] {String} ignored
 * @param [start] {Number}
 * @param [end] {Number}
 * @returns {String}
 */ function $99e85b3aa0ff6c3b$var$toString(encoding, start, end) {
    var buffer = this;
    var index = start | 0;
    if (!end) end = buffer.length;
    var string = "";
    var chr = 0;
    while(index < end){
        chr = buffer[index++];
        if (chr < 128) {
            string += String.fromCharCode(chr);
            continue;
        }
        if ((chr & 0xE0) === 0xC0) // 2 bytes
        chr = (chr & 0x1F) << 6 | buffer[index++] & 0x3F;
        else if ((chr & 0xF0) === 0xE0) // 3 bytes
        chr = (chr & 0x0F) << 12 | (buffer[index++] & 0x3F) << 6 | buffer[index++] & 0x3F;
        else if ((chr & 0xF8) === 0xF0) // 4 bytes
        chr = (chr & 0x07) << 18 | (buffer[index++] & 0x3F) << 12 | (buffer[index++] & 0x3F) << 6 | buffer[index++] & 0x3F;
        if (chr >= 0x010000) {
            // A surrogate pair
            chr -= 0x010000;
            string += String.fromCharCode((chr >>> 10) + 0xD800, (chr & 0x3FF) + 0xDC00);
        } else string += String.fromCharCode(chr);
    }
    return string;
}
/**
 * Buffer.prototype.copy()
 *
 * @param target {Buffer}
 * @param [targetStart] {Number}
 * @param [start] {Number}
 * @param [end] {Number}
 * @returns {number}
 */ function $99e85b3aa0ff6c3b$var$copy(target, targetStart, start, end) {
    var i;
    if (!start) start = 0;
    if (!end && end !== 0) end = this.length;
    if (!targetStart) targetStart = 0;
    var len = end - start;
    if (target === this && start < targetStart && targetStart < end) // descending
    for(i = len - 1; i >= 0; i--)target[i + targetStart] = this[i + start];
    else // ascending
    for(i = 0; i < len; i++)target[i + targetStart] = this[i + start];
    return len;
}

});




parcelRegister("kf9sO", function(module, exports) {

$parcel$export(module.exports, "setExtPackers", () => $ebcc8ca58364a95b$export$860189e95c38d517, (v) => $ebcc8ca58364a95b$export$860189e95c38d517 = v);
// ext-packer.js
var $ebcc8ca58364a95b$export$860189e95c38d517;
$ebcc8ca58364a95b$export$860189e95c38d517 = $ebcc8ca58364a95b$var$setExtPackers;

var $78TVd = parcelRequire("78TVd");
var $ebcc8ca58364a95b$var$Buffer = $78TVd.global;
var $ebcc8ca58364a95b$var$packTypedArray = $78TVd.Uint8Array.from;
var $ebcc8ca58364a95b$var$_encode;
var $ebcc8ca58364a95b$var$ERROR_COLUMNS = {
    name: 1,
    message: 1,
    stack: 1,
    columnNumber: 1,
    fileName: 1,
    lineNumber: 1
};
function $ebcc8ca58364a95b$var$setExtPackers(codec) {
    codec.addExtPacker(0x0E, Error, [
        $ebcc8ca58364a95b$var$packError,
        $ebcc8ca58364a95b$var$encode
    ]);
    codec.addExtPacker(0x01, EvalError, [
        $ebcc8ca58364a95b$var$packError,
        $ebcc8ca58364a95b$var$encode
    ]);
    codec.addExtPacker(0x02, RangeError, [
        $ebcc8ca58364a95b$var$packError,
        $ebcc8ca58364a95b$var$encode
    ]);
    codec.addExtPacker(0x03, ReferenceError, [
        $ebcc8ca58364a95b$var$packError,
        $ebcc8ca58364a95b$var$encode
    ]);
    codec.addExtPacker(0x04, SyntaxError, [
        $ebcc8ca58364a95b$var$packError,
        $ebcc8ca58364a95b$var$encode
    ]);
    codec.addExtPacker(0x05, TypeError, [
        $ebcc8ca58364a95b$var$packError,
        $ebcc8ca58364a95b$var$encode
    ]);
    codec.addExtPacker(0x06, URIError, [
        $ebcc8ca58364a95b$var$packError,
        $ebcc8ca58364a95b$var$encode
    ]);
    codec.addExtPacker(0x0A, RegExp, [
        $ebcc8ca58364a95b$var$packRegExp,
        $ebcc8ca58364a95b$var$encode
    ]);
    codec.addExtPacker(0x0B, Boolean, [
        $ebcc8ca58364a95b$var$packValueOf,
        $ebcc8ca58364a95b$var$encode
    ]);
    codec.addExtPacker(0x0C, String, [
        $ebcc8ca58364a95b$var$packValueOf,
        $ebcc8ca58364a95b$var$encode
    ]);
    codec.addExtPacker(0x0D, Date, [
        Number,
        $ebcc8ca58364a95b$var$encode
    ]);
    codec.addExtPacker(0x0F, Number, [
        $ebcc8ca58364a95b$var$packValueOf,
        $ebcc8ca58364a95b$var$encode
    ]);
    if ("undefined" !== typeof Uint8Array) {
        codec.addExtPacker(0x11, Int8Array, $ebcc8ca58364a95b$var$packTypedArray);
        codec.addExtPacker(0x12, Uint8Array, $ebcc8ca58364a95b$var$packTypedArray);
        codec.addExtPacker(0x13, Int16Array, $ebcc8ca58364a95b$var$packTypedArray);
        codec.addExtPacker(0x14, Uint16Array, $ebcc8ca58364a95b$var$packTypedArray);
        codec.addExtPacker(0x15, Int32Array, $ebcc8ca58364a95b$var$packTypedArray);
        codec.addExtPacker(0x16, Uint32Array, $ebcc8ca58364a95b$var$packTypedArray);
        codec.addExtPacker(0x17, Float32Array, $ebcc8ca58364a95b$var$packTypedArray);
        // PhantomJS/1.9.7 doesn't have Float64Array
        if ("undefined" !== typeof Float64Array) codec.addExtPacker(0x18, Float64Array, $ebcc8ca58364a95b$var$packTypedArray);
        // IE10 doesn't have Uint8ClampedArray
        if ("undefined" !== typeof Uint8ClampedArray) codec.addExtPacker(0x19, Uint8ClampedArray, $ebcc8ca58364a95b$var$packTypedArray);
        codec.addExtPacker(0x1A, ArrayBuffer, $ebcc8ca58364a95b$var$packTypedArray);
        codec.addExtPacker(0x1D, DataView, $ebcc8ca58364a95b$var$packTypedArray);
    }
    if ($78TVd.hasBuffer) codec.addExtPacker(0x1B, $ebcc8ca58364a95b$var$Buffer, $78TVd.from);
}

function $ebcc8ca58364a95b$var$encode(input) {
    if (!$ebcc8ca58364a95b$var$_encode) $ebcc8ca58364a95b$var$_encode = (parcelRequire("lVQGa")).encode; // lazy load
    return $ebcc8ca58364a95b$var$_encode(input);
}
function $ebcc8ca58364a95b$var$packValueOf(value) {
    return value.valueOf();
}
function $ebcc8ca58364a95b$var$packRegExp(value) {
    value = RegExp.prototype.toString.call(value).split("/");
    value.shift();
    var out = [
        value.pop()
    ];
    out.unshift(value.join("/"));
    return out;
}
function $ebcc8ca58364a95b$var$packError(value) {
    var out = {};
    for(var key in $ebcc8ca58364a95b$var$ERROR_COLUMNS)out[key] = value[key];
    return out;
}

});

parcelRegister("a4cEb", function(module, exports) {

$parcel$export(module.exports, "getWriteType", () => $7544169297b46f4f$export$deb9b4eed403170, (v) => $7544169297b46f4f$export$deb9b4eed403170 = v);
// write-type.js
var $7544169297b46f4f$export$deb9b4eed403170;

var $767Wy = parcelRequire("767Wy");

var $8mDzd = parcelRequire("8mDzd");
var $7544169297b46f4f$var$Uint64BE = $8mDzd.Uint64BE;
var $7544169297b46f4f$var$Int64BE = $8mDzd.Int64BE;

var $78TVd = parcelRequire("78TVd");

var $VLC7O = parcelRequire("VLC7O");

var $et8ZR = parcelRequire("et8ZR");

var $1sYhO = parcelRequire("1sYhO");
var $7544169297b46f4f$require$uint8 = $1sYhO.uint8;

var $bhJdc = parcelRequire("bhJdc");
var $7544169297b46f4f$require$ExtBuffer = $bhJdc.ExtBuffer;
var $7544169297b46f4f$var$HAS_UINT8ARRAY = "undefined" !== typeof Uint8Array;
var $7544169297b46f4f$var$HAS_MAP = "undefined" !== typeof Map;
var $7544169297b46f4f$var$extmap = [];
$7544169297b46f4f$var$extmap[1] = 0xd4;
$7544169297b46f4f$var$extmap[2] = 0xd5;
$7544169297b46f4f$var$extmap[4] = 0xd6;
$7544169297b46f4f$var$extmap[8] = 0xd7;
$7544169297b46f4f$var$extmap[16] = 0xd8;
$7544169297b46f4f$export$deb9b4eed403170 = $7544169297b46f4f$var$getWriteType;
function $7544169297b46f4f$var$getWriteType(options) {
    var token = $et8ZR.getWriteToken(options);
    var useraw = options && options.useraw;
    var binarraybuffer = $7544169297b46f4f$var$HAS_UINT8ARRAY && options && options.binarraybuffer;
    var isBuffer = binarraybuffer ? $78TVd.isArrayBuffer : $78TVd.isBuffer;
    var bin = binarraybuffer ? bin_arraybuffer : bin_buffer;
    var usemap = $7544169297b46f4f$var$HAS_MAP && options && options.usemap;
    var map = usemap ? map_to_map : obj_to_map;
    var writeType = {
        "boolean": bool,
        "function": nil,
        "number": number,
        "object": useraw ? object_raw : object,
        "string": _string(useraw ? raw_head_size : str_head_size),
        "symbol": nil,
        "undefined": nil
    };
    return writeType;
    // false -- 0xc2
    // true -- 0xc3
    function bool(encoder, value) {
        var type = value ? 0xc3 : 0xc2;
        token[type](encoder, value);
    }
    function number(encoder, value) {
        var ivalue = value | 0;
        var type;
        if (value !== ivalue) {
            // float 64 -- 0xcb
            type = 0xcb;
            token[type](encoder, value);
            return;
        } else if (-32 <= ivalue && ivalue <= 0x7F) // positive fixint -- 0x00 - 0x7f
        // negative fixint -- 0xe0 - 0xff
        type = ivalue & 0xFF;
        else if (0 <= ivalue) // uint 8 -- 0xcc
        // uint 16 -- 0xcd
        // uint 32 -- 0xce
        type = ivalue <= 0xFF ? 0xcc : ivalue <= 0xFFFF ? 0xcd : 0xce;
        else // int 8 -- 0xd0
        // int 16 -- 0xd1
        // int 32 -- 0xd2
        type = -128 <= ivalue ? 0xd0 : -32768 <= ivalue ? 0xd1 : 0xd2;
        token[type](encoder, ivalue);
    }
    // uint 64 -- 0xcf
    function uint64(encoder, value) {
        var type = 0xcf;
        token[type](encoder, value.toArray());
    }
    // int 64 -- 0xd3
    function int64(encoder, value) {
        var type = 0xd3;
        token[type](encoder, value.toArray());
    }
    // str 8 -- 0xd9
    // str 16 -- 0xda
    // str 32 -- 0xdb
    // fixstr -- 0xa0 - 0xbf
    function str_head_size(length) {
        return length < 32 ? 1 : length <= 0xFF ? 2 : length <= 0xFFFF ? 3 : 5;
    }
    // raw 16 -- 0xda
    // raw 32 -- 0xdb
    // fixraw -- 0xa0 - 0xbf
    function raw_head_size(length) {
        return length < 32 ? 1 : length <= 0xFFFF ? 3 : 5;
    }
    function _string(head_size) {
        return string;
        function string(encoder, value) {
            // prepare buffer
            var length = value.length;
            var maxsize = 5 + length * 3;
            encoder.offset = encoder.reserve(maxsize);
            var buffer = encoder.buffer;
            // expected header size
            var expected = head_size(length);
            // expected start point
            var start = encoder.offset + expected;
            // write string
            length = $VLC7O.write.call(buffer, value, start);
            // actual header size
            var actual = head_size(length);
            // move content when needed
            if (expected !== actual) {
                var targetStart = start + actual - expected;
                var end = start + length;
                $VLC7O.copy.call(buffer, buffer, targetStart, start, end);
            }
            // write header
            var type = actual === 1 ? 0xa0 + length : actual <= 3 ? 0xd7 + actual : 0xdb;
            token[type](encoder, length);
            // move cursor
            encoder.offset += length;
        }
    }
    function object(encoder, value) {
        // null
        if (value === null) return nil(encoder, value);
        // Buffer
        if (isBuffer(value)) return bin(encoder, value);
        // Array
        if ($767Wy(value)) return array(encoder, value);
        // int64-buffer objects
        if ($7544169297b46f4f$var$Uint64BE.isUint64BE(value)) return uint64(encoder, value);
        if ($7544169297b46f4f$var$Int64BE.isInt64BE(value)) return int64(encoder, value);
        // ext formats
        var packer = encoder.codec.getExtPacker(value);
        if (packer) value = packer(value);
        if (value instanceof $7544169297b46f4f$require$ExtBuffer) return ext(encoder, value);
        // plain old Objects or Map
        map(encoder, value);
    }
    function object_raw(encoder, value) {
        // Buffer
        if (isBuffer(value)) return raw(encoder, value);
        // others
        object(encoder, value);
    }
    // nil -- 0xc0
    function nil(encoder, value) {
        var type = 0xc0;
        token[type](encoder, value);
    }
    // fixarray -- 0x90 - 0x9f
    // array 16 -- 0xdc
    // array 32 -- 0xdd
    function array(encoder, value) {
        var length = value.length;
        var type = length < 16 ? 0x90 + length : length <= 0xFFFF ? 0xdc : 0xdd;
        token[type](encoder, length);
        var encode = encoder.codec.encode;
        for(var i = 0; i < length; i++)encode(encoder, value[i]);
    }
    // bin 8 -- 0xc4
    // bin 16 -- 0xc5
    // bin 32 -- 0xc6
    function bin_buffer(encoder, value) {
        var length = value.length;
        var type = length < 0xFF ? 0xc4 : length <= 0xFFFF ? 0xc5 : 0xc6;
        token[type](encoder, length);
        encoder.send(value);
    }
    function bin_arraybuffer(encoder, value) {
        bin_buffer(encoder, new Uint8Array(value));
    }
    // fixext 1 -- 0xd4
    // fixext 2 -- 0xd5
    // fixext 4 -- 0xd6
    // fixext 8 -- 0xd7
    // fixext 16 -- 0xd8
    // ext 8 -- 0xc7
    // ext 16 -- 0xc8
    // ext 32 -- 0xc9
    function ext(encoder, value) {
        var buffer = value.buffer;
        var length = buffer.length;
        var type = $7544169297b46f4f$var$extmap[length] || (length < 0xFF ? 0xc7 : length <= 0xFFFF ? 0xc8 : 0xc9);
        token[type](encoder, length);
        $7544169297b46f4f$require$uint8[value.type](encoder);
        encoder.send(buffer);
    }
    // fixmap -- 0x80 - 0x8f
    // map 16 -- 0xde
    // map 32 -- 0xdf
    function obj_to_map(encoder, value) {
        var keys = Object.keys(value);
        var length = keys.length;
        var type = length < 16 ? 0x80 + length : length <= 0xFFFF ? 0xde : 0xdf;
        token[type](encoder, length);
        var encode = encoder.codec.encode;
        keys.forEach(function(key) {
            encode(encoder, key);
            encode(encoder, value[key]);
        });
    }
    // fixmap -- 0x80 - 0x8f
    // map 16 -- 0xde
    // map 32 -- 0xdf
    function map_to_map(encoder, value) {
        if (!(value instanceof Map)) return obj_to_map(encoder, value);
        var length = value.size;
        var type = length < 16 ? 0x80 + length : length <= 0xFFFF ? 0xde : 0xdf;
        token[type](encoder, length);
        var encode = encoder.codec.encode;
        value.forEach(function(val, key, m) {
            encode(encoder, key);
            encode(encoder, val);
        });
    }
    // raw 16 -- 0xda
    // raw 32 -- 0xdb
    // fixraw -- 0xa0 - 0xbf
    function raw(encoder, value) {
        var length = value.length;
        var type = length < 32 ? 0xa0 + length : length <= 0xFFFF ? 0xda : 0xdb;
        token[type](encoder, length);
        encoder.send(value);
    }
}

});
parcelRegister("8mDzd", function(module, exports) {
// int64-buffer.js
/*jshint -W018 */ // Confusing use of '!'.
/*jshint -W030 */ // Expected an assignment or function call and instead saw an expression.
/*jshint -W093 */ // Did you mean to return a conditional instead of an assignment?

var $6ZWSX = parcelRequire("6ZWSX");
var $616f11fad08f74f9$require$Buffer = $6ZWSX.Buffer;
var $616f11fad08f74f9$var$Uint64BE, $616f11fad08f74f9$var$Int64BE, $616f11fad08f74f9$var$Uint64LE, $616f11fad08f74f9$var$Int64LE;
!function(exports1) {
    // constants
    var UNDEFINED = "undefined";
    var BUFFER = UNDEFINED !== typeof $616f11fad08f74f9$require$Buffer && $616f11fad08f74f9$require$Buffer;
    var UINT8ARRAY = UNDEFINED !== typeof Uint8Array && Uint8Array;
    var ARRAYBUFFER = UNDEFINED !== typeof ArrayBuffer && ArrayBuffer;
    var ZERO = [
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
    ];
    var isArray = Array.isArray || _isArray;
    var BIT32 = 4294967296;
    var BIT24 = 16777216;
    // storage class
    var storage; // Array;
    // generate classes
    $616f11fad08f74f9$var$Uint64BE = factory("Uint64BE", true, true);
    $616f11fad08f74f9$var$Int64BE = factory("Int64BE", true, false);
    $616f11fad08f74f9$var$Uint64LE = factory("Uint64LE", false, true);
    $616f11fad08f74f9$var$Int64LE = factory("Int64LE", false, false);
    // class factory
    function factory(name, bigendian, unsigned) {
        var posH = bigendian ? 0 : 4;
        var posL = bigendian ? 4 : 0;
        var pos0 = bigendian ? 0 : 3;
        var pos1 = bigendian ? 1 : 2;
        var pos2 = bigendian ? 2 : 1;
        var pos3 = bigendian ? 3 : 0;
        var fromPositive = bigendian ? fromPositiveBE : fromPositiveLE;
        var fromNegative = bigendian ? fromNegativeBE : fromNegativeLE;
        var proto = Int64.prototype;
        var isName = "is" + name;
        var _isInt64 = "_" + isName;
        // properties
        proto.buffer = void 0;
        proto.offset = 0;
        proto[_isInt64] = true;
        // methods
        proto.toNumber = toNumber;
        proto.toString = toString;
        proto.toJSON = toNumber;
        proto.toArray = toArray;
        // add .toBuffer() method only when Buffer available
        if (BUFFER) proto.toBuffer = toBuffer;
        // add .toArrayBuffer() method only when Uint8Array available
        if (UINT8ARRAY) proto.toArrayBuffer = toArrayBuffer;
        // isUint64BE, isInt64BE
        Int64[isName] = isInt64;
        // CommonJS
        exports1[name] = Int64;
        return Int64;
        // constructor
        function Int64(buffer, offset, value, raddix) {
            if (!(this instanceof Int64)) return new Int64(buffer, offset, value, raddix);
            return init(this, buffer, offset, value, raddix);
        }
        // isUint64BE, isInt64BE
        function isInt64(b) {
            return !!(b && b[_isInt64]);
        }
        // initializer
        function init(that, buffer, offset, value, raddix) {
            if (UINT8ARRAY && ARRAYBUFFER) {
                if (buffer instanceof ARRAYBUFFER) buffer = new UINT8ARRAY(buffer);
                if (value instanceof ARRAYBUFFER) value = new UINT8ARRAY(value);
            }
            // Int64BE() style
            if (!buffer && !offset && !value && !storage) {
                // shortcut to initialize with zero
                that.buffer = newArray(ZERO, 0);
                return;
            }
            // Int64BE(value, raddix) style
            if (!isValidBuffer(buffer, offset)) {
                var _storage = storage || Array;
                raddix = offset;
                value = buffer;
                offset = 0;
                buffer = new _storage(8);
            }
            that.buffer = buffer;
            that.offset = offset |= 0;
            // Int64BE(buffer, offset) style
            if (UNDEFINED === typeof value) return;
            // Int64BE(buffer, offset, value, raddix) style
            if ("string" === typeof value) fromString(buffer, offset, value, raddix || 10);
            else if (isValidBuffer(value, raddix)) fromArray(buffer, offset, value, raddix);
            else if ("number" === typeof raddix) {
                writeInt32(buffer, offset + posH, value); // high
                writeInt32(buffer, offset + posL, raddix); // low
            } else if (value > 0) fromPositive(buffer, offset, value); // positive
            else if (value < 0) fromNegative(buffer, offset, value); // negative
            else fromArray(buffer, offset, ZERO, 0); // zero, NaN and others
        }
        function fromString(buffer, offset, str, raddix) {
            var pos = 0;
            var len = str.length;
            var high = 0;
            var low = 0;
            if (str[0] === "-") pos++;
            var sign = pos;
            while(pos < len){
                var chr = parseInt(str[pos++], raddix);
                if (!(chr >= 0)) break; // NaN
                low = low * raddix + chr;
                high = high * raddix + Math.floor(low / BIT32);
                low %= BIT32;
            }
            if (sign) {
                high = ~high;
                if (low) low = BIT32 - low;
                else high++;
            }
            writeInt32(buffer, offset + posH, high);
            writeInt32(buffer, offset + posL, low);
        }
        function toNumber() {
            var buffer = this.buffer;
            var offset = this.offset;
            var high = readInt32(buffer, offset + posH);
            var low = readInt32(buffer, offset + posL);
            if (!unsigned) high |= 0; // a trick to get signed
            return high ? high * BIT32 + low : low;
        }
        function toString(radix) {
            var buffer = this.buffer;
            var offset = this.offset;
            var high = readInt32(buffer, offset + posH);
            var low = readInt32(buffer, offset + posL);
            var str = "";
            var sign = !unsigned && high & 0x80000000;
            if (sign) {
                high = ~high;
                low = BIT32 - low;
            }
            radix = radix || 10;
            while(true){
                var mod = high % radix * BIT32 + low;
                high = Math.floor(high / radix);
                low = Math.floor(mod / radix);
                str = (mod % radix).toString(radix) + str;
                if (!high && !low) break;
            }
            if (sign) str = "-" + str;
            return str;
        }
        function writeInt32(buffer, offset, value) {
            buffer[offset + pos3] = value & 255;
            value = value >> 8;
            buffer[offset + pos2] = value & 255;
            value = value >> 8;
            buffer[offset + pos1] = value & 255;
            value = value >> 8;
            buffer[offset + pos0] = value & 255;
        }
        function readInt32(buffer, offset) {
            return buffer[offset + pos0] * BIT24 + (buffer[offset + pos1] << 16) + (buffer[offset + pos2] << 8) + buffer[offset + pos3];
        }
    }
    function toArray(raw) {
        var buffer = this.buffer;
        var offset = this.offset;
        storage = null; // Array
        if (raw !== false && offset === 0 && buffer.length === 8 && isArray(buffer)) return buffer;
        return newArray(buffer, offset);
    }
    function toBuffer(raw) {
        var buffer = this.buffer;
        var offset = this.offset;
        storage = BUFFER;
        if (raw !== false && offset === 0 && buffer.length === 8 && $616f11fad08f74f9$require$Buffer.isBuffer(buffer)) return buffer;
        var dest = new BUFFER(8);
        fromArray(dest, 0, buffer, offset);
        return dest;
    }
    function toArrayBuffer(raw) {
        var buffer = this.buffer;
        var offset = this.offset;
        var arrbuf = buffer.buffer;
        storage = UINT8ARRAY;
        if (raw !== false && offset === 0 && arrbuf instanceof ARRAYBUFFER && arrbuf.byteLength === 8) return arrbuf;
        var dest = new UINT8ARRAY(8);
        fromArray(dest, 0, buffer, offset);
        return dest.buffer;
    }
    function isValidBuffer(buffer, offset) {
        var len = buffer && buffer.length;
        offset |= 0;
        return len && offset + 8 <= len && "string" !== typeof buffer[offset];
    }
    function fromArray(destbuf, destoff, srcbuf, srcoff) {
        destoff |= 0;
        srcoff |= 0;
        for(var i = 0; i < 8; i++)destbuf[destoff++] = srcbuf[srcoff++] & 255;
    }
    function newArray(buffer, offset) {
        return Array.prototype.slice.call(buffer, offset, offset + 8);
    }
    function fromPositiveBE(buffer, offset, value) {
        var pos = offset + 8;
        while(pos > offset){
            buffer[--pos] = value & 255;
            value /= 256;
        }
    }
    function fromNegativeBE(buffer, offset, value) {
        var pos = offset + 8;
        value++;
        while(pos > offset){
            buffer[--pos] = -value & 255 ^ 255;
            value /= 256;
        }
    }
    function fromPositiveLE(buffer, offset, value) {
        var end = offset + 8;
        while(offset < end){
            buffer[offset++] = value & 255;
            value /= 256;
        }
    }
    function fromNegativeLE(buffer, offset, value) {
        var end = offset + 8;
        value++;
        while(offset < end){
            buffer[offset++] = -value & 255 ^ 255;
            value /= 256;
        }
    }
    // https://github.com/retrofox/is-array
    function _isArray(val) {
        return !!val && "[object Array]" == Object.prototype.toString.call(val);
    }
}(typeof module.exports.nodeName !== "string" ? module.exports : module.exports || {});

});

parcelRegister("et8ZR", function(module, exports) {

$parcel$export(module.exports, "getWriteToken", () => $a88ac0b3df0345c2$export$eded4acbd3ff6542, (v) => $a88ac0b3df0345c2$export$eded4acbd3ff6542 = v);
// write-token.js
var $a88ac0b3df0345c2$export$eded4acbd3ff6542;

var $9NvM5 = parcelRequire("9NvM5");

var $8mDzd = parcelRequire("8mDzd");
var $a88ac0b3df0345c2$var$Uint64BE = $8mDzd.Uint64BE;
var $a88ac0b3df0345c2$var$Int64BE = $8mDzd.Int64BE;

var $1sYhO = parcelRequire("1sYhO");
var $a88ac0b3df0345c2$require$uint8 = $1sYhO.uint8;

var $78TVd = parcelRequire("78TVd");
var $a88ac0b3df0345c2$var$Buffer = $78TVd.global;
var $a88ac0b3df0345c2$var$IS_BUFFER_SHIM = $78TVd.hasBuffer && "TYPED_ARRAY_SUPPORT" in $a88ac0b3df0345c2$var$Buffer;
var $a88ac0b3df0345c2$var$NO_TYPED_ARRAY = $a88ac0b3df0345c2$var$IS_BUFFER_SHIM && !$a88ac0b3df0345c2$var$Buffer.TYPED_ARRAY_SUPPORT;
var $a88ac0b3df0345c2$var$Buffer_prototype = $78TVd.hasBuffer && $a88ac0b3df0345c2$var$Buffer.prototype || {};
$a88ac0b3df0345c2$export$eded4acbd3ff6542 = $a88ac0b3df0345c2$var$getWriteToken;
function $a88ac0b3df0345c2$var$getWriteToken(options) {
    if (options && options.uint8array) return $a88ac0b3df0345c2$var$init_uint8array();
    else if ($a88ac0b3df0345c2$var$NO_TYPED_ARRAY || $78TVd.hasBuffer && options && options.safe) return $a88ac0b3df0345c2$var$init_safe();
    else return $a88ac0b3df0345c2$var$init_token();
}
function $a88ac0b3df0345c2$var$init_uint8array() {
    var token = $a88ac0b3df0345c2$var$init_token();
    // float 32 -- 0xca
    // float 64 -- 0xcb
    token[0xca] = $a88ac0b3df0345c2$var$writeN(0xca, 4, $a88ac0b3df0345c2$var$writeFloatBE);
    token[0xcb] = $a88ac0b3df0345c2$var$writeN(0xcb, 8, $a88ac0b3df0345c2$var$writeDoubleBE);
    return token;
}
// Node.js and browsers with TypedArray
function $a88ac0b3df0345c2$var$init_token() {
    // (immediate values)
    // positive fixint -- 0x00 - 0x7f
    // nil -- 0xc0
    // false -- 0xc2
    // true -- 0xc3
    // negative fixint -- 0xe0 - 0xff
    var token = $a88ac0b3df0345c2$require$uint8.slice();
    // bin 8 -- 0xc4
    // bin 16 -- 0xc5
    // bin 32 -- 0xc6
    token[0xc4] = $a88ac0b3df0345c2$var$write1(0xc4);
    token[0xc5] = $a88ac0b3df0345c2$var$write2(0xc5);
    token[0xc6] = $a88ac0b3df0345c2$var$write4(0xc6);
    // ext 8 -- 0xc7
    // ext 16 -- 0xc8
    // ext 32 -- 0xc9
    token[0xc7] = $a88ac0b3df0345c2$var$write1(0xc7);
    token[0xc8] = $a88ac0b3df0345c2$var$write2(0xc8);
    token[0xc9] = $a88ac0b3df0345c2$var$write4(0xc9);
    // float 32 -- 0xca
    // float 64 -- 0xcb
    token[0xca] = $a88ac0b3df0345c2$var$writeN(0xca, 4, $a88ac0b3df0345c2$var$Buffer_prototype.writeFloatBE || $a88ac0b3df0345c2$var$writeFloatBE, true);
    token[0xcb] = $a88ac0b3df0345c2$var$writeN(0xcb, 8, $a88ac0b3df0345c2$var$Buffer_prototype.writeDoubleBE || $a88ac0b3df0345c2$var$writeDoubleBE, true);
    // uint 8 -- 0xcc
    // uint 16 -- 0xcd
    // uint 32 -- 0xce
    // uint 64 -- 0xcf
    token[0xcc] = $a88ac0b3df0345c2$var$write1(0xcc);
    token[0xcd] = $a88ac0b3df0345c2$var$write2(0xcd);
    token[0xce] = $a88ac0b3df0345c2$var$write4(0xce);
    token[0xcf] = $a88ac0b3df0345c2$var$writeN(0xcf, 8, $a88ac0b3df0345c2$var$writeUInt64BE);
    // int 8 -- 0xd0
    // int 16 -- 0xd1
    // int 32 -- 0xd2
    // int 64 -- 0xd3
    token[0xd0] = $a88ac0b3df0345c2$var$write1(0xd0);
    token[0xd1] = $a88ac0b3df0345c2$var$write2(0xd1);
    token[0xd2] = $a88ac0b3df0345c2$var$write4(0xd2);
    token[0xd3] = $a88ac0b3df0345c2$var$writeN(0xd3, 8, $a88ac0b3df0345c2$var$writeInt64BE);
    // str 8 -- 0xd9
    // str 16 -- 0xda
    // str 32 -- 0xdb
    token[0xd9] = $a88ac0b3df0345c2$var$write1(0xd9);
    token[0xda] = $a88ac0b3df0345c2$var$write2(0xda);
    token[0xdb] = $a88ac0b3df0345c2$var$write4(0xdb);
    // array 16 -- 0xdc
    // array 32 -- 0xdd
    token[0xdc] = $a88ac0b3df0345c2$var$write2(0xdc);
    token[0xdd] = $a88ac0b3df0345c2$var$write4(0xdd);
    // map 16 -- 0xde
    // map 32 -- 0xdf
    token[0xde] = $a88ac0b3df0345c2$var$write2(0xde);
    token[0xdf] = $a88ac0b3df0345c2$var$write4(0xdf);
    return token;
}
// safe mode: for old browsers and who needs asserts
function $a88ac0b3df0345c2$var$init_safe() {
    // (immediate values)
    // positive fixint -- 0x00 - 0x7f
    // nil -- 0xc0
    // false -- 0xc2
    // true -- 0xc3
    // negative fixint -- 0xe0 - 0xff
    var token = $a88ac0b3df0345c2$require$uint8.slice();
    // bin 8 -- 0xc4
    // bin 16 -- 0xc5
    // bin 32 -- 0xc6
    token[0xc4] = $a88ac0b3df0345c2$var$writeN(0xc4, 1, $a88ac0b3df0345c2$var$Buffer.prototype.writeUInt8);
    token[0xc5] = $a88ac0b3df0345c2$var$writeN(0xc5, 2, $a88ac0b3df0345c2$var$Buffer.prototype.writeUInt16BE);
    token[0xc6] = $a88ac0b3df0345c2$var$writeN(0xc6, 4, $a88ac0b3df0345c2$var$Buffer.prototype.writeUInt32BE);
    // ext 8 -- 0xc7
    // ext 16 -- 0xc8
    // ext 32 -- 0xc9
    token[0xc7] = $a88ac0b3df0345c2$var$writeN(0xc7, 1, $a88ac0b3df0345c2$var$Buffer.prototype.writeUInt8);
    token[0xc8] = $a88ac0b3df0345c2$var$writeN(0xc8, 2, $a88ac0b3df0345c2$var$Buffer.prototype.writeUInt16BE);
    token[0xc9] = $a88ac0b3df0345c2$var$writeN(0xc9, 4, $a88ac0b3df0345c2$var$Buffer.prototype.writeUInt32BE);
    // float 32 -- 0xca
    // float 64 -- 0xcb
    token[0xca] = $a88ac0b3df0345c2$var$writeN(0xca, 4, $a88ac0b3df0345c2$var$Buffer.prototype.writeFloatBE);
    token[0xcb] = $a88ac0b3df0345c2$var$writeN(0xcb, 8, $a88ac0b3df0345c2$var$Buffer.prototype.writeDoubleBE);
    // uint 8 -- 0xcc
    // uint 16 -- 0xcd
    // uint 32 -- 0xce
    // uint 64 -- 0xcf
    token[0xcc] = $a88ac0b3df0345c2$var$writeN(0xcc, 1, $a88ac0b3df0345c2$var$Buffer.prototype.writeUInt8);
    token[0xcd] = $a88ac0b3df0345c2$var$writeN(0xcd, 2, $a88ac0b3df0345c2$var$Buffer.prototype.writeUInt16BE);
    token[0xce] = $a88ac0b3df0345c2$var$writeN(0xce, 4, $a88ac0b3df0345c2$var$Buffer.prototype.writeUInt32BE);
    token[0xcf] = $a88ac0b3df0345c2$var$writeN(0xcf, 8, $a88ac0b3df0345c2$var$writeUInt64BE);
    // int 8 -- 0xd0
    // int 16 -- 0xd1
    // int 32 -- 0xd2
    // int 64 -- 0xd3
    token[0xd0] = $a88ac0b3df0345c2$var$writeN(0xd0, 1, $a88ac0b3df0345c2$var$Buffer.prototype.writeInt8);
    token[0xd1] = $a88ac0b3df0345c2$var$writeN(0xd1, 2, $a88ac0b3df0345c2$var$Buffer.prototype.writeInt16BE);
    token[0xd2] = $a88ac0b3df0345c2$var$writeN(0xd2, 4, $a88ac0b3df0345c2$var$Buffer.prototype.writeInt32BE);
    token[0xd3] = $a88ac0b3df0345c2$var$writeN(0xd3, 8, $a88ac0b3df0345c2$var$writeInt64BE);
    // str 8 -- 0xd9
    // str 16 -- 0xda
    // str 32 -- 0xdb
    token[0xd9] = $a88ac0b3df0345c2$var$writeN(0xd9, 1, $a88ac0b3df0345c2$var$Buffer.prototype.writeUInt8);
    token[0xda] = $a88ac0b3df0345c2$var$writeN(0xda, 2, $a88ac0b3df0345c2$var$Buffer.prototype.writeUInt16BE);
    token[0xdb] = $a88ac0b3df0345c2$var$writeN(0xdb, 4, $a88ac0b3df0345c2$var$Buffer.prototype.writeUInt32BE);
    // array 16 -- 0xdc
    // array 32 -- 0xdd
    token[0xdc] = $a88ac0b3df0345c2$var$writeN(0xdc, 2, $a88ac0b3df0345c2$var$Buffer.prototype.writeUInt16BE);
    token[0xdd] = $a88ac0b3df0345c2$var$writeN(0xdd, 4, $a88ac0b3df0345c2$var$Buffer.prototype.writeUInt32BE);
    // map 16 -- 0xde
    // map 32 -- 0xdf
    token[0xde] = $a88ac0b3df0345c2$var$writeN(0xde, 2, $a88ac0b3df0345c2$var$Buffer.prototype.writeUInt16BE);
    token[0xdf] = $a88ac0b3df0345c2$var$writeN(0xdf, 4, $a88ac0b3df0345c2$var$Buffer.prototype.writeUInt32BE);
    return token;
}
function $a88ac0b3df0345c2$var$write1(type) {
    return function(encoder, value) {
        var offset = encoder.reserve(2);
        var buffer = encoder.buffer;
        buffer[offset++] = type;
        buffer[offset] = value;
    };
}
function $a88ac0b3df0345c2$var$write2(type) {
    return function(encoder, value) {
        var offset = encoder.reserve(3);
        var buffer = encoder.buffer;
        buffer[offset++] = type;
        buffer[offset++] = value >>> 8;
        buffer[offset] = value;
    };
}
function $a88ac0b3df0345c2$var$write4(type) {
    return function(encoder, value) {
        var offset = encoder.reserve(5);
        var buffer = encoder.buffer;
        buffer[offset++] = type;
        buffer[offset++] = value >>> 24;
        buffer[offset++] = value >>> 16;
        buffer[offset++] = value >>> 8;
        buffer[offset] = value;
    };
}
function $a88ac0b3df0345c2$var$writeN(type, len, method, noAssert) {
    return function(encoder, value) {
        var offset = encoder.reserve(len + 1);
        encoder.buffer[offset++] = type;
        method.call(encoder.buffer, value, offset, noAssert);
    };
}
function $a88ac0b3df0345c2$var$writeUInt64BE(value, offset) {
    new $a88ac0b3df0345c2$var$Uint64BE(this, offset, value);
}
function $a88ac0b3df0345c2$var$writeInt64BE(value, offset) {
    new $a88ac0b3df0345c2$var$Int64BE(this, offset, value);
}
function $a88ac0b3df0345c2$var$writeFloatBE(value, offset) {
    $9NvM5.write(this, value, offset, false, 23, 4);
}
function $a88ac0b3df0345c2$var$writeDoubleBE(value, offset) {
    $9NvM5.write(this, value, offset, false, 52, 8);
}

});
parcelRegister("1sYhO", function(module, exports) {

$parcel$export(module.exports, "uint8", () => $11172b8efa90f0ea$export$52e103c63c4e68cf, (v) => $11172b8efa90f0ea$export$52e103c63c4e68cf = v);
// write-unit8.js
var $11172b8efa90f0ea$export$52e103c63c4e68cf;
var $11172b8efa90f0ea$var$constant = $11172b8efa90f0ea$export$52e103c63c4e68cf = new Array(256);
for(var $11172b8efa90f0ea$var$i = 0x00; $11172b8efa90f0ea$var$i <= 0xFF; $11172b8efa90f0ea$var$i++)$11172b8efa90f0ea$var$constant[$11172b8efa90f0ea$var$i] = $11172b8efa90f0ea$var$write0($11172b8efa90f0ea$var$i);
function $11172b8efa90f0ea$var$write0(type) {
    return function(encoder) {
        var offset = encoder.reserve(1);
        encoder.buffer[offset] = type;
    };
}

});



parcelRegister("exLMk", function(module, exports) {

$parcel$export(module.exports, "createCodec", () => $a9693595180fb0e6$export$a4cf2f585987cc8, (v) => $a9693595180fb0e6$export$a4cf2f585987cc8 = v);
$parcel$export(module.exports, "install", () => $a9693595180fb0e6$export$4b3e715f166fdd78, (v) => $a9693595180fb0e6$export$4b3e715f166fdd78 = v);
$parcel$export(module.exports, "filter", () => $a9693595180fb0e6$export$3dea766d36a8935f, (v) => $a9693595180fb0e6$export$3dea766d36a8935f = v);
$parcel$export(module.exports, "preset", () => $a9693595180fb0e6$export$f5ab8217e0edff04, (v) => $a9693595180fb0e6$export$f5ab8217e0edff04 = v);
// codec-base.js
var $a9693595180fb0e6$export$a4cf2f585987cc8;
var $a9693595180fb0e6$export$4b3e715f166fdd78;
var $a9693595180fb0e6$export$3dea766d36a8935f;
// default shared codec
var $a9693595180fb0e6$export$f5ab8217e0edff04;

var $767Wy = parcelRequire("767Wy");
$a9693595180fb0e6$export$a4cf2f585987cc8 = $a9693595180fb0e6$var$createCodec;
$a9693595180fb0e6$export$4b3e715f166fdd78 = $a9693595180fb0e6$var$install;
$a9693595180fb0e6$export$3dea766d36a8935f = $a9693595180fb0e6$var$filter;

var $78TVd = parcelRequire("78TVd");
function $a9693595180fb0e6$var$Codec(options) {
    if (!(this instanceof $a9693595180fb0e6$var$Codec)) return new $a9693595180fb0e6$var$Codec(options);
    this.options = options;
    this.init();
}
$a9693595180fb0e6$var$Codec.prototype.init = function() {
    var options = this.options;
    if (options && options.uint8array) this.bufferish = $78TVd.Uint8Array;
    return this;
};
function $a9693595180fb0e6$var$install(props) {
    for(var key in props)$a9693595180fb0e6$var$Codec.prototype[key] = $a9693595180fb0e6$var$add($a9693595180fb0e6$var$Codec.prototype[key], props[key]);
}
function $a9693595180fb0e6$var$add(a, b) {
    return a && b ? ab : a || b;
    function ab() {
        a.apply(this, arguments);
        return b.apply(this, arguments);
    }
}
function $a9693595180fb0e6$var$join(filters) {
    filters = filters.slice();
    return function(value) {
        return filters.reduce(iterator, value);
    };
    function iterator(value, filter) {
        return filter(value);
    }
}
function $a9693595180fb0e6$var$filter(filter) {
    return $767Wy(filter) ? $a9693595180fb0e6$var$join(filter) : filter;
}
// @public
// msgpack.createCodec()
function $a9693595180fb0e6$var$createCodec(options) {
    return new $a9693595180fb0e6$var$Codec(options);
}
$a9693595180fb0e6$export$f5ab8217e0edff04 = $a9693595180fb0e6$var$createCodec({
    preset: true
});

});


parcelRegister("crMK8", function(module, exports) {

$parcel$export(module.exports, "FlexDecoder", () => $90fdd1030cd4d735$export$dc31976c5858f14d, (v) => $90fdd1030cd4d735$export$dc31976c5858f14d = v);
$parcel$export(module.exports, "FlexEncoder", () => $90fdd1030cd4d735$export$bd62260bb192511e, (v) => $90fdd1030cd4d735$export$bd62260bb192511e = v);
// flex-buffer.js
var $90fdd1030cd4d735$export$dc31976c5858f14d;
var $90fdd1030cd4d735$export$bd62260bb192511e;
$90fdd1030cd4d735$export$dc31976c5858f14d = $90fdd1030cd4d735$var$FlexDecoder;
$90fdd1030cd4d735$export$bd62260bb192511e = $90fdd1030cd4d735$var$FlexEncoder;

var $78TVd = parcelRequire("78TVd");
var $90fdd1030cd4d735$var$MIN_BUFFER_SIZE = 2048;
var $90fdd1030cd4d735$var$MAX_BUFFER_SIZE = 65536;
var $90fdd1030cd4d735$var$BUFFER_SHORTAGE = "BUFFER_SHORTAGE";
function $90fdd1030cd4d735$var$FlexDecoder() {
    if (!(this instanceof $90fdd1030cd4d735$var$FlexDecoder)) return new $90fdd1030cd4d735$var$FlexDecoder();
}
function $90fdd1030cd4d735$var$FlexEncoder() {
    if (!(this instanceof $90fdd1030cd4d735$var$FlexEncoder)) return new $90fdd1030cd4d735$var$FlexEncoder();
}
$90fdd1030cd4d735$var$FlexDecoder.mixin = $90fdd1030cd4d735$var$mixinFactory($90fdd1030cd4d735$var$getDecoderMethods());
$90fdd1030cd4d735$var$FlexDecoder.mixin($90fdd1030cd4d735$var$FlexDecoder.prototype);
$90fdd1030cd4d735$var$FlexEncoder.mixin = $90fdd1030cd4d735$var$mixinFactory($90fdd1030cd4d735$var$getEncoderMethods());
$90fdd1030cd4d735$var$FlexEncoder.mixin($90fdd1030cd4d735$var$FlexEncoder.prototype);
function $90fdd1030cd4d735$var$getDecoderMethods() {
    return {
        bufferish: $78TVd,
        write: write,
        fetch: $90fdd1030cd4d735$var$fetch,
        flush: flush,
        push: $90fdd1030cd4d735$var$push,
        pull: $90fdd1030cd4d735$var$pull,
        read: $90fdd1030cd4d735$var$read,
        reserve: reserve,
        offset: 0
    };
    function write(chunk) {
        var prev = this.offset ? $78TVd.prototype.slice.call(this.buffer, this.offset) : this.buffer;
        this.buffer = prev ? chunk ? this.bufferish.concat([
            prev,
            chunk
        ]) : prev : chunk;
        this.offset = 0;
    }
    function flush() {
        while(this.offset < this.buffer.length){
            var start = this.offset;
            var value;
            try {
                value = this.fetch();
            } catch (e) {
                if (e && e.message != $90fdd1030cd4d735$var$BUFFER_SHORTAGE) throw e;
                // rollback
                this.offset = start;
                break;
            }
            this.push(value);
        }
    }
    function reserve(length) {
        var start = this.offset;
        var end = start + length;
        if (end > this.buffer.length) throw new Error($90fdd1030cd4d735$var$BUFFER_SHORTAGE);
        this.offset = end;
        return start;
    }
}
function $90fdd1030cd4d735$var$getEncoderMethods() {
    return {
        bufferish: $78TVd,
        write: $90fdd1030cd4d735$var$write,
        fetch: fetch,
        flush: flush,
        push: $90fdd1030cd4d735$var$push,
        pull: pull,
        read: $90fdd1030cd4d735$var$read,
        reserve: reserve,
        send: send,
        maxBufferSize: $90fdd1030cd4d735$var$MAX_BUFFER_SIZE,
        minBufferSize: $90fdd1030cd4d735$var$MIN_BUFFER_SIZE,
        offset: 0,
        start: 0
    };
    function fetch() {
        var start = this.start;
        if (start < this.offset) {
            var end = this.start = this.offset;
            return $78TVd.prototype.slice.call(this.buffer, start, end);
        }
    }
    function flush() {
        while(this.start < this.offset){
            var value = this.fetch();
            if (value) this.push(value);
        }
    }
    function pull() {
        var buffers = this.buffers || (this.buffers = []);
        var chunk = buffers.length > 1 ? this.bufferish.concat(buffers) : buffers[0];
        buffers.length = 0; // buffer exhausted
        return chunk;
    }
    function reserve(length) {
        var req = length | 0;
        if (this.buffer) {
            var size = this.buffer.length;
            var start = this.offset | 0;
            var end = start + req;
            // is it long enough?
            if (end < size) {
                this.offset = end;
                return start;
            }
            // flush current buffer
            this.flush();
            // resize it to 2x current length
            length = Math.max(length, Math.min(size * 2, this.maxBufferSize));
        }
        // minimum buffer size
        length = Math.max(length, this.minBufferSize);
        // allocate new buffer
        this.buffer = this.bufferish.alloc(length);
        this.start = 0;
        this.offset = req;
        return 0;
    }
    function send(buffer) {
        var length = buffer.length;
        if (length > this.minBufferSize) {
            this.flush();
            this.push(buffer);
        } else {
            var offset = this.reserve(length);
            $78TVd.prototype.copy.call(buffer, this.buffer, offset);
        }
    }
}
// common methods
function $90fdd1030cd4d735$var$write() {
    throw new Error("method not implemented: write()");
}
function $90fdd1030cd4d735$var$fetch() {
    throw new Error("method not implemented: fetch()");
}
function $90fdd1030cd4d735$var$read() {
    var length = this.buffers && this.buffers.length;
    // fetch the first result
    if (!length) return this.fetch();
    // flush current buffer
    this.flush();
    // read from the results
    return this.pull();
}
function $90fdd1030cd4d735$var$push(chunk) {
    var buffers = this.buffers || (this.buffers = []);
    buffers.push(chunk);
}
function $90fdd1030cd4d735$var$pull() {
    var buffers = this.buffers || (this.buffers = []);
    return buffers.shift();
}
function $90fdd1030cd4d735$var$mixinFactory(source) {
    return mixin;
    function mixin(target) {
        for(var key in source)target[key] = source[key];
        return target;
    }
}

});



parcelRegister("k7dTF", function(module, exports) {

$parcel$export(module.exports, "decode", () => $ea4f3db5dacd81d7$export$2f872c0f2117be69, (v) => $ea4f3db5dacd81d7$export$2f872c0f2117be69 = v);
// decode.js
var $ea4f3db5dacd81d7$export$2f872c0f2117be69;
$ea4f3db5dacd81d7$export$2f872c0f2117be69 = $ea4f3db5dacd81d7$var$decode;

var $1w0SX = parcelRequire("1w0SX");
var $ea4f3db5dacd81d7$require$DecodeBuffer = $1w0SX.DecodeBuffer;
function $ea4f3db5dacd81d7$var$decode(input, options) {
    var decoder = new $ea4f3db5dacd81d7$require$DecodeBuffer(options);
    decoder.write(input);
    return decoder.read();
}

});
parcelRegister("1w0SX", function(module, exports) {

$parcel$export(module.exports, "DecodeBuffer", () => $11a9776e3cfdb23f$export$e04f9cd16b1f90b5, (v) => $11a9776e3cfdb23f$export$e04f9cd16b1f90b5 = v);
// decode-buffer.js
var $11a9776e3cfdb23f$export$e04f9cd16b1f90b5;
$11a9776e3cfdb23f$export$e04f9cd16b1f90b5 = $11a9776e3cfdb23f$var$DecodeBuffer;

var $iqQb0 = parcelRequire("iqQb0");
var $11a9776e3cfdb23f$require$preset = $iqQb0.preset;

var $crMK8 = parcelRequire("crMK8");
var $11a9776e3cfdb23f$require$FlexDecoder = $crMK8.FlexDecoder;
$11a9776e3cfdb23f$require$FlexDecoder.mixin($11a9776e3cfdb23f$var$DecodeBuffer.prototype);
function $11a9776e3cfdb23f$var$DecodeBuffer(options) {
    if (!(this instanceof $11a9776e3cfdb23f$var$DecodeBuffer)) return new $11a9776e3cfdb23f$var$DecodeBuffer(options);
    if (options) {
        this.options = options;
        if (options.codec) {
            var codec = this.codec = options.codec;
            if (codec.bufferish) this.bufferish = codec.bufferish;
        }
    }
}
$11a9776e3cfdb23f$var$DecodeBuffer.prototype.codec = $11a9776e3cfdb23f$require$preset;
$11a9776e3cfdb23f$var$DecodeBuffer.prototype.fetch = function() {
    return this.codec.decode(this);
};

});
parcelRegister("iqQb0", function(module, exports) {

$parcel$export(module.exports, "preset", () => $d6b320de0670d0c7$export$f5ab8217e0edff04, (v) => $d6b320de0670d0c7$export$f5ab8217e0edff04 = v);
// read-core.js
var $d6b320de0670d0c7$export$f5ab8217e0edff04;

var $bhJdc = parcelRequire("bhJdc");
var $d6b320de0670d0c7$require$ExtBuffer = $bhJdc.ExtBuffer;

var $mpjdp = parcelRequire("mpjdp");

var $kz6K3 = parcelRequire("kz6K3");
var $d6b320de0670d0c7$require$readUint8 = $kz6K3.readUint8;

var $lcnle = parcelRequire("lcnle");

var $exLMk = parcelRequire("exLMk");
$exLMk.install({
    addExtUnpacker: $d6b320de0670d0c7$var$addExtUnpacker,
    getExtUnpacker: $d6b320de0670d0c7$var$getExtUnpacker,
    init: $d6b320de0670d0c7$var$init
});
$d6b320de0670d0c7$export$f5ab8217e0edff04 = $d6b320de0670d0c7$var$init.call($exLMk.preset);
function $d6b320de0670d0c7$var$getDecoder(options) {
    var readToken = $lcnle.getReadToken(options);
    return decode;
    function decode(decoder) {
        var type = $d6b320de0670d0c7$require$readUint8(decoder);
        var func = readToken[type];
        if (!func) throw new Error("Invalid type: " + (type ? "0x" + type.toString(16) : type));
        return func(decoder);
    }
}
function $d6b320de0670d0c7$var$init() {
    var options = this.options;
    this.decode = $d6b320de0670d0c7$var$getDecoder(options);
    if (options && options.preset) $mpjdp.setExtUnpackers(this);
    return this;
}
function $d6b320de0670d0c7$var$addExtUnpacker(etype, unpacker) {
    var unpackers = this.extUnpackers || (this.extUnpackers = []);
    unpackers[etype] = $exLMk.filter(unpacker);
}
function $d6b320de0670d0c7$var$getExtUnpacker(type) {
    var unpackers = this.extUnpackers || (this.extUnpackers = []);
    return unpackers[type] || extUnpacker;
    function extUnpacker(buffer) {
        return new $d6b320de0670d0c7$require$ExtBuffer(buffer, type);
    }
}

});
parcelRegister("mpjdp", function(module, exports) {

$parcel$export(module.exports, "setExtUnpackers", () => $0435b00383ef65a7$export$fdf7bcdbf71b0bd2, (v) => $0435b00383ef65a7$export$fdf7bcdbf71b0bd2 = v);
// ext-unpacker.js
var $0435b00383ef65a7$export$fdf7bcdbf71b0bd2;
$0435b00383ef65a7$export$fdf7bcdbf71b0bd2 = $0435b00383ef65a7$var$setExtUnpackers;

var $78TVd = parcelRequire("78TVd");
var $0435b00383ef65a7$var$Buffer = $78TVd.global;
var $0435b00383ef65a7$var$_decode;
var $0435b00383ef65a7$var$ERROR_COLUMNS = {
    name: 1,
    message: 1,
    stack: 1,
    columnNumber: 1,
    fileName: 1,
    lineNumber: 1
};
function $0435b00383ef65a7$var$setExtUnpackers(codec) {
    codec.addExtUnpacker(0x0E, [
        $0435b00383ef65a7$var$decode,
        $0435b00383ef65a7$var$unpackError(Error)
    ]);
    codec.addExtUnpacker(0x01, [
        $0435b00383ef65a7$var$decode,
        $0435b00383ef65a7$var$unpackError(EvalError)
    ]);
    codec.addExtUnpacker(0x02, [
        $0435b00383ef65a7$var$decode,
        $0435b00383ef65a7$var$unpackError(RangeError)
    ]);
    codec.addExtUnpacker(0x03, [
        $0435b00383ef65a7$var$decode,
        $0435b00383ef65a7$var$unpackError(ReferenceError)
    ]);
    codec.addExtUnpacker(0x04, [
        $0435b00383ef65a7$var$decode,
        $0435b00383ef65a7$var$unpackError(SyntaxError)
    ]);
    codec.addExtUnpacker(0x05, [
        $0435b00383ef65a7$var$decode,
        $0435b00383ef65a7$var$unpackError(TypeError)
    ]);
    codec.addExtUnpacker(0x06, [
        $0435b00383ef65a7$var$decode,
        $0435b00383ef65a7$var$unpackError(URIError)
    ]);
    codec.addExtUnpacker(0x0A, [
        $0435b00383ef65a7$var$decode,
        $0435b00383ef65a7$var$unpackRegExp
    ]);
    codec.addExtUnpacker(0x0B, [
        $0435b00383ef65a7$var$decode,
        $0435b00383ef65a7$var$unpackClass(Boolean)
    ]);
    codec.addExtUnpacker(0x0C, [
        $0435b00383ef65a7$var$decode,
        $0435b00383ef65a7$var$unpackClass(String)
    ]);
    codec.addExtUnpacker(0x0D, [
        $0435b00383ef65a7$var$decode,
        $0435b00383ef65a7$var$unpackClass(Date)
    ]);
    codec.addExtUnpacker(0x0F, [
        $0435b00383ef65a7$var$decode,
        $0435b00383ef65a7$var$unpackClass(Number)
    ]);
    if ("undefined" !== typeof Uint8Array) {
        codec.addExtUnpacker(0x11, $0435b00383ef65a7$var$unpackClass(Int8Array));
        codec.addExtUnpacker(0x12, $0435b00383ef65a7$var$unpackClass(Uint8Array));
        codec.addExtUnpacker(0x13, [
            $0435b00383ef65a7$var$unpackArrayBuffer,
            $0435b00383ef65a7$var$unpackClass(Int16Array)
        ]);
        codec.addExtUnpacker(0x14, [
            $0435b00383ef65a7$var$unpackArrayBuffer,
            $0435b00383ef65a7$var$unpackClass(Uint16Array)
        ]);
        codec.addExtUnpacker(0x15, [
            $0435b00383ef65a7$var$unpackArrayBuffer,
            $0435b00383ef65a7$var$unpackClass(Int32Array)
        ]);
        codec.addExtUnpacker(0x16, [
            $0435b00383ef65a7$var$unpackArrayBuffer,
            $0435b00383ef65a7$var$unpackClass(Uint32Array)
        ]);
        codec.addExtUnpacker(0x17, [
            $0435b00383ef65a7$var$unpackArrayBuffer,
            $0435b00383ef65a7$var$unpackClass(Float32Array)
        ]);
        // PhantomJS/1.9.7 doesn't have Float64Array
        if ("undefined" !== typeof Float64Array) codec.addExtUnpacker(0x18, [
            $0435b00383ef65a7$var$unpackArrayBuffer,
            $0435b00383ef65a7$var$unpackClass(Float64Array)
        ]);
        // IE10 doesn't have Uint8ClampedArray
        if ("undefined" !== typeof Uint8ClampedArray) codec.addExtUnpacker(0x19, $0435b00383ef65a7$var$unpackClass(Uint8ClampedArray));
        codec.addExtUnpacker(0x1A, $0435b00383ef65a7$var$unpackArrayBuffer);
        codec.addExtUnpacker(0x1D, [
            $0435b00383ef65a7$var$unpackArrayBuffer,
            $0435b00383ef65a7$var$unpackClass(DataView)
        ]);
    }
    if ($78TVd.hasBuffer) codec.addExtUnpacker(0x1B, $0435b00383ef65a7$var$unpackClass($0435b00383ef65a7$var$Buffer));
}

function $0435b00383ef65a7$var$decode(input) {
    if (!$0435b00383ef65a7$var$_decode) $0435b00383ef65a7$var$_decode = (parcelRequire("k7dTF")).decode; // lazy load
    return $0435b00383ef65a7$var$_decode(input);
}
function $0435b00383ef65a7$var$unpackRegExp(value) {
    return RegExp.apply(null, value);
}
function $0435b00383ef65a7$var$unpackError(Class) {
    return function(value) {
        var out = new Class();
        for(var key in $0435b00383ef65a7$var$ERROR_COLUMNS)out[key] = value[key];
        return out;
    };
}
function $0435b00383ef65a7$var$unpackClass(Class) {
    return function(value) {
        return new Class(value);
    };
}
function $0435b00383ef65a7$var$unpackArrayBuffer(value) {
    return new Uint8Array(value).buffer;
}

});

parcelRegister("kz6K3", function(module, exports) {

$parcel$export(module.exports, "getReadFormat", () => $ef8c4e53a4891bca$export$98bfe32ea1f56ac, (v) => $ef8c4e53a4891bca$export$98bfe32ea1f56ac = v);
$parcel$export(module.exports, "readUint8", () => $ef8c4e53a4891bca$export$d5778a2beba4ceef, (v) => $ef8c4e53a4891bca$export$d5778a2beba4ceef = v);
// read-format.js
var $ef8c4e53a4891bca$export$98bfe32ea1f56ac;
var $ef8c4e53a4891bca$export$d5778a2beba4ceef;

var $9NvM5 = parcelRequire("9NvM5");

var $8mDzd = parcelRequire("8mDzd");
var $ef8c4e53a4891bca$var$Uint64BE = $8mDzd.Uint64BE;
var $ef8c4e53a4891bca$var$Int64BE = $8mDzd.Int64BE;
$ef8c4e53a4891bca$export$98bfe32ea1f56ac = $ef8c4e53a4891bca$var$getReadFormat;
$ef8c4e53a4891bca$export$d5778a2beba4ceef = $ef8c4e53a4891bca$var$uint8;

var $78TVd = parcelRequire("78TVd");

var $VLC7O = parcelRequire("VLC7O");
var $ef8c4e53a4891bca$var$HAS_MAP = "undefined" !== typeof Map;
var $ef8c4e53a4891bca$var$NO_ASSERT = true;
function $ef8c4e53a4891bca$var$getReadFormat(options) {
    var binarraybuffer = $78TVd.hasArrayBuffer && options && options.binarraybuffer;
    var int64 = options && options.int64;
    var usemap = $ef8c4e53a4891bca$var$HAS_MAP && options && options.usemap;
    var readFormat = {
        map: usemap ? $ef8c4e53a4891bca$var$map_to_map : $ef8c4e53a4891bca$var$map_to_obj,
        array: $ef8c4e53a4891bca$var$array,
        str: $ef8c4e53a4891bca$var$str,
        bin: binarraybuffer ? $ef8c4e53a4891bca$var$bin_arraybuffer : $ef8c4e53a4891bca$var$bin_buffer,
        ext: $ef8c4e53a4891bca$var$ext,
        uint8: $ef8c4e53a4891bca$var$uint8,
        uint16: $ef8c4e53a4891bca$var$uint16,
        uint32: $ef8c4e53a4891bca$var$uint32,
        uint64: $ef8c4e53a4891bca$var$read(8, int64 ? $ef8c4e53a4891bca$var$readUInt64BE_int64 : $ef8c4e53a4891bca$var$readUInt64BE),
        int8: $ef8c4e53a4891bca$var$int8,
        int16: $ef8c4e53a4891bca$var$int16,
        int32: $ef8c4e53a4891bca$var$int32,
        int64: $ef8c4e53a4891bca$var$read(8, int64 ? $ef8c4e53a4891bca$var$readInt64BE_int64 : $ef8c4e53a4891bca$var$readInt64BE),
        float32: $ef8c4e53a4891bca$var$read(4, $ef8c4e53a4891bca$var$readFloatBE),
        float64: $ef8c4e53a4891bca$var$read(8, $ef8c4e53a4891bca$var$readDoubleBE)
    };
    return readFormat;
}
function $ef8c4e53a4891bca$var$map_to_obj(decoder, len) {
    var value = {};
    var i;
    var k = new Array(len);
    var v = new Array(len);
    var decode = decoder.codec.decode;
    for(i = 0; i < len; i++){
        k[i] = decode(decoder);
        v[i] = decode(decoder);
    }
    for(i = 0; i < len; i++)value[k[i]] = v[i];
    return value;
}
function $ef8c4e53a4891bca$var$map_to_map(decoder, len) {
    var value = new Map();
    var i;
    var k = new Array(len);
    var v = new Array(len);
    var decode = decoder.codec.decode;
    for(i = 0; i < len; i++){
        k[i] = decode(decoder);
        v[i] = decode(decoder);
    }
    for(i = 0; i < len; i++)value.set(k[i], v[i]);
    return value;
}
function $ef8c4e53a4891bca$var$array(decoder, len) {
    var value = new Array(len);
    var decode = decoder.codec.decode;
    for(var i = 0; i < len; i++)value[i] = decode(decoder);
    return value;
}
function $ef8c4e53a4891bca$var$str(decoder, len) {
    var start = decoder.reserve(len);
    var end = start + len;
    return $VLC7O.toString.call(decoder.buffer, "utf-8", start, end);
}
function $ef8c4e53a4891bca$var$bin_buffer(decoder, len) {
    var start = decoder.reserve(len);
    var end = start + len;
    var buf = $VLC7O.slice.call(decoder.buffer, start, end);
    return $78TVd.from(buf);
}
function $ef8c4e53a4891bca$var$bin_arraybuffer(decoder, len) {
    var start = decoder.reserve(len);
    var end = start + len;
    var buf = $VLC7O.slice.call(decoder.buffer, start, end);
    return $78TVd.Uint8Array.from(buf).buffer;
}
function $ef8c4e53a4891bca$var$ext(decoder, len) {
    var start = decoder.reserve(len + 1);
    var type = decoder.buffer[start++];
    var end = start + len;
    var unpack = decoder.codec.getExtUnpacker(type);
    if (!unpack) throw new Error("Invalid ext type: " + (type ? "0x" + type.toString(16) : type));
    var buf = $VLC7O.slice.call(decoder.buffer, start, end);
    return unpack(buf);
}
function $ef8c4e53a4891bca$var$uint8(decoder) {
    var start = decoder.reserve(1);
    return decoder.buffer[start];
}
function $ef8c4e53a4891bca$var$int8(decoder) {
    var start = decoder.reserve(1);
    var value = decoder.buffer[start];
    return value & 0x80 ? value - 0x100 : value;
}
function $ef8c4e53a4891bca$var$uint16(decoder) {
    var start = decoder.reserve(2);
    var buffer = decoder.buffer;
    return buffer[start++] << 8 | buffer[start];
}
function $ef8c4e53a4891bca$var$int16(decoder) {
    var start = decoder.reserve(2);
    var buffer = decoder.buffer;
    var value = buffer[start++] << 8 | buffer[start];
    return value & 0x8000 ? value - 0x10000 : value;
}
function $ef8c4e53a4891bca$var$uint32(decoder) {
    var start = decoder.reserve(4);
    var buffer = decoder.buffer;
    return buffer[start++] * 16777216 + (buffer[start++] << 16) + (buffer[start++] << 8) + buffer[start];
}
function $ef8c4e53a4891bca$var$int32(decoder) {
    var start = decoder.reserve(4);
    var buffer = decoder.buffer;
    return buffer[start++] << 24 | buffer[start++] << 16 | buffer[start++] << 8 | buffer[start];
}
function $ef8c4e53a4891bca$var$read(len, method) {
    return function(decoder) {
        var start = decoder.reserve(len);
        return method.call(decoder.buffer, start, $ef8c4e53a4891bca$var$NO_ASSERT);
    };
}
function $ef8c4e53a4891bca$var$readUInt64BE(start) {
    return new $ef8c4e53a4891bca$var$Uint64BE(this, start).toNumber();
}
function $ef8c4e53a4891bca$var$readInt64BE(start) {
    return new $ef8c4e53a4891bca$var$Int64BE(this, start).toNumber();
}
function $ef8c4e53a4891bca$var$readUInt64BE_int64(start) {
    return new $ef8c4e53a4891bca$var$Uint64BE(this, start);
}
function $ef8c4e53a4891bca$var$readInt64BE_int64(start) {
    return new $ef8c4e53a4891bca$var$Int64BE(this, start);
}
function $ef8c4e53a4891bca$var$readFloatBE(start) {
    return $9NvM5.read(this, start, false, 23, 4);
}
function $ef8c4e53a4891bca$var$readDoubleBE(start) {
    return $9NvM5.read(this, start, false, 52, 8);
}

});

parcelRegister("lcnle", function(module, exports) {

$parcel$export(module.exports, "getReadToken", () => $f6ecd310caa6dd30$export$ad386ab00192ec61, (v) => $f6ecd310caa6dd30$export$ad386ab00192ec61 = v);
// read-token.js
var $f6ecd310caa6dd30$export$ad386ab00192ec61;

var $kz6K3 = parcelRequire("kz6K3");
$f6ecd310caa6dd30$export$ad386ab00192ec61 = $f6ecd310caa6dd30$var$getReadToken;
function $f6ecd310caa6dd30$var$getReadToken(options) {
    var format = $kz6K3.getReadFormat(options);
    if (options && options.useraw) return $f6ecd310caa6dd30$var$init_useraw(format);
    else return $f6ecd310caa6dd30$var$init_token(format);
}
function $f6ecd310caa6dd30$var$init_token(format) {
    var i;
    var token = new Array(256);
    // positive fixint -- 0x00 - 0x7f
    for(i = 0x00; i <= 0x7f; i++)token[i] = $f6ecd310caa6dd30$var$constant(i);
    // fixmap -- 0x80 - 0x8f
    for(i = 0x80; i <= 0x8f; i++)token[i] = $f6ecd310caa6dd30$var$fix(i - 0x80, format.map);
    // fixarray -- 0x90 - 0x9f
    for(i = 0x90; i <= 0x9f; i++)token[i] = $f6ecd310caa6dd30$var$fix(i - 0x90, format.array);
    // fixstr -- 0xa0 - 0xbf
    for(i = 0xa0; i <= 0xbf; i++)token[i] = $f6ecd310caa6dd30$var$fix(i - 0xa0, format.str);
    // nil -- 0xc0
    token[0xc0] = $f6ecd310caa6dd30$var$constant(null);
    // (never used) -- 0xc1
    token[0xc1] = null;
    // false -- 0xc2
    // true -- 0xc3
    token[0xc2] = $f6ecd310caa6dd30$var$constant(false);
    token[0xc3] = $f6ecd310caa6dd30$var$constant(true);
    // bin 8 -- 0xc4
    // bin 16 -- 0xc5
    // bin 32 -- 0xc6
    token[0xc4] = $f6ecd310caa6dd30$var$flex(format.uint8, format.bin);
    token[0xc5] = $f6ecd310caa6dd30$var$flex(format.uint16, format.bin);
    token[0xc6] = $f6ecd310caa6dd30$var$flex(format.uint32, format.bin);
    // ext 8 -- 0xc7
    // ext 16 -- 0xc8
    // ext 32 -- 0xc9
    token[0xc7] = $f6ecd310caa6dd30$var$flex(format.uint8, format.ext);
    token[0xc8] = $f6ecd310caa6dd30$var$flex(format.uint16, format.ext);
    token[0xc9] = $f6ecd310caa6dd30$var$flex(format.uint32, format.ext);
    // float 32 -- 0xca
    // float 64 -- 0xcb
    token[0xca] = format.float32;
    token[0xcb] = format.float64;
    // uint 8 -- 0xcc
    // uint 16 -- 0xcd
    // uint 32 -- 0xce
    // uint 64 -- 0xcf
    token[0xcc] = format.uint8;
    token[0xcd] = format.uint16;
    token[0xce] = format.uint32;
    token[0xcf] = format.uint64;
    // int 8 -- 0xd0
    // int 16 -- 0xd1
    // int 32 -- 0xd2
    // int 64 -- 0xd3
    token[0xd0] = format.int8;
    token[0xd1] = format.int16;
    token[0xd2] = format.int32;
    token[0xd3] = format.int64;
    // fixext 1 -- 0xd4
    // fixext 2 -- 0xd5
    // fixext 4 -- 0xd6
    // fixext 8 -- 0xd7
    // fixext 16 -- 0xd8
    token[0xd4] = $f6ecd310caa6dd30$var$fix(1, format.ext);
    token[0xd5] = $f6ecd310caa6dd30$var$fix(2, format.ext);
    token[0xd6] = $f6ecd310caa6dd30$var$fix(4, format.ext);
    token[0xd7] = $f6ecd310caa6dd30$var$fix(8, format.ext);
    token[0xd8] = $f6ecd310caa6dd30$var$fix(16, format.ext);
    // str 8 -- 0xd9
    // str 16 -- 0xda
    // str 32 -- 0xdb
    token[0xd9] = $f6ecd310caa6dd30$var$flex(format.uint8, format.str);
    token[0xda] = $f6ecd310caa6dd30$var$flex(format.uint16, format.str);
    token[0xdb] = $f6ecd310caa6dd30$var$flex(format.uint32, format.str);
    // array 16 -- 0xdc
    // array 32 -- 0xdd
    token[0xdc] = $f6ecd310caa6dd30$var$flex(format.uint16, format.array);
    token[0xdd] = $f6ecd310caa6dd30$var$flex(format.uint32, format.array);
    // map 16 -- 0xde
    // map 32 -- 0xdf
    token[0xde] = $f6ecd310caa6dd30$var$flex(format.uint16, format.map);
    token[0xdf] = $f6ecd310caa6dd30$var$flex(format.uint32, format.map);
    // negative fixint -- 0xe0 - 0xff
    for(i = 0xe0; i <= 0xff; i++)token[i] = $f6ecd310caa6dd30$var$constant(i - 0x100);
    return token;
}
function $f6ecd310caa6dd30$var$init_useraw(format) {
    var i;
    var token = $f6ecd310caa6dd30$var$init_token(format).slice();
    // raw 8 -- 0xd9
    // raw 16 -- 0xda
    // raw 32 -- 0xdb
    token[0xd9] = token[0xc4];
    token[0xda] = token[0xc5];
    token[0xdb] = token[0xc6];
    // fixraw -- 0xa0 - 0xbf
    for(i = 0xa0; i <= 0xbf; i++)token[i] = $f6ecd310caa6dd30$var$fix(i - 0xa0, format.bin);
    return token;
}
function $f6ecd310caa6dd30$var$constant(value) {
    return function() {
        return value;
    };
}
function $f6ecd310caa6dd30$var$flex(lenFunc, decodeFunc) {
    return function(decoder) {
        var len = lenFunc(decoder);
        return decodeFunc(decoder, len);
    };
}
function $f6ecd310caa6dd30$var$fix(len, method) {
    return function(decoder) {
        return method(decoder, len);
    };
}

});




parcelRegister("968dK", function(module, exports) {

$parcel$export(module.exports, "Encoder", () => $69fb0d0a6ce7cdf2$export$a50aceb0e02a00aa, (v) => $69fb0d0a6ce7cdf2$export$a50aceb0e02a00aa = v);
// encoder.js
var $69fb0d0a6ce7cdf2$export$a50aceb0e02a00aa;
$69fb0d0a6ce7cdf2$export$a50aceb0e02a00aa = $69fb0d0a6ce7cdf2$var$Encoder;

var $afTs0 = parcelRequire("afTs0");

var $f2IWs = parcelRequire("f2IWs");
var $69fb0d0a6ce7cdf2$require$EncodeBuffer = $f2IWs.EncodeBuffer;
function $69fb0d0a6ce7cdf2$var$Encoder(options) {
    if (!(this instanceof $69fb0d0a6ce7cdf2$var$Encoder)) return new $69fb0d0a6ce7cdf2$var$Encoder(options);
    $69fb0d0a6ce7cdf2$require$EncodeBuffer.call(this, options);
}
$69fb0d0a6ce7cdf2$var$Encoder.prototype = new $69fb0d0a6ce7cdf2$require$EncodeBuffer();
$afTs0.mixin($69fb0d0a6ce7cdf2$var$Encoder.prototype);
$69fb0d0a6ce7cdf2$var$Encoder.prototype.encode = function(chunk) {
    this.write(chunk);
    this.emit("data", this.read());
};
$69fb0d0a6ce7cdf2$var$Encoder.prototype.end = function(chunk) {
    if (arguments.length) this.encode(chunk);
    this.flush();
    this.emit("end");
};

});
parcelRegister("afTs0", function(module, exports) {
/**
 * event-lite.js - Light-weight EventEmitter (less than 1KB when gzipped)
 *
 * @copyright Yusuke Kawasaki
 * @license MIT
 * @constructor
 * @see https://github.com/kawanet/event-lite
 * @see http://kawanet.github.io/event-lite/EventLite.html
 * @example
 * var EventLite = require("event-lite");
 *
 * function MyClass() {...}             // your class
 *
 * EventLite.mixin(MyClass.prototype);  // import event methods
 *
 * var obj = new MyClass();
 * obj.on("foo", function() {...});     // add event listener
 * obj.once("bar", function() {...});   // add one-time event listener
 * obj.emit("foo");                     // dispatch event
 * obj.emit("bar");                     // dispatch another event
 * obj.off("foo");                      // remove event listener
 */ function $777651728943314d$var$EventLite() {
    if (!(this instanceof $777651728943314d$var$EventLite)) return new $777651728943314d$var$EventLite();
}
(function(EventLite) {
    module.exports = EventLite;
    // property name to hold listeners
    var LISTENERS = "listeners";
    // methods to export
    var methods = {
        on: on,
        once: once,
        off: off,
        emit: emit
    };
    // mixin to self
    mixin(EventLite.prototype);
    // export mixin function
    EventLite.mixin = mixin;
    /**
   * Import on(), once(), off() and emit() methods into target object.
   *
   * @function EventLite.mixin
   * @param target {Prototype}
   */ function mixin(target) {
        for(var key in methods)target[key] = methods[key];
        return target;
    }
    /**
   * Add an event listener.
   *
   * @function EventLite.prototype.on
   * @param type {string}
   * @param func {Function}
   * @returns {EventLite} Self for method chaining
   */ function on(type, func) {
        getListeners(this, type).push(func);
        return this;
    }
    /**
   * Add one-time event listener.
   *
   * @function EventLite.prototype.once
   * @param type {string}
   * @param func {Function}
   * @returns {EventLite} Self for method chaining
   */ function once(type, func) {
        var that = this;
        wrap.originalListener = func;
        getListeners(that, type).push(wrap);
        return that;
        function wrap() {
            off.call(that, type, wrap);
            func.apply(this, arguments);
        }
    }
    /**
   * Remove an event listener.
   *
   * @function EventLite.prototype.off
   * @param [type] {string}
   * @param [func] {Function}
   * @returns {EventLite} Self for method chaining
   */ function off(type, func) {
        var that = this;
        var listners;
        if (!arguments.length) delete that[LISTENERS];
        else if (!func) {
            listners = that[LISTENERS];
            if (listners) {
                delete listners[type];
                if (!Object.keys(listners).length) return off.call(that);
            }
        } else {
            listners = getListeners(that, type, true);
            if (listners) {
                listners = listners.filter(ne);
                if (!listners.length) return off.call(that, type);
                that[LISTENERS][type] = listners;
            }
        }
        return that;
        function ne(test) {
            return test !== func && test.originalListener !== func;
        }
    }
    /**
   * Dispatch (trigger) an event.
   *
   * @function EventLite.prototype.emit
   * @param type {string}
   * @param [value] {*}
   * @returns {boolean} True when a listener received the event
   */ function emit(type, value) {
        var that = this;
        var listeners = getListeners(that, type, true);
        if (!listeners) return false;
        var arglen = arguments.length;
        if (arglen === 1) listeners.forEach(zeroarg);
        else if (arglen === 2) listeners.forEach(onearg);
        else {
            var args = Array.prototype.slice.call(arguments, 1);
            listeners.forEach(moreargs);
        }
        return !!listeners.length;
        function zeroarg(func) {
            func.call(that);
        }
        function onearg(func) {
            func.call(that, value);
        }
        function moreargs(func) {
            func.apply(that, args);
        }
    }
    /**
   * @ignore
   */ function getListeners(that, type, readonly) {
        if (readonly && !that[LISTENERS]) return;
        var listeners = that[LISTENERS] || (that[LISTENERS] = {});
        return listeners[type] || (listeners[type] = []);
    }
})($777651728943314d$var$EventLite);

});


parcelRegister("HSvGO", function(module, exports) {

$parcel$export(module.exports, "Decoder", () => $083e4cd76578bf09$export$f9de6ca0bc043724, (v) => $083e4cd76578bf09$export$f9de6ca0bc043724 = v);
// decoder.js
var $083e4cd76578bf09$export$f9de6ca0bc043724;
$083e4cd76578bf09$export$f9de6ca0bc043724 = $083e4cd76578bf09$var$Decoder;

var $afTs0 = parcelRequire("afTs0");

var $1w0SX = parcelRequire("1w0SX");
var $083e4cd76578bf09$require$DecodeBuffer = $1w0SX.DecodeBuffer;
function $083e4cd76578bf09$var$Decoder(options) {
    if (!(this instanceof $083e4cd76578bf09$var$Decoder)) return new $083e4cd76578bf09$var$Decoder(options);
    $083e4cd76578bf09$require$DecodeBuffer.call(this, options);
}
$083e4cd76578bf09$var$Decoder.prototype = new $083e4cd76578bf09$require$DecodeBuffer();
$afTs0.mixin($083e4cd76578bf09$var$Decoder.prototype);
$083e4cd76578bf09$var$Decoder.prototype.decode = function(chunk) {
    if (arguments.length) this.write(chunk);
    this.flush();
};
$083e4cd76578bf09$var$Decoder.prototype.push = function(chunk) {
    this.emit("data", chunk);
};
$083e4cd76578bf09$var$Decoder.prototype.end = function(chunk) {
    this.decode(chunk);
    this.emit("end");
};

});

parcelRegister("5Fza0", function(module, exports) {

$parcel$export(module.exports, "createCodec", () => $420c0e3164cd49ec$export$a4cf2f585987cc8, (v) => $420c0e3164cd49ec$export$a4cf2f585987cc8 = v);
// ext.js
// load both interfaces
var $420c0e3164cd49ec$export$a4cf2f585987cc8;
parcelRequire("iqQb0");
parcelRequire("hVzVX");

$420c0e3164cd49ec$export$a4cf2f585987cc8 = (parcelRequire("exLMk")).createCodec;

});

parcelRegister("762Am", function(module, exports) {

$parcel$export(module.exports, "codec", () => $52ab1960a6789808$export$1c37c01eba8ed446, (v) => $52ab1960a6789808$export$1c37c01eba8ed446 = v);
// codec.js
// load both interfaces
// @public
// msgpack.codec.preset
var $52ab1960a6789808$export$1c37c01eba8ed446;
parcelRequire("iqQb0");
parcelRequire("hVzVX");

$52ab1960a6789808$export$1c37c01eba8ed446 = {
    preset: (parcelRequire("exLMk")).preset
};

});

var $fd28d333ad7e5007$exports = {};
var $32c496bfb6c27b56$export$2e2bcd8739ae039 = /^(?:[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}|00000000-0000-0000-0000-000000000000)$/i;


function $46d323206dcbf256$var$validate(uuid) {
    return typeof uuid === "string" && (0, $32c496bfb6c27b56$export$2e2bcd8739ae039).test(uuid);
}
var $46d323206dcbf256$export$2e2bcd8739ae039 = $46d323206dcbf256$var$validate;


function $02f33e5afac044cb$var$parse(uuid) {
    if (!(0, $46d323206dcbf256$export$2e2bcd8739ae039)(uuid)) throw TypeError("Invalid UUID");
    let v;
    const arr = new Uint8Array(16); // Parse ########-....-....-....-............
    arr[0] = (v = parseInt(uuid.slice(0, 8), 16)) >>> 24;
    arr[1] = v >>> 16 & 0xff;
    arr[2] = v >>> 8 & 0xff;
    arr[3] = v & 0xff; // Parse ........-####-....-....-............
    arr[4] = (v = parseInt(uuid.slice(9, 13), 16)) >>> 8;
    arr[5] = v & 0xff; // Parse ........-....-####-....-............
    arr[6] = (v = parseInt(uuid.slice(14, 18), 16)) >>> 8;
    arr[7] = v & 0xff; // Parse ........-....-....-####-............
    arr[8] = (v = parseInt(uuid.slice(19, 23), 16)) >>> 8;
    arr[9] = v & 0xff; // Parse ........-....-....-....-############
    // (Use "/" to avoid 32-bit truncation when bit-shifting high-order bytes)
    arr[10] = (v = parseInt(uuid.slice(24, 36), 16)) / 0x10000000000 & 0xff;
    arr[11] = v / 0x100000000 & 0xff;
    arr[12] = v >>> 24 & 0xff;
    arr[13] = v >>> 16 & 0xff;
    arr[14] = v >>> 8 & 0xff;
    arr[15] = v & 0xff;
    return arr;
}
var $02f33e5afac044cb$export$2e2bcd8739ae039 = $02f33e5afac044cb$var$parse;


/**
 * Convert array of 16 byte values to UUID string format of the form:
 * XXXXXXXX-XXXX-XXXX-XXXX-XXXXXXXXXXXX
 */ const $1d0137947e8554ce$var$byteToHex = [];
for(let i = 0; i < 256; ++i)$1d0137947e8554ce$var$byteToHex.push((i + 0x100).toString(16).slice(1));
function $1d0137947e8554ce$export$8fb373d660548968(arr, offset = 0) {
    // Note: Be careful editing this code!  It's been tuned for performance
    // and works in ways you may not expect. See https://github.com/uuidjs/uuid/pull/434
    return $1d0137947e8554ce$var$byteToHex[arr[offset + 0]] + $1d0137947e8554ce$var$byteToHex[arr[offset + 1]] + $1d0137947e8554ce$var$byteToHex[arr[offset + 2]] + $1d0137947e8554ce$var$byteToHex[arr[offset + 3]] + "-" + $1d0137947e8554ce$var$byteToHex[arr[offset + 4]] + $1d0137947e8554ce$var$byteToHex[arr[offset + 5]] + "-" + $1d0137947e8554ce$var$byteToHex[arr[offset + 6]] + $1d0137947e8554ce$var$byteToHex[arr[offset + 7]] + "-" + $1d0137947e8554ce$var$byteToHex[arr[offset + 8]] + $1d0137947e8554ce$var$byteToHex[arr[offset + 9]] + "-" + $1d0137947e8554ce$var$byteToHex[arr[offset + 10]] + $1d0137947e8554ce$var$byteToHex[arr[offset + 11]] + $1d0137947e8554ce$var$byteToHex[arr[offset + 12]] + $1d0137947e8554ce$var$byteToHex[arr[offset + 13]] + $1d0137947e8554ce$var$byteToHex[arr[offset + 14]] + $1d0137947e8554ce$var$byteToHex[arr[offset + 15]];
}
function $1d0137947e8554ce$var$stringify(arr, offset = 0) {
    const uuid = $1d0137947e8554ce$export$8fb373d660548968(arr, offset); // Consistency check for valid UUID.  If this throws, it's likely due to one
    // of the following:
    // - One or more input array values don't map to a hex octet (leading to
    // "undefined" in the uuid)
    // - Invalid input values for the RFC `version` or `variant` fields
    if (!(0, $46d323206dcbf256$export$2e2bcd8739ae039)(uuid)) throw TypeError("Stringified UUID is invalid");
    return uuid;
}
var $1d0137947e8554ce$export$2e2bcd8739ae039 = $1d0137947e8554ce$var$stringify;

const $7ffc1f94643dc7e4$var$randomUUID = typeof crypto !== "undefined" && crypto.randomUUID && crypto.randomUUID.bind(crypto);
var $7ffc1f94643dc7e4$export$2e2bcd8739ae039 = {
    randomUUID: $7ffc1f94643dc7e4$var$randomUUID
};


// Unique ID creation requires a high quality random # generator. In the browser we therefore
// require the crypto API and do not support built-in fallback to lower quality random number
// generators (like Math.random()).
let $568f4ee4022ba00e$var$getRandomValues;
const $568f4ee4022ba00e$var$rnds8 = new Uint8Array(16);
function $568f4ee4022ba00e$export$2e2bcd8739ae039() {
    // lazy load so that environments that need to polyfill have a chance to do so
    if (!$568f4ee4022ba00e$var$getRandomValues) {
        // getRandomValues needs to be invoked in a context where "this" is a Crypto implementation.
        $568f4ee4022ba00e$var$getRandomValues = typeof crypto !== "undefined" && crypto.getRandomValues && crypto.getRandomValues.bind(crypto);
        if (!$568f4ee4022ba00e$var$getRandomValues) throw new Error("crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported");
    }
    return $568f4ee4022ba00e$var$getRandomValues($568f4ee4022ba00e$var$rnds8);
}



function $3fa3ae484854b431$var$v4(options, buf, offset) {
    if ((0, $7ffc1f94643dc7e4$export$2e2bcd8739ae039).randomUUID && !buf && !options) return (0, $7ffc1f94643dc7e4$export$2e2bcd8739ae039).randomUUID();
    options = options || {};
    const rnds = options.random || (options.rng || (0, $568f4ee4022ba00e$export$2e2bcd8739ae039))(); // Per 4.4, set bits for version and `clock_seq_hi_and_reserved`
    rnds[6] = rnds[6] & 0x0f | 0x40;
    rnds[8] = rnds[8] & 0x3f | 0x80; // Copy bytes to buffer, if provided
    if (buf) {
        offset = offset || 0;
        for(let i = 0; i < 16; ++i)buf[offset + i] = rnds[i];
        return buf;
    }
    return (0, $1d0137947e8554ce$export$8fb373d660548968)(rnds);
}
var $3fa3ae484854b431$export$2e2bcd8739ae039 = $3fa3ae484854b431$var$v4;


var $fd28d333ad7e5007$require$uuidV4 = $3fa3ae484854b431$export$2e2bcd8739ae039;
var $fd28d333ad7e5007$require$uuidParse = $02f33e5afac044cb$export$2e2bcd8739ae039;
var $fd28d333ad7e5007$require$uuidStringify = $1d0137947e8554ce$export$2e2bcd8739ae039;
const $fd28d333ad7e5007$var$promisify = (method)=>{
    return (...args)=>{
        try {
            const result = method(...args);
            if (result instanceof Promise) return result;
            return Promise.resolve(result);
        } catch (error) {
            return Promise.reject(error);
        }
    };
};
// browser.js
var $b4febe4ed2fc60b5$export$c564cdbbe6da493;
var $b4febe4ed2fc60b5$export$2f872c0f2117be69;
var $b4febe4ed2fc60b5$export$a50aceb0e02a00aa;
var $b4febe4ed2fc60b5$export$f9de6ca0bc043724;
var $b4febe4ed2fc60b5$export$a4cf2f585987cc8;
var $b4febe4ed2fc60b5$export$1c37c01eba8ed446;

$b4febe4ed2fc60b5$export$c564cdbbe6da493 = (parcelRequire("lVQGa")).encode;

$b4febe4ed2fc60b5$export$2f872c0f2117be69 = (parcelRequire("k7dTF")).decode;

$b4febe4ed2fc60b5$export$a50aceb0e02a00aa = (parcelRequire("968dK")).Encoder;

$b4febe4ed2fc60b5$export$f9de6ca0bc043724 = (parcelRequire("HSvGO")).Decoder;

$b4febe4ed2fc60b5$export$a4cf2f585987cc8 = (parcelRequire("5Fza0")).createCodec;

$b4febe4ed2fc60b5$export$1c37c01eba8ed446 = (parcelRequire("762Am")).codec;


$fd28d333ad7e5007$exports = (handlerTable, writeMethod)=>{
    const protocol = {
        _taskLookup: {},
        _handleCall: (data)=>{
            const id = $fd28d333ad7e5007$require$uuidStringify(data.id);
            const handler = handlerTable[data.command + ""];
            if (handler === undefined) return protocol.response(id, false, new Error("Command not registered"));
            return $fd28d333ad7e5007$var$promisify(handler)(data.data).then((data)=>{
                return protocol.response(id, true, data);
            }).catch((error)=>{
                return protocol.response(id, false, error);
            });
        },
        _handleResponse: (data)=>{
            const id = $fd28d333ad7e5007$require$uuidStringify(data.id);
            const task = protocol._taskLookup[id];
            if (task === undefined) return;
            if (data.success) task.resolve(data.data);
            else task.reject(data.data);
        },
        readMethod: (arrayBuffer)=>{
            const data = new Uint8Array(arrayBuffer);
            const decodedMessage = $b4febe4ed2fc60b5$export$2f872c0f2117be69(data);
            const typeHandlers = {
                call: protocol._handleCall,
                response: protocol._handleResponse
            };
            const handler = typeHandlers[decodedMessage.type + ""];
            if (handler) handler(decodedMessage);
        },
        response: (uuid, success, data)=>{
            const binaryUuid = $fd28d333ad7e5007$require$uuidParse(uuid);
            const packet = {
                type: "response",
                id: binaryUuid,
                start: new Date(),
                data: data,
                success: success
            };
            const encodedPacket = $b4febe4ed2fc60b5$export$c564cdbbe6da493(packet);
            writeMethod(encodedPacket);
        },
        call: (name, data)=>{
            const uuid = $fd28d333ad7e5007$require$uuidV4();
            const binaryUuid = $fd28d333ad7e5007$require$uuidParse(uuid);
            const packet = {
                type: "call",
                id: binaryUuid,
                start: new Date(),
                command: name,
                data: data
            };
            const encodedPacket = $b4febe4ed2fc60b5$export$c564cdbbe6da493(packet);
            return new Promise((resolve, reject)=>{
                protocol._taskLookup[uuid] = {
                    resolve: resolve,
                    reject: reject
                };
                writeMethod(encodedPacket);
            });
        }
    };
    return protocol;
};


var $c53890eb3e021adc$exports = {};
var $5440e9199a418654$exports = {};
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
"use strict";
var $5440e9199a418654$var$R = typeof Reflect === "object" ? Reflect : null;
var $5440e9199a418654$var$ReflectApply = $5440e9199a418654$var$R && typeof $5440e9199a418654$var$R.apply === "function" ? $5440e9199a418654$var$R.apply : function ReflectApply(target, receiver, args) {
    return Function.prototype.apply.call(target, receiver, args);
};
var $5440e9199a418654$var$ReflectOwnKeys;
if ($5440e9199a418654$var$R && typeof $5440e9199a418654$var$R.ownKeys === "function") $5440e9199a418654$var$ReflectOwnKeys = $5440e9199a418654$var$R.ownKeys;
else if (Object.getOwnPropertySymbols) $5440e9199a418654$var$ReflectOwnKeys = function ReflectOwnKeys(target) {
    return Object.getOwnPropertyNames(target).concat(Object.getOwnPropertySymbols(target));
};
else $5440e9199a418654$var$ReflectOwnKeys = function ReflectOwnKeys(target) {
    return Object.getOwnPropertyNames(target);
};
function $5440e9199a418654$var$ProcessEmitWarning(warning) {
    if (console && console.warn) console.warn(warning);
}
var $5440e9199a418654$var$NumberIsNaN = Number.isNaN || function NumberIsNaN(value) {
    return value !== value;
};
function $5440e9199a418654$var$EventEmitter() {
    $5440e9199a418654$var$EventEmitter.init.call(this);
}
$5440e9199a418654$exports = $5440e9199a418654$var$EventEmitter;
$5440e9199a418654$exports.once = $5440e9199a418654$var$once;
// Backwards-compat with node 0.10.x
$5440e9199a418654$var$EventEmitter.EventEmitter = $5440e9199a418654$var$EventEmitter;
$5440e9199a418654$var$EventEmitter.prototype._events = undefined;
$5440e9199a418654$var$EventEmitter.prototype._eventsCount = 0;
$5440e9199a418654$var$EventEmitter.prototype._maxListeners = undefined;
// By default EventEmitters will print a warning if more than 10 listeners are
// added to it. This is a useful default which helps finding memory leaks.
var $5440e9199a418654$var$defaultMaxListeners = 10;
function $5440e9199a418654$var$checkListener(listener) {
    if (typeof listener !== "function") throw new TypeError('The "listener" argument must be of type Function. Received type ' + typeof listener);
}
Object.defineProperty($5440e9199a418654$var$EventEmitter, "defaultMaxListeners", {
    enumerable: true,
    get: function() {
        return $5440e9199a418654$var$defaultMaxListeners;
    },
    set: function(arg) {
        if (typeof arg !== "number" || arg < 0 || $5440e9199a418654$var$NumberIsNaN(arg)) throw new RangeError('The value of "defaultMaxListeners" is out of range. It must be a non-negative number. Received ' + arg + ".");
        $5440e9199a418654$var$defaultMaxListeners = arg;
    }
});
$5440e9199a418654$var$EventEmitter.init = function() {
    if (this._events === undefined || this._events === Object.getPrototypeOf(this)._events) {
        this._events = Object.create(null);
        this._eventsCount = 0;
    }
    this._maxListeners = this._maxListeners || undefined;
};
// Obviously not all Emitters should be limited to 10. This function allows
// that to be increased. Set to zero for unlimited.
$5440e9199a418654$var$EventEmitter.prototype.setMaxListeners = function setMaxListeners(n) {
    if (typeof n !== "number" || n < 0 || $5440e9199a418654$var$NumberIsNaN(n)) throw new RangeError('The value of "n" is out of range. It must be a non-negative number. Received ' + n + ".");
    this._maxListeners = n;
    return this;
};
function $5440e9199a418654$var$_getMaxListeners(that) {
    if (that._maxListeners === undefined) return $5440e9199a418654$var$EventEmitter.defaultMaxListeners;
    return that._maxListeners;
}
$5440e9199a418654$var$EventEmitter.prototype.getMaxListeners = function getMaxListeners() {
    return $5440e9199a418654$var$_getMaxListeners(this);
};
$5440e9199a418654$var$EventEmitter.prototype.emit = function emit(type) {
    var args = [];
    for(var i = 1; i < arguments.length; i++)args.push(arguments[i]);
    var doError = type === "error";
    var events = this._events;
    if (events !== undefined) doError = doError && events.error === undefined;
    else if (!doError) return false;
    // If there is no 'error' event listener then throw.
    if (doError) {
        var er;
        if (args.length > 0) er = args[0];
        if (er instanceof Error) // Note: The comments on the `throw` lines are intentional, they show
        // up in Node's output if this results in an unhandled exception.
        throw er; // Unhandled 'error' event
        // At least give some kind of context to the user
        var err = new Error("Unhandled error." + (er ? " (" + er.message + ")" : ""));
        err.context = er;
        throw err; // Unhandled 'error' event
    }
    var handler = events[type];
    if (handler === undefined) return false;
    if (typeof handler === "function") $5440e9199a418654$var$ReflectApply(handler, this, args);
    else {
        var len = handler.length;
        var listeners = $5440e9199a418654$var$arrayClone(handler, len);
        for(var i = 0; i < len; ++i)$5440e9199a418654$var$ReflectApply(listeners[i], this, args);
    }
    return true;
};
function $5440e9199a418654$var$_addListener(target, type, listener, prepend) {
    var m;
    var events;
    var existing;
    $5440e9199a418654$var$checkListener(listener);
    events = target._events;
    if (events === undefined) {
        events = target._events = Object.create(null);
        target._eventsCount = 0;
    } else {
        // To avoid recursion in the case that type === "newListener"! Before
        // adding it to the listeners, first emit "newListener".
        if (events.newListener !== undefined) {
            target.emit("newListener", type, listener.listener ? listener.listener : listener);
            // Re-assign `events` because a newListener handler could have caused the
            // this._events to be assigned to a new object
            events = target._events;
        }
        existing = events[type];
    }
    if (existing === undefined) {
        // Optimize the case of one listener. Don't need the extra array object.
        existing = events[type] = listener;
        ++target._eventsCount;
    } else {
        if (typeof existing === "function") // Adding the second element, need to change to array.
        existing = events[type] = prepend ? [
            listener,
            existing
        ] : [
            existing,
            listener
        ];
        else if (prepend) existing.unshift(listener);
        else existing.push(listener);
        // Check for listener leak
        m = $5440e9199a418654$var$_getMaxListeners(target);
        if (m > 0 && existing.length > m && !existing.warned) {
            existing.warned = true;
            // No error code for this since it is a Warning
            // eslint-disable-next-line no-restricted-syntax
            var w = new Error("Possible EventEmitter memory leak detected. " + existing.length + " " + String(type) + " listeners " + "added. Use emitter.setMaxListeners() to " + "increase limit");
            w.name = "MaxListenersExceededWarning";
            w.emitter = target;
            w.type = type;
            w.count = existing.length;
            $5440e9199a418654$var$ProcessEmitWarning(w);
        }
    }
    return target;
}
$5440e9199a418654$var$EventEmitter.prototype.addListener = function addListener(type, listener) {
    return $5440e9199a418654$var$_addListener(this, type, listener, false);
};
$5440e9199a418654$var$EventEmitter.prototype.on = $5440e9199a418654$var$EventEmitter.prototype.addListener;
$5440e9199a418654$var$EventEmitter.prototype.prependListener = function prependListener(type, listener) {
    return $5440e9199a418654$var$_addListener(this, type, listener, true);
};
function $5440e9199a418654$var$onceWrapper() {
    if (!this.fired) {
        this.target.removeListener(this.type, this.wrapFn);
        this.fired = true;
        if (arguments.length === 0) return this.listener.call(this.target);
        return this.listener.apply(this.target, arguments);
    }
}
function $5440e9199a418654$var$_onceWrap(target, type, listener) {
    var state = {
        fired: false,
        wrapFn: undefined,
        target: target,
        type: type,
        listener: listener
    };
    var wrapped = $5440e9199a418654$var$onceWrapper.bind(state);
    wrapped.listener = listener;
    state.wrapFn = wrapped;
    return wrapped;
}
$5440e9199a418654$var$EventEmitter.prototype.once = function once(type, listener) {
    $5440e9199a418654$var$checkListener(listener);
    this.on(type, $5440e9199a418654$var$_onceWrap(this, type, listener));
    return this;
};
$5440e9199a418654$var$EventEmitter.prototype.prependOnceListener = function prependOnceListener(type, listener) {
    $5440e9199a418654$var$checkListener(listener);
    this.prependListener(type, $5440e9199a418654$var$_onceWrap(this, type, listener));
    return this;
};
// Emits a 'removeListener' event if and only if the listener was removed.
$5440e9199a418654$var$EventEmitter.prototype.removeListener = function removeListener(type, listener) {
    var list, events, position, i, originalListener;
    $5440e9199a418654$var$checkListener(listener);
    events = this._events;
    if (events === undefined) return this;
    list = events[type];
    if (list === undefined) return this;
    if (list === listener || list.listener === listener) {
        if (--this._eventsCount === 0) this._events = Object.create(null);
        else {
            delete events[type];
            if (events.removeListener) this.emit("removeListener", type, list.listener || listener);
        }
    } else if (typeof list !== "function") {
        position = -1;
        for(i = list.length - 1; i >= 0; i--)if (list[i] === listener || list[i].listener === listener) {
            originalListener = list[i].listener;
            position = i;
            break;
        }
        if (position < 0) return this;
        if (position === 0) list.shift();
        else $5440e9199a418654$var$spliceOne(list, position);
        if (list.length === 1) events[type] = list[0];
        if (events.removeListener !== undefined) this.emit("removeListener", type, originalListener || listener);
    }
    return this;
};
$5440e9199a418654$var$EventEmitter.prototype.off = $5440e9199a418654$var$EventEmitter.prototype.removeListener;
$5440e9199a418654$var$EventEmitter.prototype.removeAllListeners = function removeAllListeners(type) {
    var listeners, events, i;
    events = this._events;
    if (events === undefined) return this;
    // not listening for removeListener, no need to emit
    if (events.removeListener === undefined) {
        if (arguments.length === 0) {
            this._events = Object.create(null);
            this._eventsCount = 0;
        } else if (events[type] !== undefined) {
            if (--this._eventsCount === 0) this._events = Object.create(null);
            else delete events[type];
        }
        return this;
    }
    // emit removeListener for all listeners on all events
    if (arguments.length === 0) {
        var keys = Object.keys(events);
        var key;
        for(i = 0; i < keys.length; ++i){
            key = keys[i];
            if (key === "removeListener") continue;
            this.removeAllListeners(key);
        }
        this.removeAllListeners("removeListener");
        this._events = Object.create(null);
        this._eventsCount = 0;
        return this;
    }
    listeners = events[type];
    if (typeof listeners === "function") this.removeListener(type, listeners);
    else if (listeners !== undefined) // LIFO order
    for(i = listeners.length - 1; i >= 0; i--)this.removeListener(type, listeners[i]);
    return this;
};
function $5440e9199a418654$var$_listeners(target, type, unwrap) {
    var events = target._events;
    if (events === undefined) return [];
    var evlistener = events[type];
    if (evlistener === undefined) return [];
    if (typeof evlistener === "function") return unwrap ? [
        evlistener.listener || evlistener
    ] : [
        evlistener
    ];
    return unwrap ? $5440e9199a418654$var$unwrapListeners(evlistener) : $5440e9199a418654$var$arrayClone(evlistener, evlistener.length);
}
$5440e9199a418654$var$EventEmitter.prototype.listeners = function listeners(type) {
    return $5440e9199a418654$var$_listeners(this, type, true);
};
$5440e9199a418654$var$EventEmitter.prototype.rawListeners = function rawListeners(type) {
    return $5440e9199a418654$var$_listeners(this, type, false);
};
$5440e9199a418654$var$EventEmitter.listenerCount = function(emitter, type) {
    if (typeof emitter.listenerCount === "function") return emitter.listenerCount(type);
    else return $5440e9199a418654$var$listenerCount.call(emitter, type);
};
$5440e9199a418654$var$EventEmitter.prototype.listenerCount = $5440e9199a418654$var$listenerCount;
function $5440e9199a418654$var$listenerCount(type) {
    var events = this._events;
    if (events !== undefined) {
        var evlistener = events[type];
        if (typeof evlistener === "function") return 1;
        else if (evlistener !== undefined) return evlistener.length;
    }
    return 0;
}
$5440e9199a418654$var$EventEmitter.prototype.eventNames = function eventNames() {
    return this._eventsCount > 0 ? $5440e9199a418654$var$ReflectOwnKeys(this._events) : [];
};
function $5440e9199a418654$var$arrayClone(arr, n) {
    var copy = new Array(n);
    for(var i = 0; i < n; ++i)copy[i] = arr[i];
    return copy;
}
function $5440e9199a418654$var$spliceOne(list, index) {
    for(; index + 1 < list.length; index++)list[index] = list[index + 1];
    list.pop();
}
function $5440e9199a418654$var$unwrapListeners(arr) {
    var ret = new Array(arr.length);
    for(var i = 0; i < ret.length; ++i)ret[i] = arr[i].listener || arr[i];
    return ret;
}
function $5440e9199a418654$var$once(emitter, name) {
    return new Promise(function(resolve, reject) {
        function errorListener(err) {
            emitter.removeListener(name, resolver);
            reject(err);
        }
        function resolver() {
            if (typeof emitter.removeListener === "function") emitter.removeListener("error", errorListener);
            resolve([].slice.call(arguments));
        }
        $5440e9199a418654$var$eventTargetAgnosticAddListener(emitter, name, resolver, {
            once: true
        });
        if (name !== "error") $5440e9199a418654$var$addErrorHandlerIfEventEmitter(emitter, errorListener, {
            once: true
        });
    });
}
function $5440e9199a418654$var$addErrorHandlerIfEventEmitter(emitter, handler, flags) {
    if (typeof emitter.on === "function") $5440e9199a418654$var$eventTargetAgnosticAddListener(emitter, "error", handler, flags);
}
function $5440e9199a418654$var$eventTargetAgnosticAddListener(emitter, name, listener, flags) {
    if (typeof emitter.on === "function") {
        if (flags.once) emitter.once(name, listener);
        else emitter.on(name, listener);
    } else if (typeof emitter.addEventListener === "function") // EventTarget does not have `error` event semantics like Node
    // EventEmitters, we do not listen for `error` events here.
    emitter.addEventListener(name, function wrapListener(arg) {
        // IE does not have builtin `{ once: true }` support so we
        // have to do it manually.
        if (flags.once) emitter.removeEventListener(name, wrapListener);
        listener(arg);
    });
    else throw new TypeError('The "emitter" argument must be of type EventEmitter. Received type ' + typeof emitter);
}


var $5e0eb040f3eceaa7$exports = {};
var $f2be4bfe7faad0b8$exports = {};
/**
 * @author Toru Nagashima <https://github.com/mysticatea>
 * @copyright 2015 Toru Nagashima. All rights reserved.
 * See LICENSE file in root directory for full license.
 */ "use strict";
Object.defineProperty($f2be4bfe7faad0b8$exports, "__esModule", {
    value: true
});
/**
 * @typedef {object} PrivateData
 * @property {EventTarget} eventTarget The event target.
 * @property {{type:string}} event The original event object.
 * @property {number} eventPhase The current event phase.
 * @property {EventTarget|null} currentTarget The current event target.
 * @property {boolean} canceled The flag to prevent default.
 * @property {boolean} stopped The flag to stop propagation immediately.
 * @property {Function|null} passiveListener The listener if the current listener is passive. Otherwise this is null.
 * @property {number} timeStamp The unix time.
 * @private
 */ /**
 * Private data for event wrappers.
 * @type {WeakMap<Event, PrivateData>}
 * @private
 */ const $f2be4bfe7faad0b8$var$privateData = new WeakMap();
/**
 * Cache for wrapper classes.
 * @type {WeakMap<Object, Function>}
 * @private
 */ const $f2be4bfe7faad0b8$var$wrappers = new WeakMap();
/**
 * Get private data.
 * @param {Event} event The event object to get private data.
 * @returns {PrivateData} The private data of the event.
 * @private
 */ function $f2be4bfe7faad0b8$var$pd(event) {
    const retv = $f2be4bfe7faad0b8$var$privateData.get(event);
    console.assert(retv != null, "'this' is expected an Event object, but got", event);
    return retv;
}
/**
 * @see https://dom.spec.whatwg.org/#interface-event
 * @private
 */ /**
 * The event wrapper.
 * @constructor
 * @param {EventTarget} eventTarget The event target of this dispatching.
 * @param {Event|{type:string}} event The original event to wrap.
 */ function $f2be4bfe7faad0b8$var$Event(eventTarget, event) {
    $f2be4bfe7faad0b8$var$privateData.set(this, {
        eventTarget: eventTarget,
        event: event,
        eventPhase: 2,
        currentTarget: eventTarget,
        canceled: false,
        stopped: false,
        passiveListener: null,
        timeStamp: event.timeStamp || Date.now()
    });
    // https://heycam.github.io/webidl/#Unforgeable
    Object.defineProperty(this, "isTrusted", {
        value: false,
        enumerable: true
    });
    // Define accessors
    const keys = Object.keys(event);
    for(let i = 0; i < keys.length; ++i){
        const key = keys[i];
        if (!(key in this)) Object.defineProperty(this, key, $f2be4bfe7faad0b8$var$defineRedirectDescriptor(key));
    }
}
// Should be enumerable, but class methods are not enumerable.
$f2be4bfe7faad0b8$var$Event.prototype = {
    /**
     * The type of this event.
     * @type {string}
     */ get type () {
        return $f2be4bfe7faad0b8$var$pd(this).event.type;
    },
    /**
     * The target of this event.
     * @type {EventTarget}
     */ get target () {
        return $f2be4bfe7faad0b8$var$pd(this).eventTarget;
    },
    /**
     * The target of this event.
     * @type {EventTarget}
     */ get currentTarget () {
        return $f2be4bfe7faad0b8$var$pd(this).currentTarget;
    },
    /**
     * @returns {EventTarget[]} The composed path of this event.
     */ composedPath () {
        const currentTarget = $f2be4bfe7faad0b8$var$pd(this).currentTarget;
        if (currentTarget == null) return [];
        return [
            currentTarget
        ];
    },
    /**
     * Constant of NONE.
     * @type {number}
     */ get NONE () {
        return 0;
    },
    /**
     * Constant of CAPTURING_PHASE.
     * @type {number}
     */ get CAPTURING_PHASE () {
        return 1;
    },
    /**
     * Constant of AT_TARGET.
     * @type {number}
     */ get AT_TARGET () {
        return 2;
    },
    /**
     * Constant of BUBBLING_PHASE.
     * @type {number}
     */ get BUBBLING_PHASE () {
        return 3;
    },
    /**
     * The target of this event.
     * @type {number}
     */ get eventPhase () {
        return $f2be4bfe7faad0b8$var$pd(this).eventPhase;
    },
    /**
     * Stop event bubbling.
     * @returns {void}
     */ stopPropagation () {
        const data = $f2be4bfe7faad0b8$var$pd(this);
        if (typeof data.event.stopPropagation === "function") data.event.stopPropagation();
    },
    /**
     * Stop event bubbling.
     * @returns {void}
     */ stopImmediatePropagation () {
        const data = $f2be4bfe7faad0b8$var$pd(this);
        data.stopped = true;
        if (typeof data.event.stopImmediatePropagation === "function") data.event.stopImmediatePropagation();
    },
    /**
     * The flag to be bubbling.
     * @type {boolean}
     */ get bubbles () {
        return Boolean($f2be4bfe7faad0b8$var$pd(this).event.bubbles);
    },
    /**
     * The flag to be cancelable.
     * @type {boolean}
     */ get cancelable () {
        return Boolean($f2be4bfe7faad0b8$var$pd(this).event.cancelable);
    },
    /**
     * Cancel this event.
     * @returns {void}
     */ preventDefault () {
        const data = $f2be4bfe7faad0b8$var$pd(this);
        if (data.passiveListener != null) {
            console.warn("Event#preventDefault() was called from a passive listener:", data.passiveListener);
            return;
        }
        if (!data.event.cancelable) return;
        data.canceled = true;
        if (typeof data.event.preventDefault === "function") data.event.preventDefault();
    },
    /**
     * The flag to indicate cancellation state.
     * @type {boolean}
     */ get defaultPrevented () {
        return $f2be4bfe7faad0b8$var$pd(this).canceled;
    },
    /**
     * The flag to be composed.
     * @type {boolean}
     */ get composed () {
        return Boolean($f2be4bfe7faad0b8$var$pd(this).event.composed);
    },
    /**
     * The unix time of this event.
     * @type {number}
     */ get timeStamp () {
        return $f2be4bfe7faad0b8$var$pd(this).timeStamp;
    }
};
// `constructor` is not enumerable.
Object.defineProperty($f2be4bfe7faad0b8$var$Event.prototype, "constructor", {
    value: $f2be4bfe7faad0b8$var$Event,
    configurable: true,
    writable: true
});
// Ensure `event instanceof window.Event` is `true`.
if (typeof window !== "undefined" && typeof window.Event !== "undefined") {
    Object.setPrototypeOf($f2be4bfe7faad0b8$var$Event.prototype, window.Event.prototype);
    // Make association for wrappers.
    $f2be4bfe7faad0b8$var$wrappers.set(window.Event.prototype, $f2be4bfe7faad0b8$var$Event);
}
/**
 * Get the property descriptor to redirect a given property.
 * @param {string} key Property name to define property descriptor.
 * @returns {PropertyDescriptor} The property descriptor to redirect the property.
 * @private
 */ function $f2be4bfe7faad0b8$var$defineRedirectDescriptor(key) {
    return {
        get () {
            return $f2be4bfe7faad0b8$var$pd(this).event[key];
        },
        set (value) {
            $f2be4bfe7faad0b8$var$pd(this).event[key] = value;
        },
        configurable: true,
        enumerable: true
    };
}
/**
 * Get the property descriptor to call a given method property.
 * @param {string} key Property name to define property descriptor.
 * @returns {PropertyDescriptor} The property descriptor to call the method property.
 * @private
 */ function $f2be4bfe7faad0b8$var$defineCallDescriptor(key) {
    return {
        value () {
            const event = $f2be4bfe7faad0b8$var$pd(this).event;
            return event[key].apply(event, arguments);
        },
        configurable: true,
        enumerable: true
    };
}
/**
 * Define new wrapper class.
 * @param {Function} BaseEvent The base wrapper class.
 * @param {Object} proto The prototype of the original event.
 * @returns {Function} The defined wrapper class.
 * @private
 */ function $f2be4bfe7faad0b8$var$defineWrapper(BaseEvent, proto) {
    const keys = Object.keys(proto);
    if (keys.length === 0) return BaseEvent;
    /** CustomEvent */ function CustomEvent(eventTarget, event) {
        BaseEvent.call(this, eventTarget, event);
    }
    CustomEvent.prototype = Object.create(BaseEvent.prototype, {
        constructor: {
            value: CustomEvent,
            configurable: true,
            writable: true
        }
    });
    // Define accessors.
    for(let i = 0; i < keys.length; ++i){
        const key = keys[i];
        if (!(key in BaseEvent.prototype)) {
            const descriptor = Object.getOwnPropertyDescriptor(proto, key);
            const isFunc = typeof descriptor.value === "function";
            Object.defineProperty(CustomEvent.prototype, key, isFunc ? $f2be4bfe7faad0b8$var$defineCallDescriptor(key) : $f2be4bfe7faad0b8$var$defineRedirectDescriptor(key));
        }
    }
    return CustomEvent;
}
/**
 * Get the wrapper class of a given prototype.
 * @param {Object} proto The prototype of the original event to get its wrapper.
 * @returns {Function} The wrapper class.
 * @private
 */ function $f2be4bfe7faad0b8$var$getWrapper(proto) {
    if (proto == null || proto === Object.prototype) return $f2be4bfe7faad0b8$var$Event;
    let wrapper = $f2be4bfe7faad0b8$var$wrappers.get(proto);
    if (wrapper == null) {
        wrapper = $f2be4bfe7faad0b8$var$defineWrapper($f2be4bfe7faad0b8$var$getWrapper(Object.getPrototypeOf(proto)), proto);
        $f2be4bfe7faad0b8$var$wrappers.set(proto, wrapper);
    }
    return wrapper;
}
/**
 * Wrap a given event to management a dispatching.
 * @param {EventTarget} eventTarget The event target of this dispatching.
 * @param {Object} event The event to wrap.
 * @returns {Event} The wrapper instance.
 * @private
 */ function $f2be4bfe7faad0b8$var$wrapEvent(eventTarget, event) {
    const Wrapper = $f2be4bfe7faad0b8$var$getWrapper(Object.getPrototypeOf(event));
    return new Wrapper(eventTarget, event);
}
/**
 * Get the stopped flag of a given event.
 * @param {Event} event The event to get.
 * @returns {boolean} The flag to stop propagation immediately.
 * @private
 */ function $f2be4bfe7faad0b8$var$isStopped(event) {
    return $f2be4bfe7faad0b8$var$pd(event).stopped;
}
/**
 * Set the current event phase of a given event.
 * @param {Event} event The event to set current target.
 * @param {number} eventPhase New event phase.
 * @returns {void}
 * @private
 */ function $f2be4bfe7faad0b8$var$setEventPhase(event, eventPhase) {
    $f2be4bfe7faad0b8$var$pd(event).eventPhase = eventPhase;
}
/**
 * Set the current target of a given event.
 * @param {Event} event The event to set current target.
 * @param {EventTarget|null} currentTarget New current target.
 * @returns {void}
 * @private
 */ function $f2be4bfe7faad0b8$var$setCurrentTarget(event, currentTarget) {
    $f2be4bfe7faad0b8$var$pd(event).currentTarget = currentTarget;
}
/**
 * Set a passive listener of a given event.
 * @param {Event} event The event to set current target.
 * @param {Function|null} passiveListener New passive listener.
 * @returns {void}
 * @private
 */ function $f2be4bfe7faad0b8$var$setPassiveListener(event, passiveListener) {
    $f2be4bfe7faad0b8$var$pd(event).passiveListener = passiveListener;
}
/**
 * @typedef {object} ListenerNode
 * @property {Function} listener
 * @property {1|2|3} listenerType
 * @property {boolean} passive
 * @property {boolean} once
 * @property {ListenerNode|null} next
 * @private
 */ /**
 * @type {WeakMap<object, Map<string, ListenerNode>>}
 * @private
 */ const $f2be4bfe7faad0b8$var$listenersMap = new WeakMap();
// Listener types
const $f2be4bfe7faad0b8$var$CAPTURE = 1;
const $f2be4bfe7faad0b8$var$BUBBLE = 2;
const $f2be4bfe7faad0b8$var$ATTRIBUTE = 3;
/**
 * Check whether a given value is an object or not.
 * @param {any} x The value to check.
 * @returns {boolean} `true` if the value is an object.
 */ function $f2be4bfe7faad0b8$var$isObject(x) {
    return x !== null && typeof x === "object" //eslint-disable-line no-restricted-syntax
    ;
}
/**
 * Get listeners.
 * @param {EventTarget} eventTarget The event target to get.
 * @returns {Map<string, ListenerNode>} The listeners.
 * @private
 */ function $f2be4bfe7faad0b8$var$getListeners(eventTarget) {
    const listeners = $f2be4bfe7faad0b8$var$listenersMap.get(eventTarget);
    if (listeners == null) throw new TypeError("'this' is expected an EventTarget object, but got another value.");
    return listeners;
}
/**
 * Get the property descriptor for the event attribute of a given event.
 * @param {string} eventName The event name to get property descriptor.
 * @returns {PropertyDescriptor} The property descriptor.
 * @private
 */ function $f2be4bfe7faad0b8$var$defineEventAttributeDescriptor(eventName) {
    return {
        get () {
            const listeners = $f2be4bfe7faad0b8$var$getListeners(this);
            let node = listeners.get(eventName);
            while(node != null){
                if (node.listenerType === $f2be4bfe7faad0b8$var$ATTRIBUTE) return node.listener;
                node = node.next;
            }
            return null;
        },
        set (listener) {
            if (typeof listener !== "function" && !$f2be4bfe7faad0b8$var$isObject(listener)) listener = null; // eslint-disable-line no-param-reassign
            const listeners = $f2be4bfe7faad0b8$var$getListeners(this);
            // Traverse to the tail while removing old value.
            let prev = null;
            let node = listeners.get(eventName);
            while(node != null){
                if (node.listenerType === $f2be4bfe7faad0b8$var$ATTRIBUTE) {
                    // Remove old value.
                    if (prev !== null) prev.next = node.next;
                    else if (node.next !== null) listeners.set(eventName, node.next);
                    else listeners.delete(eventName);
                } else prev = node;
                node = node.next;
            }
            // Add new value.
            if (listener !== null) {
                const newNode = {
                    listener: listener,
                    listenerType: $f2be4bfe7faad0b8$var$ATTRIBUTE,
                    passive: false,
                    once: false,
                    next: null
                };
                if (prev === null) listeners.set(eventName, newNode);
                else prev.next = newNode;
            }
        },
        configurable: true,
        enumerable: true
    };
}
/**
 * Define an event attribute (e.g. `eventTarget.onclick`).
 * @param {Object} eventTargetPrototype The event target prototype to define an event attrbite.
 * @param {string} eventName The event name to define.
 * @returns {void}
 */ function $f2be4bfe7faad0b8$var$defineEventAttribute(eventTargetPrototype, eventName) {
    Object.defineProperty(eventTargetPrototype, `on${eventName}`, $f2be4bfe7faad0b8$var$defineEventAttributeDescriptor(eventName));
}
/**
 * Define a custom EventTarget with event attributes.
 * @param {string[]} eventNames Event names for event attributes.
 * @returns {EventTarget} The custom EventTarget.
 * @private
 */ function $f2be4bfe7faad0b8$var$defineCustomEventTarget(eventNames) {
    /** CustomEventTarget */ function CustomEventTarget() {
        $f2be4bfe7faad0b8$var$EventTarget.call(this);
    }
    CustomEventTarget.prototype = Object.create($f2be4bfe7faad0b8$var$EventTarget.prototype, {
        constructor: {
            value: CustomEventTarget,
            configurable: true,
            writable: true
        }
    });
    for(let i = 0; i < eventNames.length; ++i)$f2be4bfe7faad0b8$var$defineEventAttribute(CustomEventTarget.prototype, eventNames[i]);
    return CustomEventTarget;
}
/**
 * EventTarget.
 *
 * - This is constructor if no arguments.
 * - This is a function which returns a CustomEventTarget constructor if there are arguments.
 *
 * For example:
 *
 *     class A extends EventTarget {}
 *     class B extends EventTarget("message") {}
 *     class C extends EventTarget("message", "error") {}
 *     class D extends EventTarget(["message", "error"]) {}
 */ function $f2be4bfe7faad0b8$var$EventTarget() {
    /*eslint-disable consistent-return */ if (this instanceof $f2be4bfe7faad0b8$var$EventTarget) {
        $f2be4bfe7faad0b8$var$listenersMap.set(this, new Map());
        return;
    }
    if (arguments.length === 1 && Array.isArray(arguments[0])) return $f2be4bfe7faad0b8$var$defineCustomEventTarget(arguments[0]);
    if (arguments.length > 0) {
        const types = new Array(arguments.length);
        for(let i = 0; i < arguments.length; ++i)types[i] = arguments[i];
        return $f2be4bfe7faad0b8$var$defineCustomEventTarget(types);
    }
    throw new TypeError("Cannot call a class as a function");
/*eslint-enable consistent-return */ }
// Should be enumerable, but class methods are not enumerable.
$f2be4bfe7faad0b8$var$EventTarget.prototype = {
    /**
     * Add a given listener to this event target.
     * @param {string} eventName The event name to add.
     * @param {Function} listener The listener to add.
     * @param {boolean|{capture?:boolean,passive?:boolean,once?:boolean}} [options] The options for this listener.
     * @returns {boolean} `true` if the listener was added actually.
     */ addEventListener (eventName, listener, options) {
        if (listener == null) return false;
        if (typeof listener !== "function" && !$f2be4bfe7faad0b8$var$isObject(listener)) throw new TypeError("'listener' should be a function or an object.");
        const listeners = $f2be4bfe7faad0b8$var$getListeners(this);
        const optionsIsObj = $f2be4bfe7faad0b8$var$isObject(options);
        const capture = optionsIsObj ? Boolean(options.capture) : Boolean(options);
        const listenerType = capture ? $f2be4bfe7faad0b8$var$CAPTURE : $f2be4bfe7faad0b8$var$BUBBLE;
        const newNode = {
            listener: listener,
            listenerType: listenerType,
            passive: optionsIsObj && Boolean(options.passive),
            once: optionsIsObj && Boolean(options.once),
            next: null
        };
        // Set it as the first node if the first node is null.
        let node = listeners.get(eventName);
        if (node === undefined) {
            listeners.set(eventName, newNode);
            return true;
        }
        // Traverse to the tail while checking duplication..
        let prev = null;
        while(node != null){
            if (node.listener === listener && node.listenerType === listenerType) // Should ignore duplication.
            return false;
            prev = node;
            node = node.next;
        }
        // Add it.
        prev.next = newNode;
        return true;
    },
    /**
     * Remove a given listener from this event target.
     * @param {string} eventName The event name to remove.
     * @param {Function} listener The listener to remove.
     * @param {boolean|{capture?:boolean,passive?:boolean,once?:boolean}} [options] The options for this listener.
     * @returns {boolean} `true` if the listener was removed actually.
     */ removeEventListener (eventName, listener, options) {
        if (listener == null) return false;
        const listeners = $f2be4bfe7faad0b8$var$getListeners(this);
        const capture = $f2be4bfe7faad0b8$var$isObject(options) ? Boolean(options.capture) : Boolean(options);
        const listenerType = capture ? $f2be4bfe7faad0b8$var$CAPTURE : $f2be4bfe7faad0b8$var$BUBBLE;
        let prev = null;
        let node = listeners.get(eventName);
        while(node != null){
            if (node.listener === listener && node.listenerType === listenerType) {
                if (prev !== null) prev.next = node.next;
                else if (node.next !== null) listeners.set(eventName, node.next);
                else listeners.delete(eventName);
                return true;
            }
            prev = node;
            node = node.next;
        }
        return false;
    },
    /**
     * Dispatch a given event.
     * @param {Event|{type:string}} event The event to dispatch.
     * @returns {boolean} `false` if canceled.
     */ dispatchEvent (event) {
        if (event == null || typeof event.type !== "string") throw new TypeError('"event.type" should be a string.');
        // If listeners aren't registered, terminate.
        const listeners = $f2be4bfe7faad0b8$var$getListeners(this);
        const eventName = event.type;
        let node = listeners.get(eventName);
        if (node == null) return true;
        // Since we cannot rewrite several properties, so wrap object.
        const wrappedEvent = $f2be4bfe7faad0b8$var$wrapEvent(this, event);
        // This doesn't process capturing phase and bubbling phase.
        // This isn't participating in a tree.
        let prev = null;
        while(node != null){
            // Remove this listener if it's once
            if (node.once) {
                if (prev !== null) prev.next = node.next;
                else if (node.next !== null) listeners.set(eventName, node.next);
                else listeners.delete(eventName);
            } else prev = node;
            // Call this listener
            $f2be4bfe7faad0b8$var$setPassiveListener(wrappedEvent, node.passive ? node.listener : null);
            if (typeof node.listener === "function") try {
                node.listener.call(this, wrappedEvent);
            } catch (err) {
                /*eslint-disable no-console */ if (typeof console !== "undefined" && typeof console.error === "function") console.error(err);
            /*eslint-enable no-console */ }
            else if (node.listenerType !== $f2be4bfe7faad0b8$var$ATTRIBUTE && typeof node.listener.handleEvent === "function") node.listener.handleEvent(wrappedEvent);
            // Break if `event.stopImmediatePropagation` was called.
            if ($f2be4bfe7faad0b8$var$isStopped(wrappedEvent)) break;
            node = node.next;
        }
        $f2be4bfe7faad0b8$var$setPassiveListener(wrappedEvent, null);
        $f2be4bfe7faad0b8$var$setEventPhase(wrappedEvent, 0);
        $f2be4bfe7faad0b8$var$setCurrentTarget(wrappedEvent, null);
        return !wrappedEvent.defaultPrevented;
    }
};
// `constructor` is not enumerable.
Object.defineProperty($f2be4bfe7faad0b8$var$EventTarget.prototype, "constructor", {
    value: $f2be4bfe7faad0b8$var$EventTarget,
    configurable: true,
    writable: true
});
// Ensure `eventTarget instanceof window.EventTarget` is `true`.
if (typeof window !== "undefined" && typeof window.EventTarget !== "undefined") Object.setPrototypeOf($f2be4bfe7faad0b8$var$EventTarget.prototype, window.EventTarget.prototype);
$f2be4bfe7faad0b8$exports.defineEventAttribute = $f2be4bfe7faad0b8$var$defineEventAttribute;
$f2be4bfe7faad0b8$exports.EventTarget = $f2be4bfe7faad0b8$var$EventTarget;
$f2be4bfe7faad0b8$exports.default = $f2be4bfe7faad0b8$var$EventTarget;
$f2be4bfe7faad0b8$exports = $f2be4bfe7faad0b8$var$EventTarget;
$f2be4bfe7faad0b8$exports.EventTarget = $f2be4bfe7faad0b8$exports["default"] = $f2be4bfe7faad0b8$var$EventTarget;
$f2be4bfe7faad0b8$exports.defineEventAttribute = $f2be4bfe7faad0b8$var$defineEventAttribute;


var $5e0eb040f3eceaa7$require$EventTarget = $f2be4bfe7faad0b8$exports.EventTarget;
var $5e0eb040f3eceaa7$require$defineEventAttribute = $f2be4bfe7faad0b8$exports.defineEventAttribute;
var $cbcee261d685d22a$exports = {};
var $cfae44f0dfdf62c0$exports = {};
// shim for using process in browser
var $cfae44f0dfdf62c0$var$process = $cfae44f0dfdf62c0$exports = {};
// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.
var $cfae44f0dfdf62c0$var$cachedSetTimeout;
var $cfae44f0dfdf62c0$var$cachedClearTimeout;
function $cfae44f0dfdf62c0$var$defaultSetTimout() {
    throw new Error("setTimeout has not been defined");
}
function $cfae44f0dfdf62c0$var$defaultClearTimeout() {
    throw new Error("clearTimeout has not been defined");
}
(function() {
    try {
        if (typeof setTimeout === "function") $cfae44f0dfdf62c0$var$cachedSetTimeout = setTimeout;
        else $cfae44f0dfdf62c0$var$cachedSetTimeout = $cfae44f0dfdf62c0$var$defaultSetTimout;
    } catch (e) {
        $cfae44f0dfdf62c0$var$cachedSetTimeout = $cfae44f0dfdf62c0$var$defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === "function") $cfae44f0dfdf62c0$var$cachedClearTimeout = clearTimeout;
        else $cfae44f0dfdf62c0$var$cachedClearTimeout = $cfae44f0dfdf62c0$var$defaultClearTimeout;
    } catch (e) {
        $cfae44f0dfdf62c0$var$cachedClearTimeout = $cfae44f0dfdf62c0$var$defaultClearTimeout;
    }
})();
function $cfae44f0dfdf62c0$var$runTimeout(fun) {
    if ($cfae44f0dfdf62c0$var$cachedSetTimeout === setTimeout) //normal enviroments in sane situations
    return setTimeout(fun, 0);
    // if setTimeout wasn't available but was latter defined
    if (($cfae44f0dfdf62c0$var$cachedSetTimeout === $cfae44f0dfdf62c0$var$defaultSetTimout || !$cfae44f0dfdf62c0$var$cachedSetTimeout) && setTimeout) {
        $cfae44f0dfdf62c0$var$cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $cfae44f0dfdf62c0$var$cachedSetTimeout(fun, 0);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return $cfae44f0dfdf62c0$var$cachedSetTimeout.call(null, fun, 0);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return $cfae44f0dfdf62c0$var$cachedSetTimeout.call(this, fun, 0);
        }
    }
}
function $cfae44f0dfdf62c0$var$runClearTimeout(marker) {
    if ($cfae44f0dfdf62c0$var$cachedClearTimeout === clearTimeout) //normal enviroments in sane situations
    return clearTimeout(marker);
    // if clearTimeout wasn't available but was latter defined
    if (($cfae44f0dfdf62c0$var$cachedClearTimeout === $cfae44f0dfdf62c0$var$defaultClearTimeout || !$cfae44f0dfdf62c0$var$cachedClearTimeout) && clearTimeout) {
        $cfae44f0dfdf62c0$var$cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $cfae44f0dfdf62c0$var$cachedClearTimeout(marker);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return $cfae44f0dfdf62c0$var$cachedClearTimeout.call(null, marker);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return $cfae44f0dfdf62c0$var$cachedClearTimeout.call(this, marker);
        }
    }
}
var $cfae44f0dfdf62c0$var$queue = [];
var $cfae44f0dfdf62c0$var$draining = false;
var $cfae44f0dfdf62c0$var$currentQueue;
var $cfae44f0dfdf62c0$var$queueIndex = -1;
function $cfae44f0dfdf62c0$var$cleanUpNextTick() {
    if (!$cfae44f0dfdf62c0$var$draining || !$cfae44f0dfdf62c0$var$currentQueue) return;
    $cfae44f0dfdf62c0$var$draining = false;
    if ($cfae44f0dfdf62c0$var$currentQueue.length) $cfae44f0dfdf62c0$var$queue = $cfae44f0dfdf62c0$var$currentQueue.concat($cfae44f0dfdf62c0$var$queue);
    else $cfae44f0dfdf62c0$var$queueIndex = -1;
    if ($cfae44f0dfdf62c0$var$queue.length) $cfae44f0dfdf62c0$var$drainQueue();
}
function $cfae44f0dfdf62c0$var$drainQueue() {
    if ($cfae44f0dfdf62c0$var$draining) return;
    var timeout = $cfae44f0dfdf62c0$var$runTimeout($cfae44f0dfdf62c0$var$cleanUpNextTick);
    $cfae44f0dfdf62c0$var$draining = true;
    var len = $cfae44f0dfdf62c0$var$queue.length;
    while(len){
        $cfae44f0dfdf62c0$var$currentQueue = $cfae44f0dfdf62c0$var$queue;
        $cfae44f0dfdf62c0$var$queue = [];
        while(++$cfae44f0dfdf62c0$var$queueIndex < len)if ($cfae44f0dfdf62c0$var$currentQueue) $cfae44f0dfdf62c0$var$currentQueue[$cfae44f0dfdf62c0$var$queueIndex].run();
        $cfae44f0dfdf62c0$var$queueIndex = -1;
        len = $cfae44f0dfdf62c0$var$queue.length;
    }
    $cfae44f0dfdf62c0$var$currentQueue = null;
    $cfae44f0dfdf62c0$var$draining = false;
    $cfae44f0dfdf62c0$var$runClearTimeout(timeout);
}
$cfae44f0dfdf62c0$var$process.nextTick = function(fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) for(var i = 1; i < arguments.length; i++)args[i - 1] = arguments[i];
    $cfae44f0dfdf62c0$var$queue.push(new $cfae44f0dfdf62c0$var$Item(fun, args));
    if ($cfae44f0dfdf62c0$var$queue.length === 1 && !$cfae44f0dfdf62c0$var$draining) $cfae44f0dfdf62c0$var$runTimeout($cfae44f0dfdf62c0$var$drainQueue);
};
// v8 likes predictible objects
function $cfae44f0dfdf62c0$var$Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
$cfae44f0dfdf62c0$var$Item.prototype.run = function() {
    this.fun.apply(null, this.array);
};
$cfae44f0dfdf62c0$var$process.title = "browser";
$cfae44f0dfdf62c0$var$process.browser = true;
$cfae44f0dfdf62c0$var$process.env = {};
$cfae44f0dfdf62c0$var$process.argv = [];
$cfae44f0dfdf62c0$var$process.version = ""; // empty string to avoid regexp issues
$cfae44f0dfdf62c0$var$process.versions = {};
function $cfae44f0dfdf62c0$var$noop() {}
$cfae44f0dfdf62c0$var$process.on = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.addListener = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.once = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.off = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.removeListener = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.removeAllListeners = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.emit = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.prependListener = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.prependOnceListener = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.listeners = function(name) {
    return [];
};
$cfae44f0dfdf62c0$var$process.binding = function(name) {
    throw new Error("process.binding is not supported");
};
$cfae44f0dfdf62c0$var$process.cwd = function() {
    return "/";
};
$cfae44f0dfdf62c0$var$process.chdir = function(dir) {
    throw new Error("process.chdir is not supported");
};
$cfae44f0dfdf62c0$var$process.umask = function() {
    return 0;
};


"use strict";
var $cbcee261d685d22a$var$__spreadArrays = $cbcee261d685d22a$exports && $cbcee261d685d22a$exports.__spreadArrays || function() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
};
Object.defineProperty($cbcee261d685d22a$exports, "__esModule", {
    value: true
});
var $cbcee261d685d22a$var$BrowserInfo = /** @class */ function() {
    function BrowserInfo(name, version, os) {
        this.name = name;
        this.version = version;
        this.os = os;
    }
    return BrowserInfo;
}();
$cbcee261d685d22a$exports.BrowserInfo = $cbcee261d685d22a$var$BrowserInfo;
var $cbcee261d685d22a$var$NodeInfo = /** @class */ function() {
    function NodeInfo(version) {
        this.version = version;
        this.name = "node";
        this.os = $cfae44f0dfdf62c0$exports.platform;
    }
    return NodeInfo;
}();
$cbcee261d685d22a$exports.NodeInfo = $cbcee261d685d22a$var$NodeInfo;
var $cbcee261d685d22a$var$BotInfo = /** @class */ function() {
    function BotInfo() {
        this.bot = true; // NOTE: deprecated test name instead
        this.name = "bot";
        this.version = null;
        this.os = null;
    }
    return BotInfo;
}();
$cbcee261d685d22a$exports.BotInfo = $cbcee261d685d22a$var$BotInfo;
// tslint:disable-next-line:max-line-length
var $cbcee261d685d22a$var$SEARCHBOX_UA_REGEX = /alexa|bot|crawl(er|ing)|facebookexternalhit|feedburner|google web preview|nagios|postrank|pingdom|slurp|spider|yahoo!|yandex/;
var $cbcee261d685d22a$var$SEARCHBOT_OS_REGEX = /(nuhk)|(Googlebot)|(Yammybot)|(Openbot)|(Slurp)|(MSNBot)|(Ask Jeeves\/Teoma)|(ia_archiver)/;
var $cbcee261d685d22a$var$REQUIRED_VERSION_PARTS = 3;
var $cbcee261d685d22a$var$userAgentRules = [
    [
        "aol",
        /AOLShield\/([0-9\._]+)/
    ],
    [
        "edge",
        /Edge\/([0-9\._]+)/
    ],
    [
        "edge-ios",
        /EdgiOS\/([0-9\._]+)/
    ],
    [
        "yandexbrowser",
        /YaBrowser\/([0-9\._]+)/
    ],
    [
        "vivaldi",
        /Vivaldi\/([0-9\.]+)/
    ],
    [
        "kakaotalk",
        /KAKAOTALK\s([0-9\.]+)/
    ],
    [
        "samsung",
        /SamsungBrowser\/([0-9\.]+)/
    ],
    [
        "silk",
        /\bSilk\/([0-9._-]+)\b/
    ],
    [
        "miui",
        /MiuiBrowser\/([0-9\.]+)$/
    ],
    [
        "beaker",
        /BeakerBrowser\/([0-9\.]+)/
    ],
    [
        "edge-chromium",
        /Edg\/([0-9\.]+)/
    ],
    [
        "chromium-webview",
        /(?!Chrom.*OPR)wv\).*Chrom(?:e|ium)\/([0-9\.]+)(:?\s|$)/
    ],
    [
        "chrome",
        /(?!Chrom.*OPR)Chrom(?:e|ium)\/([0-9\.]+)(:?\s|$)/
    ],
    [
        "phantomjs",
        /PhantomJS\/([0-9\.]+)(:?\s|$)/
    ],
    [
        "crios",
        /CriOS\/([0-9\.]+)(:?\s|$)/
    ],
    [
        "firefox",
        /Firefox\/([0-9\.]+)(?:\s|$)/
    ],
    [
        "fxios",
        /FxiOS\/([0-9\.]+)/
    ],
    [
        "opera-mini",
        /Opera Mini.*Version\/([0-9\.]+)/
    ],
    [
        "opera",
        /Opera\/([0-9\.]+)(?:\s|$)/
    ],
    [
        "opera",
        /OPR\/([0-9\.]+)(:?\s|$)/
    ],
    [
        "ie",
        /Trident\/7\.0.*rv\:([0-9\.]+).*\).*Gecko$/
    ],
    [
        "ie",
        /MSIE\s([0-9\.]+);.*Trident\/[4-7].0/
    ],
    [
        "ie",
        /MSIE\s(7\.0)/
    ],
    [
        "bb10",
        /BB10;\sTouch.*Version\/([0-9\.]+)/
    ],
    [
        "android",
        /Android\s([0-9\.]+)/
    ],
    [
        "ios",
        /Version\/([0-9\._]+).*Mobile.*Safari.*/
    ],
    [
        "safari",
        /Version\/([0-9\._]+).*Safari/
    ],
    [
        "facebook",
        /FBAV\/([0-9\.]+)/
    ],
    [
        "instagram",
        /Instagram\s([0-9\.]+)/
    ],
    [
        "ios-webview",
        /AppleWebKit\/([0-9\.]+).*Mobile/
    ],
    [
        "ios-webview",
        /AppleWebKit\/([0-9\.]+).*Gecko\)$/
    ],
    [
        "searchbot",
        $cbcee261d685d22a$var$SEARCHBOX_UA_REGEX
    ]
];
var $cbcee261d685d22a$var$operatingSystemRules = [
    [
        "iOS",
        /iP(hone|od|ad)/
    ],
    [
        "Android OS",
        /Android/
    ],
    [
        "BlackBerry OS",
        /BlackBerry|BB10/
    ],
    [
        "Windows Mobile",
        /IEMobile/
    ],
    [
        "Amazon OS",
        /Kindle/
    ],
    [
        "Windows 3.11",
        /Win16/
    ],
    [
        "Windows 95",
        /(Windows 95)|(Win95)|(Windows_95)/
    ],
    [
        "Windows 98",
        /(Windows 98)|(Win98)/
    ],
    [
        "Windows 2000",
        /(Windows NT 5.0)|(Windows 2000)/
    ],
    [
        "Windows XP",
        /(Windows NT 5.1)|(Windows XP)/
    ],
    [
        "Windows Server 2003",
        /(Windows NT 5.2)/
    ],
    [
        "Windows Vista",
        /(Windows NT 6.0)/
    ],
    [
        "Windows 7",
        /(Windows NT 6.1)/
    ],
    [
        "Windows 8",
        /(Windows NT 6.2)/
    ],
    [
        "Windows 8.1",
        /(Windows NT 6.3)/
    ],
    [
        "Windows 10",
        /(Windows NT 10.0)/
    ],
    [
        "Windows ME",
        /Windows ME/
    ],
    [
        "Open BSD",
        /OpenBSD/
    ],
    [
        "Sun OS",
        /SunOS/
    ],
    [
        "Chrome OS",
        /CrOS/
    ],
    [
        "Linux",
        /(Linux)|(X11)/
    ],
    [
        "Mac OS",
        /(Mac_PowerPC)|(Macintosh)/
    ],
    [
        "QNX",
        /QNX/
    ],
    [
        "BeOS",
        /BeOS/
    ],
    [
        "OS/2",
        /OS\/2/
    ],
    [
        "Search Bot",
        $cbcee261d685d22a$var$SEARCHBOT_OS_REGEX
    ]
];
function $cbcee261d685d22a$var$detect(userAgent) {
    if (!!userAgent) return $cbcee261d685d22a$var$parseUserAgent(userAgent);
    if (typeof navigator !== "undefined") return $cbcee261d685d22a$var$parseUserAgent(navigator.userAgent);
    return $cbcee261d685d22a$var$getNodeVersion();
}
$cbcee261d685d22a$exports.detect = $cbcee261d685d22a$var$detect;
function $cbcee261d685d22a$var$parseUserAgent(ua) {
    // opted for using reduce here rather than Array#first with a regex.test call
    // this is primarily because using the reduce we only perform the regex
    // execution once rather than once for the test and for the exec again below
    // probably something that needs to be benchmarked though
    var matchedRule = ua !== "" && $cbcee261d685d22a$var$userAgentRules.reduce(function(matched, _a) {
        var browser = _a[0], regex = _a[1];
        if (matched) return matched;
        var uaMatch = regex.exec(ua);
        return !!uaMatch && [
            browser,
            uaMatch
        ];
    }, false);
    if (!matchedRule) return null;
    var name = matchedRule[0], match = matchedRule[1];
    if (name === "searchbot") return new $cbcee261d685d22a$var$BotInfo();
    var versionParts = match[1] && match[1].split(/[._]/).slice(0, 3);
    if (versionParts) {
        if (versionParts.length < $cbcee261d685d22a$var$REQUIRED_VERSION_PARTS) versionParts = $cbcee261d685d22a$var$__spreadArrays(versionParts, $cbcee261d685d22a$var$createVersionParts($cbcee261d685d22a$var$REQUIRED_VERSION_PARTS - versionParts.length));
    } else versionParts = [];
    return new $cbcee261d685d22a$var$BrowserInfo(name, versionParts.join("."), $cbcee261d685d22a$var$detectOS(ua));
}
$cbcee261d685d22a$exports.parseUserAgent = $cbcee261d685d22a$var$parseUserAgent;
function $cbcee261d685d22a$var$detectOS(ua) {
    for(var ii = 0, count = $cbcee261d685d22a$var$operatingSystemRules.length; ii < count; ii++){
        var _a = $cbcee261d685d22a$var$operatingSystemRules[ii], os = _a[0], regex = _a[1];
        var match = regex.test(ua);
        if (match) return os;
    }
    return null;
}
$cbcee261d685d22a$exports.detectOS = $cbcee261d685d22a$var$detectOS;
function $cbcee261d685d22a$var$getNodeVersion() {
    var isNode = typeof $cfae44f0dfdf62c0$exports !== "undefined" && $cfae44f0dfdf62c0$exports.version;
    return isNode ? new $cbcee261d685d22a$var$NodeInfo($cfae44f0dfdf62c0$exports.version.slice(1)) : null;
}
$cbcee261d685d22a$exports.getNodeVersion = $cbcee261d685d22a$var$getNodeVersion;
function $cbcee261d685d22a$var$createVersionParts(count) {
    var output = [];
    for(var ii = 0; ii < count; ii++)output.push("0");
    return output;
}


var $5e0eb040f3eceaa7$require$detect = $cbcee261d685d22a$exports.detect;
const $5e0eb040f3eceaa7$var$browser = $5e0eb040f3eceaa7$require$detect();
const $5e0eb040f3eceaa7$var$AudioContext = $parcel$global.AudioContext || $parcel$global.webkitAudioContext;
const $5e0eb040f3eceaa7$var$BUFFER_SIZE = 4096;
/**
 * Reference: https://w3c.github.io/mediacapture-record/#mediarecorder-api
 * @extends EventTarget
 */ class $5e0eb040f3eceaa7$var$OpusMediaRecorder extends $5e0eb040f3eceaa7$require$EventTarget {
    /**
   * A function that returns the encoder web worker
   * @name workerFactory
   * @function
   * @returns {worker} An instance of ./encoderWorker.js web worker.
   */ /**
   *
   * @param {MediaStream} stream - The MediaStream to be recorded. This will
   *          be the value of the stream attribute.
   * @param {MediaRecorderOptions} [options] - A dictionary of options to for
   *          the UA instructing how the recording will take part.
   *          options.mimeType, if present, will become the value of mimeType
   *          attribute.
   * @param {Object} [workerOptions] This is a NON-STANDARD options to
   *          configure how to import the web worker .wasm compiled binaries
   *          used for encoding.
   * @param {workerFactory} [workerOptions.encoderWorkerFactory] A factory
   *          function that create a web worker instance of ./encoderWorker.js
   *          and returns it. function(){return new Worker('./encoderWorker.umd.js')}
   *          is used by default. This is NON-STANDARD.
   * @param {string} [workerOptions.OggOpusEncoderWasmPath]
   *          Path of ./OggOpusEncoder.wasm which is used for OGG Opus encoding
   *          by the encoder worker. This is NON-STANDARD.
   * @param {string} [workerOptions.WebMOpusEncoderWasmPath]
   *          Path of ./WebMOpusEncoder.wasm which is used for WebM Opus encoding
   *          by the encoder worker. This is NON-STANDARD.
   */ constructor(stream, options = {}, workerOptions = {}){
        const { mimeType: mimeType, audioBitsPerSecond: audioBitsPerSecond, videoBitsPerSecond: videoBitsPerSecond, bitsPerSecond: bitsPerSecond } = options; // eslint-disable-line
        // NON-STANDARD options
        const { encoderWorkerFactory: encoderWorkerFactory, OggOpusEncoderWasmPath: OggOpusEncoderWasmPath, WebMOpusEncoderWasmPath: WebMOpusEncoderWasmPath } = workerOptions;
        super();
        // Attributes for the specification conformance. These have their own getters.
        this._stream = stream;
        this._state = "inactive";
        this._mimeType = mimeType || "";
        this._audioBitsPerSecond = audioBitsPerSecond || bitsPerSecond;
        /** @type {'inactive'|'readyToInit'|'encoding'|'closed'} */ this.workerState = "inactive";
        // Parse MIME Type
        if (!$5e0eb040f3eceaa7$var$OpusMediaRecorder.isTypeSupported(this._mimeType)) throw new TypeError("invalid arguments, a MIME Type is not supported");
        switch($5e0eb040f3eceaa7$var$OpusMediaRecorder._parseType(this._mimeType).subtype){
            case "wave":
            case "wav":
                this._mimeType = "audio/wave";
                break;
            case "webm":
                this._mimeType = "audio/webm";
                break;
            case "ogg":
                this._mimeType = "audio/ogg";
                break;
            default:
                // Select a type depending on OS.
                switch($5e0eb040f3eceaa7$var$browser && $5e0eb040f3eceaa7$var$browser.name){
                    case "chrome":
                        this._mimeType = "audio/webm";
                        break;
                    case "firefox":
                        this._mimeType = "audio/ogg";
                        break;
                    case "edge":
                        this._mimeType = "audio/webm";
                        break;
                    case "ios":
                    case "safari":
                        this._mimeType = "audio/wave";
                        break;
                    default:
                        this._mimeType = "audio/webm";
                }
        }
        switch(this._mimeType){
            case "audio/wave":
                this._wasmPath = ""; // wasm is not used
                break;
            case "audio/webm":
                this._wasmPath = WebMOpusEncoderWasmPath || "";
                break;
            case "audio/ogg":
                this._wasmPath = OggOpusEncoderWasmPath || "";
                break;
            default:
                throw new Error(`Internal Error: Unexpected MIME Type: ${this._mimeType}`);
        }
        // Get current directory for worker
        let workerDir = "";
        if (document.currentScript) workerDir = document.currentScript.src;
        else if (self.location) workerDir = self.location.href;
        workerDir = workerDir.substr(0, workerDir.lastIndexOf("/")) + "/encoderWorker.umd.js";
        // If worker function is imported via <script> tag, make it blob to get URL.
        if (typeof $5e0eb040f3eceaa7$var$OpusMediaRecorder.encoderWorker === "function") workerDir = URL.createObjectURL(new Blob([
            `(${$5e0eb040f3eceaa7$var$OpusMediaRecorder.encoderWorker})()`
        ]));
        // Spawn a encoder worker
        this._workerFactory = typeof encoderWorkerFactory === "function" ? encoderWorkerFactory : (_)=>new Worker(workerDir);
        this._spawnWorker();
    }
    /**
   * The MediaStream [GETUSERMEDIA] to be recorded.
   * @return {MediaStream}
   */ get stream() {
        return this._stream;
    }
    /**
   * The MIME type [RFC2046] that has been selected as the container for
   * recording. This entry includes all the parameters to the base
   * mimeType. The UA should be able to play back any of the MIME types
   * it supports for recording. For example, it should be able to display
   * a video recording in the HTML <video> tag. The default value for
   * this property is platform-specific.
   * @return {string}
   */ get mimeType() {
        return this._mimeType;
    }
    /**
   * The current state of the OpusMediaRecorder object. When the OpusMediaRecorder
   * is created, the UA MUST set this attribute to inactive.
   * @return {"inactive"|"recording"|"paused"}
   */ get state() {
        return this._state;
    }
    /**
   * The value of the Video encoding. Unsupported.
   * @return {undefined}
   */ get videoBitsPerSecond() {
        // Video encoding is not supported
        return undefined;
    }
    /**
   * The value of the Audio encoding target bit rate that was passed to
   * the Platform (potentially truncated, rounded, etc), or the calculated one
   * if the user has specified bitsPerSecond.
   * @return {number|undefined}
   */ get audioBitsPerSecond() {
        return this._audioBitsPerSecond;
    }
    /**
   * Initialize worker
   */ _spawnWorker() {
        this.worker = this._workerFactory();
        this.worker.onmessage = (e)=>this._onmessageFromWorker(e);
        this.worker.onerror = (e)=>this._onerrorFromWorker(e);
        this._postMessageToWorker("loadEncoder", {
            mimeType: this._mimeType,
            wasmPath: this._wasmPath
        });
    }
    /**
   * Post message to the encoder web worker.
   * @param {"init"|"pushInputData"|"getEncodedData"|"done"} command - Type of message to send to the worker
   * @param {object} message - Payload to the worker
   */ _postMessageToWorker(command, message = {}) {
        switch(command){
            case "loadEncoder":
                let { mimeType: mimeType, wasmPath: wasmPath } = message;
                this.worker.postMessage({
                    command: command,
                    mimeType: mimeType,
                    wasmPath: wasmPath
                });
                break;
            case "init":
                // Initialize the worker
                let { sampleRate: sampleRate, channelCount: channelCount, bitsPerSecond: bitsPerSecond } = message;
                this.worker.postMessage({
                    command: command,
                    sampleRate: sampleRate,
                    channelCount: channelCount,
                    bitsPerSecond: bitsPerSecond
                });
                this.workerState = "encoding";
                // Start streaming
                this.source.connect(this.processor);
                this.processor.connect(this.context.destination);
                let eventToPush = new $parcel$global.Event("start");
                this.dispatchEvent(eventToPush);
                break;
            case "pushInputData":
                // Pass input audio buffer to the encoder to encode.
                // The worker MAY trigger 'encodedData'.
                let { channelBuffers: channelBuffers, length: length, duration: duration } = message;
                this.worker.postMessage({
                    command: command,
                    channelBuffers: channelBuffers,
                    length: length,
                    duration: duration
                });
                break;
            case "getEncodedData":
                // Request encoded result.
                // Expected 'encodedData' event from the worker
                this.worker.postMessage({
                    command: command
                });
                break;
            case "done":
                // Tell encoder finallize the job and destory itself.
                // Expected 'lastEncodedData' event from the worker.
                this.worker.postMessage({
                    command: command
                });
                break;
            default:
                // This is an error case
                throw new Error("Internal Error: Incorrect postMessage requested.");
        }
    }
    /**
   * onmessage() callback from the worker.
   * @param {message} event - message from the worker
   */ _onmessageFromWorker(event) {
        const { command: command, buffers: buffers } = event.data;
        let eventToPush;
        switch(command){
            case "readyToInit":
                const { sampleRate: sampleRate, channelCount: channelCount } = this;
                this.workerState = "readyToInit";
                // If start() is already called initialize worker
                if (this.state === "recording") this._postMessageToWorker("init", {
                    sampleRate: sampleRate,
                    channelCount: channelCount,
                    bitsPerSecond: this.audioBitsPerSecond
                });
                break;
            case "encodedData":
            case "lastEncodedData":
                let data = new Blob(buffers, {
                    "type": this._mimeType
                });
                eventToPush = new $parcel$global.Event("dataavailable");
                eventToPush.data = data;
                this.dispatchEvent(eventToPush);
                // Detect of stop() called before
                if (command === "lastEncodedData") {
                    eventToPush = new $parcel$global.Event("stop");
                    this.dispatchEvent(eventToPush);
                    this.workerState = "closed";
                }
                break;
            default:
                break; // Ignore
        }
    }
    /**
   * onerror() callback from the worker.
   * @param {ErrorEvent} error - error object from the worker
   */ _onerrorFromWorker(error) {
        // Stop stream first
        this.source.disconnect();
        this.processor.disconnect();
        this.worker.terminate();
        this.workerState = "closed";
        // Send message to host
        let message = [
            "FileName: " + error.filename,
            "LineNumber: " + error.lineno,
            "Message: " + error.message
        ].join(" - ");
        let errorToPush = new $parcel$global.Event("error");
        errorToPush.name = "UnknownError";
        errorToPush.message = message;
        this.dispatchEvent(errorToPush);
    }
    /**
   * Enable onaudioprocess() callback.
   * @param {number} timeslice - In seconds. OpusMediaRecorder should request data
   *                              from the worker every timeslice seconds.
   */ _enableAudioProcessCallback(timeslice) {
        // pass frame buffers to the worker
        let elapsedTime = 0;
        this.processor.onaudioprocess = (e)=>{
            const { inputBuffer: inputBuffer, playbackTime: playbackTime } = e; // eslint-disable-line
            const { sampleRate: sampleRate, length: length, duration: duration, numberOfChannels: numberOfChannels } = inputBuffer; // eslint-disable-line
            // Create channel buffers to pass to the worker
            const channelBuffers = new Array(numberOfChannels);
            for(let i = 0; i < numberOfChannels; i++)channelBuffers[i] = inputBuffer.getChannelData(i);
            // Pass data to the worker
            const message = {
                channelBuffers: channelBuffers,
                length: length,
                duration: duration
            };
            this._postMessageToWorker("pushInputData", message);
            // Calculate time
            elapsedTime += duration;
            if (elapsedTime >= timeslice) {
                this._postMessageToWorker("getEncodedData");
                elapsedTime = 0;
            }
        };
    }
    /**
   * Begins recording media; this method can optionally be passed a timeslice
   * argument with a value in milliseconds.
   * @param {number} timeslice - If this is specified, the media will be captured
   *        in separate chunks of that duration, rather than the default behavior
   *        of recording the media in a single large chunk. In other words, an
   *        undefined value of timeslice will be understood as the largest long value.
   */ start(timeslice = Number.MAX_SAFE_INTEGER) {
        if (this.state !== "inactive") throw new Error("DOMException: INVALID_STATE_ERR, state must be inactive.");
        if (timeslice < 0) throw new TypeError("invalid arguments, timeslice should be 0 or higher.");
        timeslice /= 1000; // Convert milliseconds to seconds
        // Check worker is closed (usually by stop()) and init.
        if (this.workerState === "closed") this._spawnWorker();
        // Get channel count and sampling rate
        // channelCount: https://www.w3.org/TR/mediacapture-streams/#media-track-settings
        // sampleRate: https://developer.mozilla.org/en-US/docs/Web/API/BaseAudioContext/sampleRate
        this.context = new $5e0eb040f3eceaa7$var$AudioContext();
        let tracks = this.stream.getAudioTracks();
        if (!tracks[0]) throw new Error("DOMException: UnkownError, media track not found.");
        this.channelCount = tracks[0].getSettings().channelCount || 1;
        this.sampleRate = this.context.sampleRate;
        /** @type {MediaStreamAudioSourceNode} */ this.source = this.context.createMediaStreamSource(this.stream);
        /** @type {ScriptProcessorNode} */ this.processor = this.context.createScriptProcessor($5e0eb040f3eceaa7$var$BUFFER_SIZE, this.channelCount, this.channelCount);
        // Start recording
        this._state = "recording";
        this._enableAudioProcessCallback(timeslice);
        // If the worker is already loaded then start
        if (this.workerState === "readyToInit") {
            const { sampleRate: sampleRate, channelCount: channelCount } = this;
            this._postMessageToWorker("init", {
                sampleRate: sampleRate,
                channelCount: channelCount,
                bitsPerSecond: this.audioBitsPerSecond
            });
        }
    }
    /**
   * Stops recording, at which point a dataavailable event containing
   * the final Blob of saved data is fired. No more recording occurs.
   */ stop() {
        if (this.state === "inactive") throw new Error("DOMException: INVALID_STATE_ERR, state must NOT be inactive.");
        // Stop stream first
        this.source.disconnect();
        this.processor.disconnect();
        this.context.close();
        // Stop event will be triggered at _onmessageFromWorker(),
        this._postMessageToWorker("done");
        this._state = "inactive";
    }
    /**
   * Pauses the recording of media.
   */ pause() {
        if (this.state === "inactive") throw new Error("DOMException: INVALID_STATE_ERR, state must NOT be inactive.");
        // Stop stream first
        this.source.disconnect();
        this.processor.disconnect();
        let event = new $parcel$global.Event("pause");
        this.dispatchEvent(event);
        this._state = "paused";
    }
    /**
   * Resumes recording of media after having been paused.
   */ resume() {
        if (this.state === "inactive") throw new Error("DOMException: INVALID_STATE_ERR, state must NOT be inactive.");
        // Restart streaming data
        this.source.connect(this.processor);
        this.processor.connect(this.context.destination);
        let event = new $parcel$global.Event("resume");
        this.dispatchEvent(event);
        this._state = "recording";
    }
    /**
   * Requests a Blob containing the saved data received thus far (or since
   * the last time requestData() was called. After calling this method,
   * recording continues, but in a new Blob.
   */ requestData() {
        if (this.state === "inactive") throw new Error("DOMException: INVALID_STATE_ERR, state must NOT be inactive.");
        // dataavailable event will be triggerd at _onmessageFromWorker()
        this._postMessageToWorker("getEncodedData");
    }
    /**
   * Returns a Boolean value indicating if the given MIME type is supported
   * by the current user agent .
   * @param {string} typeType - A MIME Type, including parameters when needed,
   *          specifying a container and/or codec formats for recording.
   * @return {boolean}
   */ static isTypeSupported(mimeType) {
        // See: https://w3c.github.io/mediacapture-record/#dom-mediarecorder-istypesupported
        // 1. If empty string, return true.
        if (typeof mimeType === "string" && !mimeType) return true;
        try {
            var { type: type, subtype: subtype, codec: codec } = $5e0eb040f3eceaa7$var$OpusMediaRecorder._parseType(mimeType);
        } catch (error) {
            // 2. If not a valid string, return false.
            return false;
        }
        if (type !== "audio" || !(subtype === "ogg" || subtype === "webm" || subtype === "wave" || subtype === "wav")) // 3,4. If type and subtype are unsupported the return false.
        return false;
        // 5. If codec is unsupported then return false.
        // 6. If the specified combination of all is not supported than return false.
        switch(subtype){
            case "ogg":
                if (codec !== "opus" && codec) return false;
                break;
            case "webm":
                if (codec !== "opus" && codec) return false;
                break;
            case "wave":
            case "wav":
                if (codec) return false; // Currently only supports signed 16 bits
                break;
        }
        // 7. return true.
        return true;
    }
    /**
   * Parse MIME. A helper function for isTypeSupported() and etc.
   * @param {string} mimeType - typeType - A MIME Type, including parameters when needed,
   *          specifying a container and/or codec formats for recording.
   * @return {?object} - An object with type, subtype, codec attributes
   *          if parsed correctly. null is returned if parsing failed.
   *          If mimeType is an empty string then return an object with attributes
   *          are empty strings
   */ static _parseType(mimeType) {
        try {
            const regex = /^(\w+)\/(\w+)(;\s*codecs=(\w+))?$/;
            var [, type, subtype, , codec] = mimeType.match(regex);
        } catch (error) {
            if (typeof mimeType === "string" && !mimeType) return {
                type: "",
                subtype: "",
                codec: ""
            };
            return null;
        }
        return {
            type: type,
            subtype: subtype,
            codec: codec
        };
    }
}
// EventHandler attributes.
// This code is a non-standard EventTarget but required by event-target-shim.
[
    "start",
    "stop",
    "dataavailable",
    /* Called to handle the dataavailable event. The Blob of
                        recorded data is contained in this event and can be
                        accessed via its data attribute. */ "pause",
    "resume",
    "error" // Called to handle a MediaRecorderErrorEvent.
].forEach((name)=>$5e0eb040f3eceaa7$require$defineEventAttribute($5e0eb040f3eceaa7$var$OpusMediaRecorder.prototype, name));
// MS Edge specific monkey patching:
// onaudioprocess callback cannot be triggered more than twice when postMessage
// uses the seconde transfer argument. So disable the transfer argument only in Edge.
if ($5e0eb040f3eceaa7$var$browser && $5e0eb040f3eceaa7$var$browser.name === "edge") (function() {
    var original = Worker.prototype.postMessage;
    Worker.prototype.postMessage = function(message, transfer = null) {
        original.apply(this, [
            message
        ]);
    };
})();
$5e0eb040f3eceaa7$exports = $5e0eb040f3eceaa7$var$OpusMediaRecorder;


var $815844dde2cfbfb2$exports = {};
const $815844dde2cfbfb2$var$logs = document.querySelector(".logs");
$815844dde2cfbfb2$exports = {
    log: (message)=>{
        console.log(message);
        const log = document.createElement("div");
        log.classList.add("log");
        log.innerText = message;
        $815844dde2cfbfb2$var$logs.prepend(log);
    },
    error: (message)=>{
        console.error(message);
        const log = document.createElement("div");
        log.classList.add("log");
        log.classList.add("error");
        log.innerText = message;
        $815844dde2cfbfb2$var$logs.prepend(log);
    },
    warning: (message)=>{
        console.error(message);
        const log = document.createElement("div");
        log.classList.add("log");
        log.classList.add("warning");
        log.innerText = message;
        $815844dde2cfbfb2$var$logs.prepend(log);
    }
};


var $999f9709ad6a83f8$exports = {};
var $56b621a6dd25b2cb$exports = {};
"use strict";
$56b621a6dd25b2cb$exports = function(workerUrl, origin, isESM) {
    if (origin === self.location.origin) // If the worker bundle's url is on the same origin as the document,
    // use the worker bundle's own url.
    return workerUrl;
    else {
        // Otherwise, create a blob URL which loads the worker bundle with `importScripts`.
        var source = isESM ? "import " + JSON.stringify(workerUrl) + ";" : "importScripts(" + JSON.stringify(workerUrl) + ");";
        return URL.createObjectURL(new Blob([
            source
        ], {
            type: "application/javascript"
        }));
    }
};


let $999f9709ad6a83f8$var$url = new URL("encoderWorker.umd.22eb93c3.js", import.meta.url);
$999f9709ad6a83f8$exports = $56b621a6dd25b2cb$exports($999f9709ad6a83f8$var$url.toString(), $999f9709ad6a83f8$var$url.origin, true);


$c53890eb3e021adc$exports = ()=>{
    const recorder = {
        _events: new $5440e9199a418654$exports(),
        _mediaRecorder: undefined,
        _stream: undefined,
        getMediaRecorder: (stream)=>{
            if (window.MediaRecorder.isTypeSupported("audio/ogg; codecs=opus")) return new window.MediaRecorder(stream, {
                mimeType: "audio/ogg; codecs=opus"
            });
            $815844dde2cfbfb2$exports.warning("For best experience, please, use firefox");
            const workerOptions = {
                encoderWorkerFactory: function() {
                    return new Worker($999f9709ad6a83f8$exports);
                },
                OggOpusEncoderWasmPath: "https://cdn.jsdelivr.net/npm/opus-media-recorder@latest/OggOpusEncoder.wasm",
                WebMOpusEncoderWasmPath: "https://cdn.jsdelivr.net/npm/opus-media-recorder@latest/WebMOpusEncoder.wasm"
            };
            return new $5e0eb040f3eceaa7$exports(stream, {
                mimeType: "audio/ogg; codecs=opus"
            }, workerOptions);
        },
        getLocalStream: ()=>{
            return navigator.mediaDevices.getUserMedia({
                video: false,
                audio: true
            }).then((stream)=>{
                const track = stream.getAudioTracks()[0];
                return track.applyConstraints({
                    audio: {
                        channelCount: 1,
                        sampleRate: 24000
                    }
                }).then(()=>stream);
            }).catch((err)=>{
                console.error(`you got an error: ${err}`);
                alert(error);
            });
        },
        record: ()=>{
            return recorder.getLocalStream().then((stream)=>{
                const mediaRecorder = recorder.getMediaRecorder(stream);
                mediaRecorder.start(10);
                mediaRecorder.ondataavailable = (e)=>{
                    if (e.data.length === 0) return;
                    recorder._events.emit("samples", e.data);
                };
                recorder._mediaRecorder = mediaRecorder;
                recorder._stream = stream;
            });
        },
        stop: ()=>{
            if (recorder._mediaRecorder) {
                recorder._mediaRecorder.stop();
                recorder._stream.getTracks().forEach(function(track) {
                    track.stop();
                });
            }
        },
        on: (...args)=>{
            return recorder._events.on(...args);
        }
    };
    return recorder;
};


var $00583c9794cbe277$exports = {};
const $6732b8f697e1d194$export$1cd93882633e45f5 = (t, n = 4294967295, e = 79764919)=>{
    const r = new Int32Array(256);
    let o, s, i, c = n;
    for(o = 0; o < 256; o++){
        for(i = o << 24, s = 8; s > 0; --s)i = 2147483648 & i ? i << 1 ^ e : i << 1;
        r[o] = i;
    }
    for(o = 0; o < t.length; o++)c = c << 8 ^ r[255 & (c >> 24 ^ t[o])];
    return c;
}, $6732b8f697e1d194$export$c564cdbbe6da493 = (t)=>{
    const n = [];
    for (const e of t){
        let t = (e + 42) % 256;
        0 === t || 10 === t || 13 === t || 61 === t ? n.push("=" + String.fromCharCode((t + 64) % 256)) : n.push(String.fromCharCode(t));
    }
    return n.join("");
}, $6732b8f697e1d194$export$2f872c0f2117be69 = (n, e = $6732b8f697e1d194$export$1cd93882633e45f5)=>{
    const r = (t)=>new Uint8Array(t.length / 2).map((n, e)=>parseInt(t.substring(2 * e, 2 * (e + 1)), 16)), o = (t)=>r(t)[0], s = new Map;
    [
        ,
        8364,
        ,
        8218,
        402,
        8222,
        8230,
        8224,
        8225,
        710,
        8240,
        352,
        8249,
        338,
        ,
        381,
        ,
        ,
        8216,
        8217,
        8220,
        8221,
        8226,
        8211,
        8212,
        732,
        8482,
        353,
        8250,
        339,
        ,
        382,
        376
    ].forEach((t, n)=>s.set(t, n));
    const i = new Uint8Array(n.length);
    let c, a, l, f = !1, g = 0, h = 42, p = n.length > 13 && "dynEncode" === n.substring(0, 9), u = 0;
    p && (u = 11, a = o(n.substring(9, u)), a <= 1 && (u += 2, h = o(n.substring(11, u))), 1 === a && (u += 8, l = ((t)=>new DataView(r(t).buffer).getInt32(0, !0))(n.substring(13, u))));
    const d = 256 - h;
    for(let t = u; t < n.length; t++)if (c = n.charCodeAt(t), 61 !== c || f) {
        if (92 === c && t < n.length - 5 && p) {
            const e = n.charCodeAt(t + 1);
            117 !== e && 85 !== e || (c = parseInt(n.substring(t + 2, t + 6), 16), t += 5);
        }
        if (c > 255) {
            const t = s.get(c);
            t && (c = t + 127);
        }
        f && (f = !1, c -= 64), i[g++] = c < h && c > 0 ? c + d : c - h;
    } else f = !0;
    const m = i.subarray(0, g);
    if (p && 1 === a) {
        const t = e(m);
        if (t !== l) {
            const n = "Decode failed crc32 validation";
            throw console.error("`simple-yenc`\n", n + "\n", "Expected: " + l + "; Got: " + t + "\n", "Visit https://github.com/eshaz/simple-yenc for more information"), Error(n);
        }
    }
    return m;
}, $6732b8f697e1d194$export$c7423f8ce0b2cbf9 = (n, e = '"', r = $6732b8f697e1d194$export$1cd93882633e45f5, o)=>{
    const s = (t, n)=>(t % n + n) % n, i = (t, n)=>n.push(String.fromCharCode(61, (t + 64) % 256)), c = (t)=>t.map((t)=>t.toString(16).padStart(2, "0"));
    let a, l, f = [], g = 1 / 0, h = Array(256).fill(0);
    if ('"' === e ? (l = [
        0,
        8,
        9,
        10,
        11,
        12,
        13,
        34,
        92,
        61
    ], a = (t)=>0 === t || 8 === t || 9 === t || 10 === t || 11 === t || 12 === t || 13 === t || 34 === t || 92 === t || 61 === t) : "'" === e ? (l = [
        0,
        8,
        9,
        10,
        11,
        12,
        13,
        39,
        92,
        61
    ], a = (t)=>0 === t || 8 === t || 9 === t || 10 === t || 11 === t || 12 === t || 13 === t || 39 === t || 92 === t || 61 === t) : "`" === e && (l = [
        13,
        61,
        96
    ], f = [
        7,
        205,
        231
    ], a = (t, n)=>13 === t || 36 === t && 123 === n || 61 === t || 92 === t && (85 === n || 117 === n) || 96 === t), void 0 === o) {
        o = 0;
        for(let t = 0; t < n.length; t++){
            const e = 0 | n[t];
            h[e]++;
            for(let r = 0; r < f.length; r++){
                const o = f[r];
                s(e - n[t + 1] | 0, 256) === o && h[e]++;
            }
        }
        for(let t = 0; t < 256; t++){
            let n = 0;
            for(let e = 0; e < l.length; e++)n += h[s(l[e] - t, 256)];
            n < g && (g = n, o = t);
        }
    }
    const p = [
        "dynEncode",
        "01",
        c([
            o
        ]),
        ...c(((t)=>{
            const n = new Uint8Array(4);
            return new DataView(n.buffer).setInt32(0, t, !0), [
                ...n
            ];
        })(r(n)))
    ];
    for(let t = 0; t < n.length; t++){
        const e = (n[t] + o) % 256;
        a(e, (n[t + 1] + o) % 256) ? i(e, p) : p.push(String.fromCharCode(e));
    }
    return "\\" === p[p.length - 1] && (p.pop(), i(92, p)), p.join("");
}, $6732b8f697e1d194$export$fac44ee5b035f737 = (t)=>t.replace(/[\\]/g, "\\\\").replace(/[`]/g, "\\`").replace(/\${/g, "\\${");


function $6cc8fed272338330$export$2e2bcd8739ae039() {
    // setup static methods
    const uint8Array = Uint8Array;
    const float32Array = Float32Array;
    if (!$6cc8fed272338330$export$2e2bcd8739ae039.modules) Object.defineProperties($6cc8fed272338330$export$2e2bcd8739ae039, {
        modules: {
            value: new WeakMap()
        },
        setModule: {
            value (Ref, module) {
                $6cc8fed272338330$export$2e2bcd8739ae039.modules.set(Ref, Promise.resolve(module));
            }
        },
        getModule: {
            value (Ref, wasmString) {
                let module = $6cc8fed272338330$export$2e2bcd8739ae039.modules.get(Ref);
                if (!module) {
                    if (!wasmString) {
                        wasmString = Ref.wasm;
                        module = $6cc8fed272338330$export$2e2bcd8739ae039.inflateDynEncodeString(wasmString).then((data)=>WebAssembly.compile(data));
                    } else module = WebAssembly.compile((0, $6732b8f697e1d194$export$2f872c0f2117be69)(wasmString));
                    $6cc8fed272338330$export$2e2bcd8739ae039.modules.set(Ref, module);
                }
                return module;
            }
        },
        concatFloat32: {
            value (buffers, length) {
                let ret = new float32Array(length), i = 0, offset = 0;
                while(i < buffers.length){
                    ret.set(buffers[i], offset);
                    offset += buffers[i++].length;
                }
                return ret;
            }
        },
        getDecodedAudio: {
            value: (errors, channelData, samplesDecoded, sampleRate, bitDepth)=>({
                    errors: errors,
                    channelData: channelData,
                    samplesDecoded: samplesDecoded,
                    sampleRate: sampleRate,
                    bitDepth: bitDepth
                })
        },
        getDecodedAudioMultiChannel: {
            value (errors, input, channelsDecoded, samplesDecoded, sampleRate, bitDepth) {
                let channelData = [], i, j;
                for(i = 0; i < channelsDecoded; i++){
                    const channel = [];
                    for(j = 0; j < input.length;)channel.push(input[j++][i] || []);
                    channelData.push($6cc8fed272338330$export$2e2bcd8739ae039.concatFloat32(channel, samplesDecoded));
                }
                return $6cc8fed272338330$export$2e2bcd8739ae039.getDecodedAudio(errors, channelData, samplesDecoded, sampleRate, bitDepth);
            }
        },
        /*
       ******************
       * Compression Code
       ******************
       */ inflateDynEncodeString: {
            value (source) {
                source = (0, $6732b8f697e1d194$export$2f872c0f2117be69)(source);
                return new Promise((resolve)=>{
                    // prettier-ignore
                    const puffString = String.raw`dynEncode0114db91da9bu*ttt$#U¤¤U¤¤3yzzss|yusvuyÚ&4<054<,5T44^T44<(6U~J(44< ~A544U~6J0444545 444J0444J,4U4UÒ7U454U4Z4U4U^/6545T4T44BU~64CU~O4U54U~5 U5T4B4Z!4U~5U5U5T4U~6U4ZTU5U5T44~4O4U2ZTU5T44Z!4B6T44U~64B6U~O44U~4O4U~54U~5 44~C4~54U~5 44~5454U4B6Ub!444~UO4U~5 U54U4ZTU#44U$464<4~B6^4<444~U~B4U~54U544~544~U5 µUä#UJUè#5TT4U0ZTTUX5U5T4T4Uà#~4OU4U $~C4~54U~5 T44$6U\!TTT4UaT4<6T4<64<Z!44~4N4<U~5 4UZ!4U±_TU#44UU6UÔ~B$544$6U\!4U6U¤#~B44Uä#~B$~64<6_TU#444U~B~6~54<Y!44<_!T4Y!4<64~444~AN44<U~6J4U5 44J4U[!U#44UO4U~54U~5 U54 7U6844J44J 4UJ4UJ04VK(44<J44<J$4U´~54U~5 4U¤~5!TTT4U$5"U5TTTTTTT4U$"4VK,U54<(6U~64<$6_!4< 64~6A54A544U~6#J(U54A4U[!44J(44#~A4U6UUU[!4464~64_!4<64~54<6T4<4]TU5 T4Y!44~44~AN4U~54U~54U5 44J(44J UÄA!U5U#UôJU"UÔJU#UÔ"JU#U´"JT4U´ZTU5T4UôZTU5T4UDZTU5T4U$[T44~UO4U~5 UÔUô4U~U´$.U5T4UP[T4U~4~UO4U~5 U#<U#<4U~U2$.UÄUN 44 ~UO4U~5 44!~UO4U~5 4U~4~UO4U~5 44J44J(U5 44U¤~J@44Uä~J<44UD~J844U~J44U$54U$5U54U$54U1^4U1^!4U~54U~5U54U~6U4U^/65T4T4U$54U~4BU~4O4U54U~5 UU'464U'_/54UU~5T4T4U~4BU~UO4U54U~5 U54Uä~4U¤~4U~U'$!44~5U5T44\T44U<~$6U\!4U#aT4U~4U~4O4U~5 U5U5U5TTT4U$"4YTU5 4U4~C5U5 U5U5444$4~64~\TU5 4U~4U~5T4Y!44O4U~54U~54U5 4CYTU5 4Uä~4U¤~4U~4$6TU54U\!44Bæ4Bä~[!4U~4UD~4U~4U~4$6TU54U\!44B4B~[!44U<~4U4~$5 4U"U#$544"Y!454U^!44<J44<(J454U~84­UN!#%'+/37?GOWgw·×÷Uä;U9$%& !"#`;
                    $6cc8fed272338330$export$2e2bcd8739ae039.getModule($6cc8fed272338330$export$2e2bcd8739ae039, puffString).then((wasm)=>WebAssembly.instantiate(wasm, {})).then(({ exports: exports })=>{
                        // required for minifiers that mangle the __heap_base property
                        const instanceExports = new Map(Object.entries(exports));
                        const puff = instanceExports.get("puff");
                        const memory = instanceExports.get("memory")["buffer"];
                        const dataArray = new uint8Array(memory);
                        const heapView = new DataView(memory);
                        let heapPos = instanceExports.get("__heap_base");
                        // source length
                        const sourceLength = source.length;
                        const sourceLengthPtr = heapPos;
                        heapPos += 4;
                        heapView.setInt32(sourceLengthPtr, sourceLength, true);
                        // source data
                        const sourcePtr = heapPos;
                        heapPos += sourceLength;
                        dataArray.set(source, sourcePtr);
                        // destination length
                        const destLengthPtr = heapPos;
                        heapPos += 4;
                        heapView.setInt32(destLengthPtr, dataArray.byteLength - heapPos, true);
                        // destination data fills in the rest of the heap
                        puff(heapPos, destLengthPtr, sourcePtr, sourceLengthPtr);
                        resolve(dataArray.slice(heapPos, heapPos + heapView.getInt32(destLengthPtr, true)));
                    });
                });
            }
        }
    });
    Object.defineProperty(this, "wasm", {
        enumerable: true,
        get: ()=>this._wasm
    });
    this.getOutputChannels = (outputData, channelsDecoded, samplesDecoded)=>{
        let output = [], i = 0;
        while(i < channelsDecoded)output.push(outputData.slice(i * samplesDecoded, i++ * samplesDecoded + samplesDecoded));
        return output;
    };
    this.allocateTypedArray = (len, TypedArray, setPointer = true)=>{
        const ptr = this._wasm.malloc(TypedArray.BYTES_PER_ELEMENT * len);
        if (setPointer) this._pointers.add(ptr);
        return {
            ptr: ptr,
            len: len,
            buf: new TypedArray(this._wasm.HEAP, ptr, len)
        };
    };
    this.free = ()=>{
        this._pointers.forEach((ptr)=>{
            this._wasm.free(ptr);
        });
        this._pointers.clear();
    };
    this.codeToString = (ptr)=>{
        const characters = [], heap = new Uint8Array(this._wasm.HEAP);
        for(let character = heap[ptr]; character !== 0; character = heap[++ptr])characters.push(character);
        return String.fromCharCode.apply(null, characters);
    };
    this.addError = (errors, message, frameLength, frameNumber, inputBytes, outputSamples)=>{
        errors.push({
            message: message,
            frameLength: frameLength,
            frameNumber: frameNumber,
            inputBytes: inputBytes,
            outputSamples: outputSamples
        });
    };
    this.instantiate = (_EmscriptenWASM, _module)=>{
        if (_module) $6cc8fed272338330$export$2e2bcd8739ae039.setModule(_EmscriptenWASM, _module);
        this._wasm = new _EmscriptenWASM($6cc8fed272338330$export$2e2bcd8739ae039).instantiate();
        this._pointers = new Set();
        return this._wasm.ready.then(()=>this);
    };
}



/* **************************************************
 * This file is auto-generated during the build process.
 * Any edits to this file will be overwritten.
 ****************************************************/ function $42da1043ef19c7aa$export$2e2bcd8739ae039(WASMAudioDecoderCommon) {
    var Module = Module;
    function ready() {}
    Module = {};
    /** @param {string|number=} what */ function abort(what) {
        throw what;
    }
    for(var base64ReverseLookup = new Uint8Array(123), /*'z'+1*/ i = 25; i >= 0; --i){
        base64ReverseLookup[48 + i] = 52 + i;
        base64ReverseLookup[65 + i] = i;
        base64ReverseLookup[97 + i] = 26 + i;
    }
    base64ReverseLookup[43] = 62;
    base64ReverseLookup[47] = 63;
    /** @noinline */ function base64Decode(b64) {
        var b1, b2, i = 0, j = 0, bLength = b64.length, output = new Uint8Array((bLength * 3 >> 2) - (b64[bLength - 2] == "=") - (b64[bLength - 1] == "="));
        for(; i < bLength; i += 4, j += 3){
            b1 = base64ReverseLookup[b64.charCodeAt(i + 1)];
            b2 = base64ReverseLookup[b64.charCodeAt(i + 2)];
            output[j] = base64ReverseLookup[b64.charCodeAt(i)] << 2 | b1 >> 4;
            output[j + 1] = b1 << 4 | b2 >> 2;
            output[j + 2] = b2 << 6 | base64ReverseLookup[b64.charCodeAt(i + 3)];
        }
        return output;
    }
    if (!$42da1043ef19c7aa$export$2e2bcd8739ae039.wasm) Object.defineProperty($42da1043ef19c7aa$export$2e2bcd8739ae039, "wasm", {
        get: ()=>String.raw`dynEncode01a36c6f98c83ø%yã¯#6ïIØh¼ÿ-^º*:8ÖJÒ#Á(¶3ùsÕÿ§£/.*[v²¯\õzºÜá»(oBM×å ÊvmË1±Iü(&Øb?0=MáPðxA%TÔÎ=} c×0ÓPùN:Ê£ÌÓ±æQñÒ¥M_ªqA1kð¹¥ÊÇ@6u§­k¿Ä9Ó²FÒà(A£c£  )ìTÃ=M]+àaåÅBÃ±cÈ¼{±!ÕÕ_ò#²ßá'Ö«ñÛ.ò¿á(h¯Äò´ýÏ ÆB\0¬E¸?s*iê9)~QÄõÿ6+º·=Ml½UÀ<i½í¤ìgà°Wå,µ$Ü®(m¬ézq§6¥Ô"±¬o1ÜGw¾Yüá¼¸Æ$)ÍÏ(!jÃä »ãóªI,XÍÑãÈ_Ø±ã°=M6ØJX½>«¥$´ªFÏó	÷¨M/§=}WÃs¥FÈ$9»PsH0Ç3»P®WqöCðé~¥Ö}¸:taã/±©Ý×sôdv[<áëx[ôÿ0bñRºÊ½jËzhq¹J"Ò'*¤0Ó34Þ¯rÑöv[B/¨¿ê9!ïr÷²Çn5ÉMEk5Ú?7Úk,*dÔörÏk4VáÔÕÖÝjooooaú¼l^Û=}MQï]½ßQ²lÂù[g=M9	~êÃ3¨¨Ó 9ñgGze	¹©ulfÙ	|¯Sà¦oÌt= ¶zÈ<Ã·ÿñºßÏÃh]9Í©:#Dãø»­3LeÙ	¯©[¿)hÓ¯fó¦Ûæþ?p9
VïÈnÊ á$Ëµ¥Ö%Ú1Érn:fÓ¯æ¸©Õº£¬ó+ |;ýoô:*W(©Jÿ+vOÄb7<×­ßëÙ	[)oU89~ÚÇ3Í¿V¡N¢&¿vlGÐäÝk©&M6» ¡6!^°©äÞÔûÏ vÚÃBÆL¿,Y+ÏÇjàìL£¡Rñ¤ekX\ÍyF= 1X1ªhýQ^údç@!G
¥ Ñ)°+w±yÅIOiÇµ;gR#ó¨'%âfº£P¾ SÃã[¥Eýc&0v¢\G-ÌÏùÙ¡ÜpSX-UQÏ <ÄJ#i"Ú<Ùo;ðúÙ¡Ú6i¹|#òm·ÝßÝYÐÓ	= ë$}¥Ö
q_.Ä¾³}ÊðÿXi·xKQQK=MÎKÚ8ÏR«øé³M[§ÍôÛ§@4åÁË¿Ç(=Mð2¦ù ÍèÃÊÃ
Ë'ÇeÜ3£<ü¨Ü&lw"j5i,¤{öÞØ~OcÒWØ®æÏ¦ëJòªéøX¦±n«rüÆ»g/Ò	ðlzd²IªÎ~¨Ö j=Mv0ª¬¢©Aí~DøÝõU±nø+møFÛæiáFU'ª³'ø^%npÂû d)"~ßVÔÒY¿gò}Q7"Ìæ]Âº¯eFZ0í îv ídc§ª^i\Ò	qÖáÏ¿û·Ãdý©Äî-|7Ñ{à~UrÂVÆ¯£ª/wYÒF',nÃæV¶ócyçiØç7µe$ É~)&òûô$d1G5Sê=M@= ÓçÓ^=}Q²U¾µ:ã7ç4ÿît3?Âvsºïÿ
ðëA¨ 4e\WÓXÉ2¾Àl<U£{>f«#¬pªÔHê5_Ìîr³éÄ¼áõ,=}ËÖõ7Â= = T	qãMaÑ¤Ö)_;©T$¢¡k"×b¢"lë­}åëí"ÐDã:Ôo5{Ïªæ6Nnû?=M)~9Î* ä@­Äk¨c$ne&^3ÕÔ/Vì§"ñ1Ô¯»3Hæ}oTÏ{ËZ= jùÔòó¡6_DÒKM÷ÞwÙ.tRc£I!fuWw¶YYT»° I ·®D=M5ß®ÆhÙðí=M¨þ­¹§«ùïËÔtëYÌìnÉÔ~eóóÌ
íef»1öýÆìôu)Àê±tõ¸pK*ÄÕ;ñßé;{OtÑü;åpñÞSØo¬9<{	ÛS¼Súë!<qV»¶ã®Ôlù>Ä,(s³UÊ­Õ£õ5Éµ-û©^Üëã¶SÃC%(%^}3ùIã4}ý¼|
^ëºhÜ*ßÓ{ðÕ¥rí¬Øz´cTd<xOZ¡5¾µÙà?´àLsk|êLà; -«)rSXY»ûWf³Ü{JAÀÀÐ.pD× LØIÞoÉHö¤ÍI§{®/¥õ= 'ç+éy¹¦3ÁMjÌ:mÕP@²û×,Ö½0ù	:ÒÁ>!\¼á0%ãôw¡AGi´à/X®¤k¯þK²Ï:ÛÑýPHõ·_rÊ¾²îrÈO¸û8u=}ðè¡¸8ÐÑØQR5y)P/¿!5ÇZ#lõ;4°0­ÅÉ±RµòòÁ{±«W¯üý²!¥ú¯×U1¼{gÏTïìÑîu´&iFÀ7zÅÐ÷îHÁªT÷°s©ãÞCu½Pðìô»Y$íÌ?ËÜ*=Mq¤àþ?ðN\ëÝ§Ñdñ+´ä°iyßÌzp´(õ¦Lvç»P~áÆínÄÇ:Ñ= ×k¤Oæ~Ù¶Ï¦?¨¾Uh,a[SäÅP,æu«NèÆÝýI<Ç}:«3;·Õ = ·@kj;@#G:ÓWÚµ!­[>YÂyX×vF?êÀædø!¿ñ°×_o3¥)fÇ(LÝÙª±~O÷M{^=MuØ]§6áÊc$ÅT@{õI=M{÷¼d	Û³=}8>³LlÊUÕmí(kx¾ý;çZÇâùÂÀ+·@Xª¥¡ò F@¨¾	h<FB+îQ BG¨= h©¢âcWIå
21ä²¸´R»ç]rÁÓ·³ÖÜ}À^o³ô¤ðÚË'±<<äìqNun¬Ê%vu³0îlS%Ç *þ5HV÷ø9O tõn#he¤M·ÅÏKg³æÚ=M¥L&¬67°¬Òäªw+²¥Äq¼í°EW+ð/¦MüÚù=}]Åz?HËÂ+'·¸SÁ [ð9jÐ6ÂÈÏå ò%n38áü-1t±)	Å,W¬­GÏ¸£Qå¤^P5«4w¥Ýx¾vÉ7ì¸0FI,´4§ó7-+¬öXdo6ÊHî=M¤Ä.pU´ü$¶7÷þÔ±Bãÿ)(ö=MO/k4,NHEÊzØqìß,j[I®iÈªÇë[Ò¸îl¶uB×C°sÍ×Xµ{îw+\;K½@
M(¨Ll£v¬i?æÆQPê½²óÿ>¤ØfüÐ¬v;­RÐíMj\Èìë¦æz-K{|xÐJt<aóñ/·}µ½þæF®|´h_Å ÂQ%<ÊÙg2(e3ß/¡òm6Y/= s72õr7 x¡IuhzY_1nf>©Uc|zõ¥g¸¢}ÛOÕUéñ!%@Âíç¥ßm¹v9ôÈÚ+QÒcÏ?'À4c£%%àAÛ'.¯«¸Q¸¶0dÜS³îC£÷Ý%$ô¼pÄ:¹(hLd¯<#hö1X3³¢ÏÅØèÐøå§²Íú¡.¨KqÏ¸eÿ¾H¯æîÎÜ7³u= q/<ý\ióLñ$w£GÑ¹zÿôí©¶¦EØØ²HY7RöÇNðBAÆ§8ÿ&.ði? °v°¶ìcøø¤ähá= DW×mclÜê<ô|­p7<#lïsVÊ°ä3*5ÞHñ]Þû5Gòqw,uhõÁuJ¸vJ?HËL*Ç,wðB56T=}óíB×WîyM
ÒÂÌ±[¿m)i°­M
¡Íãe§(¤78m}ô= Þw^kF#].âÂ'à6"7ï ª¢Ã*¾	¾à·UóÝ71\gÒ«k®ÿunÑH[[1Î3.'5à·ËßuCLBÔgî­ïÖaäèûV3_×ÏævOqaçUZ<-KsZù~©\!¼¾^Íô2^?*\ÓRG+lÑ)ÀØËDÝf|]\xÂý$4ðÛþw¸9GÐ ýA·¶¶vpZºüX@@øp	4z&²Âj3É·=Må¯= v¾gUR¨Wdª­/x·+,ae*1ù¦vÎl
^mºò¦Ó"@×¥sô#ù  ;Êr[B¢êµ- [a|>]ê6¢JHXÎÒ@:{=}qá!ÍÌ³K¡ "A=Mä= °zÞÆç*1z^5ºbÏÈ*mZUíí ÅÐá´ çÏã){ÜÄ½
8ApG× ¬·F¼EÌ1å9ÚbnX&>÷ÿÉ~1$5@Òa,à¢'¹<i´Å?2U¸Ðá©´¡ª¬;pwÌ µÑËu ý¸Æ¸fæ­¾â@À2>Ðÿy2ûL¯×VãñéÊ^sY8éíÍ,FìQÖ§<uDR.´Oôùï lh%øiîcÜUª4Jsá±|"VèhejÙSqúcá5T©¶Ê¨^'Þl ±ÞSÄ¬#ÂÀÃ"¼ôÖ£;R"¡sÙáY¿±Y k Ç5wBY®z®³
V9Ý-[°,ÒÀ\l
þyãÈËh8ºÇ@´i1üÂ&qÙÖ-b:ê|Ï3 ¯üÃ¹¦Ædù"YèIÁ«_è;÷UÓ¬pÛCôÂ»s]@ÇD ëT®\,"jif¨ 	hg£> )[Ç9)Æ,3Ó©Î¼= ¸k@ÄÊÖH7¨Å9ywÐ¢WBÄ¨)*Ó/Û#:÷¤%ÛKu3f@¿Z(M=M°/ }àPC¡OCÿîòE?¥Æ±G(´MùcpÁ0¶YE$$IH®ô¼ÚXr§pþkÞå%>ÖÚn  ºóØ@ýµÐú-²ø\ø?L©}]NõqlÅiÑ3Ï³ì¥Ú½vëýô3?r+¬Áõ¥â4Û¥ )H¤ë}ºæQ´*Ã8¡x(ðª=M=}¶wªf4¯FR!"µö·\VêT)jâßm8¨ÛM¬¥úãcFÁÏrHÖ¢8[á¦c@¡JÍûv
Tb!r~{%u·Ûû3pC0¦wnP/{³¹½ Þs³¡å5!Üf^¦³Ó"ì¼QÌ¦kú5µ-ðøD¿h6õÈ þ©ªVàÍà©×ãGß¬H#þhïdiÊàÕ\-´°3Tê¼Eû¤ .[fL¡Jü,ÉKÃ®ëBF³.Z*ÌE¨V^
¯ªf#ºuºY)êÜ£Pñf×Z	Iºæ2ÞÆÔUÇx4"BU®¯RÐúÖ:ô·eAAlD,[Oò0bÁ¡){Ãuánò\ a?ÁlaÇPæÌ+ê° ?ywíÑî.Ùãë3;+@ü>Õ= î}1võQ%n<_¸FÆï!ZµÑã}¡"ÉS°É'íÔ¶¶)ÞÒü;?í÷LäIá¨H0Ô#ÁB§#J½¢=}î¥"ÉØ\?rÚÃp®2q(=MY¯hµ ¥x4ôË_·2ögÉXP/_ÇF|Ë¾ÿfêÛ*Ó2 q¸Ó®»cþëÝSÛ¹
rÞ¤®Qb.©6®8W
³Ågz¦Û**ºYbY,ÒZð$æÍ¸oíÁhóÃdrö #°ñ0Ì^kØâ\Ìºå umónÏxÂA5ÁkmW,iÖL4aavw¹Ç°=M3ªë09WTÓ­¤Énýö§:Îâ-* bÀi­%º²ÜÖ±bÝÏ	Ïna«è
êÕw®ç§·ÁÂz ~	ûµ/<4Ç¬Õf¢P{½}Ù®ÏI ä1Áb= ÐgçM$7G=}sd¹P»ì2U©B¿eM&%T
5´iâgeúeù'ú¾"Ie$ðW´K*¼ÚE=M T	 àýoC½7Äf*±²ýÔLBÞûGW ô õ¥sÏÄûnüvw¢]×0LþQiÅK¿¬ÇÀ¤¬/´õ	4tµbU,¢2¬ ÄtppåkJÌD·É7æýD8ªüMÀLbÝå?;¤$Â1½\iJfÙèôA»ýMÝCuü)ÏUx}êßj¡4x¢âêä¯±%§^¸©ïÂõ¡´ÃÌãq§è&¾Þ°®÷á]9´Fñ Ý3+c¾ë60\¹þ7ú=MÑyÿ-)F¿ÑF¤2Ù­ÂgÍ=}2ÈHéº?é.½=MORèàl;U¸/wØs¯£à±:7p©:®¡ZLá*wE#vShdäª¥JNóq¯BîÅó¡JVAve7¿Á,´¦@0PôRC5aÚç¸\·}x¡r6Ïpoÿ÷ÁÕ«G_Ü7dqé³wJÏ¯3Ë |FKcÈ¡´+/ÍN4Jðø VnÛ·ø= ¸«A,¬*=}óo@Ú¿ö»b=MAöf_ú³ï¢ÓÑ¢ÐÌJtSò²LI>Ix'áÎº°»â=MC¼Vé^>Ý¹V9§ãÉ-Ð|£CÖËÜ­ùCt[
Fg7WÚlÂ³ä¯Õsü÷±,d%¤ÊÒzjªGI®®&)AeQÞÈÇ.ú:VÂ$Éíøßó¦²°Po{±]Êv,NXå¸P8Ý_#12·u",Æ4bà"¡&ÚªGÊz§§\üÝ½gò6Ñ&{àciÓÉ¯f»5[ =}#ÿ¼\ëe}²¾~ªi~ÆÓa§N@væ4L­lì=}Y°EQÆÈ©8÷_d*8M×ÿÐÉøa=M­³«5nm'±öq\±/+â!4g,TN»ø P©0}[zñZÿèr)¦EÏ;N¡ß$= ¢aÛÁÔdº®Ñ;Xò\tIþ}T¾grGu<ï rB¯Õ}PÞîãB=}iÓ5ÀÁ)Y.½Ãqó ÓS«N¡µaÜT,BÊõd'~²h%tüõÀíÖzô{DW Àþ=M «.v·õâñÉe6eR¾fµh¾ñ¼¶zõñèLLRYË"&ÅÃ£z{èý4LÄ.H¬41~ÈdPîÏÀ¼ð lröø*¿pÇÃiz.aá^¹î/u ?a£e±lzZÚ>\¦ê= ²HõsßÔ1/ô= F¨e´B{¸Û­ºÇûf©U8grÉ4â	²À ¾Ï+Â§¹ò@YÆª´+±õ1½Ê'·³ó¯¼ô{	1ç£Ü½~ííÍñFû{M\ÎîÖ5h¼L+;Âf4Rs³++ôp¥\±(KR{0ãÏýñÍ;&e¤»ïí9øl-Eî¦§âz{´ÈDÔ¬Ì@ìCÖt Hv¹é³ûé#= 1H/10ûÍX¬!L&Ì[(Ì£¸©äh´|®gû4×½Y~#¹øÿ'÷J×dF4¸T÷ ¥£bÏçÜþMªúSOÅúr0pÛG¯µ]LU³ÍÝH<äO³Åúª"Nðå+/±#Ñ¸£¼Ä/]»ÀÎ0¾ôËÍDÍ½IæÇÀöàHÂ=Mæké+êévË|àÅ.UK
ôF1c§Ô+ÎÜ¤¦$îP7ä¼ÕJ>ëC¸¬KX»N8üÐÀ­G2¥g>}r°ùÊæ.¨ä¸´&ÈWûq
6¹ïÿâî¨Ïº%Ú!ÜMÞÀU=}ð"ÛZ­ÃjÇ=}âY<úÍìuõ÷p¿pÕ6âqäÔfÔÜá;ÀÛ	)Û)%			^e	I!=MüíY¡NÈîRþ@/·°ÍmOÀÇ(óuWu!¸õVgÆ½ó5hí²¾8,ÚAÌr4AöäfgeÕ"Zz
i,òk¬SÎ%>6û¼u
ªùâ{rþJªÆ0³îêqvHÕS8í´öhm±hÜè¿ô<ÏjÛ
Ëä\rçÓ'ñmúÉgðB;9i¨ÜÌ{îRxø+Tz®
åÞë¥vì[JþæZmË[µ÷ª4}qRÒÜ4Ýf~ |1¬ 9¹5lK/=M0JÓNuÏMüæ­Þû¸Y4 #x|= >ÍÆZ¯:nR{ª$* ¶¶2èÌ>%m ÿQd±P-
ÁoJäcNôK)÷è63W+¨¥nÆ¡A§áÆ§ßWqsÝ#ºF
6]äc&õîáÊæ:=}Â|<f¥¢e£Àà^	Ì4Öçã#s^MY=M:­uygmqEÊÑr«¢H·ÀY>?ÕAëéXjÖb&ù ¡6âyÚÑÌúxô¬¼H'¬+5pP*þüGzñè7A)-	Ê0BDmHÐ Þ+ª0®G±uRMGm/Y<¥go³§Â4Hð=}óç6À-	éàsó9uÉ+,â¥Ò.ØöÑü0k5­Ñ¦.&ëüýpz|Ú¦ZdhæÀùèíü<= é!gaô·îØµÈIC;­|°Ëo~)ñ{Pö<FÑ{D¸ðÓe9?hBêÀ-
²×öÞ1ûWDPzö¡j÷ßøÆZ
aDM¹}éO70ÈÓÔ2?A,Æ¨d«OãÚ÷YTKmæ:¸ÆÜÆhàèdUo·æ}ÆmßwMå¾!UìxøCGHFGfnØk:e±Æ)ùTÂÊ¬o¥ü·Hp×ÛcI#º|&ûß4qYêæwA¼íE£0Ôx²'Õ'=}æ»DÄêóÈâ6jÅ^p·~Païw
¸°N¼í7­×~j:ÎG H smâmá«7-°í =}mÙi'pë*K2¡ÞâV^É%gg~lç½Ò
°oã)kË*c¦ÿJø_µ ³ÜéßÒïÔ=M°I°j,KCÌ}}P¥Øs._ÆõZ¬´äêN­»ö²¸Ã#ÊG?­UÙ­JejzûË(}®¨gñ¬Ïº<õ6ë8eK>$Öæ3ù³²sæ+¿á]#[:ÜJ6ì@¡÷!U£ i{ê= =}iU,m0Ü±ôú°ÿ×µßc¦¥ß¯S$V£N£Î®^7#Áv#I/ÙGu;ä©0xNðqßÜJd-cÅ;¿±n	ÌÇÕ"àÖQRs½BÜ|ÇI }¶à'ÛCÊ³@æ/¤Ôw+aAå©çI2äÄ+1á±TOòãÇÇçOòäÏ³z®³Ð ´ß£VTIn¸èÕ²º=}ga;v8\GTÑwax¨h{Ôdqª_j±¬ÍJßÊdñ©Gjy¨Þ´S¶ÁÞË{#À»¬Ë*ßãS¤ÞT4¾¤~©nvZmo	åt]ÒPJDwâÌ¶¿STjÝ%¸¤Îß9«9ªÏ{56#ðßyµ»SDv¨aÅ°w1¨jÉ[§2¿8¸´ÌÝÐx8Ü EýÜKv»|U¼øhÌeñë(Ã£UYçúçDSLîù_õúÇÿ(4¿º¤Ot=}w|é8HÛísfmc[DÒoêûtPW½]=}ÇsKê¼LV²6kòfÄx(&«ÁAzq1Q+j'ÕA\BZd ;W¼Ñèü*Å[À×$ì|µ±uûÈe«&G{¬öoa³F°ôî³=}C"|pzJ8ÀD,eO2f:·®¨À¯8ÂOÏÛÈ5\TöFsP¼+½#5[k0E¼ù{! ¢W=MéØ=Mx¢+áGê,?	æåh¯tgÁw´%uu¦ÅnëåÐ/Þê%Åï=}PJKqÝCG=}¹ØæS·í£ 7{ï¿8ïã¶<·<ûk e&f0½Ñ&Þ´=}ÄéN¢ØhaÄáTü%5íÀÛìl¿dU|ïp &4^Æv2{h÷ Å7+x®îß¸Hdjô@m«hÑß,Ìf9øâP^ú¦"e¥wkWxWÞ6¦¾?i²þéC»TNô&¾pHß´Â5=M:d´R, N»¸½:zÃÊú4ËB¡ÖþZ@  Ã2iÒtÅ/© FÆÉXÕÓO³¾Ûs0æ³(é»RÅ¢:zuwçÕ?½d÷8¿òÃ\¡°Q/Ý¿¡9/p_2WÚGy3f8øIëV9I.\êÿöG =M9Uý+ ÷Ü}J~@»o¨q§_>Ëd1ÕüIÃ=}=}µ¶I^pãÕñó+k#càñõ­´ö¥t(ÛC³= ­Ôuà+DÁå½çòòÃÕ= ±tx§tt>³nÝ*ë¤´TÇPJ³z°+9áÉÄ¹"ïÊ¢§2?]°¼&KiÖNrï/À¶½SLj±¬Ù±{{µO«ûTd#ÁÞË{	cÙàé%ôckª§þ²{]jé%ð¥ÙäÊ61ïë*åfa×ÿ®°zæÕd)¤¾OÆûÒà2È%P©xî%¦yûîSc]ñuD»G¦:$3ß&m¿=}JÀ*¥¹* ñ*1·Môþy61ÇoÕ*ø±úx£~ìdScäçZj.=MeäML\òc>@Òf7ý~¬ñ¥ãÜ{ 
YåQdÙ°ï0·uØÛ&qa¡Ê¦Wg
1.µ{]1nnÃeþï¤;ÖDÉYR¦Yjòæv§é²µ-õaRÛÈ\²ò¤¥Êè¦ð=MVÂ¬×MANdYËÑúa¶mà+ÂßgH»hI.Ú@ÚbLÚb%ðPðPðºoýÄlIs,w/æÃ²Ù*Ø%~@n4Î½nN"-3Õ5<i©túQmø­ÊJà³q'ØÙ¬î÷µ-¡:]R­2ÆîyOïøøIG÷îYíÑ|1Ç~Õn9\dQ©~àÖ5¯°fÖøK\baozÕfnaZB:ÑvnÕÖÖ"glíoÕrùÁ1¶ÊÅ±èçM%m_ÛKæØÈJ±A¼kâbÎû)3ÍL= õ§q Î°dËøÂ½]:}x-Ü¸£-Ì(= ð*f¢×Q ]µÈsFØdþmZ·,À^þdH!7d=}¨õè6ÁèEÁ
-ÚØÛ/o= ãÕ-  P=MQÿ°ÑÕDºYÈäÃ\ÇªÚ¸ç=}ì.s[ërGJÊDàoâ«»bÙÔÊ«!S_pðùôG¥	ÛH¿×TùË3®³ddú vêKÎ®[ïºYMÃrcÃuÔOñw¾²PYãM_ón,%Ùré¹\,Öãrz%ám:±haMUNyºã=}òævS®bÃúaËPÀSºõ»NÊc­Ü¬¡ËiôFnÎ;?]	ØsþiÄß=}KS=}íÅahGØ|ú,éfõÐ"Ý'd­NÍÍÉ
3"A}Çó©ÍøU/¾äÊºå.mÌIÛÜÎbÐ5
ëËm§ãOÑô  [wmó 3IL#Wõ¥Õ)_·¿Ðk4Eö±Kd§%#Í4wÆ:ì¡ :;ÇÐ7­ýw§æùùY|Ìq7-
\Ôo­¿+V~QÀwD}ÉÒK¹hÓ¹ÅD¡)òÅÅ£à¬üÆÏdjc¤±0ùÙª,ØÔ·}çÿÙôý½;)¾jÈÅw3x·þÇ|¬= Iï$xiÌKSÍÉL<mó<Åoª7q]o2
hþð= üIÕ®)õMÑ÷v×¨Â*ñ;©v/oæ¨K®»ÌEþÑ
¡FÔÆVíV=}% Erð¥YSHyG9ÿ*Ðäyï9)!,ä5d/î×ÑfVÛ>6t
FtCÜ5¿½= x¡K±û	p=MÌìóÁèÞ÷(+~Èðð=M\¹ÐÑ»É:(ù5XàV=MÏ¬á²Ü uSÓ%$ik<d-oÓ¿¬å5®5ÇÔàÎ³oþ!LtÜ	+4LJfI×:ïæ=}ëâÉîÒhÒ\$8%?å}¸ÿé¦ÝÅ¬ºÙÔ^¤Ö(;°¦®ë½¨ßõÚ¢Ó¨LG´èçÙ;ü1j¯Á#yï¤Æ:ÎàæpQRE1 îWøMûG9­çuwG"}õ¦îNÈfÔëI%uåzÜzoüj)²9ÁíC>ìojóy-¢Mù¯»w8,Ë1B¹³&¢­Õ¢!'!}uå³17¬HMm+Óíé	É¦]Ý·oÿQÕp§/<bC2êÌØ|~dr´<ø.:a4ëTCãðEmóiï3âTÀÑì7p#¿Ì1Äð¾Ì_ýä\mñguiz$§|äÔLèPÀñz¯u]Áç[dÍàæ­=}+A­qS¼ô£cÂó£'£¨uÇ	Ù81Ï=}Yü,2k#ÑÍC.¢ËØeËa¬¶¸7¼ªêGªå7Dä°ëî±Å3ÕúôÕ»l@ë÷¾ÃæÃ¬xÍnN¼)]è¦ì§µDÃÃË!UgÆsèMpÑ9'ë±BËÏ×Ä\¤þ·ÿ#5LkÏ¬Âjyû4[/ÿëî¯¨ôR#»¯Iün¦^ÀPZmýÿó70ø]ºD\àYÇR¸B÷×ÈAº1ÝFÒ¡6.¢¡ââ"¡fèf7É¬J7!ªPÝÙ= ¤×\ØQäz¯w%ÈÉï±uUí±t¢IÍ>_ÈîkÑ!ô½OÐR·iX]GF²	ìâhØbo	"_	Ï'²ëç9ÊMê,ÎZÈ¥*IO³I¸&+ì1aã¶vÐ»]8uÁ9ëÛÑË1âFc=MÆ\#PüóCÄj&Y7T´Eøè:v&¬5I}ÑÄÌ©Ý)S/cëtÁvy×.iu8¯Iî«³ú°ü	>4¿vyÆ%âKiÝVÅ@ñ1¶¶ ñÚX3ª£wØÃÀÞ,EÜ
~ðF¼ÜÃjW²C«¸GüPcA,"s(\«[1²I¥8@n°øBK	«Ùtj5·eÕÖ¥t~ÿú;ïd=M,ë¿ðÇü?JuùJîÏó(¹è'>i7åkõ:Ø8Åg4HÅUHIáhÛ)ïH<ÕOûAJßJ!Ì}mÔëöW=MÒ
øzxåß=M/
N+v©·-ÖýI.'Ü_Hýòh©rÖ©r¨×ù&%ü§ß Ôë"uI%T%OÊ°Á vïÿæGÞmF7Æ%2c=M ;öæx/äÛ#Ígã/}óTáI²WÄÑútB(# éIÁñ#Z3l*Æ:æP\J2M°ýÕ¾æ\ø Ý½jGø= ÊÛ/qYßÇTÉê~¡³FqnÄéÐDRnd ±n,ÐÕEÑÛÌÐò?9Þ+ßg)Æ{P :OmÑÜcÑ¼|cSPÕ{ÀvD0Å¦aAÅÒÍBA= 3¬Vá,ö-×·åsB/×¼àØ6W éLº\IÂÄ´£hªWB0¨zÇ*á£/8ÏVuä[fØlûIG0ã=MFhÔmÌfB5²ñlEÜÁÝÏÀP·ÍrÛÁsA"Ð¼1ªnÐ8óÃxô3·Ýî«'À7æ-g&5Fõ9ð¿	»N[ñ&¡WLÉ{Ó=}n=}fWI$1^ü¾ì1züFØôÂÒ%²Cd1
(æ¿Jå±ì»B¿~«okÄá+Î]7ß²ã<ßæ<2öÜ;Ú¯,|§Ry=}Cy<ÔSg¤k×ôA®j,ËR¾]¬è7Y¹ùA7üh»ÀÍ?÷3Õ(ÓñsÅvÈ°pZ¼WÝeÓWíR¼¡ÌêÁÉG¸ò* úÀ
!ÙNÏ¾æ)¦SMk§8AoôµUëàD
¬®U­^â?ÕAþfF,¤NÖ{¬Üè+IÝLªkþ§=}±­Ð|Ìþ~£T§ÃßÛ;VÉ6iu=}UGÁ¾aá=Mh3Ì	Ó~c.}ÏUÂ7Z«Ê0Æö@4f/<u/pÕk;Öø8·Á§~Ê0ñ<XÎóU¼nEÍgO#Ñ®ìlO»3×Ü:õ5ø3j.6(To./ÂßãåsÎ@LK§t%ç¸#ÉÐöoï3$'ÐÁ|.	iHóÛ/©^í*\;sy±üSy]ÕðºÇàl¬Ô~ã9wMn«×¾W}C,/&­ºÖÂwP4ù²näá±m¤á±ë62	ìjYùÌhiÌ)ñl¼®ÀÖÝjo/q9Ê(ä"õÑ{Ê3²-HD¿ºj¯ùÛëÞºýÎIÞyþÔ¥ïùØ¡2ÇêiVUçSé8¾¥ÃææÑOèÈ¦òøÇ;QíOPîz÷ñàYÇdÏ?ãºµù{Ö(ZÎ\ñ´fç0'fm9^©ì!62[§Ãõ£UB+EñP¤Ç_¸ãóÿv9pdp0üÌ]ÙÂ,ÍaV·ÍVT$#Ê6×@ÚòÂLÝa:Ë[T¿%Ö±ñà¹xÌqý¢ÖA´DÚr#Î~Ò= ,BZö °1ß¡£@w;ãì·¡BHÆ>,ÈÙ±\gÆÙu+ø²óíØ©ãzÄÐ#ãËïW»£æ´Úá¼:x«¶úHtL®³²wNÓñÒeG&ðõwüÖ0¢A	ýÚNhég[JK(Ô ¿¬ûñÚM/o·=}¬Há>{øN-pÆ¯ÁLúÂÓÐ«æG¶~ã»¥%S|¬ûä&48¾Ï~3'tG90x¯Â«DÇjð0-6'"Jb¿SBn¤%Âwf®¤¢éÞ#i§&= þõ¦¢wÚ¬C2êt'!ã@m'qa$äUjKÇ¡k¶D2áò Yç$nNÓlã búB´ôï¶2èé:Pbìb!Â÷Êæ4!ÝÎê0Pi[O4*K¶1)Ek=MgÓâh,~p_¾ yÉnà³Tr¿ÆÀ_ºÕ	0Züoì&aÄÈ©%{g"+ñ jÂ¦ýòÕÌjvwÁ]ÍrdGÕÆqnxp<^L*Î OãÈá1LjK= ßÎ">g'èø:¬S>·BqA¢sDý§ÐÖÆãÚs~K²æ³Z\âIÿÔ´{¹$êþ¿ÈS6K¾eó ±am+TÏfcoÒ~§×¡øÚn¹Î_?zyúGÃYÿîÄNõK]Ì¹¶ì§gÀÆvH¶¢çªb)'Å5Idj>µç¢W¾í¥­:øiµe=}Æk¸ÖJ¥=}(+%°9g¯?d(xÄo7¨¯s&K±øÇÒl¾ä"zÉÜøYÜíÀÚkv±#mO*süÂGçìR@¼3'Mý3.BB]Ï= a~SÀQ9,xìÄêð!Ç@¶Úu50*! y!p°ûó¿VäWvËLý4rIP2Î6jèßë!o-ÿ<ØoÉuá¼¤É@¤;|Y1H\êÏt3î÷âÿÍç«8n¬~;:qB@uJ>ð²ÚlÅQñø5 
*j$^örÁ\Ì \\Ml@1kë+Ì°¯îÐ÷ó2(Þgã+Y:ÉXÚ5Î%jÔi^ußò| Q¬Ñ¤bO¹È^[)t+J
÷%j­fÜM@V2ñ¹Mîx9V¨ø­Ú8­Na)ÝÁðà¹4ÝÊ·øf#çTÆps!K þôP Ê¥Sü¦ôM»Wïæq¯¨5#ÀAJ'gdk®zÉaÕ)IÓK×6ò¯×þí'MÚ¨j=M<T¿n°¥Vi=M&6hß¢À×O]M6o
á&ÆC^é¯X,¸ìnI]ÀÁ^z»d®¯I¡QHm¦©5Õb áÍ9þ6âi0}AàÙ+
îÇRliû3^äÈ»]ÊR6i¦v)^æ\^UlÝóPc"¾Z´nGQm*Lô\@¯a	wÞ×@@ðªZr&b}ô5êl½r,uàþºÙTfÐ¡G?"
Å«>ë]ËÙàôû]µ|ÞCë*hôóÀ&ÙõaX_[jz|#(Bä£NÁ \}ÓBa&¬þWnGÕ$GEÏC=}¶ÀG9$p1øA.\öj=MV' ©Náõsò5è¨ùÅª·¶ÿÅÞåDê¦h{ª+2®¿-'«ËºU,sØK-*uÓY(XXXnÚó¶Õ yF/EîOmõ­ýEÇÖè@vð¿×éÿqRÍ(ûQLW;\Ë½bnl=M<Ç©a°Þ·½ñ¡MçUÓVÉU?ä{2âÆÔö^Ü>°þÄÅSe[cãqØP*_ÏkaUpvÇÙ|fN^Øý:7.6x7\ûñ<Üß$s=M;Û­ãêtçÚ@íd¦û<ìç·ÿæRz[¯Ølß%Ëûm½/HpyS;;g"Ús;= d Ç2ý®ÝÒÞî¥STåiÃcQ.½þb·Íá/3ð´i3oÇ8uCj]$§ÃßÉé¢¼»xèO¼Çµ×hÙë£.s~·xÅ¶Uw3ÔÂZí×IFÔBs;ëý½ì÷!eÆ-dòìej ¸L"ðµáÓRîejj×{ëejêjíÎWÌäyz§¼ºçbä¬ð§uáiW2Õ0õ2U6=}ìGÄ½e3>ë«_MR¥ò¨^Á´ljs-g"Ýëlb]ÔD_MÎ¬a õè¶ádZa ?¹%ÄñÀJSy'÷tUDdÓMùì /Wï/ßãæ<UL°-t$t¼MßÐ-	ó"*R¾X_èþéhJé2R»"XÁ°¾ ÅLWofEå4aë	K)@Êúe-¿òÙ±¢n@;öôr¬\cÜ$øY¯NxúóßHL´¡)¥pÌIé"¯T©ÎØ"H®	Þô7÷IËoÌ#á¶ÌÊ'çÅ+¿ª¾5òèÒ|ic@¬;MVï7¾m¦­ûxy±t¢FÜ¦È[Ê8Y@(KlXSü©éälã+7¼¼Õ :=}r´Öú=}Ú2/ÆÆ	¿"éuÀ¿r;¿r;ÊzÇj¾©1Bµíøo¶Îi¡4õx	?PÅ´6,>9¬|¯,9ÎäQíHfÿ9UÁüGoA)\ïú|ð±ìZWôBÔ4i)VÀçíþÆUJÓn÷Ìï{¿ÛCQ¿Íp{è\3´
Î´WÊôJ1¹"\K"5liýI³õÜÏ Åb¹ÅD¹\FÒ)¾Ä_×»jÒùk)à"~çp3Ì²]¤ö5À¹(°n5k½¥çY%½zaTìd= ]­Vµ,XAG?
Ô/ùÌ$äÑìdX-ØIÙq.iÖ9²ýÿhÄx;sÄa÷eú¤ÙÎ´tlã÷Wê¶µüs+}]å¾g.¯Ðm-(-däþJÚ±ké¼I%i¼-Äj¨ü<3= ÕsðKß¨ÙäDB*xgÕI&¡·òÖATfÕ+kÁ6¦Ñs×Ò^÷^H!ÜÆxÕ@¯m²ãRÊ0ýþYÄÌk©Êí¥4°Q9îÅ6}¸vOÜê(ÞGô~qWrd½S«½1Þ]þÒ('+µÀ§øKÔ<ÿ·;É-!ÝÅ5Fo@ä²øe+'.ßÔdë.ô+Ç£¥lPrÆÑnëÕì7kÐ§*E(fë*sÍIHLê¨¨y}µJµ4Di.}®P{ÊBÀ±0ã§ë ]î&[ëêå6<ùàßÙxÂxÕØÎrEÕaÓ¤µøÊ=Må¬¢§bKÐN|®ºÔvÐ+<Wugã¸b:Ças@®r<äï "úøkDlBX/néÞ<§¤7ÆsÚ -æÂlÑ|'Ãd#ô[O">~ÃÔ»Ú\ÿ¯'K>^á­	0ÿKDõæùVæQJ,Qü'ý¦^xâøöà,YÌhuÈU=M"RÄ÷ÞÞië@= Y8uL DÊEì¡è¡ynV¹´ã	(u¥ÈêMDpªÈ®hKÑS~GúÞe§ÖÅÐ4Ùpê¬rðÖ#V.¾¦³bIç×}CÎ)Kú6VO¾*iÂ@ád7QHæ³¿AgL¨®¦Òþïô¼-Çöb½4IóH´Ì@Zo=}àyK?Ý«GáE:uÿ²D&&Â¨Ð¸[h¥¡w:z|êÖ>GmzÂë ^ä4°Áè]XFª	ÞÎÎèyW¬L Y¶¸Üùþü ³Ô63ÖÈtÃ@-(¦¼²µ\*ÃäÒv¿IH«y%ÏÓB±=}kÅÌ÷GÍ=M[íNî9rÆ.ÞÊÍá= 6ï2- N(¤ÁYÀÕÇ²d¹äã?%B=MÌëãÆà(°#>ïOí]9¤ûÙÆ¥Íß¾=}Ji1z6.~C¯õ¾Ò°=}3ÅàC)÷!jSnS\©uÑxù<ÝÒ= ]ïQf*÷²x´ýÅ ý&LJÎc2¿Yf÷E7#øÑµ?§:ÉÏhÞ­^.å.ÝÈ¶£=M\/@ ¹ØõóYêbÊ\ïu¦²a´7vÒf op´bÈ_&¹rzl¡jÔ¿öß$YÜNafä.p,¿±&1I¿Y= }·Ïx{Òì¿]%zÀTÚ6CæµÆ1l÷ùPõòÖZ[1ìû +WzÁzÁNp!n!bK Y= ´Ñe+wçvæ°\Jª>÷¢0?cc6­ÚA_d´­«vr¹ÞN2¤k<6ã7z,	µYô¶¶¨×åþÍ­HxDôxZ½WäøÀ>>Õ(æ8ÿ),Ü/>2¤üÿµ:GËj*&"fDÃøTÈ5Îõ0é¡üóiV%:õs88^V_|§Põ³~)ÕÛZ
ÐÒÕhþÿø¯KBàÆÂÖ9ûcþÉµ¥Ð/ôÈíZ¡g&= »ìJ"øÒhLeLKï0û©nõ ¥mý~öÿýÒâ%àY D6Û[sn¬o|¼Üd½eÐ<aúÌ±£3§çIðõ=}n0 Ëlp	'å&ÀÞqDÑ,@Ýùq }µbâV&¬5Íô3_FzêÖOÎm>q¹W%ÚaÄ±ÕnÅtx¡+Ü~Ñ@ã¿'¸xÎÃ÷ï0^ªw)WS®oiFq»Ä© ´<ÑDöÛNO%9÷Sr¼Ío÷!U6ÝØç¦^äw»ð^ñ=}57= iæÌÞÈÍùî§Õfdµé:òÓA¥×Ówp¾ ¾kÜhf/axr®·º]àßãþ¸«s¥âòFä½WÁCêèc¹}h~¤ÉÑÎ½1÷jlyú	iO1ý­SZáÑÂP¹oV#¡²ú Ê¾Öýqo¤;j3wÁ}ê4wéLjgfêO­0n-? gi¾þ÷§@Ï²HP-iUÕ7 ¢Kù_<UòÎnÈH¶L5)[gÅæRâ´.ßÉ^sIþ¾7\}~J1paõÏËQ,wJªÁýÞSÓ.¸áäÃÀ·t/ÅÝ$ÅÃÛbµègÙ¤9üÆ*[A­ujr$µcñ£ñ¸wÄo·UÏã{ù«à-¾ûZçn<ßÞ77£nÒäyZîr>çM®jµß&aæË°©íñÂÒj3ê÷¢Èh¤<U²"p)Ü%;Ùªe;^þð0!8áÑ&VÆÝèÁe'=MüSß_òZÃv¿= 2= k)U>'(åó¿ì]øu½ñ÷ÂÏøÞ?ÜåJîMl«ûìêkh]¿hmVï¶zg[]UÒ/¿Py04Û5Ù;þ:-6ce0CÆÔH=MT²aÃê*;Öãë6;ïmÂm7dî®,Wrû!'CçfEÊÐÓ¯UÖ6±¹Õ$¸ºÛ?Òy^	+=MÈ<7¯>9eXe"i¥|±£~±úi
ù£Â= (­´ÇzuRh|ã½L
â÷êÍfcaræ@âóÍÙPNÒælõÃÀ½Ô@0¦ÏlÿíTùV.ÓPÜ;²e3 OòT]w<Qõÿ06lÂN­Ý¬5fÝ|}IàælNÉû¬KLâ¼P6ä0®gÂ5®&t¹ÊåLáK9Då¡³Â· õ¬@ÞV¨Ëí³ëçÔG³üö»~%cv¬é
­ûå GDKfêá¦sö«Ù å/CXóùIí ØÀ@Ó= 0ÊÝ!K<ô>WÓÈ-è4	G{)öL8«?BP»«·lrõn·Éy¼a8_jÌ¾Gy./êÝ¥öAÝû¯Î;Ýû@F~ÏR½\gÑö= ÐÞV0ö×¬:î»hëFæùãí=M]¼Ùûü£{3 ¤ùp<ût? ÅJÆ(2X}}äèqÉïëXåew}56Ãæv«ÄúºÃvn	çvø±úÎ_n²©tíO-t~Öd(Ô6!õZhÞr/í³â'u=}m³çRÍìUæÔ+¥9r NtDþ¡\Gb0Áé]utÆZkêë?ý<Ð>ùLëé{Rôãhr®dg½ºÒî_Á'gf«UÉS ë1ÆjúSJÊQ$×=M_ÑT_³íD+¬®'JÁ¸Ææ8î6¯òÖ¢ÐAÕ²~³¡)BeêéÕv>0´ïOÆj¶%Nô¡ÑVhd4Q+õBÙüÚßU"þX ÀB´a.'}_AÜ£¶ã¾1¯7HñDò²íJvwSÂ£¹ñ2%ÉM×3qC2°	9=}Ç] gs sl{ ½_ÊK[®e«ØäÜ$ xïScBÛzÃ,C6!r]?;¥f&	^a¿?]²0B_b1oÁäïîXh&ý"GísÚ³ÿúR
H QÏú¶}i»7¢æatæ ÖÉÔîe o°= ¡8®À	g(N Z\"íòéÇË7lÎëÕÜKorÐvíGõ7aÕ÷*ê&¸®<GÖá4ûö4kDÿFØ.?6þ4â/¦Í{rÍzL0sæìðÏZþáëÏóJÂNë-6-½_pr´/[F÷]·ÏË(èLJÚ|®5(´èæÒ²¬°0ê×ØkÖ= Æýñ/h]0h?ØÆø¼=M
SHn];9ÐXTêðpßq=}gsK9XÔíÍÊ§+¹ânßª÷@ì5)'q@ ¤/î©¸#(aÞÇVUo:ÈÑå°r<Zr H»}:_%Ö¦·í&÷õØo©¨rªIÆù^smî¦¾ùj¦ñ7à=M¾çß^öM²!ád~°Á~&h/ y3#ñàÙ'nE¦»ÑÐÜ£h¤¸¾sÝÈã³
)ù(øqùå;LbaHóÛê	|ÿd8Ú¤õÌ¯ DÖ3MoXaþF¯%E	#^èÖÈà[ã¥)ð²ÒOà_#øcÃõñ	[ÂSÒlï,@|r6@V [Â¨;«£r7³$S#¶G SØ¯Èáæ92eDüù?ðM¥Äf.¿YÆ&«S3¥s>tÌm+i»t DþOü'±¬GJ9êlôü¼Rù.3×3= Þ.:oÐE>K<?Ï£ÖÈm·ÿ1q=MäÌUû×UÔÏØ80ë«ÞK¤x XªQÕ3ÓªÃ:ÈI°Iü38°<J%ùÐð0qÏÐ9PÉØÕê·$ðáºªß¥ÿ¬»_I¡Fã?-uÙd.hÚÆvþ$¥_GÞT4¦¾3]Ý¡TØt½ìís¾oýþ²^×ÜÚsvüúõâñtÚI\ÌÎß®ZIn]êÍýx£ý ¿ÝÅ®¦tÓ¥Rªðì)xI(zî?*³'l5Í}¦³ÁUîyª±få%²= ¥ë_åd£R2 Ý^brÿÁ$0ºá$= :Jc@ªæ»õìz>ÎðgNÛV1ãhQ= Qfß²4-ÇÒ8X¬¸£,¤wàm5è*íT8£*$cmChýSMrÝ¶öpÅªp] U3Þè1lÜ¶Ü;ós·ï)è,YW£È~åð>¼GhcÏÌ¼¸ÿþhk)d´QÞGb%è¼MlKìjý·=}k:#ÌÏðH3ÜÌú\N>Ì= ¾ ÒÚí¨	üU:.cÜá9ëFS¬=}r×½\¶ûN­1k."T½¹W¿|;ZäÐúüßV]:0Ó| Cþ;\YëæßÙ ÁBöÌ¶~ Û#ð1bB|jèj¤#þ_ñ5Ä ÍnZûse²¡$Â£D¨_ºxxi¹£Õ±S¾»T® ÙØ4íA½kTÄ=Mf××íRëG²3\ï£NQÇô½FÙN¶ ý}§?¶ÔìvâX±>boÎgV ¾÷³Ùøl2NæäÑÞÇªýÇ9Á¬òo§/gK~Xh#¼|ã~ðª¦+Cät~Ikbi3gK(5D¹ÎV¥îÿtÑ÷Wo­¹X]m|FÖë+.\Oÿs¿ëwéR]ÜÈ6¡³	º 3Á_õ¯ú@bXT;xUq=Mq&O¼¡ &¶©üÉlÖ(e&­äJ¦ú/éü
=}Z¶µR÷TÎOjÉYÄ4ýÏìë@âÒU{Î\h'
æhÄ!ðLyOgæyM0mØ|Îtk­ýL2÷U~Q¹Ä¿oy´T$°õ¢]¹KùáÑéÂ¨³¦±\i³£ÉÓ)(Qþe8O»v°ñàý\GKÍ¯Ú)ÚI-6ÛÛªq×ÎE]¡Sç5tÙÃø91^ ÅíM@»~ds½=M_3 uun¼\-=}X:i÷}}Ct:Yäå¸ÐUÀ70jäl©ôãÒ#nØOý%È6æNz1ÅÔ³A(ARO ¨;Àê5	¹a:N!0¹çx*lÑêÎðjZ Ij59ÏX)<Ôßo			Øÿ´üø ý9á®øéééçyÑW¾1´Êý×¢j+)õ*p¹+&æ¦é®9·8M­xøDM­HÐÂBÐ6|äù¶ñ«°TÔ/FR-öÿ«ºçÈHi=}VtÙ½IÇqXaåÔwB?lÞàoSÛ)Kùÿ&öàïÞKÊ¿.qÐÌÎT²=Mÿîý:4Bêp= ñ¯üæ´­Nõ¦ýsô¬Ù¶²tVM²ó"aÂ%*ú¼W¥qïíöh¡oÏOÂ3Î¶n;f·FK-«lg&ÙJE+vÜ·= QË(á6ÿ°òOÆÈ+XTÝjëì8·pÀ¥_C;7¯ÈûîÑî/Ò,üõÏ|pÉ8&ÅQZ»*.XYÜÎ(.7±ÄMÙØáË8Þ×ÄàÌõ²òª¬Êíæ|éZ}²C´ZÔvÒ«ËÐC;õÕTK#»ìCw¿­Â/e¼ørB4³³¯¨oÕ±3©^ÃÕ¨Ð!ÍËô ïï²x?¬.óK@¾÷Å·ã½ÜÈº³§Mt¼úíF2/T=MY1-aÀÁF×ù= ç_o% AÑÖçæóÿ_	¾ðuxÖ¨O4ªÐã8ò%ç@òz$0k-ÒH¢bt)tüVÑ2mÃ¦ü/x_ ;<þÓûAsvü¤kx7¬N5aÛ¢ØÞ¢FÓHz6^]òÊ(l	¼ù_MÐÝÁ½Õ/#¡çy4äÄ<¡BN¸é"Quú)K>èZ~í|¤è8ëÍzÙýÛÍùÿL¹èEÈÚjmr= èÀ®ýB×æus~òåà¥£ F­dcæz]¨äüC)q©y[VÖüoxà÷6ÑW-4íü0ªßª«$Dot;VÀ¶= $ü3dCç2eióW[)°ÂªÄaðïË_wÉáÄ§/Z,Ú@ð_L<,[P-wÉá=Mð
¶f'.iÉ3ô>»ÙIT,ª¨=M¶_ð_4#'¯D ÙT}gFßË1t5îÄWogD×+39c,^»Q=M:Dçã
0£è®ZñxR¬ò1w1.¢.Â= Ý~5eâ±Ô)R³ivÊKÿBal!§%%ö£Â|~?uèÎDýx­{N!ðiÒh°Ø¬CSxKVv¿QÀïMÁ"3©®-üL¿èg#5-b,ìÀMÂà{¤åØSâJI¯Ü£o¬^³z7RùÚ³	EÍôwàû¯HüHN¤44¬¶D 4¬÷MÛÙqp÷Ü­Â&jéÒÜ	ß	= ^= HæONó]º(­åý:ì &µÔh½/7µÌ£<ÍõþIâ-¤þ)Ä!õÌP[Ãä¾«È6~°ÒÐÝögGÎh¤fùßIÝ¨ ÖRq-Òâý)ýN¼&±Gx!5­NGÄ(ÖÛµWÜÔ'¶³,ó&U¶Ã$ò³=}ùæÀ5ó{Õ®Áðw#dJÌ¼÷Røwüé=}mç}^¦
Â= ¶Èªæº¨§eüÆ¦»¿BtþÞÍÏKýbÂ§zu©rþÙÛ-Äû"MF¥m6vt0©ÉÒsMUcä4fðÆá²÷éT*Ýf®6ÞMW3ñôY=MöÎ)Íø¿¸«hèIWÞ;gÈt·Íúèk£ ÖiÖüìÐî	kkm/ß#1Ù%­÷¨çdFì XtýC	Þ|ùÈVA4ÿ'9Õ%ÜËèþ	mÜ¶&9Ì}ç¸«ÏUÞþÍÉàâV¼ql¯i:Ïwßô«ÇªSâ\aØYífF¯­¯\ÃaUU-S'õ-§
Æ³¤§êÌZ þ×¶:rg¸KÕ»2ô<¶.}3hêõÝC7.ä"ôv?â¾PûU2ÙKë,FÏ9ÎúÉü\Â¥ä·£©±K÷éº«ô¹ 	çöÄç0.D¼ÒEÿÓq°µß-Õù:Émî7àßÅà4ùÌùÏ¿Fç*^^Àèoï#Oß¤	«Ã®ä3ø_¶§|Ô¢!vg'Så¯hÎ÷-úPy² ç5²YIæ»QÊxKá#P4êKÙèyËw só*C@d*ªä¦#SåGÖðàïKÀø®Ç~\¹ÁHMzõ¨øL5óÞÛ0Sô-÷ãæL#UB¶N3àÌt®ETp¶Vt­!CfFJ!"õ7$ôüT OÙë~Ã¾ñSw&Æ|=M_¤´	ÏúLÌª\§½&=MD|Å>wkÈJ
zµJ(ZÄ¢A·øF¥J¿·l-'gÖálÈ¡jAEúN¦<ÌÍ-ütµæù±J=Mæ³ãÏ[ä±Éº3ß«*÷¯zî±n#ý´8Î	]þqP?CÚþnn=M0åus x¤Û2þaóÑv½PÛ^c«= MëÊ|¯¤1ÂW¼«õ9
-å÷?¬e±¿Ü­¤ÖGü-)ÄüdãnRP{õ!J[zí¤M8®z y(^mbpî%7¸úÜjÉ[~ÆRä;&âx^¼^+tÀñk9¨¿w?#Æoä¨ä"¤b¢js\Êxf øX'~S ÀÍíqóiX[P¿Ã½TagÅÈ­çSUíÏõÔNÎôKÐe«¦ZXh¸ãø3Éw¡X½ª[²¶*åmä	!¯(M+©Åú¨Zú¨lçed½}±¯¶±÷¦!"xB9ºBo§pJÒ©¶"¢:d­UÕö©Hä®åø¬É*ÞK{HhSÎAUîô@Õ7<Ùt/gÃÈ²¦*öy«wô£îjÆ
WÓbà:ÚÎbß§òñ[=}wÖ:¿©Ehã¤ºÉQ·9¶W6z×vuX/¹RÙ®D¹SÙçØÃÉ-rà©È!Z¯ù¿KÌCb= WÃîÝæ!þÌR®U¼¹s¼å¯ùÝf¥(V@Äz¼Ã«<ÂõöÄHô@('>ã(ì[ZÍ# )0ÍÃ­z¥|ÌFØ ËG®{+ÝÉÜ7eñ	®=}úó!ò.ôkg>X<¾ã}Ã£ÄÃWõj%Gó@G|ð1ôEeî,¥*ü¾°É$x0Ëg±¼ò,Å·tÀÄÔ$à4s¦;GL¥È³.@®};FéÛÑ*=}oè/jlð£Ìú¯Ëø=MÑy[Ú@'n?¬íHðQ9O(nÄk%ò9OU)k½%Oÿ¸,åH°(¶D×Ú38Ù9}r¿åb±SOãÓô¿gdU³{Sà<0²Æé\oÈë·c0d´·r3ÈW¿Ò¿µXz= £i_9ëmwvGàöýÔ{ËÈ(Hèòn~æ*Ú4^|ùç*ëÏØ+ô´ÀµK+Ñ§Ë¾´À	èùÿìÅÝ5
.wìhµ/nã';¥Å¥
ÀYË³ncõÚK4ßuß}rtèó:-/Õ»Øsn½K¼E´iÇ	ÑÞ4¹0Ô³5I¨´¹*?³EV*p+pÌNíxH]µVênão×TM8¡­ÐóxÐ<ú¶ê­ù­ÔÎüªÝÜ¨n|llµI- ¼{¹ «Dê:ÇÌ]5\¹ÀI3(Ï¦®0"i4µÕÌÌßU/èÓZÄºc¥¹EÓËÇ:KüXÆUû¶×«ÓVÉEQ°®ý³­½©4^·z&*²EÍ|=M¢ÙA:ÄÚ»S°(ÍçLªóª©iKoØjÁñò%/YÑèFu{ç³2Xl2Ã$Ã÷¢R³/ïË	P¯¿XÞo´áªÖÝf?ôàõdñy«ÛöSã¬¦3n×ñ8¦(Q5ÿ½{
¶ m¡¹WÍ~óãÓ°Ík©'>ÒýÁCØµøqó²ªòÐ_HÕ¢öóÇ|Ì®ñP°z}ZÔñÿSÄÀ9á±y¡ÉA?4ÈÎ¼OIOÅðÍioBÅ&WlÃÌ:Ëx¯<ayaP3D°rá:o&p®½= ¼còù¥þ!KQÎCÌKéü°e¬ïäæ9²äfÊ	!¤´1©¿¿Æ;fjØeÙ¯<¬hqNÕýY×C´pÅ¡¹Î¡þ#'åc(yCÿG?l{F8q«è)&!^¡ðQZYÔPA*f'C~×ÐYvíòÞÛøíÎ3ø'ÚtøúwyÀúNãxyQ¸Ì%¤p\ÃwíG]mHQñ´o:Ö9ÕÌðÜøEXÙ|1qM¦@aÒ4+È[ÛàÞ7Ëõà d×rXuX·mË0}¹é\ù5EÑÓ3_7£·Ùç×ïÂ£0[cf¨QÎ¹°Ô´	ÎVJxÝn!\ÿul¡N-âJÊmVg3¸7D#\FÁxHµ÷áî=MnT~FV·L*E«Á-ÉáàÀ·n#Ât¬±½¦zÍQÜl(E¥2K¿´7ý&.·+%òMRîûyj-áùè:(Xò#µß±«=M@µß±l÷ó%j%´ 3Gíù{Ç9ª+äz,¤{e£®à´Ze®+þèÿ$[ÔYT+þ[ø1f
Ý2@5gÐiøÌÌÁÔÐ7;îK¿Úái©Ê_t8¶ÊïÈèÿMçÑç%e¨Ä¬Ï«¤k äUæ0²ßµ÷ßà8¬¹àËößyý7NÐmEèÜù7åÇFôo±FòHéì.ÏßUÎi»¦Ð3Kó9÷VTr¾¶ýÕ!ü!üWIMÁ×výH­¿åDÎ8](IºÅ	_¸òCYç±êG å$$
ØËÏJEµ~ ½9¿µ-©#då¼pïÛRñ_jE]¥.]bÁðsPbYü"ÐyÊ5Hmído·êÃ¼äÀÙKx¢*½1ëÍtuÔS<RTeÆÂ´wÅ½h|P;´3íÓÁ¢e}Ï6Âlhh6O=Mj¬,AW¼x^yÑíÑÃytØ5.Õ³;MæGdï²¤§ð8ÎEi¤·YÂBR$À ¼4¤Þ+U~ûrAÞÀo°Ã{§2ÞÃTA3gØ¦6ÜÑ$Á1ö	mBé¤g}<ðQ®«c;|þ×"kÅ níáÔM¹wG¡\PmÊ7ÎÏm1ø2 s#s=}#¼ûõ'Sëaúð°Nh>ìªÑ­ã_¸rvupC¡)Æ]ã'[,³	?= bÎ\FÃfìÔ,ày%àwS«_¦à+Èå²1VüVx[EÚA6÷ûF5¡R
{ùd»ÎÚ·-¸R¸û ;&Ý±2,NÝ¯3Ð2)°QÂT Û{Á¹:¿~êVjdÈjýËÜå1ÆmAsÕÊÛÁ&æéj=}²biß¬_Ô÷õzáÂL¦´»¯ú/´ù]±Ó¹(F¡ßu(±4&| ÔØ>j¢«Ï*9*±ê ÊÒ­é&&1üä³mc±a´FCU"ü£òº¨±¢»©iÝ³ùþ ©óÁ*©Èþ?		Î'Ã³+ðÀÏ:<õk#ÏPÖZî â+»ÑêÉ»öïã5xÖd/É)äÉñÂÅ+?¬ó¾~ªLÅÁwzøüêcä©;9©¾XroÄ3
$âQºhÛ
Ç;=}cÕ¤æ ÔÓÂOÉe?ÃÎÍÜõÉkÃÂFÝPotÅªT1Lå¬ôN{[Ý³Tc :RÑmÄkº±V ´/R>¯hí=MNK'»54¦üw+wð2»çv(ÒêÐ°{½¡),÷EÓTeÖÓsuf;åÕ)ûó=Mûå¤ê¥>[Ç8%¯HßÑ«ÌKÊWU9ÓÅR÷çc§/E¶ÀÄÆvÇ¤¹JYýN%½Ð{9:~®Øêù2öÖÕõoëËÈ6ù]ìÔD÷w¶ô4IÙãR¸_.WÉsßøBTFÖn¼]@ÆQ= ÒîBRê#L"úÛLµêÔù»ÿ­T*NÞÊìiB÷$à°¹,{9?%n)ç·äJ%:
ûÝÆ0,?ìjV·Nç÷ÛÅ«IÁ²MÃ¥J±Jx%õ¶ÃÚãÁ9KocÆ²	3*4^OìÄÈ.òòø"cÄplh(SZ+ovß±h¹ó²d¬e´jÇv¸y= 	}=}<w¬]bU¬Ý1ÐLèì¬wê-02Ù»³C@DÚ=}M.Í»qÚJPà!­T­ÚF*x8|¶kºISÀBV~ü^;)í83=Mù-Ãy&a§÷_;à;A{D®Â\z0,m4q¤ÁÏÿRVöYBFFdýbVR*Gü$¨=MÉ	¢ºqÀÆùLeÚôj±bGý_Ùúü >ìñ¯ë¯¹%+ÅÓ@cK%%ë+bO°ö=}JZøíqNÇ81Ì|ç2Ý¸?çøAQXl%'öE>Äj¯ïùc÷1û \Ú Ü9öàHû]Ñ7 >ð³>óGf0Iõ8ïÎï73ÓD¡ªìû]°ñmr'æþ[h7ØdQÏÜ.àh´T5 Ö"Ý	AòhÔÞNå=}ÄÞÎ2
¢°ºõsh5.h¢H¤gNhÖøPÂs4§ÀÿÒKÕÄp%ÛÈ°'X\XsùYÌAè±ËE^G¯))=}<ÚT»¬À+D.¬ðÜ¸ê.jSÂàb¿,´ïªHA¬Jc°Ú~öt|rè#H£ÝÏa¢ÙVjh×åHz­ñ>Ú?^+*±=MüÿFRÍ·ÛTTÊ[¤ôFfæ´9Õë÷Cäs~wÉ?ÃµAãJMTÔßÐäR4
ð¢¿1jô<Ùì1Ûh&g©,ôRM©2V«ãlÙz  pÁèï­Æ(} JÈÍ®>¦tkJÈ"~ÌÊÿÈÒ3* ª"ÁP_ö#¢7Ê<²4OêßÔT¦2·Ô³r[­¸Ujf¥êÒCû:TÉã14×Û
*DÝgBMfo ¦|ie¡Ñð;ÆÙÃú^Ú]º³î ÊÅ	 Ý/ìè\m²m^I­9l0¸øûíÉÞO×æµ¢[½Dâ-N<+©}¨yL*ö?$=}GÜ"x&ópêBýÊT?aÎ§?,S	åù^p'®èy(h\5Q¾«)­¹»,ô»7Nô«àè)J%KèíJ%óWiD¡ç= >æ=MÀ
»Ä2jr6òÔ¶0Ç¤;¢i¦«bC·&i°÷èõRÃEÕuYL_¢> Þ"½¹8[ÉÇ¢LÝ#¨2:+"Ax¢Í¶ÀÂ[vkwN¶­·,-%Ô /Éä©j<ý
=}È^äC|,p[?g=Miz]÷>YÚdÐsBÎ$G¡¤-TÓi0pIjèY9c+±·2¨«D½w'Ð7Zd¼ÍÙèöùº?å½³+­D¦\@z]Ýåâù»ÌåÂE=MLñ¾Á$!ýý4Ùzò=}­nJïl38øi&b ç\Äìg®xxóùs¯ÎU^;Ý-Êm}½Îçr­¨0Û9³±_³>£¤NÈ~7)3ÉrcÀ<Q´wºhÙËþóÉb ö\Û?AihÜÀ#e¬,¶«ØÎ·9 Äå»e(y;ÝbDåzÁ*à=M)Cæ]½ø&öðÀéé+¢ãÂçnO« nú/êBömd%aKõ/ w¬§Þ½Z¿ÃK¿¼Íº·8n!%m¸ßâéÅÿ6'õÁlHMú¾8ß±Dç3Zñ~{¸×'éR×tüº= èÒÚtº= {èÒÙtèºàEj½pa¿¢52<²Ç"àaÚ?÷ê3AuI½L©5­¶IÝõxüÒÔIØWn=}Z¨õÔ=MÖËtðcúRæt¸¶}GÈKÎaÝGH¬*4ºçbÔ5pö2¼2ÈÏéw°C5[èk¤Èòè¨Ó¹02G¨ØàQ­XÓD0ÔËä:P=Mì
¦ã'ÎÐ9¾OæÝ_n¶òËö8àßK¿[¿Sÿg= ß'jý»28¼2H¨2\-êôQÔå]û{)=M ûtJQõy=}Y­já\Ï=M¾Ü ¨2<vò³«0ÞhÀaú±*}[FÝºr%Ò{Ü ª½zµúiMÿõsÝÇÙ Å@³^|£_[¢òyvuo4êwo¶ª½âcüëuj¯°ÉÔÏ¿T§÷ØúÅ{tÇÑ¹Å4wlÑsáûO»ÝÈZÓw)¶H{k>FoO¡õu&;f) ²óíÂõä[Ü2JÈ­º(ËZgãÒË' ø8dFUÄ¢o¦Ä(AÂÍnRâ_¯u3 b._rmµ:ÿkU
ÿUE¼´º£î´ÍùÀÅ¦hç¸rÍúj>3jW?Výß¶tÂøé¹äGùD3_\]blÔ2Ùâ×Æ­Þ
!÷[ãçÙm <L§µé]ïî!;ÏÐ½A{¥¿Ey£Y:c¹wBÅ0Eÿ"³ïÆ"µÿâ£ºâZô¼mû*;q	kræJøÉ×ä!CÜ}he¦
Vï^2Ý"æsä4 ¸Ëå,ö!/¯Ú^m Ìâ'Æ#:»GP ÙÎîCïµË~ñ^æóvz^ÐÙìÃ­õþèöi®á7Â¯ÝIã±QÈ#UúKoöÖ'ã¼8ÈÙ)ì÷å;Ï-JÊDÅ;¹êàCòësÊY¦ æ%á¼-£íxo&vYKawd÷¥Â_g{= .Ô´Æn¶ô°Bx¼y½Ff-ºöbþ¯Ô=MÞl -V¿V(àA/ì\ÃW­ t'SMÀÒõ.2åÅÃS»øºhFÉkäÇÖ®U_?[J©ÑÚÃïIt?W{3í4¥A bÕÜõ8ý)DëÄÀ²ù)Â©æÌ<ÍL,o{°Ë6øß±c»K= {m¸Rµ­;§Íµþ
ôãrÌc÷¸±>zÝ¶¼æ§lÔ93éI°ÂÐÿ1	âËÝõ= øëÑì¸C=MXJé¯·x:i½×à2´­ÕJíÍ ¤ÃIt_¾ðÎk=}äLg÷ëµô/ ÜZIq©©Âá×9Ktÿìl+B¾õå0¦»ÔOá=Mbë<]=}hG¡2=}´dj9dS «Ài ijÜäÇÙ/ À}º¤ÎXõ­üdè7«]áÄÇ #W= àGfa»¦»yæjÃ³n=}:.26)8NµEv·>E¶6ÑzGÁ4pÚÏ­$ö/[|w;í= Êeø­Ûrù¢ÎdQ4àý¦ÛüCAñÿ\=  øÐIêª!$~þ°
4×8-¦JOôÕG{ëÊ}¡¬D5{NEJ§þZí¼éôCæ£×ãå®=}¥×*½ÑS¬Cì3Ú¬qâað3ö/ÇU|¹Kô¦Øº<Ûñ(4ôï¼ñÐ»v8¬pt¡Çm¬f¦ð%Eõ-÷Ë(õ9ÌÌ³oõ)ßH-õÌ¨¥¼mSâNwöªð^ãíQFq 1]§w°ôJ<¿\×·å-Wu6ë]R-äú%I¦øØºý»3	®¦µn¯wÄ,·Ç¨w!MaÃ« A	­tØ*á= W©Ûx-¹"¬SË­½XZJUz]s>H²ÜNU­Õ 1igv[Ñ8ªGCUÎÞ¦nõûLÞË<­TI2åÂüFz/Ï¸A£q_ N=Mðõ/Ù2¶@õ=}æAwsGÎùÂb¡Íà÷åacp£7+RYÊ(5#>¼±ÑÆ;K·nê'(§YMÍø÷Í®(öóPDwÉè1¶5yê4É,<óÓ^êYçLÑ\æ_æ'TqìÄæ×èëk!Ëpô3)ÿ¦ûº½yøî)1ÌÀjûRi¼ïnòævZ-ÔÞ,zmÀ,´kØHW¡ 9CÃDØãö4ØYÝL­*¶â\vKlHÿ²øMWþ¾xÜY8PT¿éEÝCr>g¦-ß°«ëf¬e¬Ö³ÿGÌS_£Ïà~¦zSèÛzS¿}¸Yõ©í£é\MOô®®3ÁÙp»3²§"B°G!+æ¼o=MâÐPyQË<9=Mõ»ìT)è õ³[ ¡lEüã^Èÿdjùù¯£ÿÆ\Ç».[¿£YmÃ ¼éýó|zçp­Ýóå½m·J5ïÉÁM -÷Æ8-ñSµ¾¦Rl%¨½MEa²5\÷­«ºÄGw®ÅõÀs%~ÃH¿¸l&k÷<n=MLHÁxÓF0Ø÷Òç¿EºÓ~\[tN§Èp¬Î'À­ÉÅâ{g¬Êéê-çÒ%,#è­y]6¹Ñö[º«ÿÙÂQR¨ÑB²:Î@Ì&°¸V×ÂOóSöÅÍ<²ÙùS
.Wá{5%*&PË{r+o
á{=}% G+0&PÎ{2-á{ä¨þÅ_=}²ûd¡=}kb&4% È´DpªN·ùß á{ô¨^´âzqªÍ¥g¬³õ¨.íF­-¤!í$j4ññÅ´³-ëÏ89¨©oÃ¼¦î³ô<49¬ÚK¿y	GU¯&ÕÜ-)¯	©ëÊá=}ÿ®³ÌãÙºÃô#ÑãI£hÿ#a¥Ïp¨k¸Ñcó¤±q¨ËM«£W²Ãõ#ÔßLäÿxøÂâW²_ø>¥ÿÞºÃõ#Jr¨ë·l¤Õ¨ÿ#a¥ß	ÑãQ£2;®Ó÷#@®N8Íã!@õM ½Dî/!À!ÿÚªúA¢yøð"bv PúÚ~V ,N>"	RY"xpòa]|¡ú?Æ<dY"{ãÓæÓEÙ#YYÓÓÆ=}¯ín7úÍÖm)ðþ]ÇÅÖ
JgÆÀ¨ZøoòòLí¾×)pþÛë×bÖ	 àE¨®=}ÿ¬	Ñ7DI¾û·b¬Áª8÷ðð¬øsï§Ã3ê	ÿÐÃ¸þ¬Yß=M9J~ÛPÞ¹$B¸= "JÔßÝU[ÜÖ~5Þ.FäN«®Àã\"ð©YØMç\ïÀ¶yFÚt+ØÆ
Ó±mÐä'bÿç¤©À£Ò<:ò¡ó×h¿\¼Úà@ÄXþ ÂÑðTÒPåqï·;µy
×"á¢úbRê²\ÈÖ¬ÒÑð¨>.laé¸pá6ÿc¤Ïßnrq«=}{½[âØÔíºñOlÇ!1èõ(ó«"¯l&N{hÜ7façz4Î£ï¾âºï-ÔñaÎ qcÞæ°U]Ëg¢_QáÎ¾.¿	ï]÷ðr:z÷ÀÃcÒa. '¬-3Ë/yçBw¿ºò0jí¿'áÞã9ßÕK¸Í|6 vùâ2wä4PFay»¨ô¼Dy½·;=}ý®>ýE¨E± Pzö#èå<¿,Î©ªÔ@yçù´!ô ]  ðÞ¡íß Â2cµËt q¾¶AHûýM&¹Peãª¬1ÃÌã»Ä!XOu^åãJ8è2¥K8Ke]ëFw}ü.Z]µ?Sùà¬>ùyÎþñsºëí¿ùÓ[ûí>ÐUhnÔBäpR*Å¾@hÓÒ@7Àc¦)-ªI«8Ów|íà&M¢ì·Mú7NFúÛ$7ÓÇ2Áú&®ÿ´¸§ÑÒ³Ôàa.1ên3B6Kå= âk4NèD÷¸Ò[AgØÉ^\M¿«DÍ_8ýÂMfT>¸bÓÃ'ê[ÔõLu^[3©N]vòý(7UHe3¤Ö(sQf+s÷²ÅR×ßÝïë\Rµiµ²Ú¯ÝñrípuÜCë&ctJ+=}.H)¾¡âïþXTGíä¿wc´MÌK;ÎÍFÂ+YHÏQÁ¢²ø¿QR¶JNøäÆX;¬sqK^ ø>ãcy -(DsbÜx:ÊÚ($EêÅ3Vz0¾õQYÁwj:^vf9:î5\Kàã\û[¬È¼ÚÎÿ!÷P~_Þ~üw©ó®KÀÿþÙG´¥æàªsä6³eÃnÌçn(QÛ+Ñû {6ËÖj1.[mtp@ÿ=}'D2Le¿G_×w¹°cw°KCThBÍµ8×Ü#u_UnIôðÒ¦â±çj±Æñôõ÷½ZI3K4Åçtµý7:<Õ¼Rø\·»Z'ÐFÓúÉoØEqWÄ¶XóÉ:Pû¾¬aGP­Z[Bá3fCÍd÷=}8\úà-IÀòÌW-÷aJh	¡=M®[gf1XÄÞ3¹D©!;÷ï¾-ÃÕÓ½DµOx}{¡ðÛ7úcùH;|ç¤Lz£ÿÞiË 8¶ã4ó%¹ª,ØL}.9é'Ëë= 	ò¸©#¼d 	kêDØÎpmU>NÑï	æ¦à¹c/È7èa¹Tß>µÛè¢þ·ÈÚïi8æsÂp	Äñ½kçßú;Jó°A¨ùf-ÜoÛË=}¾û£K2¶ñ$ed¹*÷¬>yIeÕúûTôî.E¥^,¤~Ãè«q¢$ÇçGdÆøb·ï@Q³¼I
¬ó)êç"ºrþÓÙAèÒû§àüZm??(£ÓæIá¸ÚKÚ^ÌË	JñKõÌ)å: ,Ô'LÿúÜHhÊ8R»kXä?W<NäÂYåÆ±Pý¾¯áX<:Ýå=Ms©ññQi²w·÷Ïù(æN,>%x|ë ²±wëEaé)"óPõx@áÝYnzÃþÓ= Ô\¥LuM"·*Ä x)ÜõÈ éP]Á&Fu
yô¬©kwë¯Á_%ÂÔ+'ãOúùç¶¡ãÑú?¿ã{*ßXÞÜ+ò@©k7ÌØl7°À4
ùÂÛ¬)¯"x}W±~°~EuûÑîVQB*éL=}Æ¿_V/3÷Üà2eégÝ<&ÛÌi&Òª©òµiÄËÁÒ ó¿iÜÝvüªkÊhFM«FÃW~óSRZ$ªq¾tò>0ã)¦k»|ÃÓ$NÍìsÒcÙÓã_ÆòÆ*f>äÚÝÍ+5ð$²u+)°Ó«æÑæßè±.¤÷fÖ¹Ó+¬[ÂÎ/uk<A¶~\·gCïÎ©(/Ç¿XOk«¡ö9'«³w´MüßjcüóÁK÷@7ÿôiI;ªôöi Z¦Ô<)ÔaõC»2Á]Êÿ Ó8Øêdõ¾£8a£½xï.èÌ¼ióêè4;ÂmïÓ×ñ£ ãÊMÿô¹_ÿ&À}hMswI1«?áeNo*Ü²ô(ù"/fTXä?¯Z­Ï&ï÷¬¿º÷Ý= m1iR¢»z<k×*O×ÃçÑ\þ1?A{EÔS{Ûwg\[b=}yb5UÒp¹Ýc¤QJh= ^YÙ½sZÐ
ð(tÍß= ×:ä8)¶Å¤6{§:ÞPðíSatt;>÷©8m¤ºoÖcàA{v)4c±^´?Úûâ×gC&®7Ù= ³}Rh;«Y¬To^Ôr6=}ó3ÍVÞbs,3ªJ[·òóµh³t5UøXÿÏÏ×¦Å$.ð?¯õì\áÂÍSl~WpÁ Ô¯Pè¢½d]ï*OÂÚ8Ç©ÖöS§Òérï<ÿî)ÃC7â§BjD^C¥HÆJîêÍ*?{¢Æ>Eû{FëWÁZÖ?¥±º\K+¯0âHdzÿØr§#*À¥YùàÑöD)¥eE'ÚÇ¿u®ïM¸|~¨×_%Ó¥Ô¦;ÐØd÷öëÍ×þJ£÷w4¯Z(ýÉÛz±ÄÁô,é|É=M&À|Ù ³£Rª¤cäè hMbÿ.)¶£Ýý|.¬+©¤Jª²ã|j+¤o¤DKËF¸8ÌÂî¬>póUØ´I÷µàW§´HÀ%ßåÁ´£wßR$íÑªHÈ=MYv[±×ÿ¬ófÓÓ¡ø5öñRj{O¥bt³ ó«
ø&®%M«« ðãvMU@¿¶m1ò³Y¬ÆÇ¯AË;ð»¬¨¥BòÓÚÂ÷¢2dãÌùÌËùØÉiñDDÄ©¢4¦x:é¶ùÜºNW.s-êOÞBáaÊKB>\ÂÁs±u¾=}C:'ô?¼>¡z¢¢r¢ò¢zâê%ã¡CsáÂ«Ò¿:$Óm }ûÁÏ¯e´­ s&yÃÝ£;fbª°Æcf®.Eâ.¢r5âì2}¼iæÆ"3cìÏÊåc£m%Í³	Â¯Â#æ§ëh¤¡¹èj::g"9 B ìÒ¬eÃ[!6â2¥n«ô½¨AIO»º-¢nåÜ#ÚUè¤/Ei!w~Y~Y~YÎM¸ñuÇz¢}ÛëÝ|¾÷ºÇÓ£fgd¦³BNÚg%Ás¼ ª¸oMbYÍäâtÛ%ôöO¼fh	f¢Ï5OÑo(hË©=M³-ú2w+Â4e·$Pã»@éÍ÷Ó·ºßHôßGfµð(NË°3·LK¾ ßÚæú¾C¨­o¶óà±s ÛÆ=M*ú	xàæ¨YÑwÆ¥?K»Ü³±½+°ÈÞ])ÙDK½gr§*]íä¨¾ê¯Ë¤áåBêFåäIóñã­¯'F%Ï¹­%ä¨Z»ámÇ*¢ïO¤bËà×&ÇDÖ
þçÎ*@èn+ìO±^sî!|É>s¶(àá¾=}îAQ«ôg¾K£ar^øÁÀfÒ)äçÓ?±Ò¯¢½!âu¡_Ri= i¡iËòfýæ æL!Vá ¢øÚjvwÉÒ=MuØÚx<nMíM= íTYÅý!ùÉ909á8»È¶h2èítã$2:bÓÌ2jq qoi||OLwU3+Å]T£ó®0±Á±	7ïbî n&a=}G	]]ÛQq@1å] <H×X ,= [Åtåä%pÂØo?~Õqc¿}Y}9À8ýþiýÏbp^p p¬	}{W~×xwx7íÓÌðß¶¥v(¤sÇØ|KVÃg6æ
1~TìùG«8+¦±*ÊÚq¿Y/f~WýX7[ë&ýÑÌ¿ÑT¤)u~óªlõVÌJ E#-5×åÏ;@HÔ'BOr,($ëKãC/úôï @b?úÞü%¿¯=}z]Z¥çÒÀF0rÃÛW­7Ì!¥úîn&mìe:G¨êæÿ¸O ÌËÅ3å?zhöAGQÇ¹oOjs	L;úy~¨¡£¹lÌ¼ÿl¸î§qÐ{WwöÄê½úè¨iÀ-eËrÇHrR=}É«Âàì.ýÝ³Ü¶
+[1ßÿ3Ç«úÓL8³-58zmløPä7ô7AáÏC·6I¾+¼¯ö¢HïÊ~ô§¾ª"þªÿ6ìv³m6JÇ$s4Ågéô¯uÏ×L- g¤dcÑ= |ÎxÍÃªõ÷ÏT¥*¸ôg6É­E7Êõp)_ °Þrqo"	zX4.´$3Ð§ÓWhw¨¾q¸b0
Û* l(r>¨9ÁîYÈ]²}ã^	zLNr½°P= 9.bóÿ|o}r°,mËQ0
Yt?2¥ : ÊÁazØ¸p¬}8?þN1T0kaVðÉ¶
Q| ×>¨©6_úÛ9 õ
Õð{,ÎØ©Æ@_:à9øK^	,_2}iEîÁrC=MT=Mì+Dâuy1[hr=}éª)Þ6þùÛudq7:péNÙçIº_yÙ ZØÝPü@\xW|ÎYHN r{paGnÚÕ}ìûrý/Ê]©á\F4OC{Úm"ßi] lèòÞéýñTÞ= VT 9'Wøb>ïý» ÙhF¹©*ÿ¡jß-Å]«5Öã$î6îÜQÓ}å¯vìÙê«×®µè?Îµn{ÑB[ã÷& ©Êºî*¬GÃsÉÖÕ=M±* Ûxgþ}.iôAÍ	A§Ã³0:òïÈJ5¹Aë'súúñátn,õç­ª5\k6Ê,=M+É¥N®'àÄksm£ÊQ°Ú-v«µ1Þ£³.ñHöì¶»û²³¦Óá*ç¢é:5àÔcøðß(´e<mEëc²´ñe{öc:íJ ëU(+È£Ús­czìº¦-ß_
©*$R+ ¾3jµÚ;Z×lÜï©5-ãÑ+øoÆÈF©+½mÖF<Ôgäu<%/cÑJ@ög= k?z³6KéèøÕ£Þ¼gH-l³±ç]®+Ù [½zcÓCÏúwÆA±çóêm:µ¥9JçÛäå¯¶MAw'o#;ÄC½3øÛSÎj2ß¯w®\êäN¸<­¤p§» ë HÃÑ'·M²Ù»¦qY0&xv)]ÐéµØ,õÕ>ía$ø=MÆºv|z'¦¸ü­,zòêûÀÓ"qOö?@É}}û1¾Þý­ªÍl	ÄZY=}-*è("Þ6S">|ßBL6OÏé®Wí°ëÝÝï=MÀvòüÎU¿\ú¼õPÏá%YqæË×º=}æþÈ?aæüÇ×²ÿËÇóo= ÞÂµG*%ÈòrXõ*^Nî­íbÆðÞàÈÄIq@o=}_æâ4	!Oð"!ñ4'?G]æ<ÒáÇ4Á}ÄP6É,h,\JJ{ÖJEDÙíýåS	òDg}]æDdñÑþ¨Õ¿½KX»¹MIKÍ'AÕÂµ®¦Z¶­îõðÏmþE-}ú0ud¶§xlk¶}úùÎ'U¨©á°û[
¬ZªO?äaj·«|>? %m ÀàhG +0w$ÔLÍí¹å	+ç}hÏþ±åþë'×åY¯å$cÿ'1¦0­³+áøºÓqtd}Ðª2An^úôq&V}ÄªµõQëÎ>G1óÝ
xI¦êqâKswÁÚ5s= 
Ö÷ÙlëA<NZçÁàB¢ ÞDÖmq q}Pª5u7_LH1QV¦Ú'èBaÅPK®o'ñ9«îën^Ua&½Øi5^r	¸:¢JÝ"LÖ:*ðoô ÖÈÓT©&Ìâ ô<¹»2üÏ¸Ýyv²=}¹@	Ð²|¾ª!=M}{^qÿµ]àÉÜ¡N©¼*ßyl
óý&m2À$sy|â ûo|ÎuºXWIT&r_8dªµqsd¾Ôdq=}4êv-nM½Þ¬Q,0n8>²Á^óû]TîvEn?DÔÊÑ¹ßü¢(Î³}ïYõ}øì<}ï¹]ÚÌÐn)évwmäsYÖ3" *IQ(|ÎÙâ7A¢ø6/<.IÒûZàÇOj>IÑ)âqftMp´,
Ò!xJIdKìQÖ:îe1ÏQøÝt $
Lb¸ù ¢<ñÿ¿Wãu<nzÓáa'¡îæedC«lÝ¹E!.y­2ßõGYf2^4­ÆåÀJ¼Ý&5¤8eÖ¦±Ì¶CÑR#:èhv»È&´´ÿ¦÷Ûál0w 	â é<u¸Óæ¾GböÌóó³é ?Ï)7eRrâï95¼³¸pEÍ¡ª®\¸wÓá
M*7¤ùSLFÏM6ÑGåXr­}ÜÇ'©Ç]WÐ6èf Ã¿#ÉwùUéCPDR<d<êXåÁ&Ô,V¦àû-kN¥Ò«âÁÅ<å1a-¯Ö£*»Ó_
M+þg= í>%°ye»iaT= ;å ÿXÓ+2àÕ×1àï}G½òiÖ	Ö],7dÿ´°ãº«Ü;ãié}É%÷ý0Z8üærF¥;= ¯aõYå±C(]ÔíÀwFµ¾#*´#è°wb8MQu[¡´3lß[MÓ·öl=M!Ø½QVK?ÐfI|sn+5°¡3²aCECóè¼ÎJJl&{ÃùP½ÁpEgãüãÕkÛoiÖÖ·W´_i@W#dø{ÿ»À³ëÕKÂQaêË!Í#MAws=MwÿæÍpFáå¯/·¶QduAB²¸	6Çé)²{¥«ZÓHâ4¢ÖmÓÅª
äØ´o÷6¼¤¥Ñ<<°Øo#Î_·¢ªQ«AÆi¯ »¨¡¸¨VÄåÞÿ~ü³TÎ%°$ÃÎsèóq,t8ôdï°/ú­zùüb­S;ª#¾ös$¹7ë±mË¿¢Û ª7o(êüÏßlWl¬nºAòî0²aviúp?ÇUXTÕÖØuÅ|ë¢2rn la??Wöu|¡qÙÝ7]=}Í¾¸AaûàbÃýäPÊÈZß ßI¯û½93t!~5Íô,È:®pú
)A:¹î²ìßQêÏVMæêÁHëv&ú¨
îÇ5»¹%iF\¾
*í²¨ ókDw= äåGÏ~oÖ!3zýrC µBX¬íà·ú8 &^æpÉ=}&"ð8Z±8ÉQ2þ¾ÂîÞÒñÁ9Ð·eÐÀª= \\êo^A*åæ¦È] µf%YhÊQr®´<
aâï=}_ÞKgÛ!xi¼ÒÇíÙH(¨¡³¡¦õäåD*Jhï,û+÷éìÍ3+ºMK+æ(®ÂÆÞvmZævD¢0VMå¡lîÄ"]VóæÔÅ^^+N³]QÒÖô¦Rzg¥»$bØFV)=M=}¿ZÈ_­D$aÞ¹q2 ² fVO¿HÃîT=}«NEàçÁD+{bÑêmÉé×¹»6½¥4+¥<ã¿G¤ ÕhÞ%2ÇFûøÿ'Mc}«³UhO.ó§¸ÓðþOÛjD15»àøÇÂìBéLÃ2~÷ÚN~­Â4.4IiÆ/¯°Kl¼=}ÅÜ'©Ëß |9bùýîiÂ^}b¿;g1Fµ§¦,¯Ö2Ô<= "¡h
2®ò»R.ÃÚ÷¹ ö¡ð´Wßà'­#D«Úß,¡ã¾íåÕ©âÎJÅþ9º#íã<ÉTæx´¤ùKLg=MÚS»nz¦MdaYZqé}WÙcgT	©¥Áæ ¶~Mú¸òî¿°AÔ74Ù:÷úhL~õü0rìì}ZÜÑñÅÔ¹IéÝýÑðµ-l.u6ezïZÕÇôù¶Ïc¤ê¸è[ZÖw þ0AOZt 4îÞ¹ïTÕvªæ±/Tøóz= Àöé¢xI.ï§¯ìËêb÷îÖÅ%¹{þ1×wtë×wø	{Oéõ{éá{~ø¢ËÆßc7Á²
¨Æ àÀ0¸ÚõP@Ûyû**Ú:åIþ1sEÜÛÈkÿç¡ï/ÿwû+»Ð"ÛLù§,açCÞa·¡áeõ¦ q@C)~B¿sFaqBÒoZLDay-?+h©C&©BTýMv+HqI¯¾°W= ^ =MFBXÁ¬s0òãÖÇÀCZa= vo©W½q
æ	gL¹ý§þ4|¢ ø6bP´ºÒÕøãº,.óGÙÉÈôGHÝÔsë¸Z8è\NEazºzðsÆ\Où_·®íså×ÿTYú\´.ç½Ãyà= d/¹iÖX¼CÕ÷zZyÚÛ§¦íø$QFQg­:ô¥¨]DaâþÍR@{ßjq'J±"¯ÎsøÛCr4~Àâµ µÜñ°°mGré&U
4ñß¸×{ 6\×lå&ýÁg»#wvý= 6Á© î0{#¬¥Ø¿æ|(@F¸ ¸ þ åè´ù¢ïÄ coK°BàBNPìø/Qg¤sèD
6ô7ÄOOâ0êüL$»B¸tñÿ¸ûR)ÎÎÐ«¹XòHô»é"zr:y|÷TX/4·þôCâ?ORcÖz:Ú¹ý®×7½nÒµ)t°åÐ.µùÛ½ô$Q)UÞ ÐX÷|» .ÆhöôX0ÏOÀ
Ð°±2*EÁV)ÉñBØ"h]Ê79aLséámÍQ1<H@*iÐ~fa~p _í%)¾.hõV|"
gIYö î!ýãqõ=}T8= ­ÓÁvó!NÍmØH°òLÊ7YWu1õqÍÜm\/ÁL¡i<ÒBÂXi}îDNÅq¨\PäÈMÑËE¦çº'þ,bÎå8vS«XÔsöäª(¯¿ÊÖ6Lx½Ä9¿°Dä¸r)áe»ÄÛ¾t£ÿ/hFò~jÅG(ó\°åy¶³§_¿?¢
BÁWWÜ&Ó£qYO~Y= T~Y~Y~Y6]/rLx!]âÅë@«¥© dwºz=MËJ¢iÕA,ï	Ív<lÕB(Ï	Ìnül=Myµì×Tg6ëÕLG6ìÙ\öëÔH7öìØXwvëÖPWvìÚ= ÖkÓFOnkimlynkqmln¡¿kd¿m¿lt¿n?kl?m?l|?nÿkhÿmÿlxÿnkpmln ßkfßmßlvßn_kn_m_l~_nkjmlznkrmì»=}â<kIÕ@<o	Ñük9U?8O	Ð4ç¶îß,Ç6íÝ<6îá(·öíÜ8÷öîà0×víÞ@vîâ&¯Öàó¶T·uly¿pkìòqqù2TÖÿqrw1ØöaJ?\Ô"_àÊ;¬8¶p/uì	éÖÌÕLA	â ñÖo7@
m9ÜÞê	p,>|^ýÃJ(ÕßRT~:{LH<@ÿòú{|8O=M¢þ}ýç[ÚuÖôA0±$i
_ÊÛÆtüìqïM½uw5QIïXLÔþP\=MqöaÁ'4A-ùMjÕ= ù\õxÕK4è@ïvËFÉüXkOðÕ7:ï~Ê!ü²mûF	S1üO
É¾;pé	W,ü=M	>>9	+@~=}	^F¼y^}vA  "z±rdàwÖ*ëÛ}^1q= Ç
?Ov?)Vrõf\=MÜðºMØIyÎw8}Rxf\ìòZÙàLz^BÂ3dfU÷ÉòkÌ¼àÎN58UîIm ¼"Çò¡\bU$¼ÄÞ*¡Y&HãZ{A ÜtöÿZêâ~@à]ïÿ]\qEAr\]½ßÒhÖ"]!9fB[¶ ¨  b^áÊ¯DÐäÏ®&¦Z®&hê(dB:tbûW­SÙUéç¥´ßã¾H'ðJ[Þõ=MYLÎõòHA]!^øÍoÿÚ¥Ö%2í©øD¯¯©U¯¯½2ÓÃ»;Å÷·D'«eÝ´É¹ä
ÎéøÔ§¯ÑÔá!SFÇÃfÇ3:ãè¥®Ìõ;ÒíôÌ&#¯?ÃfÞÜ= µÿÌofÌáDKíó#M#ïO'QRµ0ú8ÃP	(mÃ×Ùûæùß¸9pÿxßXèR$\ä&2äý×z%WZ$I°&÷}$ª¾÷áX*T}¤ÿ_ÆÉâ'1¶=}}c xd_x¼Âª^CÍ}¸"Q3væÚ°0ÃdÁÓ¶ò÷çÒ«91Û/² ô8ªDHâo¤»iEÌËsá«Uæ¸­áÎ¯ÁKÆO0§z»,â½ÝøÏ=}µc.*è¥á)Í¦qì3P¢°]2é×ã½ýc\ÈÍ®þFTT°'#9Z*1çx{ñ³aÇfßÝ¸Âè=}<¤A¨|õ<ªaI£	è9ºf[W·ÿñ\HÞæX®=}^$¦¹= tH²Má¨ê£¶¦ó¬Ãk¤ñ¨óªc¤«D££Ù²Cæ¤!$â£s²£¾ðãé´«
«ï¯à¦q §Ò´I»É(§ø¬àõS^C:Ãy­3qísù*KcêcÜ~c·ª}¤eÜÊ  ã°ÓØ'Ó}ª"S&ã:*$b¸¨aÇÁ7ð¥~_¨kY³m5½3¬ÖÂÿ ¼'fävfwE¥ÿ ¸öcQL¤Ðý¯ÕÈëC $Ý¥á¥Û^Ó0¬ý¼%åäÛ&1ó¾9;¡ëÃe±'ÏÑÅ"å'BØ2àz´M·«Þ­Ä´A7Ô
d§)Nl'¤¯=}d;yQ[?¯ÒmSªL+q­µ4-·´L¿ÇEXè.àÅaÆ´Mµ>·=}{üÏM¹Æ+%º6éÒ´AJëëÛ¬N'Míáõ¡T7Ñ ÃBÿ75öÙÕÄÆæ	½ÞþéîÑn[qDø\?¹>I¹zËâ
©ØÚÌÀÁEÃºjÍë¨@µEïõ ÎÜìÎv¡ÝÎ]$û®Ê^ý$ÊP8@íóûNl9ô=MÎØðOÞ z
ÕXq¼ÐÞÄh)¿àÆmWØH ZHÝ~ª~¬i{v½ª6H¦ÚjkRÛUÖ)Ûô8= 1×z4wõ
è ûBPÑÚúYñýùòrï¶U~\Lªmf÷âzös84cÉæ¶R>
î$yÍã­F#eÿcÉó®ëëÉ;É©%«A¬y 4¹æÄ~GgTÍçØ|t¼ê'ø´ô&rd{SÚ©¾=}ÆâÑ¼E"­´vU²/!øpäj®Ô}Ë2àiöªíÑ·)4,ÒìM÷5²üOã5JjÕ~}2Í¿9:]-Ñ üÄÍ°^ÄÍùTakÃ~S'Ï7± Å5bzüáS ÓðÏ¶Ìa"M[Q@ÊùÐÔMD¢)LN±sî±Jjé}|[|Q^
M¦^;Uq±¼[÷~NR4b4"6áWùû]4 sïS= #S]3L4°,;C}['V)l@ØÒ>t=MvT0]Ví¡cE"98/ ÷»Uñ<ÅZÂÁ"fcÐ]ª¸0hccC	¬x2CN¸&J¸ÅÏÿÉäoÜå©ûæþÁhn¤»ÝÎÁ5d!±¢IÅk	GàfâYdyô^~ûéÙVÆ¤Úæ7Ïrµ®¦0µÑ×ö=M¡¿|¼7É÷úWr ÈÜ!úø~î¾Bjà!ÿù¾=}¾ì¢'àÛIøåõÜúwæ üm9ú]<è@]1¢Hôð£U)C]Z«HÓþäëUêù_ 5#Iå3òvDÁ±¦¾Æ,tÅnKr7-©qO¸Ú0ï55P<È·n÷ixÖ§æ1x F!ðBú*4Èpµx¢=MâuaW (_ª¶+í/½ò­SÐ[úaõ~EIûâ¥Ö;3ü¨/9ºxg9xN?W8>½Å
ßo:5èzwYxÑ iPM= vÀkÕ:Û0(¢èLgÚi@GìßR÷BHÎ?ù:Vê¾éÔºÎö¢M²ÜYëï OÆ¬í;Ç*NÐ@Î= #fýòôWjsê9Ø¹¡hú HÂÉ7ûâ YdH=Mû!~FÁ1EÈ%xGíØtîMIÆâßKÙÁp=}ÞÀ+þ£×P§gþ#*#yú£|rºC¤f¤{¢TË+Â»¡b,£ç£ñ¬cÆµsç¤pÐ¢û|ò2».aÊÓCº³s¾ËVJ³. Ýó9¤_lgÒ³Ó³ä¯¬G3ä±¨OC%©%Î_³#»3%ÑYß'ßÌë{}»Â´HZVôºÌkínØ.­YVÛO?W1[g;S£êX»£i÷¯ô=}B<uQ(ÄÙoæJXÅcGM&]:º	¢×= 1½¨[ô¦ÐpnwI%Èò
ØüóÖekD ¡RËÊPænG[+ÃÂÞU?<¶NÍªùù38yµK¾übUäwF*°xHÇÚ Eæ1¡eY0¾yÏR Û*¤Q¡Ô7Ü!õ&¹Ýä²ÒÊ\¡ÁBTnP<_p	Éñ_Ôô·ËÔ'ïÓ¡Pe]_yÄfZì°.z5Ç¾¥6É67[î5¢¦(£¢%à*B6ànUHàta[àÝboà÷Rà·-à±Èªá|µáÔÂázÎá-ÛáÓõéá7Â÷ábêá1iáS:"áõþ*á²2á;9á~AáIá{¾RáZá´^báéÊkáZEsáÍ|á7^á¯öáá©,áa³¥âÂý©¯>¦ã@ »#
þÙVlYÚ/übÜ~Y~/V0{®éq)rï»wÂþêØéH4Þ«
ésûÖ)ßh§«>%i¦=}½rï¯þG}9eº±«ºi]Yw.)õ§ó½ï=MîË1Å%rBEk°0?±¿ðÁòUEÖÓ8ZÕ½~SÊÕ:Ä®{ÉBj¨OËR.èßýøïñ¬ikÝÌ
ñ7¥Fê­¡²øUC5uÄÍm÷O}Iþ¸Fj¬í¦¨î§"¡ÆÛ= ôÓ;ã=}iÆd@J%P§8Â¨jb«Q!¶¡ÄûÅ	ì"6WWØ[ÒPgUÑ¹âÇtTð/WÐ)í¾F.WäÝëõ£?8ÛéªëþËçeëA¶IâG_X5ñÑN÷
L1õÀR¨]rÈ^üâ7eî:¨J¨*G­O¶¿þÏsêSbýS«A	®­¨¤%Ïªd ¦dbf¨.«á"öÔJøèpø¸J±K«ýPBÍ(-FlÍí= øO(Y-b~LKõ75Gí?!ø5:JøC5iíQ¯õdn­÷ýRì)%þÑ­WéÍû ñ|Ü>ÚktP7Øù1=}<?¼= ûØ7UV'(XÈiìFµ!ÿ%0ù¹¶ùõï.Ôjx.wû'´v.kÏEø= +02­ÜVI³eåáôëZÑ(@ÎwB¨ï,ËCû¤90{OoRoT @j>SknfgÓ2UÚ\ï;nüÑ¨6tpcu¿µI@æjN|§zviÈ>Ââ§6tÑîéJ4Õï÷)}ðy^ÏûA("û¹^
ô]Þ6È¼<
©ýh¼Ï»@dWîµïëj=M½xvusÂB)tH÷!6JÜÅ8'6Ìÿ:HSó­úÈ¶¶6/î*9È9'vç¡MìÇÅ(
¶:<cÁ¬þ¸r©:yÚgt
é¿ºVà9å¢ûÅAhS[×©RÄÔ'.7ú×¾E[Å2åyÚ-OH4ÿ×2V´¿00ÃÛaHOø®Ê
»ïf;ß7ÔdD7Ø'@¾%¶%ýðÓ½doû¿çs7Ã!~´+\ ÃJ¦Û¹³c}~¡Wð
NÂÐÕâg	k  f*Ö sfh­áIai.tXq6
= ßTPCò²ÏMsh@òV;|q°DÊºq\Ó(Örõ?¼s,>ñW\k"1Oá#aL¦öy}V'àØ"~E*ÀjJ|Ey))Ç¾i#©Ús}p,y-ÜàO{ÎZÇEx%³®]ÀØêjc?Øo{x¯åöÂ=}vf'êþ0ìÂ=Mï(´¼uÜo3±»Ó"O¤]{= v;ÁRõÞõ:ö«Ý<6tÛ,w¤6»öÓ4¶ÓÔ@ãxì¡Û1vd{\Ï¦j3Þ) êu-ÎêTOÇTÆüÔ
§m2f\Ú?N*|»tæ[«F¯s
3±vÖW<ó®ðÐÖØó¦ä½»JLV2½ªK4¿â+èþ©õsÃ²å©è"g!jW"uwu*	váoÍpQÎ= KÀt.UA~~&ðÜKÞ¹Æ¡úíp]ÝN®Nr	@
¥ÝM1o~$ùÀS=}A
}ôÝCÀâ¬%ª£ÄC£#|Y~¢~Y~QV~Y~YXA_¡EùJ¢Æ~tâ~i#e¹_ÁÚz}k{°±Ojìa9Á¶ÓsPåÈÈ¹ëÑÒæeT'%hË\º[T#GqH:òÙ5>V8äc)[H
­à¿5kþ=}k¥u
jtKÀf~t6.Çã§e+=M°6·.¥<Ä#üT!K:NÚÈ._v«a^Õbt<m>ñÏìCJà®ÀÌ>fåÜÎM]ýUDÜuïÜYn'(éëïÙxÂ mÌbCf>ÃÐ:=MUäè@úw{ê¨pÈÇzËÕåöAèàk_ÆfËÌQ7^"w}¢ÂW!ÄÜÊ6¡ã|úI¿%_ÊÏ)ÇÐÀ)Ra¡%(ÖBõ93ÝÙÉõu¸­Òµ!¿AÉgÛ2häq9h ºõ
Y6×®¤¾«ÎS°	ÎÛNW7bºTLvýp	v8¼ë±Bmàb,Çâ¾êu/t0¾1ezÄ?Ù³JOa{î«4ÌïhEùtú@;øÑ9QÌ·ÈVç!US¸À§d¦ãÉä£©sV~Ù¢Ü~Y0~Y~|V~á<;ìE¾6ërh»H¾ä=M¥¬zLå¹~µ~¦çéu#¯G5(>7,=MD·\ÈeîáQé­3êZlUyG³=UÎÜç:6#zVëÞný9ÆÒ/Vó}=}eú$Öµ;ÖT¦cu7.QºÒÁ4Ñ«r= hÂüô¾EX:4¢4L¡Iq{À}id§I¹ÖøÉ o¢\wp=MMÈ\&QOÝíZÃw|ÁX)ñ Gk·CÐi¸}ÑMðâØE®Ï[5àu0¹úsÝd×¥æÊ½L*ä­ðÉ|èö¤= 
óñ@Ñyt2Ð÷ãN>9B¿E¹È¶ü¯/P;&~âçÅçoþ)ZÎT©ÐÆ4 ÖþfF@Ká^ºv÷±c(à¯~ËBåü? ´)òÑ%ø_Nb$QÆÓÏÂåt2Ö§á!¬ä6ÚSÍ2¦Þá,P@"§º/'Åç£¢©(dA¸*YK·ïåÄÏÄ2>¸´ÁM':ÍóøèXAÝí±%Òø®ñbÃ×æ²8yKÞ
«y«ÄÉ3B)½Þ·AZgÿÎ+¢Vdq¼2àj¿Ä@'ÒÂÿ3|-ç¸,ÊaK]&¡¡*ë£Á=M¨$
«9'{HçC¦¦(ù­ÆË@¾&@éTS¹² R§¯@ð¥¾>/À²öôö3)8Õ³7,§aÿ¾mdü¹-V V£n-Ó÷/Hø)pþÎnaµ1=MgÛy|QÝcTÁÞ½qa¬vYY:øÎ¿yXæeK¦Aî^õF¾Î	9ÂUdà+]Ä_â% ÜF;Å«Á£ã³£­iY~Y~Y<}Yz}Øqú~YP<GrZUÚgû) ¢6y×üÙilô1ð_öÃñ4-_AFçë5Õ9B7&­ê>÷<QiV¢M%Ý®%Ø¢¦°¡ýH,æ1¹Ä}~G0F±Éé]ÏÜEnÄà@üýB¶°sÚg]Äj	¾DµoiGÏÕÄÈy7î2ïôû=MiaÛWÂ>T¨Ô9WZnßÎ¿fO\½ÙYH/ÐÅÞñ|}+àuª!xG6ÆN-?§Î?Ñu¨NÑ8]ÅYeáÚ¡qDøÁ®¡ò±±ÔMpJS1²uav2þ3rA^¡0¨rÛ3$»È¨tÌ+gaùÍ*s^Õ'fáDÏá·m@ÓÙá«6Ë?¦ý´k"ºd!Bëá.?ËÑ0åú×â"-É	¯iTÿÔ9þw-ÆâÌA= ¢.
ü¥ÉCÆ´hz,¹Èòá<v6üH6%·oö<= É8×¢5iz¢<ñ= 
©%X¼k
Éü'¡@(gà¾¢VÌmq²ÜUmÈ
ÑÑ)qlfíØB¿3rYa¥/Á·XI³= V(OrË~¡Å?&-4F;ÛnµÁpÌ.ÌÆ H7Í*%Õ²8tq0nÜK $=}[%ÎÛùûìw¡íïßMËÿhRøLI¢x*yó °Ò8=M\ôî{,ýA¨xDUE1TÒ7yyÖ¢àÁ1°ÛñãJ$GéU!S¶n>ÉMo>l¿	,	µßþëBue}Ð*YÕÎ­þÜÂ)Ù¹áæ»vq(7ÊÞ_&	3!X&Bñ¡ÁG"@¯ýXV.TîH¾Re z0F¹¨sßyfàJWº üZ:ráafþÂUÂ.
ûâ®²ë!#w'¤É±3#¶U&¹àk¬tÃÜÞ©T àëEr³});v³bÿÁek;<fß@ÛïQB²×%C§Z|Æ[Âä§þjô/-éL;ßm.ÐFÿ[Ø-Aa#Ô¥Þ¨OýÉcS#Nò¨_Ö¸õ¾ÒgOæ+åÄ% å«Ôù´ôÌüQ+6&Å·:,;_îç´ çÿXµVßío28á«hOüÉ	¡ùÔÊò+LÅÉýøåN= '´µ!Ð7SVö%Ç¬júëÛWä%ô¬âÿ7ÓL'Ðõ¯H5EÂÅËè-,·*	Ì &õ·Êë\Úê-íÌ.aÔ÷¤øWî7¹4W63©þ¤|ÛZfL¸R{@¥0ðÚ{7Pû6zJ?Aµ¹fÒV; qªÏQM
T´.8Ï)a	4kURÏaqLÏ9¢V¾¡â'h¡´¹o)üÛ:¨:á¹	_
äÜ®$ØÏ\lå¹ÙSC>qå3Ú®Û2(#Ïo!Ò©À·ækÔ÷i+Ä$»OéçôÌ% >èCÐ%½ø´7Ú­©Ä[|­¤w@¸c*³¤{/´ãøáÿ²ævËá;·ºã= ð¤ÿm*ºøpªL5ß3ÕnÖºef1¿¸>¦ÜÂVdÙÜ¾Uü¹¿q'^¤<ù:¤3¤®rJæ|7ÛUÕ°Ger÷{!Ü¨éLIãþ=MÕK÷Èd0üìó8V¯?Í¶dõÅ2ð#W.óÊ±'Ç±¹iå}»Ë9+$Ã.Ëm,¥zV4S\Î¥¥øÆ_øÛ·H)$ó3^¶¥ê©æ&ÓÔ«%¤jã»-¬#f"V6ª0J Ã=}(FáS\Úa%?Aó~¦¹±]f<Ú¿(yäº{j¼iÜ$ªê+£*É»[ªÎÒ}e>¦ÙÓ0Ø;JüdåâîóÖ¦Õ(c}!®sU·QÔ*h>oå/Ì=}Ò$-.ä]Ä«rÒ#b%SeÁïù<®B;£k»ôéK«äRÔà¬v(/lÝÓ^ü¾z$¹t'?üÃÉ×r#zµv$ÜÚ¸] Jã.g;Åÿ>£Jx^½ÿK­XÐm<D§y-C[Ï«Ð¸CTßî4&²F$~Ä°6Gã³~1%jêë=MÃR¢îM^!4zb¶Rd-oºC{æ]÷6r=MëA}îUé\6Î_Ã¤5ò,dÙõL<wXÚ3®XXgù¸d²l)õÕ$j´¬võuØ©!Äê>Ñ5@
q4¢Þð½¥î+QìÔ\Ï7·×ÀÇN1Æ@Ì^l¹VÀ+´<õ^,ëò5¥y³W8GQÜ\±¥E/|GÍL]¹ò/ÆìTÃÕEî_ù\4gá5Ëù<4\®ky éÇV"Ùü´Õ6×:òÅ\öø¬>RãéXí4Ä&ïIúéb_>,îøÎ»=uþopVoílfoY¶è/O íéXÝ(îÓèg7Ìq<q¯AÁp÷°¹ßP ¹4?ÏÁ77Ð_õÕxrÈù}RåÜÐàzÚe ²áV\Ì*yyæÞ[mCºÛ"1>3ópÁ7,4 ÿ(´qüÇæ¶×·¢àØÜ	­Ø4uC
2õÂi'Íâë>ö:uxõyÁêýCäFß^³aÄ-QòG2Gt\×böë rºueA8w÷Ðp/ãXIðèWñ	Ê= a*!ìòV²ÁEïô=MZ;	BG°
KöqÈ=}òRuL ÚëÌ<ñ(ÀÝ~á°ñOC4=MÝZK19ÂGµºþ|Æ]dö0¹Ù N¸þuöÐ"mxs2asþ= ×²]cÝ âoÁEÌÉµË·½Ní~åÌ×É0 ÄUýÌ*Ö2d ­Û"7ÅÉj0f,xíG%
ÚMyÁØ¿2\h¶ÓÅðiKös×ÿÚÀî	pR<ûN$è=}ËQ(}}V<±1aK.bm(©{B+þÑ¼ÄÙéüÜÍÑÙ;*x8Ta"¤áÖû'¦¹8î¨ö7 )5æ{Þn¥¾O¼ºèsÜ* 9;p­ÂyýK:ÙÛJÐím{ ªÛæÊ/P	Ñ[,èæþ1oõ²Yk¶&ï_Sã~¾@ÊX_Ò¡¡.sP4*Ú lD£ßó»+êE%3û¨q³WÀ%jæjÓ÷r°êð«Ïø.gJÀ4k9çL7@º&a»w\·.ñÌéÊÁ¢Wj¬ËSðg¶4ÛyÈ¬Èj/Ôòär
ÌÇÒ¸ ÷vÓ½á(ßx?1ô¼»Ð¦p¨<;Ä<(æVSæÄ¾øÙ	Ñ¿ïý<&þ©óÅÖº\z\sÚ²Êpfné[ êá9 pê= 3¥ýù#6ÛÝ.2¨x?Öö#}¼¥¯[ÐcMTåo¬ÔC³ú®Tîö'4ÅÛËå2êÅßù/õ9_;Ñi*gMí/âh;Ö4è ¹8&û×oÔb+hâÊüßpT[H$h¶ÀÏ!¡k²¹ø©¡fÏ!¿pÂ¹¡n%¸®eÆÏï	Dc;¨Fú[Wì¯­i#ÞÅ¹$H³9­Ô¤Æûhªjà¨ÓFØÂHäpÓ²ÏÒªæUdwâ®ÀÕäpÛ¦IlHfDÊLó­û©È&ûÄ¬5ÑÊe2§{xÀª ,Tãêf)3ËÓ¥õfäê¿­ØdS=Mÿ³Û©cÁÛ®VÛk'Ò$(2@äPu´'ºdVÐûhûæ ßî.::9%%¼?ö¥mZ¹e=MbC¢±/rÖ){ä¦ûgz&F	ffÐ[ Ô®qp#öÎIå~Çy?£©¬=MS= ç¼-^·äCI£	9Ó·Ê°y/©´µ?:ÑñWîá¶^n+h8ÜÌéM§°'MëJà5úñÿ\ñ©5Ò5e¼JlYmÇÎÃì9ðÁ¿{íÍ¯z6þú¢êÍuçÆÌ(K'ç³ ¾ÂÕ×nAoí¼5XÖ+T&­Â4ÇLtB<^ÿÖðIf¢ÃÖS¨ö!y&,@Ù(|ÞImeCLh@êHiY¼¡28^¹Þ7å\q[Ã<ÑH/=}¬òÜ(ÂÎÒüÝ
2Ý  û&AóAæ¢VUCÔn?K~ÁPÞµðàrHö^®ÅMV-ÁMã¸ðZôxF?-Ê6n
kÈ=M6áüñLdXúØàÄ|çIâIÜiWdÎ=}Þ¦= P8½6"zòþåÇswõµBò:d âÓKå¤"¾*a¤ÍÜôÀ½É|el{×°J×pc7÷°ßÆH0ÚY÷ O{+~xðSxÿwÝÂÑåbvîx#¼Ý~ü=M%îsµÚXéB,;V{¤B\Ýõ3®Í*^8Ã²Ç[T²<*<BC×£-&St×§Fá'EyW×1g~ôcÌ©ÎT*,júÊ¶Sç!¼éÇD|?È¨VvÓcÞÀr
iï	^ |[±-:QKßØnjÜÕ¨KE£Ê-[æ#-x¥*®T&³ÊÈ-3W.su/v-hûî/'h¦¹RB¶.ÙBû_Ýc"ÆÏhe$ Ïw=MV]å¯æ:è£Ú'Sè£psý=}²Ííì±WÐm¥Ü¯= 7­"Éfyx,Óí¿+)8~ÆcÔ·Á¨%Ç$+à±^?DÙlÁ9pS)b¼S?©-Ì®¡$ÜSO¤¿=}°3à®õ/Jåpóó)'þÃìä½ïÙ±6yáu~9SB4¢w6Xô,rØ-Àáã)Z37ÚÎë øµ,ÝèÑÄÐ vëRµ8sc«ÈÔ}¦1owÕ._U»IZ_×ºÂýeLÒÛl¤Ü=}h=Mt(»ý¿ãÖLM=M]ñÞ {;Y¬ru¨tÌ%ª×[E,y JAâs-*âyþµKöÃ&}½vè¸/v<+H(vrÀ°¿¢éª@¯4zÕº&²Ïe¢|<óÀdd(Ùû#E Ñ[RªqodF]¡» à«Âq«f\´4Kg2dÊìË^¼qîiöÑ[ò©é8	xH¿?ÃqfÖ­óªÂ }¨»{Òg¡2Å¿ä/|ÏÍ T¡®.¢
÷Á#ì¥Ã¯@~ÖSY~Y~Y~Y~YÚ»]²
¢ª¥AµåVéõ3±±Oí©é£¿?OBíäÞã¤¥¯ÿ¡q½#ª³¥Ýc¤§£ÿ¡!c«dãÁK¤À£:"âsgB5êÖ¥¹c±Û¦'Ä¨_þ½p¢¬: n"rAb,*2òëçïåíéññìèðæîêòrkgoemiq1 
¿¤ÌÈÐ¦¶ÎÞÊÚ²B#3K[GW/?%5M]IY1A$4L\HX0@¦î¯Ô°ÖÊbS[W?E-=}IYaT<H0@FV^Zëûý	ñR´ÕìÍ¾ü{\©)éiJ	º7÷yÙW±òoÏQB"¡Ö¸bE$P
ëýü
¢jbu.üêG¹ùZ0pP  ÆÜZWIL&úó÷éì jcd êbÔíÜ§gùYòÑÀ = .õ«rLÂÿß_"ÜbAúø¢|»#7UYT8f~Z«½×/bìËBóâ¡©T_þùy>yt¸Æ^3Ë°¿_ñL¸S¡ÝX!ÿzdx®Rv»É _i8b½V |¹¥Ðã¬KmmmEE¯Ú}ºC¦÷"""þþ£¶Ù¤MçØÙÙ9:Ô£F½¾î<S8óÆ­á¼Ô ó²MVVVIIc:¬~²ððð¸¸\/;ÁK¶xyyù  ã³ß£©$££· âzU|mY~yU~Ð~|YR1é)ªµYb¤ôäà[í!Æoò§Â³Ùæ|©MÌ»c ¥@Ã%©V¤ë£=}A´ßHOnÏnÕ!C(jdÔuÞeJ	
¥LÝNU1âÜÞ1ñPìfð­Þ~eo¶[nÝÅ, _=M)35éý5ëaD,*eÄõÞg*		¯ÒLÍÎU-Ì~-o1H\<åÏØðÙ² _ºÑ5~ÌiÍà\é¤
û#¼ë;~°Þ}vIÃ«$äÏî½])ÊH¦= 
©é/ÑZ¿n49ÁZÈjlëB<&,_F=}Pi¡GFôÇ-¿ñ@ìnÐ-ÛjÅoö]~]ÉL = ½)+õÑY·.9IÁYÌ*ìóÂ<(T_E5NPg=M!HPJnUÛyúÍwVX{ob5 \çÁJ½
Å@%qWÃÖ+»q±µ|nI³Ìå.V3R¤¾#÷±a¼¼hm^eOÊýeù?ÃFFñÉ´ðÚû@°èÊr~,5tÉFÂZÌÿ.Õ:rKÁT*Y¼ií^guÏÞ=}g	¿ÄPfùi=}mQTÕ0ATÀ
kÛ>:g¶¹&|e"U[ïJ¼&åqU³V;}WÙÞì»cÁóeè9´v{&ÙÃ¤±$<»p®Í[u­O
ýuy?Ç6F ÑÉ¶æ°Úý&0ð
Ò{<®UÔÉJâËß.Ô2rLV:1»q¶m[wÕÏ=}w¿È@f Ùi)ÍQX­@AXà
l;2Ç³ùæ{m¢-\åáJ>Ãç'_Js=}¥/{~YÐXZpY><~Yaw5å(­ÜV¢lÿ[Ññ»o$ÕMn%7¦òñÚÀ:ÞsÊÐ1sÛó= 2 ã>°®ü8úpf!pWFûxnï*	jþ¹i)8Î.v,ç¾_LåpRü4uL´*ýìwA	Zf?áçxÏ{"kB>¯8%ÉçÜ¨¾½ÔZE8A¼}ÈæYÁ¦a2IÁÝÀìwlMèkh¼GÕ=MÜB--x{ÔÌ /óä]=}e~ÎÔKjÉ=Mê1eyÀGâÏfb(äÁÌMbÜãò]î^=Mþ'ÛîøO¨;?<Ñùojªlðuqmh=Mp ÍÿÞªÍxö½Úá®ÈöN¼¼4ÁÊJ^î¢-èõó´asÒ¬) hú¥árÑh,&äù9a´&= ÎÚE¡|úu-4ÛqNùÚ¿XïØz©DÛxYÙùÞ»jRwÆn§@X¤Òd²pÙq²(bõ¢ È[rì¢­ªjJ×XVVút©PÂÂxRWluAte¢'wèéâV;¥»C²¥#$»)$oE9²²p@¼nOl}|6= F´Pt/gßà¼5ÕÈ~ïyl?vÄ Iö]ðj@qá¯e;'pÓ­N¹fÓÏ²vSà/fÓ²
;±«££$Ã'¸RÝxÿ©i×ë.5ÙvËPIü}ðfW?IÞ0v=}J »+(Ô´¾Çùiï/Dû½öTØioh»/hÔ¼>×ùj1ûÁvTài oj¡ß3º,_Ô28ïÜ²H÷Ý2XÿÞ²hÁpNrV -&S¥Ë'¤Ã³#ô×0ÿ¢&=MYf{â^A
z|!PjQ|XÂ^
z{á@: 
z {â: 
zß{ØÂp. zß|Øp> 
úÁm* TÎâlQ|8Ú^
úÂ{x²(  úB{xÒ0  úÂ|xò8  úB|x@  
:ª:º:Ê:Ú:ê:ú ~A½RÁX)XO{nA©
É
é
	
ªÊê
Ú¦VÓ¶VÔÆVÕÖVÖæV×öVØVÙV:$ÏÅ¾¼lí	U6DÏÍþ¼nýUz¤ s¬s´ t¼tÄ uÌuÔ vÜvä wìwô xüx yy z
#¨É{'¸	{+ÈI{/Ø{3èÉ|7ø	Ú)BèÝY¥³)$»Ý¤¾WÐIÈ²ëì_âr¢?âp Öro:Ö"l!|Ú*ê'ú(
)jêgúh
iJ*4uòíÐ à¹#©£³©ÃqÍ¥0äyUßRnàáR\ÞArÁU2ÈlAURÐnÁVrØpAVà2ªÄg2µð,êÌhR¹ .*Ôir½0jÜjÁ ò²u*Å ëòu:É ì2uJÍ íruZÑ î²vjÕ ïòvzY~Âý2vÝ ñrvá Â9C££³«%óÔJ"ÎâW#Ãá+º*Åa+Ú2Çá,ú:Éa,BËá-:JÍa-ZRÏá.zZÑa.bÓá/ºjÕa/Úr×á0úzÙa0Ûá1:Ýa1Zßá2záa2¢Ãâkº*ÅbkÚ2!Õ<bo
Ú@r!×=}âpJúPz!Ù>bp= !Û?âqÊ:prtvxz|~^¶§²«$£££cY~Y~Y~Y~Y'ÙmP^uMO= mNP\qÎD-©}D/½=}C2­D.¥Èøxóþà8øööÀøô ÐøK7=M½J:=MI6!ÍLJ8-·òÜ OòÝ/VrÞWÖrÜ¢ÇõlÃ>ß5ìÆ6¿ìÄ@Ïì3M¼	>
U	=}aÌI>Q¬6íÐFíÑPomÒHUmÐôÎRbîRaÒbÞbgÍ¾VjÕUfáÎOVhÑ®9ÿfÿpðhZõNWnPX|ñPWù^Ðý¥¸¯Sd¦¼×Ód¤Â·sd¥º§ëE-ÄYÅ.ÉIÛ.Å]û-³ÌwÓe±Òse¯Êóå²Î³Ä0Ýi{0ß};/âm0ÞgÅ1ëûÓ­cË~Y~Y¾fÓlÞ¸ÇQEè6/àrW}l ÏytÛj§2¢[ÕÜ"ê:l]K¥t$¨Y¸>$§MÂÅ©lÁÏSPäª¿ï
ó ­Ô çØ´läÏÂTç³û×[hJ¹D /<èº8Åÿ93ìå«2Ê=}³ÝeËñ7U)ï½½_v)s¼ét÷InXëIÓðBïÝjöHBÑMJwáPÖòD",æPÙÇmúJãçêÁ1ÕÞLFzTgÇöï°(Kõå:ÁáBæL¹ýì9¸UP6mÆ¶|ûlmä!Ø00O/ü¼~{=}j}Ùé.ùwVÆAÒü6rA¹0°êE ú<ÅE&úìò¼£j¶©£²
~Y\ÝàbV~Y¢K~	ó~ùû^0MYÊÈB©T*þ^\? Z9eSkÐU·<.2ïÅ4<k÷:¼k
"z¡0á"°aù³s ïÒîµ«x>Ìn7
mu0q°ññ&É&ÉöW:ÙY0Y0ª/§¯²ª°¨±©±)zê-õhLÌE×ÉÆEÓWuJxLárø6Ãî/î¸Ê.õu(üEÏô8ö=  6ð6p"}öIÑPøàCó.]y#©U;l2Í³Hh«ÖlT<ï¹ø¿ýµù½yzÙÞ<Ã²òr­ÎLQKK×¼×Àx@w>JTëDqý¡¹qáXfÍ>wºZ)ùjÇ.6µ¶Õ;÷-Ãö?ÒË®L«N²O°À=}àAÎnÍ ?=}ÝOýýOO*ÉJ¼qyþßzH¡©P?<¬ð&P= ËáÔÄÖa'k¸é·¬Î§$p! !p!ð$Æ1®OI;üî@ÓO;gÓ¬#ÇÙÿäETìO£$@:³ä(>Ûzí0RHN=M	

R>XþÛz Ûªöt\ï£+|½ »XP÷QVÈû³JºÆ+Y÷9Z}¥@¾Ý= ÿcAÜ'£³æpóCèA^5£Ë)öt[zçHÍÞQá!+£³æpqE'¨Záª2{ürÞn¬£ÔwYßÛä\7TÃa"yRSIbâmiÖZñµ=M£2]ÑqøG}Ò`
    });
    var HEAP8, HEAP16, HEAP32, HEAPU8, HEAPU16, HEAPU32, HEAPF32, HEAPF64, wasmMemory;
    function updateMemoryViews() {
        var b = wasmMemory.buffer;
        HEAP8 = new Int8Array(b);
        HEAP16 = new Int16Array(b);
        HEAPU8 = new Uint8Array(b);
        HEAPU16 = new Uint16Array(b);
        HEAP32 = new Int32Array(b);
        HEAPU32 = new Uint32Array(b);
        HEAPF32 = new Float32Array(b);
        HEAPF64 = new Float64Array(b);
    }
    function JS_cos(x) {
        return Math.cos(x);
    }
    function JS_exp(x) {
        return Math.exp(x);
    }
    var _emscripten_memcpy_js = (dest, src, num)=>HEAPU8.copyWithin(dest, src, src + num);
    var abortOnCannotGrowMemory = (requestedSize)=>{
        abort("OOM");
    };
    var _emscripten_resize_heap = (requestedSize)=>{
        var oldSize = HEAPU8.length;
        requestedSize >>>= 0;
        abortOnCannotGrowMemory(requestedSize);
    };
    var wasmImports = {
        /** @export */ b: JS_cos,
        /** @export */ a: JS_exp,
        /** @export */ c: _emscripten_memcpy_js,
        /** @export */ d: _emscripten_resize_heap
    };
    function initRuntime(wasmExports) {
        wasmExports["f"]();
    }
    var imports = {
        "a": wasmImports
    };
    var _opus_frame_decoder_create, _malloc, _opus_frame_decode_float_deinterleaved, _opus_frame_decoder_destroy, _free;
    this.setModule = (data)=>{
        WASMAudioDecoderCommon.setModule($42da1043ef19c7aa$export$2e2bcd8739ae039, data);
    };
    this.getModule = ()=>WASMAudioDecoderCommon.getModule($42da1043ef19c7aa$export$2e2bcd8739ae039);
    this.instantiate = ()=>{
        this.getModule().then((wasm)=>WebAssembly.instantiate(wasm, imports)).then((instance)=>{
            const wasmExports = instance.exports;
            _opus_frame_decoder_create = wasmExports["g"];
            _malloc = wasmExports["h"];
            _opus_frame_decode_float_deinterleaved = wasmExports["i"];
            _opus_frame_decoder_destroy = wasmExports["j"];
            _free = wasmExports["k"];
            wasmMemory = wasmExports["e"];
            updateMemoryViews();
            initRuntime(wasmExports);
            ready();
        });
        this.ready = new Promise((resolve)=>{
            ready = resolve;
        }).then(()=>{
            this.HEAP = wasmMemory.buffer;
            this.malloc = _malloc;
            this.free = _free;
            this.opus_frame_decoder_create = _opus_frame_decoder_create;
            this.opus_frame_decode_float_deinterleaved = _opus_frame_decode_float_deinterleaved;
            this.opus_frame_decoder_destroy = _opus_frame_decoder_destroy;
        });
        return this;
    };
}


function $27034431d4d4accd$export$2e2bcd8739ae039(options = {}) {
    // static properties
    if (!$27034431d4d4accd$export$2e2bcd8739ae039.errors) // prettier-ignore
    Object.defineProperties($27034431d4d4accd$export$2e2bcd8739ae039, {
        errors: {
            value: new Map([
                [
                    -1,
                    "OPUS_BAD_ARG: One or more invalid/out of range arguments"
                ],
                [
                    -2,
                    "OPUS_BUFFER_TOO_SMALL: Not enough bytes allocated in the buffer"
                ],
                [
                    -3,
                    "OPUS_INTERNAL_ERROR: An internal error was detected"
                ],
                [
                    -4,
                    "OPUS_INVALID_PACKET: The compressed data passed is corrupted"
                ],
                [
                    -5,
                    "OPUS_UNIMPLEMENTED: Invalid/unsupported request number"
                ],
                [
                    -6,
                    "OPUS_INVALID_STATE: An encoder or decoder structure is invalid or already freed"
                ],
                [
                    -7,
                    "OPUS_ALLOC_FAIL: Memory allocation has failed"
                ]
            ])
        }
    });
    // injects dependencies when running as a web worker
    // async
    this._init = ()=>new this._WASMAudioDecoderCommon(this).instantiate(this._EmscriptenWASM, this._module).then((common)=>{
            this._common = common;
            this._inputBytes = 0;
            this._outputSamples = 0;
            this._frameNumber = 0;
            this._input = this._common.allocateTypedArray(this._inputSize, Uint8Array);
            this._output = this._common.allocateTypedArray(this._outputChannels * this._outputChannelSize, Float32Array);
            const mapping = this._common.allocateTypedArray(this._channels, Uint8Array);
            mapping.buf.set(this._channelMappingTable);
            this._decoder = this._common.wasm.opus_frame_decoder_create(this._sampleRate, this._channels, this._streamCount, this._coupledStreamCount, mapping.ptr, this._preSkip, this._forceStereo);
        });
    Object.defineProperty(this, "ready", {
        enumerable: true,
        get: ()=>this._ready
    });
    // async
    this.reset = ()=>{
        this.free();
        return this._init();
    };
    this.free = ()=>{
        this._common.free();
        this._common.wasm.opus_frame_decoder_destroy(this._decoder);
        this._common.wasm.free(this._decoder);
    };
    this._decode = (opusFrame)=>{
        if (!(opusFrame instanceof Uint8Array)) throw Error("Data to decode must be Uint8Array. Instead got " + typeof opusFrame);
        this._input.buf.set(opusFrame);
        let samplesDecoded = this._common.wasm.opus_frame_decode_float_deinterleaved(this._decoder, this._input.ptr, opusFrame.length, this._output.ptr);
        let error;
        if (samplesDecoded < 0) {
            error = "libopus " + samplesDecoded + " " + ($27034431d4d4accd$export$2e2bcd8739ae039.errors.get(samplesDecoded) || "Unknown Error");
            console.error(error);
            samplesDecoded = 0;
        }
        return {
            outputBuffer: this._common.getOutputChannels(this._output.buf, this._outputChannels, samplesDecoded),
            samplesDecoded: samplesDecoded,
            error: error
        };
    };
    this.decodeFrame = (opusFrame)=>{
        let errors = [];
        const decoded = this._decode(opusFrame);
        if (decoded.error) this._common.addError(errors, decoded.error, opusFrame.length, this._frameNumber, this._inputBytes, this._outputSamples);
        this._frameNumber++;
        this._inputBytes += opusFrame.length;
        this._outputSamples += decoded.samplesDecoded;
        return this._WASMAudioDecoderCommon.getDecodedAudioMultiChannel(errors, [
            decoded.outputBuffer
        ], this._outputChannels, decoded.samplesDecoded, this._sampleRate);
    };
    this.decodeFrames = (opusFrames)=>{
        let outputBuffers = [], errors = [], samplesDecoded = 0, i = 0;
        while(i < opusFrames.length){
            const opusFrame = opusFrames[i++];
            const decoded = this._decode(opusFrame);
            outputBuffers.push(decoded.outputBuffer);
            samplesDecoded += decoded.samplesDecoded;
            if (decoded.error) this._common.addError(errors, decoded.error, opusFrame.length, this._frameNumber, this._inputBytes, this._outputSamples);
            this._frameNumber++;
            this._inputBytes += opusFrame.length;
            this._outputSamples += decoded.samplesDecoded;
        }
        return this._WASMAudioDecoderCommon.getDecodedAudioMultiChannel(errors, outputBuffers, this._outputChannels, samplesDecoded, this._sampleRate);
    };
    // injects dependencies when running as a web worker
    this._isWebWorker = $27034431d4d4accd$export$2e2bcd8739ae039.isWebWorker;
    this._WASMAudioDecoderCommon = $27034431d4d4accd$export$2e2bcd8739ae039.WASMAudioDecoderCommon || (0, $6cc8fed272338330$export$2e2bcd8739ae039);
    this._EmscriptenWASM = $27034431d4d4accd$export$2e2bcd8739ae039.EmscriptenWASM || (0, $42da1043ef19c7aa$export$2e2bcd8739ae039);
    this._module = $27034431d4d4accd$export$2e2bcd8739ae039.module;
    const MAX_FORCE_STEREO_CHANNELS = 8;
    const isNumber = (param)=>typeof param === "number";
    const sampleRate = options.sampleRate;
    const channels = options.channels;
    const streamCount = options.streamCount;
    const coupledStreamCount = options.coupledStreamCount;
    const channelMappingTable = options.channelMappingTable;
    const preSkip = options.preSkip;
    const forceStereo = options.forceStereo ? 1 : 0;
    // channel mapping family >= 1
    if (channels > 2 && (!isNumber(streamCount) || !isNumber(coupledStreamCount) || !Array.isArray(channelMappingTable))) throw new Error("Invalid Opus Decoder Options for multichannel decoding.");
    // libopus sample rate
    this._sampleRate = [
        8e3,
        12e3,
        16e3,
        24e3,
        48e3
    ].includes(sampleRate) ? sampleRate : 48000;
    // channel mapping family 0
    this._channels = isNumber(channels) ? channels : 2;
    this._streamCount = isNumber(streamCount) ? streamCount : 1;
    this._coupledStreamCount = isNumber(coupledStreamCount) ? coupledStreamCount : this._channels - 1;
    this._channelMappingTable = channelMappingTable || (this._channels === 2 ? [
        0,
        1
    ] : [
        0
    ]);
    this._preSkip = preSkip || 0;
    this._forceStereo = channels <= MAX_FORCE_STEREO_CHANNELS && channels != 2 ? forceStereo : 0;
    this._inputSize = 3840 * this._channels; // 256kbs per channel
    this._outputChannelSize = 5760;
    this._outputChannels = this._forceStereo ? 2 : this._channels;
    this._ready = this._init();
    return this;
}


var $b3b662250ddac7e2$exports = {};
/**
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ $b3b662250ddac7e2$exports = Worker;





var $6ZWSX = parcelRequire("6ZWSX");
var $d50a2ea465b7287c$require$Buffer = $6ZWSX.Buffer;
const $d50a2ea465b7287c$var$getWorker = ()=>globalThis.Worker || (0, (/*@__PURE__*/$parcel$interopDefault($b3b662250ddac7e2$exports)));
class $d50a2ea465b7287c$export$2e2bcd8739ae039 extends $d50a2ea465b7287c$var$getWorker() {
    constructor(options, name, Decoder, EmscriptenWASM){
        if (!(0, $6cc8fed272338330$export$2e2bcd8739ae039).modules) new (0, $6cc8fed272338330$export$2e2bcd8739ae039)();
        let source = (0, $6cc8fed272338330$export$2e2bcd8739ae039).modules.get(Decoder);
        if (!source) {
            let type = "text/javascript", isNode, webworkerSourceCode = "'use strict';" + // dependencies need to be manually resolved when stringifying this function
            `(${((_Decoder, _WASMAudioDecoderCommon, _EmscriptenWASM)=>{
                // We're in a Web Worker
                // setup Promise that will be resolved once the WebAssembly Module is received
                let decoder, moduleResolve, modulePromise = new Promise((resolve)=>{
                    moduleResolve = resolve;
                });
                self.onmessage = ({ data: { id: id, command: command, data: data } })=>{
                    let messagePromise = modulePromise, messagePayload = {
                        id: id
                    }, transferList;
                    if (command === "init") {
                        Object.defineProperties(_Decoder, {
                            WASMAudioDecoderCommon: {
                                value: _WASMAudioDecoderCommon
                            },
                            EmscriptenWASM: {
                                value: _EmscriptenWASM
                            },
                            module: {
                                value: data.module
                            },
                            isWebWorker: {
                                value: true
                            }
                        });
                        decoder = new _Decoder(data.options);
                        moduleResolve();
                    } else if (command === "free") decoder.free();
                    else if (command === "ready") messagePromise = messagePromise.then(()=>decoder.ready);
                    else if (command === "reset") messagePromise = messagePromise.then(()=>decoder.reset());
                    else {
                        // "decode":
                        // "decodeFrame":
                        // "decodeFrames":
                        Object.assign(messagePayload, decoder[command](// detach buffers
                        Array.isArray(data) ? data.map((data)=>new Uint8Array(data)) : new Uint8Array(data)));
                        // The "transferList" parameter transfers ownership of channel data to main thread,
                        // which avoids copying memory.
                        transferList = messagePayload.channelData ? messagePayload.channelData.map((channel)=>channel.buffer) : [];
                    }
                    messagePromise.then(()=>self.postMessage(messagePayload, transferList));
                };
            }).toString()})(${Decoder}, ${0, $6cc8fed272338330$export$2e2bcd8739ae039}, ${EmscriptenWASM})`;
            try {
                isNode = typeof $cfae44f0dfdf62c0$exports.versions.node !== "undefined";
            } catch  {}
            source = isNode ? `data:${type};base64,${$d50a2ea465b7287c$require$Buffer.from(webworkerSourceCode).toString("base64")}` : URL.createObjectURL(new Blob([
                webworkerSourceCode
            ], {
                type: type
            }));
            (0, $6cc8fed272338330$export$2e2bcd8739ae039).modules.set(Decoder, source);
        }
        super(source, {
            name: name
        });
        this._id = Number.MIN_SAFE_INTEGER;
        this._enqueuedOperations = new Map();
        this.onmessage = ({ data: data })=>{
            const { id: id, ...rest } = data;
            this._enqueuedOperations.get(id)(rest);
            this._enqueuedOperations.delete(id);
        };
        new EmscriptenWASM((0, $6cc8fed272338330$export$2e2bcd8739ae039)).getModule().then((module)=>{
            this.postToDecoder("init", {
                module: module,
                options: options
            });
        });
    }
    async postToDecoder(command, data) {
        return new Promise((resolve)=>{
            this.postMessage({
                command: command,
                id: this._id,
                data: data
            });
            this._enqueuedOperations.set(this._id++, resolve);
        });
    }
    get ready() {
        return this.postToDecoder("ready");
    }
    async free() {
        await this.postToDecoder("free").finally(()=>{
            this.terminate();
        });
    }
    async reset() {
        await this.postToDecoder("reset");
    }
}




class $10073398c294630e$export$2e2bcd8739ae039 extends (0, $d50a2ea465b7287c$export$2e2bcd8739ae039) {
    constructor(options){
        super(options, "opus-decoder", (0, $27034431d4d4accd$export$2e2bcd8739ae039), (0, $42da1043ef19c7aa$export$2e2bcd8739ae039));
    }
    async decodeFrame(data) {
        return this.postToDecoder("decodeFrame", data);
    }
    async decodeFrames(data) {
        return this.postToDecoder("decodeFrames", data);
    }
}


const $914bc161c46b40a3$export$6915126ba85aae77 = (Class, name)=>{
    Object.defineProperty(Class, "name", {
        value: name
    });
};


(0, $914bc161c46b40a3$export$6915126ba85aae77)((0, $27034431d4d4accd$export$2e2bcd8739ae039), "OpusDecoder");
(0, $914bc161c46b40a3$export$6915126ba85aae77)((0, $10073398c294630e$export$2e2bcd8739ae039), "OpusDecoderWebWorker");


/* Copyright 2020-2023 Ethan Halsall
    
    This file is part of codec-parser.
    
    codec-parser is free software: you can redistribute it and/or modify
    it under the terms of the GNU Lesser General Public License as published by
    the Free Software Foundation, either version 3 of the License, or
    (at your option) any later version.

    codec-parser is distributed in the hope that it will be useful,
    but WITHOUT ANY WARRANTY; without even the implied warranty of
    MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
    GNU Lesser General Public License for more details.

    You should have received a copy of the GNU Lesser General Public License
    along with this program.  If not, see <https://www.gnu.org/licenses/>
*/ /* Copyright 2020-2023 Ethan Halsall
    
    This file is part of codec-parser.
    
    codec-parser is free software: you can redistribute it and/or modify
    it under the terms of the GNU Lesser General Public License as published by
    the Free Software Foundation, either version 3 of the License, or
    (at your option) any later version.

    codec-parser is distributed in the hope that it will be useful,
    but WITHOUT ANY WARRANTY; without even the implied warranty of
    MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
    GNU Lesser General Public License for more details.

    You should have received a copy of the GNU Lesser General Public License
    along with this program.  If not, see <https://www.gnu.org/licenses/>
*/ const $860f0b5184108148$var$symbol = Symbol;
// prettier-ignore
/*
[
  [
    "left, right",
    "left, right, center",
    "left, center, right",
    "center, left, right",
    "center"
  ],
  [
    "front left, front right",
    "front left, front right, front center",
    "front left, front center, front right",
    "front center, front left, front right",
    "front center"
  ],
  [
    "side left, side right",
    "side left, side right, side center",
    "side left, side center, side right",
    "side center, side left, side right",
    "side center"
  ],
  [
    "rear left, rear right",
    "rear left, rear right, rear center",
    "rear left, rear center, rear right",
    "rear center, rear left, rear right",
    "rear center"
  ]
]
*/ const $860f0b5184108148$var$mappingJoin = ", ";
const $860f0b5184108148$export$3e501d20baea1003 = (()=>{
    const front = "front";
    const side = "side";
    const rear = "rear";
    const left = "left";
    const center = "center";
    const right = "right";
    return [
        "",
        front + " ",
        side + " ",
        rear + " "
    ].map((x)=>[
            [
                left,
                right
            ],
            [
                left,
                right,
                center
            ],
            [
                left,
                center,
                right
            ],
            [
                center,
                left,
                right
            ],
            [
                center
            ]
        ].flatMap((y)=>y.map((z)=>x + z).join($860f0b5184108148$var$mappingJoin)));
})();
const $860f0b5184108148$export$3254282aac6747d2 = "LFE";
const $860f0b5184108148$export$25d110495212ae90 = "monophonic (mono)";
const $860f0b5184108148$export$ec7f46128a2f8ed8 = "stereo";
const $860f0b5184108148$var$surround = "surround";
const $860f0b5184108148$export$8ec6a2c9fbba54e0 = (channelCount, ...mappings)=>`${[
        $860f0b5184108148$export$25d110495212ae90,
        $860f0b5184108148$export$ec7f46128a2f8ed8,
        `linear ${$860f0b5184108148$var$surround}`,
        "quadraphonic",
        `5.0 ${$860f0b5184108148$var$surround}`,
        `5.1 ${$860f0b5184108148$var$surround}`,
        `6.1 ${$860f0b5184108148$var$surround}`,
        `7.1 ${$860f0b5184108148$var$surround}`
    ][channelCount - 1]} (${mappings.join($860f0b5184108148$var$mappingJoin)})`;
const $860f0b5184108148$export$c067b99a35ad0847 = [
    $860f0b5184108148$export$25d110495212ae90,
    $860f0b5184108148$export$8ec6a2c9fbba54e0(2, $860f0b5184108148$export$3e501d20baea1003[0][0]),
    $860f0b5184108148$export$8ec6a2c9fbba54e0(3, $860f0b5184108148$export$3e501d20baea1003[0][2]),
    $860f0b5184108148$export$8ec6a2c9fbba54e0(4, $860f0b5184108148$export$3e501d20baea1003[1][0], $860f0b5184108148$export$3e501d20baea1003[3][0]),
    $860f0b5184108148$export$8ec6a2c9fbba54e0(5, $860f0b5184108148$export$3e501d20baea1003[1][2], $860f0b5184108148$export$3e501d20baea1003[3][0]),
    $860f0b5184108148$export$8ec6a2c9fbba54e0(6, $860f0b5184108148$export$3e501d20baea1003[1][2], $860f0b5184108148$export$3e501d20baea1003[3][0], $860f0b5184108148$export$3254282aac6747d2),
    $860f0b5184108148$export$8ec6a2c9fbba54e0(7, $860f0b5184108148$export$3e501d20baea1003[1][2], $860f0b5184108148$export$3e501d20baea1003[2][0], $860f0b5184108148$export$3e501d20baea1003[3][4], $860f0b5184108148$export$3254282aac6747d2),
    $860f0b5184108148$export$8ec6a2c9fbba54e0(8, $860f0b5184108148$export$3e501d20baea1003[1][2], $860f0b5184108148$export$3e501d20baea1003[2][0], $860f0b5184108148$export$3e501d20baea1003[3][0], $860f0b5184108148$export$3254282aac6747d2)
];
const $860f0b5184108148$export$cd63464c02a18ed3 = 192000;
const $860f0b5184108148$export$388131623a5f947b = 176400;
const $860f0b5184108148$export$4a9bd43882a638a3 = 96000;
const $860f0b5184108148$export$308fdd6283300e68 = 88200;
const $860f0b5184108148$export$44cafc10e39936f9 = 64000;
const $860f0b5184108148$export$671a0c9051642a0b = 48000;
const $860f0b5184108148$export$7b8ebc2092af05a9 = 44100;
const $860f0b5184108148$export$8786c8b1e955b2e9 = 32000;
const $860f0b5184108148$export$492422570a89c8b0 = 24000;
const $860f0b5184108148$export$dc67eb20d4395175 = 22050;
const $860f0b5184108148$export$a92c08b19856a52b = 16000;
const $860f0b5184108148$export$d18082a7f1daad0e = 12000;
const $860f0b5184108148$export$dd010cc0b9cbe96a = 11025;
const $860f0b5184108148$export$8024c021d839bc0e = 8000;
const $860f0b5184108148$export$8003a269f1123d37 = 7350;
const $860f0b5184108148$export$b9d4fc21491dc293 = "absoluteGranulePosition";
const $860f0b5184108148$export$2a97ae90773dd351 = "bandwidth";
const $860f0b5184108148$export$cee20cdac1cd19df = "bitDepth";
const $860f0b5184108148$export$fbead197e07be487 = "bitrate";
const $860f0b5184108148$export$d48d8e6e1487adc4 = $860f0b5184108148$export$fbead197e07be487 + "Maximum";
const $860f0b5184108148$export$971636741d86955 = $860f0b5184108148$export$fbead197e07be487 + "Minimum";
const $860f0b5184108148$export$d28b7ae062ff03c5 = $860f0b5184108148$export$fbead197e07be487 + "Nominal";
const $860f0b5184108148$export$ab1029bcae9ddb4a = "buffer";
const $860f0b5184108148$export$e2acf35f1e805875 = $860f0b5184108148$export$ab1029bcae9ddb4a + "Fullness";
const $860f0b5184108148$export$1c37c01eba8ed446 = "codec";
const $860f0b5184108148$export$a53f1e3778a12d7d = $860f0b5184108148$export$1c37c01eba8ed446 + "Frames";
const $860f0b5184108148$export$a592872ee1129cb4 = "coupledStreamCount";
const $860f0b5184108148$export$4fafbcc8068ef7ca = "crc";
const $860f0b5184108148$export$bacf03850837cc9e = $860f0b5184108148$export$4fafbcc8068ef7ca + "16";
const $860f0b5184108148$export$1cd93882633e45f5 = $860f0b5184108148$export$4fafbcc8068ef7ca + "32";
const $860f0b5184108148$export$4051a07651545597 = "data";
const $860f0b5184108148$export$6d59db4903f20f7d = "description";
const $860f0b5184108148$export$1f34108aa9eb96ab = "duration";
const $860f0b5184108148$export$bef81ba411953b51 = "emphasis";
const $860f0b5184108148$export$ae48fe32cc58ab6f = "hasOpusPadding";
const $860f0b5184108148$export$38e42c68cf43b5d4 = "header";
const $860f0b5184108148$export$b046ea5b29155775 = "isContinuedPacket";
const $860f0b5184108148$export$818e7b951c237e5d = "isCopyrighted";
const $860f0b5184108148$export$f7027d263cc898cc = "isFirstPage";
const $860f0b5184108148$export$947c0ccec8fe9e2a = "isHome";
const $860f0b5184108148$export$59545aa1378f3baa = "isLastPage";
const $860f0b5184108148$export$e512c40786d058ff = "isOriginal";
const $860f0b5184108148$export$1d1349f4eb9a7003 = "isPrivate";
const $860f0b5184108148$export$ca9d7e8ef88bd07e = "isVbr";
const $860f0b5184108148$export$50a222d9023da98b = "layer";
const $860f0b5184108148$export$f24224f1c91d8156 = "length";
const $860f0b5184108148$export$549ff81930776885 = "mode";
const $860f0b5184108148$export$f1eb63ab5aca5708 = $860f0b5184108148$export$549ff81930776885 + "Extension";
const $860f0b5184108148$export$a08b701eae9f6dda = "mpeg";
const $860f0b5184108148$export$33a1ce7cb4e60d8d = $860f0b5184108148$export$a08b701eae9f6dda + "Version";
const $860f0b5184108148$export$7a8a2426cba807b6 = "numberAACFrames";
const $860f0b5184108148$export$ed96e046486b4b25 = "outputGain";
const $860f0b5184108148$export$3dc3ed1cd86c68b4 = "preSkip";
const $860f0b5184108148$export$4882ae973e0491e = "profile";
const $860f0b5184108148$export$9840eaf33e948519 = $860f0b5184108148$var$symbol();
const $860f0b5184108148$export$b9b4c22e291dd3d9 = "protection";
const $860f0b5184108148$export$bfe96fedbe3c1b3b = "rawData";
const $860f0b5184108148$export$27e01f77e7f7ec20 = "segments";
const $860f0b5184108148$export$7ec32827e4221318 = "subarray";
const $860f0b5184108148$export$83d89fbfd8236492 = "version";
const $860f0b5184108148$export$3e1eea38d3db9f18 = "vorbis";
const $860f0b5184108148$export$3a1c3ed71012e84e = $860f0b5184108148$export$3e1eea38d3db9f18 + "Comments";
const $860f0b5184108148$export$fe63a71268ec44ee = $860f0b5184108148$export$3e1eea38d3db9f18 + "Setup";
const $860f0b5184108148$var$block = "block";
const $860f0b5184108148$export$5af3e22a52b4ea9e = $860f0b5184108148$var$block + "ingStrategy";
const $860f0b5184108148$export$f542eb4365e59cc9 = $860f0b5184108148$var$symbol();
const $860f0b5184108148$export$446963a0ea44fb9d = $860f0b5184108148$var$block + "Size";
const $860f0b5184108148$export$f3cbeb72a3601eb6 = $860f0b5184108148$var$block + "size0";
const $860f0b5184108148$export$6880a9e40f87ae65 = $860f0b5184108148$var$block + "size1";
const $860f0b5184108148$export$99f767e02b81025c = $860f0b5184108148$var$symbol();
const $860f0b5184108148$var$channel = "channel";
const $860f0b5184108148$export$1dbaf4b0a82f5d28 = $860f0b5184108148$var$channel + "MappingFamily";
const $860f0b5184108148$export$e856ca83ff30dbad = $860f0b5184108148$var$channel + "MappingTable";
const $860f0b5184108148$export$589c9a7ae9a79c5e = $860f0b5184108148$var$channel + "Mode";
const $860f0b5184108148$export$4881de1ae3929548 = $860f0b5184108148$var$symbol();
const $860f0b5184108148$export$9659c395d9de169e = $860f0b5184108148$var$channel + "s";
const $860f0b5184108148$var$copyright = "copyright";
const $860f0b5184108148$export$7306104bb28d5804 = $860f0b5184108148$var$copyright + "Id";
const $860f0b5184108148$export$19129109fa742a6f = $860f0b5184108148$var$copyright + "IdStart";
const $860f0b5184108148$export$2cef06c20297c17d = "frame";
const $860f0b5184108148$export$150180f5f882de62 = $860f0b5184108148$export$2cef06c20297c17d + "Count";
const $860f0b5184108148$export$326bb32b4ec6239b = $860f0b5184108148$export$2cef06c20297c17d + "Length";
const $860f0b5184108148$var$Number = "Number";
const $860f0b5184108148$export$5da2c6384bf58746 = $860f0b5184108148$export$2cef06c20297c17d + $860f0b5184108148$var$Number;
const $860f0b5184108148$export$e4cdad84c725445 = $860f0b5184108148$export$2cef06c20297c17d + "Padding";
const $860f0b5184108148$export$7815706ac4afa67d = $860f0b5184108148$export$2cef06c20297c17d + "Size";
const $860f0b5184108148$var$Rate = "Rate";
const $860f0b5184108148$export$cc7fd71f037082e3 = "inputSample" + $860f0b5184108148$var$Rate;
const $860f0b5184108148$var$page = "page";
const $860f0b5184108148$export$c16a704080c492f2 = $860f0b5184108148$var$page + "Checksum";
const $860f0b5184108148$export$7b4b65786d4d1f7 = $860f0b5184108148$var$symbol();
const $860f0b5184108148$export$e0e12ae5ee640391 = $860f0b5184108148$var$page + "SegmentTable";
const $860f0b5184108148$export$a60fa1703d7dd487 = $860f0b5184108148$var$page + "Sequence" + $860f0b5184108148$var$Number;
const $860f0b5184108148$var$sample = "sample";
const $860f0b5184108148$export$dda3274d649921c8 = $860f0b5184108148$var$sample + $860f0b5184108148$var$Number;
const $860f0b5184108148$export$851d973a43101ae1 = $860f0b5184108148$var$sample + $860f0b5184108148$var$Rate;
const $860f0b5184108148$export$590421bd05077aa4 = $860f0b5184108148$var$symbol();
const $860f0b5184108148$export$5f20c3cdf3b5e8be = $860f0b5184108148$var$sample + "s";
const $860f0b5184108148$var$stream = "stream";
const $860f0b5184108148$export$ef26b3900cee0fa3 = $860f0b5184108148$var$stream + "Count";
const $860f0b5184108148$export$9010c500bffe71e6 = $860f0b5184108148$var$stream + "Info";
const $860f0b5184108148$export$462f9602534f6121 = $860f0b5184108148$var$stream + "Serial" + $860f0b5184108148$var$Number;
const $860f0b5184108148$export$fd98de4d87954f15 = $860f0b5184108148$var$stream + "StructureVersion";
const $860f0b5184108148$var$total = "total";
const $860f0b5184108148$export$acdbe6200d314ea0 = $860f0b5184108148$var$total + "BytesOut";
const $860f0b5184108148$export$4ff6995501858325 = $860f0b5184108148$var$total + "Duration";
const $860f0b5184108148$export$27063c03e3b4546e = $860f0b5184108148$var$total + "Samples";
const $860f0b5184108148$export$3027c70a881d60dc = $860f0b5184108148$var$symbol();
const $860f0b5184108148$export$ccac409b8bd6669d = $860f0b5184108148$var$symbol();
const $860f0b5184108148$export$ebf36ec211205204 = $860f0b5184108148$var$symbol();
const $860f0b5184108148$export$24d5305cc192425a = $860f0b5184108148$var$symbol();
const $860f0b5184108148$export$ebd6064652549ce9 = $860f0b5184108148$var$symbol();
const $860f0b5184108148$export$58da9968c3170cb1 = $860f0b5184108148$var$symbol();
const $860f0b5184108148$export$bd2dbf3c3b57dcf1 = $860f0b5184108148$var$symbol();
const $860f0b5184108148$export$6a29256c87cd443c = $860f0b5184108148$var$symbol();
const $860f0b5184108148$export$47ed31abc613cf55 = $860f0b5184108148$var$symbol();
const $860f0b5184108148$export$604ed74fb893f0e2 = $860f0b5184108148$var$symbol();
const $860f0b5184108148$export$fd8d2ba2926cdfb6 = $860f0b5184108148$var$symbol();
const $860f0b5184108148$export$9616b51a1be2e082 = $860f0b5184108148$var$symbol();
const $860f0b5184108148$export$d9639f7fbeab4358 = $860f0b5184108148$var$symbol();
const $860f0b5184108148$export$b025372f68843755 = $860f0b5184108148$var$symbol();
const $860f0b5184108148$export$aad8462122ac592b = $860f0b5184108148$var$symbol();
const $860f0b5184108148$export$d7c4a0dd6a4567e5 = $860f0b5184108148$var$symbol();
const $860f0b5184108148$export$c34399eed923e901 = $860f0b5184108148$var$symbol();
const $860f0b5184108148$export$b97792a91f8a2a21 = $860f0b5184108148$var$symbol();
const $860f0b5184108148$export$d7e5036dad7e20bb = Uint8Array;
const $860f0b5184108148$export$40b76aa5ded53e7a = DataView;
const $860f0b5184108148$export$e46d647da3214494 = "reserved";
const $860f0b5184108148$export$a4535ec98457231d = "bad";
const $860f0b5184108148$export$13e2de3c33d99539 = "free";
const $860f0b5184108148$export$f883a24d5edde77c = "none";
const $860f0b5184108148$export$26245484299fce57 = "16bit CRC";


const $dd0c961b75cd9139$var$getCrcTable = (crcTable, crcInitialValueFunction, crcFunction)=>{
    for(let byte = 0; byte < crcTable[0, $860f0b5184108148$export$f24224f1c91d8156]; byte++){
        let crc = crcInitialValueFunction(byte);
        for(let bit = 8; bit > 0; bit--)crc = crcFunction(crc);
        crcTable[byte] = crc;
    }
    return crcTable;
};
const $dd0c961b75cd9139$var$crc8Table = $dd0c961b75cd9139$var$getCrcTable(new (0, $860f0b5184108148$export$d7e5036dad7e20bb)(256), (b)=>b, (crc)=>crc & 0x80 ? 0x07 ^ crc << 1 : crc << 1);
const $dd0c961b75cd9139$var$flacCrc16Table = [
    $dd0c961b75cd9139$var$getCrcTable(new Uint16Array(256), (b)=>b << 8, (crc)=>crc << 1 ^ (crc & 32768 ? 0x8005 : 0))
];
const $dd0c961b75cd9139$var$crc32Table = [
    $dd0c961b75cd9139$var$getCrcTable(new Uint32Array(256), (b)=>b, (crc)=>crc >>> 1 ^ (crc & 1) * 0xedb88320)
];
// build crc tables
for(let i = 0; i < 15; i++){
    $dd0c961b75cd9139$var$flacCrc16Table.push(new Uint16Array(256));
    $dd0c961b75cd9139$var$crc32Table.push(new Uint32Array(256));
    for(let j = 0; j <= 0xff; j++){
        $dd0c961b75cd9139$var$flacCrc16Table[i + 1][j] = $dd0c961b75cd9139$var$flacCrc16Table[0][$dd0c961b75cd9139$var$flacCrc16Table[i][j] >>> 8] ^ $dd0c961b75cd9139$var$flacCrc16Table[i][j] << 8;
        $dd0c961b75cd9139$var$crc32Table[i + 1][j] = $dd0c961b75cd9139$var$crc32Table[i][j] >>> 8 ^ $dd0c961b75cd9139$var$crc32Table[0][$dd0c961b75cd9139$var$crc32Table[i][j] & 0xff];
    }
}
const $dd0c961b75cd9139$export$97177c3f756cd8a4 = (data)=>{
    let crc = 0;
    const dataLength = data[0, $860f0b5184108148$export$f24224f1c91d8156];
    for(let i = 0; i !== dataLength; i++)crc = $dd0c961b75cd9139$var$crc8Table[crc ^ data[i]];
    return crc;
};
const $dd0c961b75cd9139$export$bca7964a3cb8eec7 = (data)=>{
    const dataLength = data[0, $860f0b5184108148$export$f24224f1c91d8156];
    const crcChunkSize = dataLength - 16;
    let crc = 0;
    let i = 0;
    while(i <= crcChunkSize){
        crc ^= data[i++] << 8 | data[i++];
        crc = $dd0c961b75cd9139$var$flacCrc16Table[15][crc >> 8] ^ $dd0c961b75cd9139$var$flacCrc16Table[14][crc & 0xff] ^ $dd0c961b75cd9139$var$flacCrc16Table[13][data[i++]] ^ $dd0c961b75cd9139$var$flacCrc16Table[12][data[i++]] ^ $dd0c961b75cd9139$var$flacCrc16Table[11][data[i++]] ^ $dd0c961b75cd9139$var$flacCrc16Table[10][data[i++]] ^ $dd0c961b75cd9139$var$flacCrc16Table[9][data[i++]] ^ $dd0c961b75cd9139$var$flacCrc16Table[8][data[i++]] ^ $dd0c961b75cd9139$var$flacCrc16Table[7][data[i++]] ^ $dd0c961b75cd9139$var$flacCrc16Table[6][data[i++]] ^ $dd0c961b75cd9139$var$flacCrc16Table[5][data[i++]] ^ $dd0c961b75cd9139$var$flacCrc16Table[4][data[i++]] ^ $dd0c961b75cd9139$var$flacCrc16Table[3][data[i++]] ^ $dd0c961b75cd9139$var$flacCrc16Table[2][data[i++]] ^ $dd0c961b75cd9139$var$flacCrc16Table[1][data[i++]] ^ $dd0c961b75cd9139$var$flacCrc16Table[0][data[i++]];
    }
    while(i !== dataLength)crc = (crc & 0xff) << 8 ^ $dd0c961b75cd9139$var$flacCrc16Table[0][crc >> 8 ^ data[i++]];
    return crc;
};
const $dd0c961b75cd9139$export$208e3b04219ed02 = (data)=>{
    const dataLength = data[0, $860f0b5184108148$export$f24224f1c91d8156];
    const crcChunkSize = dataLength - 16;
    let crc = 0;
    let i = 0;
    while(i <= crcChunkSize)crc = $dd0c961b75cd9139$var$crc32Table[15][(data[i++] ^ crc) & 0xff] ^ $dd0c961b75cd9139$var$crc32Table[14][(data[i++] ^ crc >>> 8) & 0xff] ^ $dd0c961b75cd9139$var$crc32Table[13][(data[i++] ^ crc >>> 16) & 0xff] ^ $dd0c961b75cd9139$var$crc32Table[12][data[i++] ^ crc >>> 24] ^ $dd0c961b75cd9139$var$crc32Table[11][data[i++]] ^ $dd0c961b75cd9139$var$crc32Table[10][data[i++]] ^ $dd0c961b75cd9139$var$crc32Table[9][data[i++]] ^ $dd0c961b75cd9139$var$crc32Table[8][data[i++]] ^ $dd0c961b75cd9139$var$crc32Table[7][data[i++]] ^ $dd0c961b75cd9139$var$crc32Table[6][data[i++]] ^ $dd0c961b75cd9139$var$crc32Table[5][data[i++]] ^ $dd0c961b75cd9139$var$crc32Table[4][data[i++]] ^ $dd0c961b75cd9139$var$crc32Table[3][data[i++]] ^ $dd0c961b75cd9139$var$crc32Table[2][data[i++]] ^ $dd0c961b75cd9139$var$crc32Table[1][data[i++]] ^ $dd0c961b75cd9139$var$crc32Table[0][data[i++]];
    while(i !== dataLength)crc = $dd0c961b75cd9139$var$crc32Table[0][(crc ^ data[i++]) & 0xff] ^ crc >>> 8;
    return crc ^ -1;
};
const $dd0c961b75cd9139$export$28e250f55413be00 = (...buffers)=>{
    const buffer = new (0, $860f0b5184108148$export$d7e5036dad7e20bb)(buffers.reduce((acc, buf)=>acc + buf[0, $860f0b5184108148$export$f24224f1c91d8156], 0));
    buffers.reduce((offset, buf)=>{
        buffer.set(buf, offset);
        return offset + buf[0, $860f0b5184108148$export$f24224f1c91d8156];
    }, 0);
    return buffer;
};
const $dd0c961b75cd9139$export$7c746b75f47c9c7d = (bytes)=>String.fromCharCode(...bytes);
// prettier-ignore
const $dd0c961b75cd9139$var$reverseTable = [
    0x0,
    0x8,
    0x4,
    0xc,
    0x2,
    0xa,
    0x6,
    0xe,
    0x1,
    0x9,
    0x5,
    0xd,
    0x3,
    0xb,
    0x7,
    0xf
];
const $dd0c961b75cd9139$export$66c1ae025e96b4bc = (val)=>$dd0c961b75cd9139$var$reverseTable[val & 15] << 4 | $dd0c961b75cd9139$var$reverseTable[val >> 4];
class $dd0c961b75cd9139$export$229c1f1c745a2f7a {
    constructor(data){
        this._data = data;
        this._pos = data[0, $860f0b5184108148$export$f24224f1c91d8156] * 8;
    }
    set position(position) {
        this._pos = position;
    }
    get position() {
        return this._pos;
    }
    read(bits) {
        const byte = Math.floor(this._pos / 8);
        const bit = this._pos % 8;
        this._pos -= bits;
        const window = ($dd0c961b75cd9139$export$66c1ae025e96b4bc(this._data[byte - 1]) << 8) + $dd0c961b75cd9139$export$66c1ae025e96b4bc(this._data[byte]);
        return window >> 7 - bit & 0xff;
    }
}



/* Copyright 2020-2023 Ethan Halsall
    
    This file is part of codec-parser.
    
    codec-parser is free software: you can redistribute it and/or modify
    it under the terms of the GNU Lesser General Public License as published by
    the Free Software Foundation, either version 3 of the License, or
    (at your option) any later version.

    codec-parser is distributed in the hope that it will be useful,
    but WITHOUT ANY WARRANTY; without even the implied warranty of
    MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
    GNU Lesser General Public License for more details.

    You should have received a copy of the GNU Lesser General Public License
    along with this program.  If not, see <https://www.gnu.org/licenses/>
*/ 
class $0139e6c9e0318001$export$2e2bcd8739ae039 {
    constructor(onCodecHeader, onCodecUpdate){
        this._onCodecHeader = onCodecHeader;
        this._onCodecUpdate = onCodecUpdate;
        this[0, $860f0b5184108148$export$aad8462122ac592b]();
    }
    [(0, $860f0b5184108148$export$d7c4a0dd6a4567e5)]() {
        this._isEnabled = true;
    }
    [(0, $860f0b5184108148$export$aad8462122ac592b)]() {
        this._headerCache = new Map();
        this._codecUpdateData = new WeakMap();
        this._codecHeaderSent = false;
        this._codecShouldUpdate = false;
        this._bitrate = null;
        this._isEnabled = false;
    }
    [(0, $860f0b5184108148$export$b025372f68843755)](bitrate, totalDuration) {
        if (this._onCodecUpdate) {
            if (this._bitrate !== bitrate) {
                this._bitrate = bitrate;
                this._codecShouldUpdate = true;
            }
            // only update if codec data is available
            const codecData = this._codecUpdateData.get(this._headerCache.get(this._currentHeader));
            if (this._codecShouldUpdate && codecData) this._onCodecUpdate({
                bitrate: bitrate,
                ...codecData
            }, totalDuration);
            this._codecShouldUpdate = false;
        }
    }
    [(0, $860f0b5184108148$export$47ed31abc613cf55)](key) {
        const header = this._headerCache.get(key);
        if (header) this._updateCurrentHeader(key);
        return header;
    }
    [(0, $860f0b5184108148$export$604ed74fb893f0e2)](key, header, codecUpdateFields) {
        if (this._isEnabled) {
            if (!this._codecHeaderSent) {
                this._onCodecHeader({
                    ...header
                });
                this._codecHeaderSent = true;
            }
            this._updateCurrentHeader(key);
            this._headerCache.set(key, header);
            this._codecUpdateData.set(header, codecUpdateFields);
        }
    }
    _updateCurrentHeader(key) {
        if (this._onCodecUpdate && key !== this._currentHeader) {
            this._codecShouldUpdate = true;
            this._currentHeader = key;
        }
    }
}


/* Copyright 2020-2023 Ethan Halsall
    
    This file is part of codec-parser.
    
    codec-parser is free software: you can redistribute it and/or modify
    it under the terms of the GNU Lesser General Public License as published by
    the Free Software Foundation, either version 3 of the License, or
    (at your option) any later version.

    codec-parser is distributed in the hope that it will be useful,
    but WITHOUT ANY WARRANTY; without even the implied warranty of
    MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
    GNU Lesser General Public License for more details.

    You should have received a copy of the GNU Lesser General Public License
    along with this program.  If not, see <https://www.gnu.org/licenses/>
*/ 
/* Copyright 2020-2023 Ethan Halsall
    
    This file is part of codec-parser.
    
    codec-parser is free software: you can redistribute it and/or modify
    it under the terms of the GNU Lesser General Public License as published by
    the Free Software Foundation, either version 3 of the License, or
    (at your option) any later version.

    codec-parser is distributed in the hope that it will be useful,
    but WITHOUT ANY WARRANTY; without even the implied warranty of
    MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
    GNU Lesser General Public License for more details.

    You should have received a copy of the GNU Lesser General Public License
    along with this program.  If not, see <https://www.gnu.org/licenses/>
*/ const $5169222015670af0$export$52342bdf89fb39e7 = new WeakMap();
const $5169222015670af0$export$5b0e32d79f1188e7 = new WeakMap();



class $dd7c0f9e54b04fc4$export$2e2bcd8739ae039 {
    constructor(codecParser, headerCache){
        this._codecParser = codecParser;
        this._headerCache = headerCache;
    }
    *[(0, $860f0b5184108148$export$bd2dbf3c3b57dcf1)]() {
        let frameData;
        do {
            frameData = yield* this.Frame[0, $860f0b5184108148$export$fd8d2ba2926cdfb6](this._codecParser, this._headerCache, 0);
            if (frameData) return frameData;
            this._codecParser[0, $860f0b5184108148$export$ccac409b8bd6669d](1); // increment to continue syncing
        }while (true);
    }
    /**
   * @description Searches for Frames within bytes containing a sequence of known codec frames.
   * @param {boolean} ignoreNextFrame Set to true to return frames even if the next frame may not exist at the expected location
   * @returns {Frame}
   */ *[(0, $860f0b5184108148$export$6a29256c87cd443c)](ignoreNextFrame) {
        let frameData = yield* this[0, $860f0b5184108148$export$bd2dbf3c3b57dcf1]();
        const frameLength = (0, $5169222015670af0$export$5b0e32d79f1188e7).get(frameData)[0, $860f0b5184108148$export$f24224f1c91d8156];
        if (ignoreNextFrame || this._codecParser._flushing || // check if there is a frame right after this one
        (yield* this.Header[0, $860f0b5184108148$export$47ed31abc613cf55](this._codecParser, this._headerCache, frameLength))) {
            this._headerCache[0, $860f0b5184108148$export$d7c4a0dd6a4567e5](); // start caching when synced
            this._codecParser[0, $860f0b5184108148$export$ccac409b8bd6669d](frameLength); // increment to the next frame
            this._codecParser[0, $860f0b5184108148$export$24d5305cc192425a](frameData);
            return frameData;
        }
        this._codecParser[0, $860f0b5184108148$export$ebd6064652549ce9](`Missing ${(0, $860f0b5184108148$export$2cef06c20297c17d)} at ${frameLength} bytes from current position.`, `Dropping current ${(0, $860f0b5184108148$export$2cef06c20297c17d)} and trying again.`);
        this._headerCache[0, $860f0b5184108148$export$aad8462122ac592b](); // frame is invalid and must re-sync and clear cache
        this._codecParser[0, $860f0b5184108148$export$ccac409b8bd6669d](1); // increment to invalidate the current frame
    }
}


/* Copyright 2020-2023 Ethan Halsall
    
    This file is part of codec-parser.
    
    codec-parser is free software: you can redistribute it and/or modify
    it under the terms of the GNU Lesser General Public License as published by
    the Free Software Foundation, either version 3 of the License, or
    (at your option) any later version.

    codec-parser is distributed in the hope that it will be useful,
    but WITHOUT ANY WARRANTY; without even the implied warranty of
    MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
    GNU Lesser General Public License for more details.

    You should have received a copy of the GNU Lesser General Public License
    along with this program.  If not, see <https://www.gnu.org/licenses/>
*/ 
/* Copyright 2020-2023 Ethan Halsall
    
    This file is part of codec-parser.
    
    codec-parser is free software: you can redistribute it and/or modify
    it under the terms of the GNU Lesser General Public License as published by
    the Free Software Foundation, either version 3 of the License, or
    (at your option) any later version.

    codec-parser is distributed in the hope that it will be useful,
    but WITHOUT ANY WARRANTY; without even the implied warranty of
    MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
    GNU Lesser General Public License for more details.

    You should have received a copy of the GNU Lesser General Public License
    along with this program.  If not, see <https://www.gnu.org/licenses/>
*/ 

/* Copyright 2020-2023 Ethan Halsall
    
    This file is part of codec-parser.
    
    codec-parser is free software: you can redistribute it and/or modify
    it under the terms of the GNU Lesser General Public License as published by
    the Free Software Foundation, either version 3 of the License, or
    (at your option) any later version.

    codec-parser is distributed in the hope that it will be useful,
    but WITHOUT ANY WARRANTY; without even the implied warranty of
    MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
    GNU Lesser General Public License for more details.

    You should have received a copy of the GNU Lesser General Public License
    along with this program.  If not, see <https://www.gnu.org/licenses/>
*/ 

class $34ee446617012033$export$2e2bcd8739ae039 {
    constructor(headerValue, dataValue){
        (0, $5169222015670af0$export$5b0e32d79f1188e7).set(this, {
            [(0, $860f0b5184108148$export$38e42c68cf43b5d4)]: headerValue
        });
        this[0, $860f0b5184108148$export$4051a07651545597] = dataValue;
    }
}


class $0b17d7d3514fce05$export$2e2bcd8739ae039 extends (0, $34ee446617012033$export$2e2bcd8739ae039) {
    static *[(0, $860f0b5184108148$export$fd8d2ba2926cdfb6)](Header, Frame, codecParser, headerCache, readOffset) {
        const headerValue = yield* Header[0, $860f0b5184108148$export$47ed31abc613cf55](codecParser, headerCache, readOffset);
        if (headerValue) {
            const frameLengthValue = (0, $5169222015670af0$export$52342bdf89fb39e7).get(headerValue)[0, $860f0b5184108148$export$326bb32b4ec6239b];
            const samplesValue = (0, $5169222015670af0$export$52342bdf89fb39e7).get(headerValue)[0, $860f0b5184108148$export$5f20c3cdf3b5e8be];
            const frame = (yield* codecParser[0, $860f0b5184108148$export$3027c70a881d60dc](frameLengthValue, readOffset))[0, $860f0b5184108148$export$7ec32827e4221318](0, frameLengthValue);
            return new Frame(headerValue, frame, samplesValue);
        } else return null;
    }
    constructor(headerValue, dataValue, samplesValue){
        super(headerValue, dataValue);
        this[0, $860f0b5184108148$export$38e42c68cf43b5d4] = headerValue;
        this[0, $860f0b5184108148$export$5f20c3cdf3b5e8be] = samplesValue;
        this[0, $860f0b5184108148$export$1f34108aa9eb96ab] = samplesValue / headerValue[0, $860f0b5184108148$export$851d973a43101ae1] * 1000;
        this[0, $860f0b5184108148$export$5da2c6384bf58746] = null;
        this[0, $860f0b5184108148$export$acdbe6200d314ea0] = null;
        this[0, $860f0b5184108148$export$27063c03e3b4546e] = null;
        this[0, $860f0b5184108148$export$4ff6995501858325] = null;
        (0, $5169222015670af0$export$5b0e32d79f1188e7).get(this)[0, $860f0b5184108148$export$f24224f1c91d8156] = dataValue[0, $860f0b5184108148$export$f24224f1c91d8156];
    }
}


/* Copyright 2020-2023 Ethan Halsall
    
    This file is part of codec-parser.
    
    codec-parser is free software: you can redistribute it and/or modify
    it under the terms of the GNU Lesser General Public License as published by
    the Free Software Foundation, either version 3 of the License, or
    (at your option) any later version.

    codec-parser is distributed in the hope that it will be useful,
    but WITHOUT ANY WARRANTY; without even the implied warranty of
    MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
    GNU Lesser General Public License for more details.

    You should have received a copy of the GNU Lesser General Public License
    along with this program.  If not, see <https://www.gnu.org/licenses/>
*/ 

/* Copyright 2020-2023 Ethan Halsall
    
    This file is part of codec-parser.
    
    codec-parser is free software: you can redistribute it and/or modify
    it under the terms of the GNU Lesser General Public License as published by
    the Free Software Foundation, either version 3 of the License, or
    (at your option) any later version.

    codec-parser is distributed in the hope that it will be useful,
    but WITHOUT ANY WARRANTY; without even the implied warranty of
    MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
    GNU Lesser General Public License for more details.

    You should have received a copy of the GNU Lesser General Public License
    along with this program.  If not, see <https://www.gnu.org/licenses/>
*/ // https://id3.org/Developer%20Information

const $a7845465f90548da$var$unsynchronizationFlag = "unsynchronizationFlag";
const $a7845465f90548da$var$extendedHeaderFlag = "extendedHeaderFlag";
const $a7845465f90548da$var$experimentalFlag = "experimentalFlag";
const $a7845465f90548da$var$footerPresent = "footerPresent";
class $a7845465f90548da$export$2e2bcd8739ae039 {
    static *getID3v2Header(codecParser, headerCache, readOffset) {
        const headerLength = 10;
        const header = {};
        let data = yield* codecParser[0, $860f0b5184108148$export$3027c70a881d60dc](3, readOffset);
        // Byte (0-2 of 9)
        // ID3
        if (data[0] !== 0x49 || data[1] !== 0x44 || data[2] !== 0x33) return null;
        data = yield* codecParser[0, $860f0b5184108148$export$3027c70a881d60dc](headerLength, readOffset);
        // Byte (3-4 of 9)
        // * `BBBBBBBB|........`: Major version
        // * `........|BBBBBBBB`: Minor version
        header[0, $860f0b5184108148$export$83d89fbfd8236492] = `id3v2.${data[3]}.${data[4]}`;
        // Byte (5 of 9)
        // * `....0000.: Zeros (flags not implemented yet)
        if (data[5] & 15) return null;
        // Byte (5 of 9)
        // * `CDEF0000`: Flags
        // * `C.......`: Unsynchronisation (indicates whether or not unsynchronisation is used)
        // * `.D......`: Extended header (indicates whether or not the header is followed by an extended header)
        // * `..E.....`: Experimental indicator (indicates whether or not the tag is in an experimental stage)
        // * `...F....`: Footer present (indicates that a footer is present at the very end of the tag)
        header[$a7845465f90548da$var$unsynchronizationFlag] = !!(data[5] & 128);
        header[$a7845465f90548da$var$extendedHeaderFlag] = !!(data[5] & 64);
        header[$a7845465f90548da$var$experimentalFlag] = !!(data[5] & 32);
        header[$a7845465f90548da$var$footerPresent] = !!(data[5] & 16);
        // Byte (6-9 of 9)
        // * `0.......|0.......|0.......|0.......`: Zeros
        if (data[6] & 128 || data[7] & 128 || data[8] & 128 || data[9] & 128) return null;
        // Byte (6-9 of 9)
        // * `.FFFFFFF|.FFFFFFF|.FFFFFFF|.FFFFFFF`: Tag Length
        // The ID3v2 tag size is encoded with four bytes where the most significant bit (bit 7)
        // is set to zero in every byte, making a total of 28 bits. The zeroed bits are ignored,
        // so a 257 bytes long tag is represented as $00 00 02 01.
        const dataLength = data[6] << 21 | data[7] << 14 | data[8] << 7 | data[9];
        header[0, $860f0b5184108148$export$f24224f1c91d8156] = headerLength + dataLength;
        return new $a7845465f90548da$export$2e2bcd8739ae039(header);
    }
    constructor(header){
        this[0, $860f0b5184108148$export$83d89fbfd8236492] = header[0, $860f0b5184108148$export$83d89fbfd8236492];
        this[$a7845465f90548da$var$unsynchronizationFlag] = header[$a7845465f90548da$var$unsynchronizationFlag];
        this[$a7845465f90548da$var$extendedHeaderFlag] = header[$a7845465f90548da$var$extendedHeaderFlag];
        this[$a7845465f90548da$var$experimentalFlag] = header[$a7845465f90548da$var$experimentalFlag];
        this[$a7845465f90548da$var$footerPresent] = header[$a7845465f90548da$var$footerPresent];
        this[0, $860f0b5184108148$export$f24224f1c91d8156] = header[0, $860f0b5184108148$export$f24224f1c91d8156];
    }
}


/* Copyright 2020-2023 Ethan Halsall
    
    This file is part of codec-parser.
    
    codec-parser is free software: you can redistribute it and/or modify
    it under the terms of the GNU Lesser General Public License as published by
    the Free Software Foundation, either version 3 of the License, or
    (at your option) any later version.

    codec-parser is distributed in the hope that it will be useful,
    but WITHOUT ANY WARRANTY; without even the implied warranty of
    MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
    GNU Lesser General Public License for more details.

    You should have received a copy of the GNU Lesser General Public License
    along with this program.  If not, see <https://www.gnu.org/licenses/>
*/ 

class $3fb1607145c26488$export$2e2bcd8739ae039 {
    /**
   * @private
   */ constructor(header){
        (0, $5169222015670af0$export$52342bdf89fb39e7).set(this, header);
        this[0, $860f0b5184108148$export$cee20cdac1cd19df] = header[0, $860f0b5184108148$export$cee20cdac1cd19df];
        this[0, $860f0b5184108148$export$fbead197e07be487] = null; // set during frame mapping
        this[0, $860f0b5184108148$export$9659c395d9de169e] = header[0, $860f0b5184108148$export$9659c395d9de169e];
        this[0, $860f0b5184108148$export$589c9a7ae9a79c5e] = header[0, $860f0b5184108148$export$589c9a7ae9a79c5e];
        this[0, $860f0b5184108148$export$851d973a43101ae1] = header[0, $860f0b5184108148$export$851d973a43101ae1];
    }
}


// http://www.mp3-tech.org/programmer/frame_header.html
const $66a3933fe72fadca$var$bitrateMatrix = {
    // bits | V1,L1 | V1,L2 | V1,L3 | V2,L1 | V2,L2 & L3
    0: [
        (0, $860f0b5184108148$export$13e2de3c33d99539),
        (0, $860f0b5184108148$export$13e2de3c33d99539),
        (0, $860f0b5184108148$export$13e2de3c33d99539),
        (0, $860f0b5184108148$export$13e2de3c33d99539),
        (0, $860f0b5184108148$export$13e2de3c33d99539)
    ],
    16: [
        32,
        32,
        32,
        32,
        8
    ],
    // 0b00100000: [64,   48,  40,  48,  16,],
    // 0b00110000: [96,   56,  48,  56,  24,],
    // 0b01000000: [128,  64,  56,  64,  32,],
    // 0b01010000: [160,  80,  64,  80,  40,],
    // 0b01100000: [192,  96,  80,  96,  48,],
    // 0b01110000: [224, 112,  96, 112,  56,],
    // 0b10000000: [256, 128, 112, 128,  64,],
    // 0b10010000: [288, 160, 128, 144,  80,],
    // 0b10100000: [320, 192, 160, 160,  96,],
    // 0b10110000: [352, 224, 192, 176, 112,],
    // 0b11000000: [384, 256, 224, 192, 128,],
    // 0b11010000: [416, 320, 256, 224, 144,],
    // 0b11100000: [448, 384, 320, 256, 160,],
    240: [
        (0, $860f0b5184108148$export$a4535ec98457231d),
        (0, $860f0b5184108148$export$a4535ec98457231d),
        (0, $860f0b5184108148$export$a4535ec98457231d),
        (0, $860f0b5184108148$export$a4535ec98457231d),
        (0, $860f0b5184108148$export$a4535ec98457231d)
    ]
};
const $66a3933fe72fadca$var$calcBitrate = (idx, interval, intervalOffset)=>8 * ((idx + intervalOffset) % interval + interval) * (1 << (idx + intervalOffset) / interval) - 8 * interval * (interval / 8 | 0);
// generate bitrate matrix
for(let i = 2; i < 15; i++)$66a3933fe72fadca$var$bitrateMatrix[i << 4] = [
    i * 32,
    $66a3933fe72fadca$var$calcBitrate(i, 4, 0),
    $66a3933fe72fadca$var$calcBitrate(i, 4, -1),
    $66a3933fe72fadca$var$calcBitrate(i, 8, 4),
    $66a3933fe72fadca$var$calcBitrate(i, 8, 0)
];
const $66a3933fe72fadca$var$v1Layer1 = 0;
const $66a3933fe72fadca$var$v1Layer2 = 1;
const $66a3933fe72fadca$var$v1Layer3 = 2;
const $66a3933fe72fadca$var$v2Layer1 = 3;
const $66a3933fe72fadca$var$v2Layer23 = 4;
const $66a3933fe72fadca$var$bands = "bands ";
const $66a3933fe72fadca$var$to31 = " to 31";
const $66a3933fe72fadca$var$layer12ModeExtensions = {
    0: $66a3933fe72fadca$var$bands + 4 + $66a3933fe72fadca$var$to31,
    16: $66a3933fe72fadca$var$bands + 8 + $66a3933fe72fadca$var$to31,
    32: $66a3933fe72fadca$var$bands + 12 + $66a3933fe72fadca$var$to31,
    48: $66a3933fe72fadca$var$bands + 16 + $66a3933fe72fadca$var$to31
};
const $66a3933fe72fadca$var$bitrateIndex = "bitrateIndex";
const $66a3933fe72fadca$var$v2 = "v2";
const $66a3933fe72fadca$var$v1 = "v1";
const $66a3933fe72fadca$var$intensityStereo = "Intensity stereo ";
const $66a3933fe72fadca$var$msStereo = ", MS stereo ";
const $66a3933fe72fadca$var$on = "on";
const $66a3933fe72fadca$var$off = "off";
const $66a3933fe72fadca$var$layer3ModeExtensions = {
    0: $66a3933fe72fadca$var$intensityStereo + $66a3933fe72fadca$var$off + $66a3933fe72fadca$var$msStereo + $66a3933fe72fadca$var$off,
    16: $66a3933fe72fadca$var$intensityStereo + $66a3933fe72fadca$var$on + $66a3933fe72fadca$var$msStereo + $66a3933fe72fadca$var$off,
    32: $66a3933fe72fadca$var$intensityStereo + $66a3933fe72fadca$var$off + $66a3933fe72fadca$var$msStereo + $66a3933fe72fadca$var$on,
    48: $66a3933fe72fadca$var$intensityStereo + $66a3933fe72fadca$var$on + $66a3933fe72fadca$var$msStereo + $66a3933fe72fadca$var$on
};
const $66a3933fe72fadca$var$layersValues = {
    0: {
        [(0, $860f0b5184108148$export$6d59db4903f20f7d)]: (0, $860f0b5184108148$export$e46d647da3214494)
    },
    2: {
        [(0, $860f0b5184108148$export$6d59db4903f20f7d)]: "Layer III",
        [(0, $860f0b5184108148$export$e4cdad84c725445)]: 1,
        [(0, $860f0b5184108148$export$f1eb63ab5aca5708)]: $66a3933fe72fadca$var$layer3ModeExtensions,
        [$66a3933fe72fadca$var$v1]: {
            [$66a3933fe72fadca$var$bitrateIndex]: $66a3933fe72fadca$var$v1Layer3,
            [(0, $860f0b5184108148$export$5f20c3cdf3b5e8be)]: 1152
        },
        [$66a3933fe72fadca$var$v2]: {
            [$66a3933fe72fadca$var$bitrateIndex]: $66a3933fe72fadca$var$v2Layer23,
            [(0, $860f0b5184108148$export$5f20c3cdf3b5e8be)]: 576
        }
    },
    4: {
        [(0, $860f0b5184108148$export$6d59db4903f20f7d)]: "Layer II",
        [(0, $860f0b5184108148$export$e4cdad84c725445)]: 1,
        [(0, $860f0b5184108148$export$f1eb63ab5aca5708)]: $66a3933fe72fadca$var$layer12ModeExtensions,
        [(0, $860f0b5184108148$export$5f20c3cdf3b5e8be)]: 1152,
        [$66a3933fe72fadca$var$v1]: {
            [$66a3933fe72fadca$var$bitrateIndex]: $66a3933fe72fadca$var$v1Layer2
        },
        [$66a3933fe72fadca$var$v2]: {
            [$66a3933fe72fadca$var$bitrateIndex]: $66a3933fe72fadca$var$v2Layer23
        }
    },
    6: {
        [(0, $860f0b5184108148$export$6d59db4903f20f7d)]: "Layer I",
        [(0, $860f0b5184108148$export$e4cdad84c725445)]: 4,
        [(0, $860f0b5184108148$export$f1eb63ab5aca5708)]: $66a3933fe72fadca$var$layer12ModeExtensions,
        [(0, $860f0b5184108148$export$5f20c3cdf3b5e8be)]: 384,
        [$66a3933fe72fadca$var$v1]: {
            [$66a3933fe72fadca$var$bitrateIndex]: $66a3933fe72fadca$var$v1Layer1
        },
        [$66a3933fe72fadca$var$v2]: {
            [$66a3933fe72fadca$var$bitrateIndex]: $66a3933fe72fadca$var$v2Layer1
        }
    }
};
const $66a3933fe72fadca$var$mpegVersionDescription = "MPEG Version ";
const $66a3933fe72fadca$var$isoIec = "ISO/IEC ";
const $66a3933fe72fadca$var$mpegVersions = {
    0: {
        [(0, $860f0b5184108148$export$6d59db4903f20f7d)]: `${$66a3933fe72fadca$var$mpegVersionDescription}2.5 (later extension of MPEG 2)`,
        [(0, $860f0b5184108148$export$50a222d9023da98b)]: $66a3933fe72fadca$var$v2,
        [(0, $860f0b5184108148$export$851d973a43101ae1)]: {
            0: (0, $860f0b5184108148$export$dd010cc0b9cbe96a),
            4: (0, $860f0b5184108148$export$d18082a7f1daad0e),
            8: (0, $860f0b5184108148$export$8024c021d839bc0e),
            12: (0, $860f0b5184108148$export$e46d647da3214494)
        }
    },
    8: {
        [(0, $860f0b5184108148$export$6d59db4903f20f7d)]: (0, $860f0b5184108148$export$e46d647da3214494)
    },
    16: {
        [(0, $860f0b5184108148$export$6d59db4903f20f7d)]: `${$66a3933fe72fadca$var$mpegVersionDescription}2 (${$66a3933fe72fadca$var$isoIec}13818-3)`,
        [(0, $860f0b5184108148$export$50a222d9023da98b)]: $66a3933fe72fadca$var$v2,
        [(0, $860f0b5184108148$export$851d973a43101ae1)]: {
            0: (0, $860f0b5184108148$export$dc67eb20d4395175),
            4: (0, $860f0b5184108148$export$492422570a89c8b0),
            8: (0, $860f0b5184108148$export$a92c08b19856a52b),
            12: (0, $860f0b5184108148$export$e46d647da3214494)
        }
    },
    24: {
        [(0, $860f0b5184108148$export$6d59db4903f20f7d)]: `${$66a3933fe72fadca$var$mpegVersionDescription}1 (${$66a3933fe72fadca$var$isoIec}11172-3)`,
        [(0, $860f0b5184108148$export$50a222d9023da98b)]: $66a3933fe72fadca$var$v1,
        [(0, $860f0b5184108148$export$851d973a43101ae1)]: {
            0: (0, $860f0b5184108148$export$7b8ebc2092af05a9),
            4: (0, $860f0b5184108148$export$671a0c9051642a0b),
            8: (0, $860f0b5184108148$export$8786c8b1e955b2e9),
            12: (0, $860f0b5184108148$export$e46d647da3214494)
        }
    },
    length: $860f0b5184108148$export$f24224f1c91d8156
};
const $66a3933fe72fadca$var$protectionValues = {
    0: (0, $860f0b5184108148$export$26245484299fce57),
    1: (0, $860f0b5184108148$export$f883a24d5edde77c)
};
const $66a3933fe72fadca$var$emphasisValues = {
    0: (0, $860f0b5184108148$export$f883a24d5edde77c),
    1: "50/15 ms",
    2: (0, $860f0b5184108148$export$e46d647da3214494),
    3: "CCIT J.17"
};
const $66a3933fe72fadca$var$channelModes = {
    0: {
        [(0, $860f0b5184108148$export$9659c395d9de169e)]: 2,
        [(0, $860f0b5184108148$export$6d59db4903f20f7d)]: (0, $860f0b5184108148$export$ec7f46128a2f8ed8)
    },
    64: {
        [(0, $860f0b5184108148$export$9659c395d9de169e)]: 2,
        [(0, $860f0b5184108148$export$6d59db4903f20f7d)]: "joint " + (0, $860f0b5184108148$export$ec7f46128a2f8ed8)
    },
    128: {
        [(0, $860f0b5184108148$export$9659c395d9de169e)]: 2,
        [(0, $860f0b5184108148$export$6d59db4903f20f7d)]: "dual channel"
    },
    192: {
        [(0, $860f0b5184108148$export$9659c395d9de169e)]: 1,
        [(0, $860f0b5184108148$export$6d59db4903f20f7d)]: (0, $860f0b5184108148$export$25d110495212ae90)
    }
};
class $66a3933fe72fadca$export$2e2bcd8739ae039 extends (0, $3fb1607145c26488$export$2e2bcd8739ae039) {
    static *[(0, $860f0b5184108148$export$47ed31abc613cf55)](codecParser, headerCache, readOffset) {
        const header = {};
        // check for id3 header
        const id3v2Header = yield* (0, $a7845465f90548da$export$2e2bcd8739ae039).getID3v2Header(codecParser, headerCache, readOffset);
        if (id3v2Header) {
            // throw away the data. id3 parsing is not implemented yet.
            yield* codecParser[0, $860f0b5184108148$export$3027c70a881d60dc](id3v2Header[0, $860f0b5184108148$export$f24224f1c91d8156], readOffset);
            codecParser[0, $860f0b5184108148$export$ccac409b8bd6669d](id3v2Header[0, $860f0b5184108148$export$f24224f1c91d8156]);
        }
        // Must be at least four bytes.
        const data = yield* codecParser[0, $860f0b5184108148$export$3027c70a881d60dc](4, readOffset);
        // Check header cache
        const key = (0, $dd0c961b75cd9139$export$7c746b75f47c9c7d)(data[0, $860f0b5184108148$export$7ec32827e4221318](0, 4));
        const cachedHeader = headerCache[0, $860f0b5184108148$export$47ed31abc613cf55](key);
        if (cachedHeader) return new $66a3933fe72fadca$export$2e2bcd8739ae039(cachedHeader);
        // Frame sync (all bits must be set): `11111111|111`:
        if (data[0] !== 0xff || data[1] < 0xe0) return null;
        // Byte (2 of 4)
        // * `111BBCCD`
        // * `...BB...`: MPEG Audio version ID
        // * `.....CC.`: Layer description
        // * `.......D`: Protection bit (0 - Protected by CRC (16bit CRC follows header), 1 = Not protected)
        // Mpeg version (1, 2, 2.5)
        const mpegVersionValues = $66a3933fe72fadca$var$mpegVersions[data[1] & 24];
        if (mpegVersionValues[0, $860f0b5184108148$export$6d59db4903f20f7d] === (0, $860f0b5184108148$export$e46d647da3214494)) return null;
        // Layer (I, II, III)
        const layerBits = data[1] & 6;
        if ($66a3933fe72fadca$var$layersValues[layerBits][0, $860f0b5184108148$export$6d59db4903f20f7d] === (0, $860f0b5184108148$export$e46d647da3214494)) return null;
        const layerValues = {
            ...$66a3933fe72fadca$var$layersValues[layerBits],
            ...$66a3933fe72fadca$var$layersValues[layerBits][mpegVersionValues[0, $860f0b5184108148$export$50a222d9023da98b]]
        };
        header[0, $860f0b5184108148$export$33a1ce7cb4e60d8d] = mpegVersionValues[0, $860f0b5184108148$export$6d59db4903f20f7d];
        header[0, $860f0b5184108148$export$50a222d9023da98b] = layerValues[0, $860f0b5184108148$export$6d59db4903f20f7d];
        header[0, $860f0b5184108148$export$5f20c3cdf3b5e8be] = layerValues[0, $860f0b5184108148$export$5f20c3cdf3b5e8be];
        header[0, $860f0b5184108148$export$b9b4c22e291dd3d9] = $66a3933fe72fadca$var$protectionValues[data[1] & 1];
        header[0, $860f0b5184108148$export$f24224f1c91d8156] = 4;
        // Byte (3 of 4)
        // * `EEEEFFGH`
        // * `EEEE....`: Bitrate index. 1111 is invalid, everything else is accepted
        // * `....FF..`: Sample rate
        // * `......G.`: Padding bit, 0=frame not padded, 1=frame padded
        // * `.......H`: Private bit.
        header[0, $860f0b5184108148$export$fbead197e07be487] = $66a3933fe72fadca$var$bitrateMatrix[data[2] & 240][layerValues[$66a3933fe72fadca$var$bitrateIndex]];
        if (header[0, $860f0b5184108148$export$fbead197e07be487] === (0, $860f0b5184108148$export$a4535ec98457231d)) return null;
        header[0, $860f0b5184108148$export$851d973a43101ae1] = mpegVersionValues[0, $860f0b5184108148$export$851d973a43101ae1][data[2] & 12];
        if (header[0, $860f0b5184108148$export$851d973a43101ae1] === (0, $860f0b5184108148$export$e46d647da3214494)) return null;
        header[0, $860f0b5184108148$export$e4cdad84c725445] = data[2] & 2 && layerValues[0, $860f0b5184108148$export$e4cdad84c725445];
        header[0, $860f0b5184108148$export$1d1349f4eb9a7003] = !!(data[2] & 1);
        header[0, $860f0b5184108148$export$326bb32b4ec6239b] = Math.floor(125 * header[0, $860f0b5184108148$export$fbead197e07be487] * header[0, $860f0b5184108148$export$5f20c3cdf3b5e8be] / header[0, $860f0b5184108148$export$851d973a43101ae1] + header[0, $860f0b5184108148$export$e4cdad84c725445]);
        if (!header[0, $860f0b5184108148$export$326bb32b4ec6239b]) return null;
        // Byte (4 of 4)
        // * `IIJJKLMM`
        // * `II......`: Channel mode
        // * `..JJ....`: Mode extension (only if joint stereo)
        // * `....K...`: Copyright
        // * `.....L..`: Original
        // * `......MM`: Emphasis
        const channelModeBits = data[3] & 192;
        header[0, $860f0b5184108148$export$589c9a7ae9a79c5e] = $66a3933fe72fadca$var$channelModes[channelModeBits][0, $860f0b5184108148$export$6d59db4903f20f7d];
        header[0, $860f0b5184108148$export$9659c395d9de169e] = $66a3933fe72fadca$var$channelModes[channelModeBits][0, $860f0b5184108148$export$9659c395d9de169e];
        header[0, $860f0b5184108148$export$f1eb63ab5aca5708] = layerValues[0, $860f0b5184108148$export$f1eb63ab5aca5708][data[3] & 48];
        header[0, $860f0b5184108148$export$818e7b951c237e5d] = !!(data[3] & 8);
        header[0, $860f0b5184108148$export$e512c40786d058ff] = !!(data[3] & 4);
        header[0, $860f0b5184108148$export$bef81ba411953b51] = $66a3933fe72fadca$var$emphasisValues[data[3] & 3];
        if (header[0, $860f0b5184108148$export$bef81ba411953b51] === (0, $860f0b5184108148$export$e46d647da3214494)) return null;
        header[0, $860f0b5184108148$export$cee20cdac1cd19df] = 16;
        // set header cache
        {
            const { length: length, frameLength: frameLength, samples: samples, ...codecUpdateFields } = header;
            headerCache[0, $860f0b5184108148$export$604ed74fb893f0e2](key, header, codecUpdateFields);
        }
        return new $66a3933fe72fadca$export$2e2bcd8739ae039(header);
    }
    /**
   * @private
   * Call MPEGHeader.getHeader(Array<Uint8>) to get instance
   */ constructor(header){
        super(header);
        this[0, $860f0b5184108148$export$fbead197e07be487] = header[0, $860f0b5184108148$export$fbead197e07be487];
        this[0, $860f0b5184108148$export$bef81ba411953b51] = header[0, $860f0b5184108148$export$bef81ba411953b51];
        this[0, $860f0b5184108148$export$e4cdad84c725445] = header[0, $860f0b5184108148$export$e4cdad84c725445];
        this[0, $860f0b5184108148$export$818e7b951c237e5d] = header[0, $860f0b5184108148$export$818e7b951c237e5d];
        this[0, $860f0b5184108148$export$e512c40786d058ff] = header[0, $860f0b5184108148$export$e512c40786d058ff];
        this[0, $860f0b5184108148$export$1d1349f4eb9a7003] = header[0, $860f0b5184108148$export$1d1349f4eb9a7003];
        this[0, $860f0b5184108148$export$50a222d9023da98b] = header[0, $860f0b5184108148$export$50a222d9023da98b];
        this[0, $860f0b5184108148$export$f1eb63ab5aca5708] = header[0, $860f0b5184108148$export$f1eb63ab5aca5708];
        this[0, $860f0b5184108148$export$33a1ce7cb4e60d8d] = header[0, $860f0b5184108148$export$33a1ce7cb4e60d8d];
        this[0, $860f0b5184108148$export$b9b4c22e291dd3d9] = header[0, $860f0b5184108148$export$b9b4c22e291dd3d9];
    }
}


class $573eda4ab45988c0$export$2e2bcd8739ae039 extends (0, $0b17d7d3514fce05$export$2e2bcd8739ae039) {
    static *[(0, $860f0b5184108148$export$fd8d2ba2926cdfb6)](codecParser, headerCache, readOffset) {
        return yield* super[0, $860f0b5184108148$export$fd8d2ba2926cdfb6]((0, $66a3933fe72fadca$export$2e2bcd8739ae039), $573eda4ab45988c0$export$2e2bcd8739ae039, codecParser, headerCache, readOffset);
    }
    constructor(header, frame, samples){
        super(header, frame, samples);
    }
}



class $e60718df768668d6$export$2e2bcd8739ae039 extends (0, $dd7c0f9e54b04fc4$export$2e2bcd8739ae039) {
    constructor(codecParser, headerCache, onCodec){
        super(codecParser, headerCache);
        this.Frame = (0, $573eda4ab45988c0$export$2e2bcd8739ae039);
        this.Header = (0, $66a3933fe72fadca$export$2e2bcd8739ae039);
        onCodec(this[0, $860f0b5184108148$export$1c37c01eba8ed446]);
    }
    get [(0, $860f0b5184108148$export$1c37c01eba8ed446)]() {
        return 0, $860f0b5184108148$export$a08b701eae9f6dda;
    }
    *[(0, $860f0b5184108148$export$9616b51a1be2e082)]() {
        return yield* this[0, $860f0b5184108148$export$6a29256c87cd443c]();
    }
}


/* Copyright 2020-2023 Ethan Halsall
    
    This file is part of codec-parser.
    
    codec-parser is free software: you can redistribute it and/or modify
    it under the terms of the GNU Lesser General Public License as published by
    the Free Software Foundation, either version 3 of the License, or
    (at your option) any later version.

    codec-parser is distributed in the hope that it will be useful,
    but WITHOUT ANY WARRANTY; without even the implied warranty of
    MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
    GNU Lesser General Public License for more details.

    You should have received a copy of the GNU Lesser General Public License
    along with this program.  If not, see <https://www.gnu.org/licenses/>
*/ 

/* Copyright 2020-2023 Ethan Halsall
    
    This file is part of codec-parser.
    
    codec-parser is free software: you can redistribute it and/or modify
    it under the terms of the GNU Lesser General Public License as published by
    the Free Software Foundation, either version 3 of the License, or
    (at your option) any later version.

    codec-parser is distributed in the hope that it will be useful,
    but WITHOUT ANY WARRANTY; without even the implied warranty of
    MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
    GNU Lesser General Public License for more details.

    You should have received a copy of the GNU Lesser General Public License
    along with this program.  If not, see <https://www.gnu.org/licenses/>
*/ 

/* Copyright 2020-2023 Ethan Halsall
    
    This file is part of codec-parser.
    
    codec-parser is free software: you can redistribute it and/or modify
    it under the terms of the GNU Lesser General Public License as published by
    the Free Software Foundation, either version 3 of the License, or
    (at your option) any later version.

    codec-parser is distributed in the hope that it will be useful,
    but WITHOUT ANY WARRANTY; without even the implied warranty of
    MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
    GNU Lesser General Public License for more details.

    You should have received a copy of the GNU Lesser General Public License
    along with this program.  If not, see <https://www.gnu.org/licenses/>
*/ /*
https://wiki.multimedia.cx/index.php/ADTS

AAAAAAAA AAAABCCD EEFFFFGH HHIJKLMM MMMMMMMM MMMOOOOO OOOOOOPP (QQQQQQQQ QQQQQQQQ)

AACHeader consists of 7 or 9 bytes (without or with CRC).
Letter  Length (bits)  Description
A  12  syncword 0xFFF, all bits must be 1
B  1   MPEG Version: 0 for MPEG-4, 1 for MPEG-2
C  2   Layer: always 0
D  1   protection absent, Warning, set to 1 if there is no CRC and 0 if there is CRC
E  2   profile, the MPEG-4 Audio Object Type minus 1
F  4   MPEG-4 Sampling Frequency Index (15 is forbidden)
G  1   private bit, guaranteed never to be used by MPEG, set to 0 when encoding, ignore when decoding
H  3   MPEG-4 Channel Configuration (in the case of 0, the channel configuration is sent via an inband PCE)
I  1   originality, set to 0 when encoding, ignore when decoding
J  1   home, set to 0 when encoding, ignore when decoding
K  1   copyrighted id bit, the next bit of a centrally registered copyright identifier, set to 0 when encoding, ignore when decoding
L  1   copyright id start, signals that this frame's copyright id bit is the first bit of the copyright id, set to 0 when encoding, ignore when decoding
M  13  frame length, this value must include 7 or 9 bytes of header length: FrameLength = (ProtectionAbsent == 1 ? 7 : 9) + size(AACFrame)
O  11  Buffer fullness // 0x7FF for VBR
P  2   Number of AAC frames (RDBs) in ADTS frame minus 1, for maximum compatibility always use 1 AAC frame per ADTS frame
Q  16  CRC if protection absent is 0 
*/ 



const $2e2502127f04fd04$var$mpegVersionValues = {
    0: "MPEG-4",
    8: "MPEG-2"
};
const $2e2502127f04fd04$var$layerValues = {
    0: "valid",
    2: (0, $860f0b5184108148$export$a4535ec98457231d),
    4: (0, $860f0b5184108148$export$a4535ec98457231d),
    6: (0, $860f0b5184108148$export$a4535ec98457231d)
};
const $2e2502127f04fd04$var$protectionValues = {
    0: (0, $860f0b5184108148$export$26245484299fce57),
    1: (0, $860f0b5184108148$export$f883a24d5edde77c)
};
const $2e2502127f04fd04$var$profileValues = {
    0: "AAC Main",
    64: "AAC LC (Low Complexity)",
    128: "AAC SSR (Scalable Sample Rate)",
    192: "AAC LTP (Long Term Prediction)"
};
const $2e2502127f04fd04$var$sampleRates = {
    0: (0, $860f0b5184108148$export$4a9bd43882a638a3),
    4: (0, $860f0b5184108148$export$308fdd6283300e68),
    8: (0, $860f0b5184108148$export$44cafc10e39936f9),
    12: (0, $860f0b5184108148$export$671a0c9051642a0b),
    16: (0, $860f0b5184108148$export$7b8ebc2092af05a9),
    20: (0, $860f0b5184108148$export$8786c8b1e955b2e9),
    24: (0, $860f0b5184108148$export$492422570a89c8b0),
    28: (0, $860f0b5184108148$export$dc67eb20d4395175),
    32: (0, $860f0b5184108148$export$a92c08b19856a52b),
    36: (0, $860f0b5184108148$export$d18082a7f1daad0e),
    40: (0, $860f0b5184108148$export$dd010cc0b9cbe96a),
    44: (0, $860f0b5184108148$export$8024c021d839bc0e),
    48: (0, $860f0b5184108148$export$8003a269f1123d37),
    52: (0, $860f0b5184108148$export$e46d647da3214494),
    56: (0, $860f0b5184108148$export$e46d647da3214494),
    60: "frequency is written explicitly"
};
// prettier-ignore
const $2e2502127f04fd04$var$channelModeValues = {
    0: {
        [(0, $860f0b5184108148$export$9659c395d9de169e)]: 0,
        [(0, $860f0b5184108148$export$6d59db4903f20f7d)]: "Defined in AOT Specific Config"
    },
    /*
  'monophonic (mono)'
  'stereo (left, right)'
  'linear surround (front center, front left, front right)'
  'quadraphonic (front center, front left, front right, rear center)'
  '5.0 surround (front center, front left, front right, rear left, rear right)'
  '5.1 surround (front center, front left, front right, rear left, rear right, LFE)'
  '7.1 surround (front center, front left, front right, side left, side right, rear left, rear right, LFE)'
  */ 64: {
        [(0, $860f0b5184108148$export$9659c395d9de169e)]: 1,
        [(0, $860f0b5184108148$export$6d59db4903f20f7d)]: (0, $860f0b5184108148$export$25d110495212ae90)
    },
    128: {
        [(0, $860f0b5184108148$export$9659c395d9de169e)]: 2,
        [(0, $860f0b5184108148$export$6d59db4903f20f7d)]: (0, $860f0b5184108148$export$8ec6a2c9fbba54e0)(2, (0, $860f0b5184108148$export$3e501d20baea1003)[0][0])
    },
    192: {
        [(0, $860f0b5184108148$export$9659c395d9de169e)]: 3,
        [(0, $860f0b5184108148$export$6d59db4903f20f7d)]: (0, $860f0b5184108148$export$8ec6a2c9fbba54e0)(3, (0, $860f0b5184108148$export$3e501d20baea1003)[1][3])
    },
    256: {
        [(0, $860f0b5184108148$export$9659c395d9de169e)]: 4,
        [(0, $860f0b5184108148$export$6d59db4903f20f7d)]: (0, $860f0b5184108148$export$8ec6a2c9fbba54e0)(4, (0, $860f0b5184108148$export$3e501d20baea1003)[1][3], (0, $860f0b5184108148$export$3e501d20baea1003)[3][4])
    },
    320: {
        [(0, $860f0b5184108148$export$9659c395d9de169e)]: 5,
        [(0, $860f0b5184108148$export$6d59db4903f20f7d)]: (0, $860f0b5184108148$export$8ec6a2c9fbba54e0)(5, (0, $860f0b5184108148$export$3e501d20baea1003)[1][3], (0, $860f0b5184108148$export$3e501d20baea1003)[3][0])
    },
    384: {
        [(0, $860f0b5184108148$export$9659c395d9de169e)]: 6,
        [(0, $860f0b5184108148$export$6d59db4903f20f7d)]: (0, $860f0b5184108148$export$8ec6a2c9fbba54e0)(6, (0, $860f0b5184108148$export$3e501d20baea1003)[1][3], (0, $860f0b5184108148$export$3e501d20baea1003)[3][0], (0, $860f0b5184108148$export$3254282aac6747d2))
    },
    448: {
        [(0, $860f0b5184108148$export$9659c395d9de169e)]: 8,
        [(0, $860f0b5184108148$export$6d59db4903f20f7d)]: (0, $860f0b5184108148$export$8ec6a2c9fbba54e0)(8, (0, $860f0b5184108148$export$3e501d20baea1003)[1][3], (0, $860f0b5184108148$export$3e501d20baea1003)[2][0], (0, $860f0b5184108148$export$3e501d20baea1003)[3][0], (0, $860f0b5184108148$export$3254282aac6747d2))
    }
};
class $2e2502127f04fd04$export$2e2bcd8739ae039 extends (0, $3fb1607145c26488$export$2e2bcd8739ae039) {
    static *[(0, $860f0b5184108148$export$47ed31abc613cf55)](codecParser, headerCache, readOffset) {
        const header = {};
        // Must be at least seven bytes. Out of data
        const data = yield* codecParser[0, $860f0b5184108148$export$3027c70a881d60dc](7, readOffset);
        // Check header cache
        const key = (0, $dd0c961b75cd9139$export$7c746b75f47c9c7d)([
            data[0],
            data[1],
            data[2],
            data[3] & 252 | data[6] & 3
        ]);
        const cachedHeader = headerCache[0, $860f0b5184108148$export$47ed31abc613cf55](key);
        if (!cachedHeader) {
            // Frame sync (all bits must be set): `11111111|1111`:
            if (data[0] !== 0xff || data[1] < 0xf0) return null;
            // Byte (2 of 7)
            // * `1111BCCD`
            // * `....B...`: MPEG Version: 0 for MPEG-4, 1 for MPEG-2
            // * `.....CC.`: Layer: always 0
            // * `.......D`: protection absent, Warning, set to 1 if there is no CRC and 0 if there is CRC
            header[0, $860f0b5184108148$export$33a1ce7cb4e60d8d] = $2e2502127f04fd04$var$mpegVersionValues[data[1] & 8];
            header[0, $860f0b5184108148$export$50a222d9023da98b] = $2e2502127f04fd04$var$layerValues[data[1] & 6];
            if (header[0, $860f0b5184108148$export$50a222d9023da98b] === (0, $860f0b5184108148$export$a4535ec98457231d)) return null;
            const protectionBit = data[1] & 1;
            header[0, $860f0b5184108148$export$b9b4c22e291dd3d9] = $2e2502127f04fd04$var$protectionValues[protectionBit];
            header[0, $860f0b5184108148$export$f24224f1c91d8156] = protectionBit ? 7 : 9;
            // Byte (3 of 7)
            // * `EEFFFFGH`
            // * `EE......`: profile, the MPEG-4 Audio Object Type minus 1
            // * `..FFFF..`: MPEG-4 Sampling Frequency Index (15 is forbidden)
            // * `......G.`: private bit, guaranteed never to be used by MPEG, set to 0 when encoding, ignore when decoding
            header[0, $860f0b5184108148$export$9840eaf33e948519] = data[2] & 192;
            header[0, $860f0b5184108148$export$590421bd05077aa4] = data[2] & 60;
            const privateBit = data[2] & 2;
            header[0, $860f0b5184108148$export$4882ae973e0491e] = $2e2502127f04fd04$var$profileValues[header[0, $860f0b5184108148$export$9840eaf33e948519]];
            header[0, $860f0b5184108148$export$851d973a43101ae1] = $2e2502127f04fd04$var$sampleRates[header[0, $860f0b5184108148$export$590421bd05077aa4]];
            if (header[0, $860f0b5184108148$export$851d973a43101ae1] === (0, $860f0b5184108148$export$e46d647da3214494)) return null;
            header[0, $860f0b5184108148$export$1d1349f4eb9a7003] = !!privateBit;
            // Byte (3,4 of 7)
            // * `.......H|HH......`: MPEG-4 Channel Configuration (in the case of 0, the channel configuration is sent via an inband PCE)
            header[0, $860f0b5184108148$export$4881de1ae3929548] = (data[2] << 8 | data[3]) & 448;
            header[0, $860f0b5184108148$export$589c9a7ae9a79c5e] = $2e2502127f04fd04$var$channelModeValues[header[0, $860f0b5184108148$export$4881de1ae3929548]][0, $860f0b5184108148$export$6d59db4903f20f7d];
            header[0, $860f0b5184108148$export$9659c395d9de169e] = $2e2502127f04fd04$var$channelModeValues[header[0, $860f0b5184108148$export$4881de1ae3929548]][0, $860f0b5184108148$export$9659c395d9de169e];
            // Byte (4 of 7)
            // * `HHIJKLMM`
            // * `..I.....`: originality, set to 0 when encoding, ignore when decoding
            // * `...J....`: home, set to 0 when encoding, ignore when decoding
            // * `....K...`: copyrighted id bit, the next bit of a centrally registered copyright identifier, set to 0 when encoding, ignore when decoding
            // * `.....L..`: copyright id start, signals that this frame's copyright id bit is the first bit of the copyright id, set to 0 when encoding, ignore when decoding
            header[0, $860f0b5184108148$export$e512c40786d058ff] = !!(data[3] & 32);
            header[0, $860f0b5184108148$export$947c0ccec8fe9e2a] = !!(data[3] & 8);
            header[0, $860f0b5184108148$export$7306104bb28d5804] = !!(data[3] & 8);
            header[0, $860f0b5184108148$export$19129109fa742a6f] = !!(data[3] & 4);
            header[0, $860f0b5184108148$export$cee20cdac1cd19df] = 16;
            header[0, $860f0b5184108148$export$5f20c3cdf3b5e8be] = 1024;
            // Byte (7 of 7)
            // * `......PP` Number of AAC frames (RDBs) in ADTS frame minus 1, for maximum compatibility always use 1 AAC frame per ADTS frame
            header[0, $860f0b5184108148$export$7a8a2426cba807b6] = data[6] & 3;
            {
                const { length: length, channelModeBits: channelModeBits, profileBits: profileBits, sampleRateBits: sampleRateBits, frameLength: frameLength, samples: samples, numberAACFrames: numberAACFrames, ...codecUpdateFields } = header;
                headerCache[0, $860f0b5184108148$export$604ed74fb893f0e2](key, header, codecUpdateFields);
            }
        } else Object.assign(header, cachedHeader);
        // Byte (4,5,6 of 7)
        // * `.......MM|MMMMMMMM|MMM.....`: frame length, this value must include 7 or 9 bytes of header length: FrameLength = (ProtectionAbsent == 1 ? 7 : 9) + size(AACFrame)
        header[0, $860f0b5184108148$export$326bb32b4ec6239b] = (data[3] << 11 | data[4] << 3 | data[5] >> 5) & 0x1fff;
        if (!header[0, $860f0b5184108148$export$326bb32b4ec6239b]) return null;
        // Byte (6,7 of 7)
        // * `...OOOOO|OOOOOO..`: Buffer fullness
        const bufferFullnessBits = (data[5] << 6 | data[6] >> 2) & 0x7ff;
        header[0, $860f0b5184108148$export$e2acf35f1e805875] = bufferFullnessBits === 0x7ff ? "VBR" : bufferFullnessBits;
        return new $2e2502127f04fd04$export$2e2bcd8739ae039(header);
    }
    /**
   * @private
   * Call AACHeader.getHeader(Array<Uint8>) to get instance
   */ constructor(header){
        super(header);
        this[0, $860f0b5184108148$export$7306104bb28d5804] = header[0, $860f0b5184108148$export$7306104bb28d5804];
        this[0, $860f0b5184108148$export$19129109fa742a6f] = header[0, $860f0b5184108148$export$19129109fa742a6f];
        this[0, $860f0b5184108148$export$e2acf35f1e805875] = header[0, $860f0b5184108148$export$e2acf35f1e805875];
        this[0, $860f0b5184108148$export$947c0ccec8fe9e2a] = header[0, $860f0b5184108148$export$947c0ccec8fe9e2a];
        this[0, $860f0b5184108148$export$e512c40786d058ff] = header[0, $860f0b5184108148$export$e512c40786d058ff];
        this[0, $860f0b5184108148$export$1d1349f4eb9a7003] = header[0, $860f0b5184108148$export$1d1349f4eb9a7003];
        this[0, $860f0b5184108148$export$50a222d9023da98b] = header[0, $860f0b5184108148$export$50a222d9023da98b];
        this[0, $860f0b5184108148$export$f24224f1c91d8156] = header[0, $860f0b5184108148$export$f24224f1c91d8156];
        this[0, $860f0b5184108148$export$33a1ce7cb4e60d8d] = header[0, $860f0b5184108148$export$33a1ce7cb4e60d8d];
        this[0, $860f0b5184108148$export$7a8a2426cba807b6] = header[0, $860f0b5184108148$export$7a8a2426cba807b6];
        this[0, $860f0b5184108148$export$4882ae973e0491e] = header[0, $860f0b5184108148$export$4882ae973e0491e];
        this[0, $860f0b5184108148$export$b9b4c22e291dd3d9] = header[0, $860f0b5184108148$export$b9b4c22e291dd3d9];
    }
    get audioSpecificConfig() {
        // Audio Specific Configuration
        // * `000EEFFF|F0HHH000`:
        // * `000EE...|........`: Object Type (profileBit + 1)
        // * `.....FFF|F.......`: Sample Rate
        // * `........|.0HHH...`: Channel Configuration
        // * `........|.....0..`: Frame Length (1024)
        // * `........|......0.`: does not depend on core coder
        // * `........|.......0`: Not Extension
        const header = (0, $5169222015670af0$export$52342bdf89fb39e7).get(this);
        const audioSpecificConfig = header[0, $860f0b5184108148$export$9840eaf33e948519] + 0x40 << 5 | header[0, $860f0b5184108148$export$590421bd05077aa4] << 5 | header[0, $860f0b5184108148$export$4881de1ae3929548] >> 3;
        const bytes = new (0, $860f0b5184108148$export$d7e5036dad7e20bb)(2);
        new (0, $860f0b5184108148$export$40b76aa5ded53e7a)(bytes[0, $860f0b5184108148$export$ab1029bcae9ddb4a]).setUint16(0, audioSpecificConfig, false);
        return bytes;
    }
}


class $f39992d4dc65edc9$export$2e2bcd8739ae039 extends (0, $0b17d7d3514fce05$export$2e2bcd8739ae039) {
    static *[(0, $860f0b5184108148$export$fd8d2ba2926cdfb6)](codecParser, headerCache, readOffset) {
        return yield* super[0, $860f0b5184108148$export$fd8d2ba2926cdfb6]((0, $2e2502127f04fd04$export$2e2bcd8739ae039), $f39992d4dc65edc9$export$2e2bcd8739ae039, codecParser, headerCache, readOffset);
    }
    constructor(header, frame, samples){
        super(header, frame, samples);
    }
}



class $ea4373f84c96dcef$export$2e2bcd8739ae039 extends (0, $dd7c0f9e54b04fc4$export$2e2bcd8739ae039) {
    constructor(codecParser, headerCache, onCodec){
        super(codecParser, headerCache);
        this.Frame = (0, $f39992d4dc65edc9$export$2e2bcd8739ae039);
        this.Header = (0, $2e2502127f04fd04$export$2e2bcd8739ae039);
        onCodec(this[0, $860f0b5184108148$export$1c37c01eba8ed446]);
    }
    get [(0, $860f0b5184108148$export$1c37c01eba8ed446)]() {
        return "aac";
    }
    *[(0, $860f0b5184108148$export$9616b51a1be2e082)]() {
        return yield* this[0, $860f0b5184108148$export$6a29256c87cd443c]();
    }
}


/* Copyright 2020-2023 Ethan Halsall
    
    This file is part of codec-parser.
    
    codec-parser is free software: you can redistribute it and/or modify
    it under the terms of the GNU Lesser General Public License as published by
    the Free Software Foundation, either version 3 of the License, or
    (at your option) any later version.

    codec-parser is distributed in the hope that it will be useful,
    but WITHOUT ANY WARRANTY; without even the implied warranty of
    MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
    GNU Lesser General Public License for more details.

    You should have received a copy of the GNU Lesser General Public License
    along with this program.  If not, see <https://www.gnu.org/licenses/>
*/ 


/* Copyright 2020-2023 Ethan Halsall
    
    This file is part of codec-parser.
    
    codec-parser is free software: you can redistribute it and/or modify
    it under the terms of the GNU Lesser General Public License as published by
    the Free Software Foundation, either version 3 of the License, or
    (at your option) any later version.

    codec-parser is distributed in the hope that it will be useful,
    but WITHOUT ANY WARRANTY; without even the implied warranty of
    MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
    GNU Lesser General Public License for more details.

    You should have received a copy of the GNU Lesser General Public License
    along with this program.  If not, see <https://www.gnu.org/licenses/>
*/ 



class $c609565fc87a2788$export$2e2bcd8739ae039 extends (0, $0b17d7d3514fce05$export$2e2bcd8739ae039) {
    static _getFrameFooterCrc16(data) {
        return (data[data[0, $860f0b5184108148$export$f24224f1c91d8156] - 2] << 8) + data[data[0, $860f0b5184108148$export$f24224f1c91d8156] - 1];
    }
    // check frame footer crc
    // https://xiph.org/flac/format.html#frame_footer
    static [(0, $860f0b5184108148$export$b97792a91f8a2a21)](data) {
        const expectedCrc16 = $c609565fc87a2788$export$2e2bcd8739ae039._getFrameFooterCrc16(data);
        const actualCrc16 = (0, $dd0c961b75cd9139$export$bca7964a3cb8eec7)(data[0, $860f0b5184108148$export$7ec32827e4221318](0, -2));
        return expectedCrc16 === actualCrc16;
    }
    constructor(data, header, streamInfoValue){
        header[0, $860f0b5184108148$export$9010c500bffe71e6] = streamInfoValue;
        header[0, $860f0b5184108148$export$bacf03850837cc9e] = $c609565fc87a2788$export$2e2bcd8739ae039._getFrameFooterCrc16(data);
        super(header, data, (0, $5169222015670af0$export$52342bdf89fb39e7).get(header)[0, $860f0b5184108148$export$5f20c3cdf3b5e8be]);
    }
}


/* Copyright 2020-2023 Ethan Halsall
    
    This file is part of codec-parser.
    
    codec-parser is free software: you can redistribute it and/or modify
    it under the terms of the GNU Lesser General Public License as published by
    the Free Software Foundation, either version 3 of the License, or
    (at your option) any later version.

    codec-parser is distributed in the hope that it will be useful,
    but WITHOUT ANY WARRANTY; without even the implied warranty of
    MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
    GNU Lesser General Public License for more details.

    You should have received a copy of the GNU Lesser General Public License
    along with this program.  If not, see <https://www.gnu.org/licenses/>
*/ /*
https://xiph.org/flac/format.html

AAAAAAAA AAAAAABC DDDDEEEE FFFFGGGH 
(IIIIIIII...)
(JJJJJJJJ|JJJJJJJJ)
(KKKKKKKK|KKKKKKKK)
LLLLLLLLL

FLAC Frame Header
Letter  Length (bits)  Description
A   13  11111111|11111
B   1   Reserved 0 - mandatory, 1 - reserved
C   1   Blocking strategy, 0 - fixed, 1 - variable
D   4   Block size in inter-channel samples
E   4   Sample rate
F   4   Channel assignment
G   3   Sample size in bits
H   1   Reserved 0 - mandatory, 1 - reserved
I   ?   if(variable blocksize)
           <8-56>:"UTF-8" coded sample number (decoded number is 36 bits) [4]
        else
           <8-48>:"UTF-8" coded frame number (decoded number is 31 bits) [4]
J   ?   if(blocksize bits == 011x)
            8/16 bit (blocksize-1)
K   ?   if(sample rate bits == 11xx)
            8/16 bit sample rate
L   8   CRC-8 (polynomial = x^8 + x^2 + x^1 + x^0, initialized with 0) of everything before the crc, including the sync code
        
*/ 


const $ebbc5c9dd68f978b$var$getFromStreamInfo = "get from STREAMINFO metadata block";
const $ebbc5c9dd68f978b$var$blockingStrategyValues = {
    0: "Fixed",
    1: "Variable"
};
const $ebbc5c9dd68f978b$var$blockSizeValues = {
    0: (0, $860f0b5184108148$export$e46d647da3214494),
    16: 192
};
for(let i = 2; i < 16; i++)$ebbc5c9dd68f978b$var$blockSizeValues[i << 4] = i < 6 ? 576 * 2 ** (i - 2) : 2 ** i;
const $ebbc5c9dd68f978b$var$sampleRateValues = {
    0: $ebbc5c9dd68f978b$var$getFromStreamInfo,
    1: (0, $860f0b5184108148$export$308fdd6283300e68),
    2: (0, $860f0b5184108148$export$388131623a5f947b),
    3: (0, $860f0b5184108148$export$cd63464c02a18ed3),
    4: (0, $860f0b5184108148$export$8024c021d839bc0e),
    5: (0, $860f0b5184108148$export$a92c08b19856a52b),
    6: (0, $860f0b5184108148$export$dc67eb20d4395175),
    7: (0, $860f0b5184108148$export$492422570a89c8b0),
    8: (0, $860f0b5184108148$export$8786c8b1e955b2e9),
    9: (0, $860f0b5184108148$export$7b8ebc2092af05a9),
    10: (0, $860f0b5184108148$export$671a0c9051642a0b),
    11: (0, $860f0b5184108148$export$4a9bd43882a638a3),
    // 0b00001100: "8-bit sample rate (in kHz) from end of header",
    // 0b00001101: "16-bit sample rate (in Hz) from end of header",
    // 0b00001110: "16-bit sample rate (in tens of Hz) from end of header",
    15: (0, $860f0b5184108148$export$a4535ec98457231d)
};
/* prettier-ignore */ const $ebbc5c9dd68f978b$var$channelAssignments = {
    /*'
  'monophonic (mono)'
  'stereo (left, right)'
  'linear surround (left, right, center)'
  'quadraphonic (front left, front right, rear left, rear right)'
  '5.0 surround (front left, front right, front center, rear left, rear right)'
  '5.1 surround (front left, front right, front center, LFE, rear left, rear right)'
  '6.1 surround (front left, front right, front center, LFE, rear center, side left, side right)'
  '7.1 surround (front left, front right, front center, LFE, rear left, rear right, side left, side right)'
  */ 0: {
        [(0, $860f0b5184108148$export$9659c395d9de169e)]: 1,
        [(0, $860f0b5184108148$export$6d59db4903f20f7d)]: (0, $860f0b5184108148$export$25d110495212ae90)
    },
    16: {
        [(0, $860f0b5184108148$export$9659c395d9de169e)]: 2,
        [(0, $860f0b5184108148$export$6d59db4903f20f7d)]: (0, $860f0b5184108148$export$8ec6a2c9fbba54e0)(2, (0, $860f0b5184108148$export$3e501d20baea1003)[0][0])
    },
    32: {
        [(0, $860f0b5184108148$export$9659c395d9de169e)]: 3,
        [(0, $860f0b5184108148$export$6d59db4903f20f7d)]: (0, $860f0b5184108148$export$8ec6a2c9fbba54e0)(3, (0, $860f0b5184108148$export$3e501d20baea1003)[0][1])
    },
    48: {
        [(0, $860f0b5184108148$export$9659c395d9de169e)]: 4,
        [(0, $860f0b5184108148$export$6d59db4903f20f7d)]: (0, $860f0b5184108148$export$8ec6a2c9fbba54e0)(4, (0, $860f0b5184108148$export$3e501d20baea1003)[1][0], (0, $860f0b5184108148$export$3e501d20baea1003)[3][0])
    },
    64: {
        [(0, $860f0b5184108148$export$9659c395d9de169e)]: 5,
        [(0, $860f0b5184108148$export$6d59db4903f20f7d)]: (0, $860f0b5184108148$export$8ec6a2c9fbba54e0)(5, (0, $860f0b5184108148$export$3e501d20baea1003)[1][1], (0, $860f0b5184108148$export$3e501d20baea1003)[3][0])
    },
    80: {
        [(0, $860f0b5184108148$export$9659c395d9de169e)]: 6,
        [(0, $860f0b5184108148$export$6d59db4903f20f7d)]: (0, $860f0b5184108148$export$8ec6a2c9fbba54e0)(6, (0, $860f0b5184108148$export$3e501d20baea1003)[1][1], (0, $860f0b5184108148$export$3254282aac6747d2), (0, $860f0b5184108148$export$3e501d20baea1003)[3][0])
    },
    96: {
        [(0, $860f0b5184108148$export$9659c395d9de169e)]: 7,
        [(0, $860f0b5184108148$export$6d59db4903f20f7d)]: (0, $860f0b5184108148$export$8ec6a2c9fbba54e0)(7, (0, $860f0b5184108148$export$3e501d20baea1003)[1][1], (0, $860f0b5184108148$export$3254282aac6747d2), (0, $860f0b5184108148$export$3e501d20baea1003)[3][4], (0, $860f0b5184108148$export$3e501d20baea1003)[2][0])
    },
    112: {
        [(0, $860f0b5184108148$export$9659c395d9de169e)]: 8,
        [(0, $860f0b5184108148$export$6d59db4903f20f7d)]: (0, $860f0b5184108148$export$8ec6a2c9fbba54e0)(8, (0, $860f0b5184108148$export$3e501d20baea1003)[1][1], (0, $860f0b5184108148$export$3254282aac6747d2), (0, $860f0b5184108148$export$3e501d20baea1003)[3][0], (0, $860f0b5184108148$export$3e501d20baea1003)[2][0])
    },
    128: {
        [(0, $860f0b5184108148$export$9659c395d9de169e)]: 2,
        [(0, $860f0b5184108148$export$6d59db4903f20f7d)]: `${(0, $860f0b5184108148$export$ec7f46128a2f8ed8)} (left, diff)`
    },
    144: {
        [(0, $860f0b5184108148$export$9659c395d9de169e)]: 2,
        [(0, $860f0b5184108148$export$6d59db4903f20f7d)]: `${(0, $860f0b5184108148$export$ec7f46128a2f8ed8)} (diff, right)`
    },
    160: {
        [(0, $860f0b5184108148$export$9659c395d9de169e)]: 2,
        [(0, $860f0b5184108148$export$6d59db4903f20f7d)]: `${(0, $860f0b5184108148$export$ec7f46128a2f8ed8)} (avg, diff)`
    },
    176: (0, $860f0b5184108148$export$e46d647da3214494),
    192: (0, $860f0b5184108148$export$e46d647da3214494),
    208: (0, $860f0b5184108148$export$e46d647da3214494),
    224: (0, $860f0b5184108148$export$e46d647da3214494),
    240: (0, $860f0b5184108148$export$e46d647da3214494)
};
const $ebbc5c9dd68f978b$var$bitDepthValues = {
    0: $ebbc5c9dd68f978b$var$getFromStreamInfo,
    2: 8,
    4: 12,
    6: (0, $860f0b5184108148$export$e46d647da3214494),
    8: 16,
    10: 20,
    12: 24,
    14: (0, $860f0b5184108148$export$e46d647da3214494)
};
class $ebbc5c9dd68f978b$export$2e2bcd8739ae039 extends (0, $3fb1607145c26488$export$2e2bcd8739ae039) {
    // https://datatracker.ietf.org/doc/html/rfc3629#section-3
    //    Char. number range  |        UTF-8 octet sequence
    //    (hexadecimal)    |              (binary)
    // --------------------+---------------------------------------------
    // 0000 0000-0000 007F | 0xxxxxxx
    // 0000 0080-0000 07FF | 110xxxxx 10xxxxxx
    // 0000 0800-0000 FFFF | 1110xxxx 10xxxxxx 10xxxxxx
    // 0001 0000-0010 FFFF | 11110xxx 10xxxxxx 10xxxxxx 10xxxxxx
    static _decodeUTF8Int(data) {
        if (data[0] > 0xfe) return null; // length byte must have at least one zero as the lsb
        if (data[0] < 0x80) return {
            value: data[0],
            length: 1
        };
        // get length by counting the number of msb that are set to 1
        let length = 1;
        for(let zeroMask = 0x40; zeroMask & data[0]; zeroMask >>= 1)length++;
        let idx = length - 1, value = 0, shift = 0;
        // sum together the encoded bits in bytes 2 to length
        // 1110xxxx 10[cccccc] 10[bbbbbb] 10[aaaaaa]
        //
        //    value = [cccccc] | [bbbbbb] | [aaaaaa]
        for(; idx > 0; shift += 6, idx--){
            if ((data[idx] & 0xc0) !== 0x80) return null; // each byte should have leading 10xxxxxx
            value |= (data[idx] & 0x3f) << shift; // add the encoded bits
        }
        // read the final encoded bits in byte 1
        //     1110[dddd] 10[cccccc] 10[bbbbbb] 10[aaaaaa]
        //
        // value = [dddd] | [cccccc] | [bbbbbb] | [aaaaaa]
        value |= (data[idx] & 0x7f >> length) << shift;
        return {
            value: value,
            length: length
        };
    }
    static [(0, $860f0b5184108148$export$c34399eed923e901)](data, headerCache) {
        const codecParserStub = {
            [(0, $860f0b5184108148$export$3027c70a881d60dc)]: function*() {
                return data;
            }
        };
        return $ebbc5c9dd68f978b$export$2e2bcd8739ae039[0, $860f0b5184108148$export$47ed31abc613cf55](codecParserStub, headerCache, 0).next().value;
    }
    static *[(0, $860f0b5184108148$export$47ed31abc613cf55)](codecParser, headerCache, readOffset) {
        // Must be at least 6 bytes.
        let data = yield* codecParser[0, $860f0b5184108148$export$3027c70a881d60dc](6, readOffset);
        // Bytes (1-2 of 6)
        // * `11111111|111110..`: Frame sync
        // * `........|......0.`: Reserved 0 - mandatory, 1 - reserved
        if (data[0] !== 0xff || !(data[1] === 0xf8 || data[1] === 0xf9)) return null;
        const header = {};
        // Check header cache
        const key = (0, $dd0c961b75cd9139$export$7c746b75f47c9c7d)(data[0, $860f0b5184108148$export$7ec32827e4221318](0, 4));
        const cachedHeader = headerCache[0, $860f0b5184108148$export$47ed31abc613cf55](key);
        if (!cachedHeader) {
            // Byte (2 of 6)
            // * `.......C`: Blocking strategy, 0 - fixed, 1 - variable
            header[0, $860f0b5184108148$export$f542eb4365e59cc9] = data[1] & 1;
            header[0, $860f0b5184108148$export$5af3e22a52b4ea9e] = $ebbc5c9dd68f978b$var$blockingStrategyValues[header[0, $860f0b5184108148$export$f542eb4365e59cc9]];
            // Byte (3 of 6)
            // * `DDDD....`: Block size in inter-channel samples
            // * `....EEEE`: Sample rate
            header[0, $860f0b5184108148$export$99f767e02b81025c] = data[2] & 240;
            header[0, $860f0b5184108148$export$590421bd05077aa4] = data[2] & 15;
            header[0, $860f0b5184108148$export$446963a0ea44fb9d] = $ebbc5c9dd68f978b$var$blockSizeValues[header[0, $860f0b5184108148$export$99f767e02b81025c]];
            if (header[0, $860f0b5184108148$export$446963a0ea44fb9d] === (0, $860f0b5184108148$export$e46d647da3214494)) return null;
            header[0, $860f0b5184108148$export$851d973a43101ae1] = $ebbc5c9dd68f978b$var$sampleRateValues[header[0, $860f0b5184108148$export$590421bd05077aa4]];
            if (header[0, $860f0b5184108148$export$851d973a43101ae1] === (0, $860f0b5184108148$export$a4535ec98457231d)) return null;
            // Byte (4 of 6)
            // * `FFFF....`: Channel assignment
            // * `....GGG.`: Sample size in bits
            // * `.......H`: Reserved 0 - mandatory, 1 - reserved
            if (data[3] & 1) return null;
            const channelAssignment = $ebbc5c9dd68f978b$var$channelAssignments[data[3] & 240];
            if (channelAssignment === (0, $860f0b5184108148$export$e46d647da3214494)) return null;
            header[0, $860f0b5184108148$export$9659c395d9de169e] = channelAssignment[0, $860f0b5184108148$export$9659c395d9de169e];
            header[0, $860f0b5184108148$export$589c9a7ae9a79c5e] = channelAssignment[0, $860f0b5184108148$export$6d59db4903f20f7d];
            header[0, $860f0b5184108148$export$cee20cdac1cd19df] = $ebbc5c9dd68f978b$var$bitDepthValues[data[3] & 14];
            if (header[0, $860f0b5184108148$export$cee20cdac1cd19df] === (0, $860f0b5184108148$export$e46d647da3214494)) return null;
        } else Object.assign(header, cachedHeader);
        // Byte (5...)
        // * `IIIIIIII|...`: VBR block size ? sample number : frame number
        header[0, $860f0b5184108148$export$f24224f1c91d8156] = 5;
        // check if there is enough data to parse UTF8
        data = yield* codecParser[0, $860f0b5184108148$export$3027c70a881d60dc](header[0, $860f0b5184108148$export$f24224f1c91d8156] + 8, readOffset);
        const decodedUtf8 = $ebbc5c9dd68f978b$export$2e2bcd8739ae039._decodeUTF8Int(data[0, $860f0b5184108148$export$7ec32827e4221318](4));
        if (!decodedUtf8) return null;
        if (header[0, $860f0b5184108148$export$f542eb4365e59cc9]) header[0, $860f0b5184108148$export$dda3274d649921c8] = decodedUtf8.value;
        else header[0, $860f0b5184108148$export$5da2c6384bf58746] = decodedUtf8.value;
        header[0, $860f0b5184108148$export$f24224f1c91d8156] += decodedUtf8[0, $860f0b5184108148$export$f24224f1c91d8156];
        // Byte (...)
        // * `JJJJJJJJ|(JJJJJJJJ)`: Blocksize (8/16bit custom value)
        if (header[0, $860f0b5184108148$export$99f767e02b81025c] === 96) {
            // 8 bit
            if (data[0, $860f0b5184108148$export$f24224f1c91d8156] < header[0, $860f0b5184108148$export$f24224f1c91d8156]) data = yield* codecParser[0, $860f0b5184108148$export$3027c70a881d60dc](header[0, $860f0b5184108148$export$f24224f1c91d8156], readOffset);
            header[0, $860f0b5184108148$export$446963a0ea44fb9d] = data[header[0, $860f0b5184108148$export$f24224f1c91d8156] - 1] + 1;
            header[0, $860f0b5184108148$export$f24224f1c91d8156] += 1;
        } else if (header[0, $860f0b5184108148$export$99f767e02b81025c] === 112) {
            // 16 bit
            if (data[0, $860f0b5184108148$export$f24224f1c91d8156] < header[0, $860f0b5184108148$export$f24224f1c91d8156]) data = yield* codecParser[0, $860f0b5184108148$export$3027c70a881d60dc](header[0, $860f0b5184108148$export$f24224f1c91d8156], readOffset);
            header[0, $860f0b5184108148$export$446963a0ea44fb9d] = (data[header[0, $860f0b5184108148$export$f24224f1c91d8156] - 1] << 8) + data[header[0, $860f0b5184108148$export$f24224f1c91d8156]] + 1;
            header[0, $860f0b5184108148$export$f24224f1c91d8156] += 2;
        }
        header[0, $860f0b5184108148$export$5f20c3cdf3b5e8be] = header[0, $860f0b5184108148$export$446963a0ea44fb9d];
        // Byte (...)
        // * `KKKKKKKK|(KKKKKKKK)`: Sample rate (8/16bit custom value)
        if (header[0, $860f0b5184108148$export$590421bd05077aa4] === 12) {
            // 8 bit
            if (data[0, $860f0b5184108148$export$f24224f1c91d8156] < header[0, $860f0b5184108148$export$f24224f1c91d8156]) data = yield* codecParser[0, $860f0b5184108148$export$3027c70a881d60dc](header[0, $860f0b5184108148$export$f24224f1c91d8156], readOffset);
            header[0, $860f0b5184108148$export$851d973a43101ae1] = data[header[0, $860f0b5184108148$export$f24224f1c91d8156] - 1] * 1000;
            header[0, $860f0b5184108148$export$f24224f1c91d8156] += 1;
        } else if (header[0, $860f0b5184108148$export$590421bd05077aa4] === 13) {
            // 16 bit
            if (data[0, $860f0b5184108148$export$f24224f1c91d8156] < header[0, $860f0b5184108148$export$f24224f1c91d8156]) data = yield* codecParser[0, $860f0b5184108148$export$3027c70a881d60dc](header[0, $860f0b5184108148$export$f24224f1c91d8156], readOffset);
            header[0, $860f0b5184108148$export$851d973a43101ae1] = (data[header[0, $860f0b5184108148$export$f24224f1c91d8156] - 1] << 8) + data[header[0, $860f0b5184108148$export$f24224f1c91d8156]];
            header[0, $860f0b5184108148$export$f24224f1c91d8156] += 2;
        } else if (header[0, $860f0b5184108148$export$590421bd05077aa4] === 14) {
            // 16 bit
            if (data[0, $860f0b5184108148$export$f24224f1c91d8156] < header[0, $860f0b5184108148$export$f24224f1c91d8156]) data = yield* codecParser[0, $860f0b5184108148$export$3027c70a881d60dc](header[0, $860f0b5184108148$export$f24224f1c91d8156], readOffset);
            header[0, $860f0b5184108148$export$851d973a43101ae1] = ((data[header[0, $860f0b5184108148$export$f24224f1c91d8156] - 1] << 8) + data[header[0, $860f0b5184108148$export$f24224f1c91d8156]]) * 10;
            header[0, $860f0b5184108148$export$f24224f1c91d8156] += 2;
        }
        // Byte (...)
        // * `LLLLLLLL`: CRC-8
        if (data[0, $860f0b5184108148$export$f24224f1c91d8156] < header[0, $860f0b5184108148$export$f24224f1c91d8156]) data = yield* codecParser[0, $860f0b5184108148$export$3027c70a881d60dc](header[0, $860f0b5184108148$export$f24224f1c91d8156], readOffset);
        header[0, $860f0b5184108148$export$4fafbcc8068ef7ca] = data[header[0, $860f0b5184108148$export$f24224f1c91d8156] - 1];
        if (header[0, $860f0b5184108148$export$4fafbcc8068ef7ca] !== (0, $dd0c961b75cd9139$export$97177c3f756cd8a4)(data[0, $860f0b5184108148$export$7ec32827e4221318](0, header[0, $860f0b5184108148$export$f24224f1c91d8156] - 1))) return null;
        if (!cachedHeader) {
            const { blockingStrategyBits: blockingStrategyBits, frameNumber: frameNumber, sampleNumber: sampleNumber, samples: samples, sampleRateBits: sampleRateBits, blockSizeBits: blockSizeBits, crc: crc, length: length, ...codecUpdateFields } = header;
            headerCache[0, $860f0b5184108148$export$604ed74fb893f0e2](key, header, codecUpdateFields);
        }
        return new $ebbc5c9dd68f978b$export$2e2bcd8739ae039(header);
    }
    /**
   * @private
   * Call FLACHeader.getHeader(Array<Uint8>) to get instance
   */ constructor(header){
        super(header);
        this[0, $860f0b5184108148$export$bacf03850837cc9e] = null; // set in FLACFrame
        this[0, $860f0b5184108148$export$5af3e22a52b4ea9e] = header[0, $860f0b5184108148$export$5af3e22a52b4ea9e];
        this[0, $860f0b5184108148$export$446963a0ea44fb9d] = header[0, $860f0b5184108148$export$446963a0ea44fb9d];
        this[0, $860f0b5184108148$export$5da2c6384bf58746] = header[0, $860f0b5184108148$export$5da2c6384bf58746];
        this[0, $860f0b5184108148$export$dda3274d649921c8] = header[0, $860f0b5184108148$export$dda3274d649921c8];
        this[0, $860f0b5184108148$export$9010c500bffe71e6] = null; // set during ogg parsing
    }
}


const $fc8c22388cf24d2d$var$MIN_FLAC_FRAME_SIZE = 2;
const $fc8c22388cf24d2d$var$MAX_FLAC_FRAME_SIZE = 524288;
class $fc8c22388cf24d2d$export$2e2bcd8739ae039 extends (0, $dd7c0f9e54b04fc4$export$2e2bcd8739ae039) {
    constructor(codecParser, headerCache, onCodec){
        super(codecParser, headerCache);
        this.Frame = (0, $c609565fc87a2788$export$2e2bcd8739ae039);
        this.Header = (0, $ebbc5c9dd68f978b$export$2e2bcd8739ae039);
        onCodec(this[0, $860f0b5184108148$export$1c37c01eba8ed446]);
    }
    get [(0, $860f0b5184108148$export$1c37c01eba8ed446)]() {
        return "flac";
    }
    *_getNextFrameSyncOffset(offset) {
        const data = yield* this._codecParser[0, $860f0b5184108148$export$3027c70a881d60dc](2, 0);
        const dataLength = data[0, $860f0b5184108148$export$f24224f1c91d8156] - 2;
        while(offset < dataLength){
            // * `11111111|111110..`: Frame sync
            // * `........|......0.`: Reserved 0 - mandatory, 1 - reserved
            const firstByte = data[offset];
            if (firstByte === 0xff) {
                const secondByte = data[offset + 1];
                if (secondByte === 0xf8 || secondByte === 0xf9) break;
                if (secondByte !== 0xff) offset++; // might as well check for the next sync byte
            }
            offset++;
        }
        return offset;
    }
    *[(0, $860f0b5184108148$export$9616b51a1be2e082)]() {
        // find the first valid frame header
        do {
            const header = yield* (0, $ebbc5c9dd68f978b$export$2e2bcd8739ae039)[0, $860f0b5184108148$export$47ed31abc613cf55](this._codecParser, this._headerCache, 0);
            if (header) {
                // found a valid frame header
                // find the next valid frame header
                let nextHeaderOffset = (0, $5169222015670af0$export$52342bdf89fb39e7).get(header)[0, $860f0b5184108148$export$f24224f1c91d8156] + $fc8c22388cf24d2d$var$MIN_FLAC_FRAME_SIZE;
                while(nextHeaderOffset <= $fc8c22388cf24d2d$var$MAX_FLAC_FRAME_SIZE){
                    if (this._codecParser._flushing || (yield* (0, $ebbc5c9dd68f978b$export$2e2bcd8739ae039)[0, $860f0b5184108148$export$47ed31abc613cf55](this._codecParser, this._headerCache, nextHeaderOffset))) {
                        // found a valid next frame header
                        let frameData = yield* this._codecParser[0, $860f0b5184108148$export$3027c70a881d60dc](nextHeaderOffset);
                        if (!this._codecParser._flushing) frameData = frameData[0, $860f0b5184108148$export$7ec32827e4221318](0, nextHeaderOffset);
                        // check that this is actually the next header by validating the frame footer crc16
                        if ((0, $c609565fc87a2788$export$2e2bcd8739ae039)[0, $860f0b5184108148$export$b97792a91f8a2a21](frameData)) {
                            // both frame headers, and frame footer crc16 are valid, we are synced (odds are pretty low of a false positive)
                            const frame = new (0, $c609565fc87a2788$export$2e2bcd8739ae039)(frameData, header);
                            this._headerCache[0, $860f0b5184108148$export$d7c4a0dd6a4567e5](); // start caching when synced
                            this._codecParser[0, $860f0b5184108148$export$ccac409b8bd6669d](nextHeaderOffset); // increment to the next frame
                            this._codecParser[0, $860f0b5184108148$export$24d5305cc192425a](frame);
                            return frame;
                        }
                    }
                    nextHeaderOffset = yield* this._getNextFrameSyncOffset(nextHeaderOffset + 1);
                }
                this._codecParser[0, $860f0b5184108148$export$ebd6064652549ce9](`Unable to sync FLAC frame after searching ${nextHeaderOffset} bytes.`);
                this._codecParser[0, $860f0b5184108148$export$ccac409b8bd6669d](nextHeaderOffset);
            } else // not synced, increment data to continue syncing
            this._codecParser[0, $860f0b5184108148$export$ccac409b8bd6669d]((yield* this._getNextFrameSyncOffset(1)));
        }while (true);
    }
    [(0, $860f0b5184108148$export$d9639f7fbeab4358)](oggPage) {
        if (oggPage[0, $860f0b5184108148$export$a60fa1703d7dd487] === 0) {
            // Identification header
            this._headerCache[0, $860f0b5184108148$export$d7c4a0dd6a4567e5]();
            this._streamInfo = oggPage[0, $860f0b5184108148$export$4051a07651545597][0, $860f0b5184108148$export$7ec32827e4221318](13);
        } else if (oggPage[0, $860f0b5184108148$export$a60fa1703d7dd487] === 1) ;
        else oggPage[0, $860f0b5184108148$export$a53f1e3778a12d7d] = (0, $5169222015670af0$export$5b0e32d79f1188e7).get(oggPage)[0, $860f0b5184108148$export$27e01f77e7f7ec20].map((segment)=>{
            const header = (0, $ebbc5c9dd68f978b$export$2e2bcd8739ae039)[0, $860f0b5184108148$export$c34399eed923e901](segment, this._headerCache);
            if (header) return new (0, $c609565fc87a2788$export$2e2bcd8739ae039)(segment, header, this._streamInfo);
            else this._codecParser[0, $860f0b5184108148$export$ebd6064652549ce9]("Failed to parse Ogg FLAC frame", "Skipping invalid FLAC frame");
        }).filter((frame)=>!!frame);
        return oggPage;
    }
}


/* Copyright 2020-2023 Ethan Halsall
    
    This file is part of codec-parser.
    
    codec-parser is free software: you can redistribute it and/or modify
    it under the terms of the GNU Lesser General Public License as published by
    the Free Software Foundation, either version 3 of the License, or
    (at your option) any later version.

    codec-parser is distributed in the hope that it will be useful,
    but WITHOUT ANY WARRANTY; without even the implied warranty of
    MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
    GNU Lesser General Public License for more details.

    You should have received a copy of the GNU Lesser General Public License
    along with this program.  If not, see <https://www.gnu.org/licenses/>
*/ 



/* Copyright 2020-2023 Ethan Halsall
    
    This file is part of codec-parser.
    
    codec-parser is free software: you can redistribute it and/or modify
    it under the terms of the GNU Lesser General Public License as published by
    the Free Software Foundation, either version 3 of the License, or
    (at your option) any later version.

    codec-parser is distributed in the hope that it will be useful,
    but WITHOUT ANY WARRANTY; without even the implied warranty of
    MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
    GNU Lesser General Public License for more details.

    You should have received a copy of the GNU Lesser General Public License
    along with this program.  If not, see <https://www.gnu.org/licenses/>
*/ 


/* Copyright 2020-2023 Ethan Halsall
    
    This file is part of codec-parser.
    
    codec-parser is free software: you can redistribute it and/or modify
    it under the terms of the GNU Lesser General Public License as published by
    the Free Software Foundation, either version 3 of the License, or
    (at your option) any later version.

    codec-parser is distributed in the hope that it will be useful,
    but WITHOUT ANY WARRANTY; without even the implied warranty of
    MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
    GNU Lesser General Public License for more details.

    You should have received a copy of the GNU Lesser General Public License
    along with this program.  If not, see <https://www.gnu.org/licenses/>
*/ /*
https://xiph.org/ogg/doc/framing.html

AAAAAAAA AAAAAAAA AAAAAAAA AAAAAAAA BBBBBBBB 00000CDE

(LSB)                                                             (MSB)
FFFFFFFF FFFFFFFF FFFFFFFF FFFFFFFF FFFFFFFF FFFFFFFF FFFFFFFF FFFFFFFF
GGGGGGGG GGGGGGGG GGGGGGGG GGGGGGGG
HHHHHHHH HHHHHHHH HHHHHHHH HHHHHHHH
IIIIIIII IIIIIIII IIIIIIII IIIIIIII

JJJJJJJJ
LLLLLLLL...

Ogg Page Header
Letter  Length (bits)  Description
A   32  0x4f676753, "OggS"
B   8   stream_structure_version
C   1   (0 no, 1 yes) last page of logical bitstream (eos)
D   1   (0 no, 1 yes) first page of logical bitstream (bos)
E   1   (0 no, 1 yes) continued packet

F   64  absolute granule position
G   32  stream serial number
H   32  page sequence no
I   32  page checksum
J   8   Number of page segments in the segment table
L   n   Segment table (n=page_segments+26).
        Segment table values sum to the total length of the packet.
        Last value is always < 0xFF. Last lacing value will be 0x00 if evenly divisible by 0xFF.
        
*/ 

class $a86b95845073ac73$export$2e2bcd8739ae039 {
    static *[(0, $860f0b5184108148$export$47ed31abc613cf55)](codecParser, headerCache, readOffset) {
        const header = {};
        // Must be at least 28 bytes.
        let data = yield* codecParser[0, $860f0b5184108148$export$3027c70a881d60dc](28, readOffset);
        // Bytes (1-4 of 28)
        // Frame sync (must equal OggS): `AAAAAAAA|AAAAAAAA|AAAAAAAA|AAAAAAAA`:
        if (data[0] !== 0x4f || // O
        data[1] !== 0x67 || // g
        data[2] !== 0x67 || // g
        data[3] !== 0x53 //    S
        ) return null;
        // Byte (5 of 28)
        // * `BBBBBBBB`: stream_structure_version
        header[0, $860f0b5184108148$export$fd98de4d87954f15] = data[4];
        // Byte (6 of 28)
        // * `00000CDE`
        // * `00000...`: All zeros
        // * `.....C..`: (0 no, 1 yes) last page of logical bitstream (eos)
        // * `......D.`: (0 no, 1 yes) first page of logical bitstream (bos)
        // * `.......E`: (0 no, 1 yes) continued packet
        const zeros = data[5] & 248;
        if (zeros) return null;
        header[0, $860f0b5184108148$export$59545aa1378f3baa] = !!(data[5] & 4);
        header[0, $860f0b5184108148$export$f7027d263cc898cc] = !!(data[5] & 2);
        header[0, $860f0b5184108148$export$b046ea5b29155775] = !!(data[5] & 1);
        const view = new (0, $860f0b5184108148$export$40b76aa5ded53e7a)((0, $860f0b5184108148$export$d7e5036dad7e20bb).from(data[0, $860f0b5184108148$export$7ec32827e4221318](0, 28))[0, $860f0b5184108148$export$ab1029bcae9ddb4a]);
        // Byte (7-14 of 28)
        // * `FFFFFFFF|FFFFFFFF|FFFFFFFF|FFFFFFFF|FFFFFFFF|FFFFFFFF|FFFFFFFF|FFFFFFFF`
        // * Absolute Granule Position
        /**
     * @todo Safari does not support getBigInt64, but it also doesn't support Ogg
     */ try {
            header[0, $860f0b5184108148$export$b9d4fc21491dc293] = view.getBigInt64(6, true);
        } catch  {}
        // Byte (15-18 of 28)
        // * `GGGGGGGG|GGGGGGGG|GGGGGGGG|GGGGGGGG`
        // * Stream Serial Number
        header[0, $860f0b5184108148$export$462f9602534f6121] = view.getInt32(14, true);
        // Byte (19-22 of 28)
        // * `HHHHHHHH|HHHHHHHH|HHHHHHHH|HHHHHHHH`
        // * Page Sequence Number
        header[0, $860f0b5184108148$export$a60fa1703d7dd487] = view.getInt32(18, true);
        // Byte (23-26 of 28)
        // * `IIIIIIII|IIIIIIII|IIIIIIII|IIIIIIII`
        // * Page Checksum
        header[0, $860f0b5184108148$export$c16a704080c492f2] = view.getInt32(22, true);
        // Byte (27 of 28)
        // * `JJJJJJJJ`: Number of page segments in the segment table
        const pageSegmentTableLength = data[26];
        header[0, $860f0b5184108148$export$f24224f1c91d8156] = pageSegmentTableLength + 27;
        data = yield* codecParser[0, $860f0b5184108148$export$3027c70a881d60dc](header[0, $860f0b5184108148$export$f24224f1c91d8156], readOffset); // read in the page segment table
        header[0, $860f0b5184108148$export$326bb32b4ec6239b] = 0;
        header[0, $860f0b5184108148$export$e0e12ae5ee640391] = [];
        header[0, $860f0b5184108148$export$7b4b65786d4d1f7] = (0, $860f0b5184108148$export$d7e5036dad7e20bb).from(data[0, $860f0b5184108148$export$7ec32827e4221318](27, header[0, $860f0b5184108148$export$f24224f1c91d8156]));
        for(let i = 0, segmentLength = 0; i < pageSegmentTableLength; i++){
            const segmentByte = header[0, $860f0b5184108148$export$7b4b65786d4d1f7][i];
            header[0, $860f0b5184108148$export$326bb32b4ec6239b] += segmentByte;
            segmentLength += segmentByte;
            if (segmentByte !== 0xff || i === pageSegmentTableLength - 1) {
                header[0, $860f0b5184108148$export$e0e12ae5ee640391].push(segmentLength);
                segmentLength = 0;
            }
        }
        return new $a86b95845073ac73$export$2e2bcd8739ae039(header);
    }
    /**
   * @private
   * Call OggPageHeader.getHeader(Array<Uint8>) to get instance
   */ constructor(header){
        (0, $5169222015670af0$export$52342bdf89fb39e7).set(this, header);
        this[0, $860f0b5184108148$export$b9d4fc21491dc293] = header[0, $860f0b5184108148$export$b9d4fc21491dc293];
        this[0, $860f0b5184108148$export$b046ea5b29155775] = header[0, $860f0b5184108148$export$b046ea5b29155775];
        this[0, $860f0b5184108148$export$f7027d263cc898cc] = header[0, $860f0b5184108148$export$f7027d263cc898cc];
        this[0, $860f0b5184108148$export$59545aa1378f3baa] = header[0, $860f0b5184108148$export$59545aa1378f3baa];
        this[0, $860f0b5184108148$export$e0e12ae5ee640391] = header[0, $860f0b5184108148$export$e0e12ae5ee640391];
        this[0, $860f0b5184108148$export$a60fa1703d7dd487] = header[0, $860f0b5184108148$export$a60fa1703d7dd487];
        this[0, $860f0b5184108148$export$c16a704080c492f2] = header[0, $860f0b5184108148$export$c16a704080c492f2];
        this[0, $860f0b5184108148$export$462f9602534f6121] = header[0, $860f0b5184108148$export$462f9602534f6121];
    }
}


class $54de051f73360197$export$2e2bcd8739ae039 extends (0, $34ee446617012033$export$2e2bcd8739ae039) {
    static *[(0, $860f0b5184108148$export$fd8d2ba2926cdfb6)](codecParser, headerCache, readOffset) {
        const header = yield* (0, $a86b95845073ac73$export$2e2bcd8739ae039)[0, $860f0b5184108148$export$47ed31abc613cf55](codecParser, headerCache, readOffset);
        if (header) {
            const frameLengthValue = (0, $5169222015670af0$export$52342bdf89fb39e7).get(header)[0, $860f0b5184108148$export$326bb32b4ec6239b];
            const headerLength = (0, $5169222015670af0$export$52342bdf89fb39e7).get(header)[0, $860f0b5184108148$export$f24224f1c91d8156];
            const totalLength = headerLength + frameLengthValue;
            const rawDataValue = (yield* codecParser[0, $860f0b5184108148$export$3027c70a881d60dc](totalLength, 0))[0, $860f0b5184108148$export$7ec32827e4221318](0, totalLength);
            const frame = rawDataValue[0, $860f0b5184108148$export$7ec32827e4221318](headerLength, totalLength);
            return new $54de051f73360197$export$2e2bcd8739ae039(header, frame, rawDataValue);
        } else return null;
    }
    constructor(header, frame, rawDataValue){
        super(header, frame);
        (0, $5169222015670af0$export$5b0e32d79f1188e7).get(this)[0, $860f0b5184108148$export$f24224f1c91d8156] = rawDataValue[0, $860f0b5184108148$export$f24224f1c91d8156];
        this[0, $860f0b5184108148$export$a53f1e3778a12d7d] = [];
        this[0, $860f0b5184108148$export$bfe96fedbe3c1b3b] = rawDataValue;
        this[0, $860f0b5184108148$export$b9d4fc21491dc293] = header[0, $860f0b5184108148$export$b9d4fc21491dc293];
        this[0, $860f0b5184108148$export$1cd93882633e45f5] = header[0, $860f0b5184108148$export$c16a704080c492f2];
        this[0, $860f0b5184108148$export$1f34108aa9eb96ab] = 0;
        this[0, $860f0b5184108148$export$b046ea5b29155775] = header[0, $860f0b5184108148$export$b046ea5b29155775];
        this[0, $860f0b5184108148$export$f7027d263cc898cc] = header[0, $860f0b5184108148$export$f7027d263cc898cc];
        this[0, $860f0b5184108148$export$59545aa1378f3baa] = header[0, $860f0b5184108148$export$59545aa1378f3baa];
        this[0, $860f0b5184108148$export$a60fa1703d7dd487] = header[0, $860f0b5184108148$export$a60fa1703d7dd487];
        this[0, $860f0b5184108148$export$5f20c3cdf3b5e8be] = 0;
        this[0, $860f0b5184108148$export$462f9602534f6121] = header[0, $860f0b5184108148$export$462f9602534f6121];
    }
}




/* Copyright 2020-2023 Ethan Halsall
    
    This file is part of codec-parser.
    
    codec-parser is free software: you can redistribute it and/or modify
    it under the terms of the GNU Lesser General Public License as published by
    the Free Software Foundation, either version 3 of the License, or
    (at your option) any later version.

    codec-parser is distributed in the hope that it will be useful,
    but WITHOUT ANY WARRANTY; without even the implied warranty of
    MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
    GNU Lesser General Public License for more details.

    You should have received a copy of the GNU Lesser General Public License
    along with this program.  If not, see <https://www.gnu.org/licenses/>
*/ 


/* Copyright 2020-2023 Ethan Halsall
    
    This file is part of codec-parser.
    
    codec-parser is free software: you can redistribute it and/or modify
    it under the terms of the GNU Lesser General Public License as published by
    the Free Software Foundation, either version 3 of the License, or
    (at your option) any later version.

    codec-parser is distributed in the hope that it will be useful,
    but WITHOUT ANY WARRANTY; without even the implied warranty of
    MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
    GNU Lesser General Public License for more details.

    You should have received a copy of the GNU Lesser General Public License
    along with this program.  If not, see <https://www.gnu.org/licenses/>
*/ 

class $0c94b01dfaac6aa0$export$2e2bcd8739ae039 extends (0, $0b17d7d3514fce05$export$2e2bcd8739ae039) {
    constructor(data, header){
        super(header, data, header[0, $860f0b5184108148$export$7815706ac4afa67d] * header[0, $860f0b5184108148$export$150180f5f882de62] / 1000 * header[0, $860f0b5184108148$export$851d973a43101ae1]);
    }
}


/* Copyright 2020-2023 Ethan Halsall
    
    This file is part of codec-parser.
    
    codec-parser is free software: you can redistribute it and/or modify
    it under the terms of the GNU Lesser General Public License as published by
    the Free Software Foundation, either version 3 of the License, or
    (at your option) any later version.

    codec-parser is distributed in the hope that it will be useful,
    but WITHOUT ANY WARRANTY; without even the implied warranty of
    MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
    GNU Lesser General Public License for more details.

    You should have received a copy of the GNU Lesser General Public License
    along with this program.  If not, see <https://www.gnu.org/licenses/>
*/ /*
https://tools.ietf.org/html/rfc7845.html
 0                   1                   2                   3
 0 1 2 3 4 5 6 7 8 9 0 1 2 3 4 5 6 7 8 9 0 1 2 3 4 5 6 7 8 9 0 1
+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+
|      'O'      |      'p'      |      'u'      |      's'      |
+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+
|      'H'      |      'e'      |      'a'      |      'd'      |
+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+
|  Version = 1  | Channel Count |           Pre-skip            |
+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+
|                     Input Sample Rate (Hz)                    |
+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+
|   Output Gain (Q7.8 in dB)    | Mapping Family|               |
+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+               :
|                                                               |
:               Optional Channel Mapping Table...               :
|                                                               |
+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+

Letter  Length (bits)  Description
A  64  Magic Signature - OpusHead
B  8   Version number - 00000001
C  8   Output channel count (unsigned)
D  16  Pre-skip (unsigned, little endian)
E  32  Sample rate (unsigned, little endian)
F  16  Output Gain (signed, little endian)
G  8   Channel Mapping family (unsigned)

// if(channel mapping !== 0)
H  8   Stream count (unsigned)
I  8   Coupled Stream Count (unsigned)
J  8*C Channel Mapping
*/ 


/* prettier-ignore */ const $8d4c615213e2a499$var$channelMappingFamilies = {
    0: (0, $860f0b5184108148$export$c067b99a35ad0847).slice(0, 2),
    /*
    0: "monophonic (mono)"
    1: "stereo (left, right)"
    */ 1: (0, $860f0b5184108148$export$c067b99a35ad0847)
};
const $8d4c615213e2a499$var$silkOnly = "SILK-only";
const $8d4c615213e2a499$var$celtOnly = "CELT-only";
const $8d4c615213e2a499$var$hybrid = "Hybrid";
const $8d4c615213e2a499$var$narrowBand = "narrowband";
const $8d4c615213e2a499$var$mediumBand = "medium-band";
const $8d4c615213e2a499$var$wideBand = "wideband";
const $8d4c615213e2a499$var$superWideBand = "super-wideband";
const $8d4c615213e2a499$var$fullBand = "fullband";
//  0 1 2 3 4 5 6 7
// +-+-+-+-+-+-+-+-+
// | config  |s| c |
// +-+-+-+-+-+-+-+-+
// prettier-ignore
const $8d4c615213e2a499$var$configTable = {
    0: {
        [(0, $860f0b5184108148$export$549ff81930776885)]: $8d4c615213e2a499$var$silkOnly,
        [(0, $860f0b5184108148$export$2a97ae90773dd351)]: $8d4c615213e2a499$var$narrowBand,
        [(0, $860f0b5184108148$export$7815706ac4afa67d)]: 10
    },
    8: {
        [(0, $860f0b5184108148$export$549ff81930776885)]: $8d4c615213e2a499$var$silkOnly,
        [(0, $860f0b5184108148$export$2a97ae90773dd351)]: $8d4c615213e2a499$var$narrowBand,
        [(0, $860f0b5184108148$export$7815706ac4afa67d)]: 20
    },
    16: {
        [(0, $860f0b5184108148$export$549ff81930776885)]: $8d4c615213e2a499$var$silkOnly,
        [(0, $860f0b5184108148$export$2a97ae90773dd351)]: $8d4c615213e2a499$var$narrowBand,
        [(0, $860f0b5184108148$export$7815706ac4afa67d)]: 40
    },
    24: {
        [(0, $860f0b5184108148$export$549ff81930776885)]: $8d4c615213e2a499$var$silkOnly,
        [(0, $860f0b5184108148$export$2a97ae90773dd351)]: $8d4c615213e2a499$var$narrowBand,
        [(0, $860f0b5184108148$export$7815706ac4afa67d)]: 60
    },
    32: {
        [(0, $860f0b5184108148$export$549ff81930776885)]: $8d4c615213e2a499$var$silkOnly,
        [(0, $860f0b5184108148$export$2a97ae90773dd351)]: $8d4c615213e2a499$var$mediumBand,
        [(0, $860f0b5184108148$export$7815706ac4afa67d)]: 10
    },
    40: {
        [(0, $860f0b5184108148$export$549ff81930776885)]: $8d4c615213e2a499$var$silkOnly,
        [(0, $860f0b5184108148$export$2a97ae90773dd351)]: $8d4c615213e2a499$var$mediumBand,
        [(0, $860f0b5184108148$export$7815706ac4afa67d)]: 20
    },
    48: {
        [(0, $860f0b5184108148$export$549ff81930776885)]: $8d4c615213e2a499$var$silkOnly,
        [(0, $860f0b5184108148$export$2a97ae90773dd351)]: $8d4c615213e2a499$var$mediumBand,
        [(0, $860f0b5184108148$export$7815706ac4afa67d)]: 40
    },
    56: {
        [(0, $860f0b5184108148$export$549ff81930776885)]: $8d4c615213e2a499$var$silkOnly,
        [(0, $860f0b5184108148$export$2a97ae90773dd351)]: $8d4c615213e2a499$var$mediumBand,
        [(0, $860f0b5184108148$export$7815706ac4afa67d)]: 60
    },
    64: {
        [(0, $860f0b5184108148$export$549ff81930776885)]: $8d4c615213e2a499$var$silkOnly,
        [(0, $860f0b5184108148$export$2a97ae90773dd351)]: $8d4c615213e2a499$var$wideBand,
        [(0, $860f0b5184108148$export$7815706ac4afa67d)]: 10
    },
    72: {
        [(0, $860f0b5184108148$export$549ff81930776885)]: $8d4c615213e2a499$var$silkOnly,
        [(0, $860f0b5184108148$export$2a97ae90773dd351)]: $8d4c615213e2a499$var$wideBand,
        [(0, $860f0b5184108148$export$7815706ac4afa67d)]: 20
    },
    80: {
        [(0, $860f0b5184108148$export$549ff81930776885)]: $8d4c615213e2a499$var$silkOnly,
        [(0, $860f0b5184108148$export$2a97ae90773dd351)]: $8d4c615213e2a499$var$wideBand,
        [(0, $860f0b5184108148$export$7815706ac4afa67d)]: 40
    },
    88: {
        [(0, $860f0b5184108148$export$549ff81930776885)]: $8d4c615213e2a499$var$silkOnly,
        [(0, $860f0b5184108148$export$2a97ae90773dd351)]: $8d4c615213e2a499$var$wideBand,
        [(0, $860f0b5184108148$export$7815706ac4afa67d)]: 60
    },
    96: {
        [(0, $860f0b5184108148$export$549ff81930776885)]: $8d4c615213e2a499$var$hybrid,
        [(0, $860f0b5184108148$export$2a97ae90773dd351)]: $8d4c615213e2a499$var$superWideBand,
        [(0, $860f0b5184108148$export$7815706ac4afa67d)]: 10
    },
    104: {
        [(0, $860f0b5184108148$export$549ff81930776885)]: $8d4c615213e2a499$var$hybrid,
        [(0, $860f0b5184108148$export$2a97ae90773dd351)]: $8d4c615213e2a499$var$superWideBand,
        [(0, $860f0b5184108148$export$7815706ac4afa67d)]: 20
    },
    112: {
        [(0, $860f0b5184108148$export$549ff81930776885)]: $8d4c615213e2a499$var$hybrid,
        [(0, $860f0b5184108148$export$2a97ae90773dd351)]: $8d4c615213e2a499$var$fullBand,
        [(0, $860f0b5184108148$export$7815706ac4afa67d)]: 10
    },
    120: {
        [(0, $860f0b5184108148$export$549ff81930776885)]: $8d4c615213e2a499$var$hybrid,
        [(0, $860f0b5184108148$export$2a97ae90773dd351)]: $8d4c615213e2a499$var$fullBand,
        [(0, $860f0b5184108148$export$7815706ac4afa67d)]: 20
    },
    128: {
        [(0, $860f0b5184108148$export$549ff81930776885)]: $8d4c615213e2a499$var$celtOnly,
        [(0, $860f0b5184108148$export$2a97ae90773dd351)]: $8d4c615213e2a499$var$narrowBand,
        [(0, $860f0b5184108148$export$7815706ac4afa67d)]: 2.5
    },
    136: {
        [(0, $860f0b5184108148$export$549ff81930776885)]: $8d4c615213e2a499$var$celtOnly,
        [(0, $860f0b5184108148$export$2a97ae90773dd351)]: $8d4c615213e2a499$var$narrowBand,
        [(0, $860f0b5184108148$export$7815706ac4afa67d)]: 5
    },
    144: {
        [(0, $860f0b5184108148$export$549ff81930776885)]: $8d4c615213e2a499$var$celtOnly,
        [(0, $860f0b5184108148$export$2a97ae90773dd351)]: $8d4c615213e2a499$var$narrowBand,
        [(0, $860f0b5184108148$export$7815706ac4afa67d)]: 10
    },
    152: {
        [(0, $860f0b5184108148$export$549ff81930776885)]: $8d4c615213e2a499$var$celtOnly,
        [(0, $860f0b5184108148$export$2a97ae90773dd351)]: $8d4c615213e2a499$var$narrowBand,
        [(0, $860f0b5184108148$export$7815706ac4afa67d)]: 20
    },
    160: {
        [(0, $860f0b5184108148$export$549ff81930776885)]: $8d4c615213e2a499$var$celtOnly,
        [(0, $860f0b5184108148$export$2a97ae90773dd351)]: $8d4c615213e2a499$var$wideBand,
        [(0, $860f0b5184108148$export$7815706ac4afa67d)]: 2.5
    },
    168: {
        [(0, $860f0b5184108148$export$549ff81930776885)]: $8d4c615213e2a499$var$celtOnly,
        [(0, $860f0b5184108148$export$2a97ae90773dd351)]: $8d4c615213e2a499$var$wideBand,
        [(0, $860f0b5184108148$export$7815706ac4afa67d)]: 5
    },
    176: {
        [(0, $860f0b5184108148$export$549ff81930776885)]: $8d4c615213e2a499$var$celtOnly,
        [(0, $860f0b5184108148$export$2a97ae90773dd351)]: $8d4c615213e2a499$var$wideBand,
        [(0, $860f0b5184108148$export$7815706ac4afa67d)]: 10
    },
    184: {
        [(0, $860f0b5184108148$export$549ff81930776885)]: $8d4c615213e2a499$var$celtOnly,
        [(0, $860f0b5184108148$export$2a97ae90773dd351)]: $8d4c615213e2a499$var$wideBand,
        [(0, $860f0b5184108148$export$7815706ac4afa67d)]: 20
    },
    192: {
        [(0, $860f0b5184108148$export$549ff81930776885)]: $8d4c615213e2a499$var$celtOnly,
        [(0, $860f0b5184108148$export$2a97ae90773dd351)]: $8d4c615213e2a499$var$superWideBand,
        [(0, $860f0b5184108148$export$7815706ac4afa67d)]: 2.5
    },
    200: {
        [(0, $860f0b5184108148$export$549ff81930776885)]: $8d4c615213e2a499$var$celtOnly,
        [(0, $860f0b5184108148$export$2a97ae90773dd351)]: $8d4c615213e2a499$var$superWideBand,
        [(0, $860f0b5184108148$export$7815706ac4afa67d)]: 5
    },
    208: {
        [(0, $860f0b5184108148$export$549ff81930776885)]: $8d4c615213e2a499$var$celtOnly,
        [(0, $860f0b5184108148$export$2a97ae90773dd351)]: $8d4c615213e2a499$var$superWideBand,
        [(0, $860f0b5184108148$export$7815706ac4afa67d)]: 10
    },
    216: {
        [(0, $860f0b5184108148$export$549ff81930776885)]: $8d4c615213e2a499$var$celtOnly,
        [(0, $860f0b5184108148$export$2a97ae90773dd351)]: $8d4c615213e2a499$var$superWideBand,
        [(0, $860f0b5184108148$export$7815706ac4afa67d)]: 20
    },
    224: {
        [(0, $860f0b5184108148$export$549ff81930776885)]: $8d4c615213e2a499$var$celtOnly,
        [(0, $860f0b5184108148$export$2a97ae90773dd351)]: $8d4c615213e2a499$var$fullBand,
        [(0, $860f0b5184108148$export$7815706ac4afa67d)]: 2.5
    },
    232: {
        [(0, $860f0b5184108148$export$549ff81930776885)]: $8d4c615213e2a499$var$celtOnly,
        [(0, $860f0b5184108148$export$2a97ae90773dd351)]: $8d4c615213e2a499$var$fullBand,
        [(0, $860f0b5184108148$export$7815706ac4afa67d)]: 5
    },
    240: {
        [(0, $860f0b5184108148$export$549ff81930776885)]: $8d4c615213e2a499$var$celtOnly,
        [(0, $860f0b5184108148$export$2a97ae90773dd351)]: $8d4c615213e2a499$var$fullBand,
        [(0, $860f0b5184108148$export$7815706ac4afa67d)]: 10
    },
    248: {
        [(0, $860f0b5184108148$export$549ff81930776885)]: $8d4c615213e2a499$var$celtOnly,
        [(0, $860f0b5184108148$export$2a97ae90773dd351)]: $8d4c615213e2a499$var$fullBand,
        [(0, $860f0b5184108148$export$7815706ac4afa67d)]: 20
    }
};
class $8d4c615213e2a499$export$2e2bcd8739ae039 extends (0, $3fb1607145c26488$export$2e2bcd8739ae039) {
    static [(0, $860f0b5184108148$export$c34399eed923e901)](dataValue, packetData, headerCache) {
        const header = {};
        // get length of header
        // Byte (10 of 19)
        // * `CCCCCCCC`: Channel Count
        header[0, $860f0b5184108148$export$9659c395d9de169e] = dataValue[9];
        // Byte (19 of 19)
        // * `GGGGGGGG`: Channel Mapping Family
        header[0, $860f0b5184108148$export$1dbaf4b0a82f5d28] = dataValue[18];
        header[0, $860f0b5184108148$export$f24224f1c91d8156] = header[0, $860f0b5184108148$export$1dbaf4b0a82f5d28] !== 0 ? 21 + header[0, $860f0b5184108148$export$9659c395d9de169e] : 19;
        if (dataValue[0, $860f0b5184108148$export$f24224f1c91d8156] < header[0, $860f0b5184108148$export$f24224f1c91d8156]) throw new Error("Out of data while inside an Ogg Page");
        // Page Segment Bytes (1-2)
        // * `AAAAA...`: Packet config
        // * `.....B..`:
        // * `......CC`: Packet code
        const packetMode = packetData[0] & 3;
        const packetLength = packetMode === 3 ? 2 : 1;
        // Check header cache
        const key = (0, $dd0c961b75cd9139$export$7c746b75f47c9c7d)(dataValue[0, $860f0b5184108148$export$7ec32827e4221318](0, header[0, $860f0b5184108148$export$f24224f1c91d8156])) + (0, $dd0c961b75cd9139$export$7c746b75f47c9c7d)(packetData[0, $860f0b5184108148$export$7ec32827e4221318](0, packetLength));
        const cachedHeader = headerCache[0, $860f0b5184108148$export$47ed31abc613cf55](key);
        if (cachedHeader) return new $8d4c615213e2a499$export$2e2bcd8739ae039(cachedHeader);
        // Bytes (1-8 of 19): OpusHead - Magic Signature
        if (key.substr(0, 8) !== "OpusHead") return null;
        // Byte (9 of 19)
        // * `00000001`: Version number
        if (dataValue[8] !== 1) return null;
        header[0, $860f0b5184108148$export$4051a07651545597] = (0, $860f0b5184108148$export$d7e5036dad7e20bb).from(dataValue[0, $860f0b5184108148$export$7ec32827e4221318](0, header[0, $860f0b5184108148$export$f24224f1c91d8156]));
        const view = new (0, $860f0b5184108148$export$40b76aa5ded53e7a)(header[0, $860f0b5184108148$export$4051a07651545597][0, $860f0b5184108148$export$ab1029bcae9ddb4a]);
        header[0, $860f0b5184108148$export$cee20cdac1cd19df] = 16;
        // Byte (10 of 19)
        // * `CCCCCCCC`: Channel Count
        // set earlier to determine length
        // Byte (11-12 of 19)
        // * `DDDDDDDD|DDDDDDDD`: Pre skip
        header[0, $860f0b5184108148$export$3dc3ed1cd86c68b4] = view.getUint16(10, true);
        // Byte (13-16 of 19)
        // * `EEEEEEEE|EEEEEEEE|EEEEEEEE|EEEEEEEE`: Sample Rate
        header[0, $860f0b5184108148$export$cc7fd71f037082e3] = view.getUint32(12, true);
        // Opus is always decoded at 48kHz
        header[0, $860f0b5184108148$export$851d973a43101ae1] = (0, $860f0b5184108148$export$671a0c9051642a0b);
        // Byte (17-18 of 19)
        // * `FFFFFFFF|FFFFFFFF`: Output Gain
        header[0, $860f0b5184108148$export$ed96e046486b4b25] = view.getInt16(16, true);
        // Byte (19 of 19)
        // * `GGGGGGGG`: Channel Mapping Family
        // set earlier to determine length
        if (header[0, $860f0b5184108148$export$1dbaf4b0a82f5d28] in $8d4c615213e2a499$var$channelMappingFamilies) {
            header[0, $860f0b5184108148$export$589c9a7ae9a79c5e] = $8d4c615213e2a499$var$channelMappingFamilies[header[0, $860f0b5184108148$export$1dbaf4b0a82f5d28]][header[0, $860f0b5184108148$export$9659c395d9de169e] - 1];
            if (!header[0, $860f0b5184108148$export$589c9a7ae9a79c5e]) return null;
        }
        if (header[0, $860f0b5184108148$export$1dbaf4b0a82f5d28] !== 0) {
            // * `HHHHHHHH`: Stream count
            header[0, $860f0b5184108148$export$ef26b3900cee0fa3] = dataValue[19];
            // * `IIIIIIII`: Coupled Stream count
            header[0, $860f0b5184108148$export$a592872ee1129cb4] = dataValue[20];
            // * `JJJJJJJJ|...` Channel Mapping table
            header[0, $860f0b5184108148$export$e856ca83ff30dbad] = [
                ...dataValue[0, $860f0b5184108148$export$7ec32827e4221318](21, header[0, $860f0b5184108148$export$9659c395d9de169e] + 21)
            ];
        }
        const packetConfig = $8d4c615213e2a499$var$configTable[248 & packetData[0]];
        header[0, $860f0b5184108148$export$549ff81930776885] = packetConfig[0, $860f0b5184108148$export$549ff81930776885];
        header[0, $860f0b5184108148$export$2a97ae90773dd351] = packetConfig[0, $860f0b5184108148$export$2a97ae90773dd351];
        header[0, $860f0b5184108148$export$7815706ac4afa67d] = packetConfig[0, $860f0b5184108148$export$7815706ac4afa67d];
        // https://tools.ietf.org/html/rfc6716#appendix-B
        switch(packetMode){
            case 0:
                // 0: 1 frame in the packet
                header[0, $860f0b5184108148$export$150180f5f882de62] = 1;
                break;
            case 1:
            // 1: 2 frames in the packet, each with equal compressed size
            case 2:
                // 2: 2 frames in the packet, with different compressed sizes
                header[0, $860f0b5184108148$export$150180f5f882de62] = 2;
                break;
            case 3:
                // 3: an arbitrary number of frames in the packet
                header[0, $860f0b5184108148$export$ca9d7e8ef88bd07e] = !!(128 & packetData[1]);
                header[0, $860f0b5184108148$export$ae48fe32cc58ab6f] = !!(64 & packetData[1]);
                header[0, $860f0b5184108148$export$150180f5f882de62] = 63 & packetData[1];
                break;
            default:
                return null;
        }
        // set header cache
        {
            const { length: length, data: headerData, channelMappingFamily: channelMappingFamily, ...codecUpdateFields } = header;
            headerCache[0, $860f0b5184108148$export$604ed74fb893f0e2](key, header, codecUpdateFields);
        }
        return new $8d4c615213e2a499$export$2e2bcd8739ae039(header);
    }
    /**
   * @private
   * Call OpusHeader.getHeader(Array<Uint8>) to get instance
   */ constructor(header){
        super(header);
        this[0, $860f0b5184108148$export$4051a07651545597] = header[0, $860f0b5184108148$export$4051a07651545597];
        this[0, $860f0b5184108148$export$2a97ae90773dd351] = header[0, $860f0b5184108148$export$2a97ae90773dd351];
        this[0, $860f0b5184108148$export$1dbaf4b0a82f5d28] = header[0, $860f0b5184108148$export$1dbaf4b0a82f5d28];
        this[0, $860f0b5184108148$export$e856ca83ff30dbad] = header[0, $860f0b5184108148$export$e856ca83ff30dbad];
        this[0, $860f0b5184108148$export$a592872ee1129cb4] = header[0, $860f0b5184108148$export$a592872ee1129cb4];
        this[0, $860f0b5184108148$export$150180f5f882de62] = header[0, $860f0b5184108148$export$150180f5f882de62];
        this[0, $860f0b5184108148$export$7815706ac4afa67d] = header[0, $860f0b5184108148$export$7815706ac4afa67d];
        this[0, $860f0b5184108148$export$ae48fe32cc58ab6f] = header[0, $860f0b5184108148$export$ae48fe32cc58ab6f];
        this[0, $860f0b5184108148$export$cc7fd71f037082e3] = header[0, $860f0b5184108148$export$cc7fd71f037082e3];
        this[0, $860f0b5184108148$export$ca9d7e8ef88bd07e] = header[0, $860f0b5184108148$export$ca9d7e8ef88bd07e];
        this[0, $860f0b5184108148$export$549ff81930776885] = header[0, $860f0b5184108148$export$549ff81930776885];
        this[0, $860f0b5184108148$export$ed96e046486b4b25] = header[0, $860f0b5184108148$export$ed96e046486b4b25];
        this[0, $860f0b5184108148$export$3dc3ed1cd86c68b4] = header[0, $860f0b5184108148$export$3dc3ed1cd86c68b4];
        this[0, $860f0b5184108148$export$ef26b3900cee0fa3] = header[0, $860f0b5184108148$export$ef26b3900cee0fa3];
    }
}


class $7068865fc990acb1$export$2e2bcd8739ae039 extends (0, $dd7c0f9e54b04fc4$export$2e2bcd8739ae039) {
    constructor(codecParser, headerCache, onCodec){
        super(codecParser, headerCache);
        this.Frame = (0, $0c94b01dfaac6aa0$export$2e2bcd8739ae039);
        this.Header = (0, $8d4c615213e2a499$export$2e2bcd8739ae039);
        onCodec(this[0, $860f0b5184108148$export$1c37c01eba8ed446]);
        this._identificationHeader = null;
    }
    get [(0, $860f0b5184108148$export$1c37c01eba8ed446)]() {
        return "opus";
    }
    /**
   * @todo implement continued page support
   */ [(0, $860f0b5184108148$export$d9639f7fbeab4358)](oggPage) {
        if (oggPage[0, $860f0b5184108148$export$a60fa1703d7dd487] === 0) {
            // Identification header
            this._headerCache[0, $860f0b5184108148$export$d7c4a0dd6a4567e5]();
            this._identificationHeader = oggPage[0, $860f0b5184108148$export$4051a07651545597];
        } else if (oggPage[0, $860f0b5184108148$export$a60fa1703d7dd487] === 1) ;
        else oggPage[0, $860f0b5184108148$export$a53f1e3778a12d7d] = (0, $5169222015670af0$export$5b0e32d79f1188e7).get(oggPage)[0, $860f0b5184108148$export$27e01f77e7f7ec20].map((segment)=>{
            const header = (0, $8d4c615213e2a499$export$2e2bcd8739ae039)[0, $860f0b5184108148$export$c34399eed923e901](this._identificationHeader, segment, this._headerCache);
            if (header) return new (0, $0c94b01dfaac6aa0$export$2e2bcd8739ae039)(segment, header);
            this._codecParser[0, $860f0b5184108148$export$58da9968c3170cb1]("Failed to parse Ogg Opus Header", "Not a valid Ogg Opus file");
        });
        return oggPage;
    }
}


/* Copyright 2020-2023 Ethan Halsall
    
    This file is part of codec-parser.
    
    codec-parser is free software: you can redistribute it and/or modify
    it under the terms of the GNU Lesser General Public License as published by
    the Free Software Foundation, either version 3 of the License, or
    (at your option) any later version.

    codec-parser is distributed in the hope that it will be useful,
    but WITHOUT ANY WARRANTY; without even the implied warranty of
    MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
    GNU Lesser General Public License for more details.

    You should have received a copy of the GNU Lesser General Public License
    along with this program.  If not, see <https://www.gnu.org/licenses/>
*/ 



/* Copyright 2020-2023 Ethan Halsall
    
    This file is part of codec-parser.
    
    codec-parser is free software: you can redistribute it and/or modify
    it under the terms of the GNU Lesser General Public License as published by
    the Free Software Foundation, either version 3 of the License, or
    (at your option) any later version.

    codec-parser is distributed in the hope that it will be useful,
    but WITHOUT ANY WARRANTY; without even the implied warranty of
    MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
    GNU Lesser General Public License for more details.

    You should have received a copy of the GNU Lesser General Public License
    along with this program.  If not, see <https://www.gnu.org/licenses/>
*/ 
class $423631361db2be72$export$2e2bcd8739ae039 extends (0, $0b17d7d3514fce05$export$2e2bcd8739ae039) {
    constructor(data, header, samples){
        super(header, data, samples);
    }
}


/* Copyright 2020-2023 Ethan Halsall
    
    This file is part of codec-parser.
    
    codec-parser is free software: you can redistribute it and/or modify
    it under the terms of the GNU Lesser General Public License as published by
    the Free Software Foundation, either version 3 of the License, or
    (at your option) any later version.

    codec-parser is distributed in the hope that it will be useful,
    but WITHOUT ANY WARRANTY; without even the implied warranty of
    MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
    GNU Lesser General Public License for more details.

    You should have received a copy of the GNU Lesser General Public License
    along with this program.  If not, see <https://www.gnu.org/licenses/>
*/ /*

1  1) [packet_type] : 8 bit value
2  2) 0x76, 0x6f, 0x72, 0x62, 0x69, 0x73: the characters ’v’,’o’,’r’,’b’,’i’,’s’ as six octets

Letter bits Description
A      8    Packet type
B      48   Magic signature (vorbis)
C      32   Version number
D      8    Channels
E      32   Sample rate
F      32   Bitrate Maximum (signed)
G      32   Bitrate Nominal (signed)
H      32   Bitrate Minimum (signed)
I      4    blocksize 1
J      4    blocksize 0
K      1    Framing flag
*/ 


const $3bc9b95d2966c665$var$blockSizes = {
};
for(let i = 0; i < 8; i++)$3bc9b95d2966c665$var$blockSizes[i + 6] = 2 ** (6 + i);
class $3bc9b95d2966c665$export$2e2bcd8739ae039 extends (0, $3fb1607145c26488$export$2e2bcd8739ae039) {
    static [(0, $860f0b5184108148$export$c34399eed923e901)](dataValue, headerCache, vorbisCommentsData, vorbisSetupData) {
        // Must be at least 30 bytes.
        if (dataValue[0, $860f0b5184108148$export$f24224f1c91d8156] < 30) throw new Error("Out of data while inside an Ogg Page");
        // Check header cache
        const key = (0, $dd0c961b75cd9139$export$7c746b75f47c9c7d)(dataValue[0, $860f0b5184108148$export$7ec32827e4221318](0, 30));
        const cachedHeader = headerCache[0, $860f0b5184108148$export$47ed31abc613cf55](key);
        if (cachedHeader) return new $3bc9b95d2966c665$export$2e2bcd8739ae039(cachedHeader);
        const header = {
            [(0, $860f0b5184108148$export$f24224f1c91d8156)]: 30
        };
        // Bytes (1-7 of 30): /01vorbis - Magic Signature
        if (key.substr(0, 7) !== "\x01vorbis") return null;
        header[0, $860f0b5184108148$export$4051a07651545597] = (0, $860f0b5184108148$export$d7e5036dad7e20bb).from(dataValue[0, $860f0b5184108148$export$7ec32827e4221318](0, 30));
        const view = new (0, $860f0b5184108148$export$40b76aa5ded53e7a)(header[0, $860f0b5184108148$export$4051a07651545597][0, $860f0b5184108148$export$ab1029bcae9ddb4a]);
        // Byte (8-11 of 30)
        // * `CCCCCCCC|CCCCCCCC|CCCCCCCC|CCCCCCCC`: Version number
        header[0, $860f0b5184108148$export$83d89fbfd8236492] = view.getUint32(7, true);
        if (header[0, $860f0b5184108148$export$83d89fbfd8236492] !== 0) return null;
        // Byte (12 of 30)
        // * `DDDDDDDD`: Channel Count
        header[0, $860f0b5184108148$export$9659c395d9de169e] = dataValue[11];
        header[0, $860f0b5184108148$export$589c9a7ae9a79c5e] = (0, $860f0b5184108148$export$c067b99a35ad0847)[header[0, $860f0b5184108148$export$9659c395d9de169e] - 1] || "application defined";
        // Byte (13-16 of 30)
        // * `EEEEEEEE|EEEEEEEE|EEEEEEEE|EEEEEEEE`: Sample Rate
        header[0, $860f0b5184108148$export$851d973a43101ae1] = view.getUint32(12, true);
        // Byte (17-20 of 30)
        // * `FFFFFFFF|FFFFFFFF|FFFFFFFF|FFFFFFFF`: Bitrate Maximum
        header[0, $860f0b5184108148$export$d48d8e6e1487adc4] = view.getInt32(16, true);
        // Byte (21-24 of 30)
        // * `GGGGGGGG|GGGGGGGG|GGGGGGGG|GGGGGGGG`: Bitrate Nominal
        header[0, $860f0b5184108148$export$d28b7ae062ff03c5] = view.getInt32(20, true);
        // Byte (25-28 of 30)
        // * `HHHHHHHH|HHHHHHHH|HHHHHHHH|HHHHHHHH`: Bitrate Minimum
        header[0, $860f0b5184108148$export$971636741d86955] = view.getInt32(24, true);
        // Byte (29 of 30)
        // * `IIII....` Blocksize 1
        // * `....JJJJ` Blocksize 0
        header[0, $860f0b5184108148$export$6880a9e40f87ae65] = $3bc9b95d2966c665$var$blockSizes[(dataValue[28] & 240) >> 4];
        header[0, $860f0b5184108148$export$f3cbeb72a3601eb6] = $3bc9b95d2966c665$var$blockSizes[dataValue[28] & 15];
        if (header[0, $860f0b5184108148$export$f3cbeb72a3601eb6] > header[0, $860f0b5184108148$export$6880a9e40f87ae65]) return null;
        // Byte (29 of 30)
        // * `00000001` Framing bit
        if (dataValue[29] !== 0x01) return null;
        header[0, $860f0b5184108148$export$cee20cdac1cd19df] = 32;
        header[0, $860f0b5184108148$export$fe63a71268ec44ee] = vorbisSetupData;
        header[0, $860f0b5184108148$export$3a1c3ed71012e84e] = vorbisCommentsData;
        {
            // set header cache
            const { length: length, data: data, version: version, vorbisSetup: vorbisSetup, vorbisComments: vorbisComments, ...codecUpdateFields } = header;
            headerCache[0, $860f0b5184108148$export$604ed74fb893f0e2](key, header, codecUpdateFields);
        }
        return new $3bc9b95d2966c665$export$2e2bcd8739ae039(header);
    }
    /**
   * @private
   * Call VorbisHeader.getHeader(Array<Uint8>) to get instance
   */ constructor(header){
        super(header);
        this[0, $860f0b5184108148$export$d48d8e6e1487adc4] = header[0, $860f0b5184108148$export$d48d8e6e1487adc4];
        this[0, $860f0b5184108148$export$971636741d86955] = header[0, $860f0b5184108148$export$971636741d86955];
        this[0, $860f0b5184108148$export$d28b7ae062ff03c5] = header[0, $860f0b5184108148$export$d28b7ae062ff03c5];
        this[0, $860f0b5184108148$export$f3cbeb72a3601eb6] = header[0, $860f0b5184108148$export$f3cbeb72a3601eb6];
        this[0, $860f0b5184108148$export$6880a9e40f87ae65] = header[0, $860f0b5184108148$export$6880a9e40f87ae65];
        this[0, $860f0b5184108148$export$4051a07651545597] = header[0, $860f0b5184108148$export$4051a07651545597];
        this[0, $860f0b5184108148$export$3a1c3ed71012e84e] = header[0, $860f0b5184108148$export$3a1c3ed71012e84e];
        this[0, $860f0b5184108148$export$fe63a71268ec44ee] = header[0, $860f0b5184108148$export$fe63a71268ec44ee];
    }
}


class $730ce5ecd1a651d8$export$2e2bcd8739ae039 extends (0, $dd7c0f9e54b04fc4$export$2e2bcd8739ae039) {
    constructor(codecParser, headerCache, onCodec){
        super(codecParser, headerCache);
        this.Frame = (0, $423631361db2be72$export$2e2bcd8739ae039);
        onCodec(this[0, $860f0b5184108148$export$1c37c01eba8ed446]);
        this._identificationHeader = null;
        this._setupComplete = false;
        this._prevBlockSize = null;
    }
    get [(0, $860f0b5184108148$export$1c37c01eba8ed446)]() {
        return 0, $860f0b5184108148$export$3e1eea38d3db9f18;
    }
    [(0, $860f0b5184108148$export$d9639f7fbeab4358)](oggPage) {
        oggPage[0, $860f0b5184108148$export$a53f1e3778a12d7d] = [];
        for (const oggPageSegment of (0, $5169222015670af0$export$5b0e32d79f1188e7).get(oggPage)[0, $860f0b5184108148$export$27e01f77e7f7ec20]){
            if (oggPageSegment[0] === 1) {
                // Identification header
                this._headerCache[0, $860f0b5184108148$export$d7c4a0dd6a4567e5]();
                this._identificationHeader = oggPage[0, $860f0b5184108148$export$4051a07651545597];
                this._setupComplete = false;
            } else if (oggPageSegment[0] === 3) // comment header
            this._vorbisComments = oggPageSegment;
            else if (oggPageSegment[0] === 5) {
                // setup header
                this._vorbisSetup = oggPageSegment;
                this._mode = this._parseSetupHeader(oggPageSegment);
                this._setupComplete = true;
            } else if (this._setupComplete) {
                const header = (0, $3bc9b95d2966c665$export$2e2bcd8739ae039)[0, $860f0b5184108148$export$c34399eed923e901](this._identificationHeader, this._headerCache, this._vorbisComments, this._vorbisSetup);
                if (header) oggPage[0, $860f0b5184108148$export$a53f1e3778a12d7d].push(new (0, $423631361db2be72$export$2e2bcd8739ae039)(oggPageSegment, header, this._getSamples(oggPageSegment, header)));
                else this._codecParser[logError]("Failed to parse Ogg Vorbis Header", "Not a valid Ogg Vorbis file");
            }
        }
        return oggPage;
    }
    _getSamples(segment, header) {
        const blockFlag = this._mode.blockFlags[segment[0] >> 1 & this._mode.mask];
        const currentBlockSize = blockFlag ? header[0, $860f0b5184108148$export$6880a9e40f87ae65] : header[0, $860f0b5184108148$export$f3cbeb72a3601eb6];
        // data is not returned on the first frame, but is used to prime the decoder
        // https://xiph.org/vorbis/doc/Vorbis_I_spec.html#x1-590004
        const samplesValue = this._prevBlockSize === null ? 0 : (this._prevBlockSize + currentBlockSize) / 4;
        this._prevBlockSize = currentBlockSize;
        return samplesValue;
    }
    // https://gitlab.xiph.org/xiph/liboggz/-/blob/master/src/liboggz/oggz_auto.c#L911
    // https://github.com/FFmpeg/FFmpeg/blob/master/libavcodec/vorbis_parser.c
    /*
   * This is the format of the mode data at the end of the packet for all
   * Vorbis Version 1 :
   *
   * [ 6:number_of_modes ]
   * [ 1:size | 16:window_type(0) | 16:transform_type(0) | 8:mapping ]
   * [ 1:size | 16:window_type(0) | 16:transform_type(0) | 8:mapping ]
   * [ 1:size | 16:window_type(0) | 16:transform_type(0) | 8:mapping ]
   * [ 1:framing(1) ]
   *
   * e.g.:
   *
   * MsB         LsB
   *              <-
   * 0 0 0 0 0 1 0 0
   * 0 0 1 0 0 0 0 0
   * 0 0 1 0 0 0 0 0
   * 0 0 1|0 0 0 0 0
   * 0 0 0 0|0|0 0 0
   * 0 0 0 0 0 0 0 0
   * 0 0 0 0|0 0 0 0
   * 0 0 0 0 0 0 0 0
   * 0 0 0 0|0 0 0 0
   * 0 0 0|1|0 0 0 0 |
   * 0 0 0 0 0 0 0 0 V
   * 0 0 0|0 0 0 0 0
   * 0 0 0 0 0 0 0 0
   * 0 0|1 0 0 0 0 0
   *
   * The simplest way to approach this is to start at the end
   * and read backwards to determine the mode configuration.
   *
   * liboggz and ffmpeg both use this method.
   */ _parseSetupHeader(setup) {
        const bitReader = new (0, $dd0c961b75cd9139$export$229c1f1c745a2f7a)(setup);
        const mode = {
            count: 0,
            blockFlags: []
        };
        // sync with the framing bit
        while((bitReader.read(1) & 0x01) !== 1);
        let modeBits;
        // search in reverse to parse out the mode entries
        // limit mode count to 63 so previous block flag will be in first packet byte
        while(mode.count < 64 && bitReader.position > 0){
            (0, $dd0c961b75cd9139$export$66c1ae025e96b4bc)(bitReader.read(8)); // read mapping
            // 16 bits transform type, 16 bits window type, all values must be zero
            let currentByte = 0;
            while(bitReader.read(8) === 0x00 && currentByte++ < 3); // a non-zero value may indicate the end of the mode entries, or invalid data
            if (currentByte === 4) {
                // transform type and window type were all zeros
                modeBits = bitReader.read(7); // modeBits may need to be used in the next iteration if this is the last mode entry
                mode.blockFlags.unshift(modeBits & 0x01); // read and store mode number -> block flag
                bitReader.position += 6; // go back 6 bits so next iteration starts right after the block flag
                mode.count++;
            } else {
                // transform type and window type were not all zeros
                // check for mode count using previous iteration modeBits
                if ((((0, $dd0c961b75cd9139$export$66c1ae025e96b4bc)(modeBits) & 126) >> 1) + 1 !== mode.count) this._codecParser[0, $860f0b5184108148$export$ebd6064652549ce9]("vorbis derived mode count did not match actual mode count");
                break;
            }
        }
        // xxxxxxxa packet type
        // xxxxxxbx mode count (number of mode count bits)
        // xxxxxcxx previous window flag
        // xxxxdxxx next window flag
        mode.mask = (1 << Math.log2(mode.count)) - 1;
        return mode;
    }
}


class $34db2c67086ea732$var$OggStream {
    constructor(codecParser, headerCache, onCodec){
        this._codecParser = codecParser;
        this._headerCache = headerCache;
        this._onCodec = onCodec;
        this._continuedPacket = new (0, $860f0b5184108148$export$d7e5036dad7e20bb)();
        this._codec = null;
        this._isSupported = null;
    }
    get [(0, $860f0b5184108148$export$1c37c01eba8ed446)]() {
        return this._codec || "";
    }
    _updateCodec(codec, Parser) {
        if (this._codec !== codec) {
            this._headerCache[0, $860f0b5184108148$export$aad8462122ac592b]();
            this._parser = new Parser(this._codecParser, this._headerCache, this._onCodec);
            this._codec = codec;
        }
    }
    _checkCodecSupport({ data: data }) {
        const idString = (0, $dd0c961b75cd9139$export$7c746b75f47c9c7d)(data[0, $860f0b5184108148$export$7ec32827e4221318](0, 8));
        switch(idString){
            case "fishead\0":
                return false; // ignore ogg skeleton packets
            case "OpusHead":
                this._updateCodec("opus", (0, $7068865fc990acb1$export$2e2bcd8739ae039));
                return true;
            case /^\x7fFLAC/.test(idString) && idString:
                this._updateCodec("flac", (0, $fc8c22388cf24d2d$export$2e2bcd8739ae039));
                return true;
            case /^\x01vorbis/.test(idString) && idString:
                this._updateCodec((0, $860f0b5184108148$export$3e1eea38d3db9f18), (0, $730ce5ecd1a651d8$export$2e2bcd8739ae039));
                return true;
            default:
                return false;
        }
    }
    _checkPageSequenceNumber(oggPage) {
        if (oggPage[0, $860f0b5184108148$export$a60fa1703d7dd487] !== this._pageSequenceNumber + 1 && this._pageSequenceNumber > 1 && oggPage[0, $860f0b5184108148$export$a60fa1703d7dd487] > 1) this._codecParser[0, $860f0b5184108148$export$ebd6064652549ce9]("Unexpected gap in Ogg Page Sequence Number.", `Expected: ${this._pageSequenceNumber + 1}, Got: ${oggPage[0, $860f0b5184108148$export$a60fa1703d7dd487]}`);
        this._pageSequenceNumber = oggPage[0, $860f0b5184108148$export$a60fa1703d7dd487];
    }
    _parsePage(oggPage) {
        if (this._isSupported === null) {
            this._pageSequenceNumber = oggPage[0, $860f0b5184108148$export$a60fa1703d7dd487];
            this._isSupported = this._checkCodecSupport(oggPage);
        }
        this._checkPageSequenceNumber(oggPage);
        const oggPageStore = (0, $5169222015670af0$export$5b0e32d79f1188e7).get(oggPage);
        const headerData = (0, $5169222015670af0$export$52342bdf89fb39e7).get(oggPageStore[0, $860f0b5184108148$export$38e42c68cf43b5d4]);
        let offset = 0;
        oggPageStore[0, $860f0b5184108148$export$27e01f77e7f7ec20] = headerData[0, $860f0b5184108148$export$e0e12ae5ee640391].map((segmentLength)=>oggPage[0, $860f0b5184108148$export$4051a07651545597][0, $860f0b5184108148$export$7ec32827e4221318](offset, offset += segmentLength));
        // prepend any existing continued packet data
        if (this._continuedPacket[0, $860f0b5184108148$export$f24224f1c91d8156]) {
            oggPageStore[0, $860f0b5184108148$export$27e01f77e7f7ec20][0] = (0, $dd0c961b75cd9139$export$28e250f55413be00)(this._continuedPacket, oggPageStore[0, $860f0b5184108148$export$27e01f77e7f7ec20][0]);
            this._continuedPacket = new (0, $860f0b5184108148$export$d7e5036dad7e20bb)();
        }
        // save any new continued packet data
        if (headerData[0, $860f0b5184108148$export$7b4b65786d4d1f7][headerData[0, $860f0b5184108148$export$7b4b65786d4d1f7][0, $860f0b5184108148$export$f24224f1c91d8156] - 1] === 0xff) this._continuedPacket = (0, $dd0c961b75cd9139$export$28e250f55413be00)(this._continuedPacket, oggPageStore[0, $860f0b5184108148$export$27e01f77e7f7ec20].pop());
        if (this._isSupported) {
            const frame = this._parser[0, $860f0b5184108148$export$d9639f7fbeab4358](oggPage);
            this._codecParser[0, $860f0b5184108148$export$24d5305cc192425a](frame);
            return frame;
        } else return oggPage;
    }
}
class $34db2c67086ea732$export$2e2bcd8739ae039 extends (0, $dd7c0f9e54b04fc4$export$2e2bcd8739ae039) {
    constructor(codecParser, headerCache, onCodec){
        super(codecParser, headerCache);
        this._onCodec = onCodec;
        this.Frame = (0, $54de051f73360197$export$2e2bcd8739ae039);
        this.Header = (0, $a86b95845073ac73$export$2e2bcd8739ae039);
        this._streams = new Map();
        this._currentSerialNumber = null;
    }
    get [(0, $860f0b5184108148$export$1c37c01eba8ed446)]() {
        const oggStream = this._streams.get(this._currentSerialNumber);
        return oggStream ? oggStream.codec : "";
    }
    *[(0, $860f0b5184108148$export$9616b51a1be2e082)]() {
        const oggPage = yield* this[0, $860f0b5184108148$export$6a29256c87cd443c](true);
        this._currentSerialNumber = oggPage[0, $860f0b5184108148$export$462f9602534f6121];
        let oggStream = this._streams.get(this._currentSerialNumber);
        if (!oggStream) {
            oggStream = new $34db2c67086ea732$var$OggStream(this._codecParser, this._headerCache, this._onCodec);
            this._streams.set(this._currentSerialNumber, oggStream);
        }
        if (oggPage[0, $860f0b5184108148$export$59545aa1378f3baa]) this._streams.delete(this._currentSerialNumber);
        return oggStream._parsePage(oggPage);
    }
}


const $9692457505e16c95$var$noOp = ()=>{};
class $9692457505e16c95$export$2e2bcd8739ae039 {
    constructor(mimeType1, { onCodec: onCodec, onCodecHeader: onCodecHeader, onCodecUpdate: onCodecUpdate, enableLogging: enableLogging = false, enableFrameCRC32: enableFrameCRC32 = true } = {}){
        this._inputMimeType = mimeType1;
        this._onCodec = onCodec || $9692457505e16c95$var$noOp;
        this._onCodecHeader = onCodecHeader || $9692457505e16c95$var$noOp;
        this._onCodecUpdate = onCodecUpdate;
        this._enableLogging = enableLogging;
        this._crc32 = enableFrameCRC32 ? (0, $dd0c961b75cd9139$export$208e3b04219ed02) : $9692457505e16c95$var$noOp;
        this[0, $860f0b5184108148$export$aad8462122ac592b]();
    }
    /**
   * @public
   * @returns The detected codec
   */ get [(0, $860f0b5184108148$export$1c37c01eba8ed446)]() {
        return this._parser ? this._parser[0, $860f0b5184108148$export$1c37c01eba8ed446] : "";
    }
    [(0, $860f0b5184108148$export$aad8462122ac592b)]() {
        this._headerCache = new (0, $0139e6c9e0318001$export$2e2bcd8739ae039)(this._onCodecHeader, this._onCodecUpdate);
        this._generator = this._getGenerator();
        this._generator.next();
    }
    /**
   * @public
   * @description Generator function that yields any buffered CodecFrames and resets the CodecParser
   * @returns {Iterable<CodecFrame|OggPage>} Iterator that operates over the codec data.
   * @yields {CodecFrame|OggPage} Parsed codec or ogg page data
   */ *flush() {
        this._flushing = true;
        for(let i = this._generator.next(); i.value; i = this._generator.next())yield i.value;
        this._flushing = false;
        this[0, $860f0b5184108148$export$aad8462122ac592b]();
    }
    /**
   * @public
   * @description Generator function takes in a Uint8Array of data and returns a CodecFrame from the data for each iteration
   * @param {Uint8Array} chunk Next chunk of codec data to read
   * @returns {Iterable<CodecFrame|OggPage>} Iterator that operates over the codec data.
   * @yields {CodecFrame|OggPage} Parsed codec or ogg page data
   */ *parseChunk(chunk) {
        for(let i = this._generator.next(chunk); i.value; i = this._generator.next())yield i.value;
    }
    /**
   * @public
   * @description Parses an entire file and returns all of the contained frames.
   * @param {Uint8Array} fileData Coded data to read
   * @returns {Array<CodecFrame|OggPage>} CodecFrames
   */ parseAll(fileData) {
        return [
            ...this.parseChunk(fileData),
            ...this.flush()
        ];
    }
    /**
   * @private
   */ *_getGenerator() {
        if (this._inputMimeType.match(/aac/)) this._parser = new (0, $ea4373f84c96dcef$export$2e2bcd8739ae039)(this, this._headerCache, this._onCodec);
        else if (this._inputMimeType.match(/mpeg/)) this._parser = new (0, $e60718df768668d6$export$2e2bcd8739ae039)(this, this._headerCache, this._onCodec);
        else if (this._inputMimeType.match(/flac/)) this._parser = new (0, $fc8c22388cf24d2d$export$2e2bcd8739ae039)(this, this._headerCache, this._onCodec);
        else if (this._inputMimeType.match(/ogg/)) this._parser = new (0, $34db2c67086ea732$export$2e2bcd8739ae039)(this, this._headerCache, this._onCodec);
        else throw new Error(`Unsupported Codec ${mimeType}`);
        this._frameNumber = 0;
        this._currentReadPosition = 0;
        this._totalBytesIn = 0;
        this._totalBytesOut = 0;
        this._totalSamples = 0;
        this._sampleRate = undefined;
        this._rawData = new Uint8Array(0);
        // start parsing out frames
        while(true){
            const frame = yield* this._parser[0, $860f0b5184108148$export$9616b51a1be2e082]();
            if (frame) yield frame;
        }
    }
    /**
   * @protected
   * @param {number} minSize Minimum bytes to have present in buffer
   * @returns {Uint8Array} rawData
   */ *[(0, $860f0b5184108148$export$3027c70a881d60dc)](minSize = 0, readOffset = 0) {
        let rawData;
        while(this._rawData[0, $860f0b5184108148$export$f24224f1c91d8156] <= minSize + readOffset){
            rawData = yield;
            if (this._flushing) return this._rawData[0, $860f0b5184108148$export$7ec32827e4221318](readOffset);
            if (rawData) {
                this._totalBytesIn += rawData[0, $860f0b5184108148$export$f24224f1c91d8156];
                this._rawData = (0, $dd0c961b75cd9139$export$28e250f55413be00)(this._rawData, rawData);
            }
        }
        return this._rawData[0, $860f0b5184108148$export$7ec32827e4221318](readOffset);
    }
    /**
   * @protected
   * @param {number} increment Bytes to increment codec data
   */ [(0, $860f0b5184108148$export$ccac409b8bd6669d)](increment) {
        this._currentReadPosition += increment;
        this._rawData = this._rawData[0, $860f0b5184108148$export$7ec32827e4221318](increment);
    }
    /**
   * @protected
   */ [(0, $860f0b5184108148$export$ebf36ec211205204)](frame) {
        this._sampleRate = frame[0, $860f0b5184108148$export$38e42c68cf43b5d4][0, $860f0b5184108148$export$851d973a43101ae1];
        frame[0, $860f0b5184108148$export$38e42c68cf43b5d4][0, $860f0b5184108148$export$fbead197e07be487] = frame[0, $860f0b5184108148$export$1f34108aa9eb96ab] > 0 ? Math.round(frame[0, $860f0b5184108148$export$4051a07651545597][0, $860f0b5184108148$export$f24224f1c91d8156] / frame[0, $860f0b5184108148$export$1f34108aa9eb96ab]) * 8 : 0;
        frame[0, $860f0b5184108148$export$5da2c6384bf58746] = this._frameNumber++;
        frame[0, $860f0b5184108148$export$acdbe6200d314ea0] = this._totalBytesOut;
        frame[0, $860f0b5184108148$export$27063c03e3b4546e] = this._totalSamples;
        frame[0, $860f0b5184108148$export$4ff6995501858325] = this._totalSamples / this._sampleRate * 1000;
        frame[0, $860f0b5184108148$export$1cd93882633e45f5] = this._crc32(frame[0, $860f0b5184108148$export$4051a07651545597]);
        this._headerCache[0, $860f0b5184108148$export$b025372f68843755](frame[0, $860f0b5184108148$export$38e42c68cf43b5d4][0, $860f0b5184108148$export$fbead197e07be487], frame[0, $860f0b5184108148$export$4ff6995501858325]);
        this._totalBytesOut += frame[0, $860f0b5184108148$export$4051a07651545597][0, $860f0b5184108148$export$f24224f1c91d8156];
        this._totalSamples += frame[0, $860f0b5184108148$export$5f20c3cdf3b5e8be];
    }
    /**
   * @protected
   */ [(0, $860f0b5184108148$export$24d5305cc192425a)](frame) {
        if (frame[0, $860f0b5184108148$export$a53f1e3778a12d7d]) {
            // Ogg container
            frame[0, $860f0b5184108148$export$a53f1e3778a12d7d].forEach((codecFrame)=>{
                frame[0, $860f0b5184108148$export$1f34108aa9eb96ab] += codecFrame[0, $860f0b5184108148$export$1f34108aa9eb96ab];
                frame[0, $860f0b5184108148$export$5f20c3cdf3b5e8be] += codecFrame[0, $860f0b5184108148$export$5f20c3cdf3b5e8be];
                this[0, $860f0b5184108148$export$ebf36ec211205204](codecFrame);
            });
            frame[0, $860f0b5184108148$export$27063c03e3b4546e] = this._totalSamples;
            frame[0, $860f0b5184108148$export$4ff6995501858325] = this._totalSamples / this._sampleRate * 1000 || 0;
            frame[0, $860f0b5184108148$export$acdbe6200d314ea0] = this._totalBytesOut;
        } else this[0, $860f0b5184108148$export$ebf36ec211205204](frame);
    }
    /**
   * @private
   */ _log(logger, messages) {
        if (this._enableLogging) {
            const stats = [
                `${(0, $860f0b5184108148$export$1c37c01eba8ed446)}:         ${this[0, $860f0b5184108148$export$1c37c01eba8ed446]}`,
                `inputMimeType: ${this._inputMimeType}`,
                `readPosition:  ${this._currentReadPosition}`,
                `totalBytesIn:  ${this._totalBytesIn}`,
                `${(0, $860f0b5184108148$export$acdbe6200d314ea0)}: ${this._totalBytesOut}`
            ];
            const width = Math.max(...stats.map((s)=>s[0, $860f0b5184108148$export$f24224f1c91d8156]));
            messages.push(`--stats--${"-".repeat(width - 9)}`, ...stats, "-".repeat(width));
            logger("codec-parser", messages.reduce((acc, message)=>acc + "\n  " + message, ""));
        }
    }
    /**
   * @protected
   */ [(0, $860f0b5184108148$export$ebd6064652549ce9)](...messages) {
        this._log(console.warn, messages);
    }
    /**
   * @protected
   */ [(0, $860f0b5184108148$export$58da9968c3170cb1)](...messages) {
        this._log(console.error, messages);
    }
}



var $9cd9b424bab85416$export$2e2bcd8739ae039 = (0, $9692457505e16c95$export$2e2bcd8739ae039);
const $9cd9b424bab85416$export$b9d4fc21491dc293 = $860f0b5184108148$export$b9d4fc21491dc293;
const $9cd9b424bab85416$export$2a97ae90773dd351 = $860f0b5184108148$export$2a97ae90773dd351;
const $9cd9b424bab85416$export$cee20cdac1cd19df = $860f0b5184108148$export$cee20cdac1cd19df;
const $9cd9b424bab85416$export$fbead197e07be487 = $860f0b5184108148$export$fbead197e07be487;
const $9cd9b424bab85416$export$d48d8e6e1487adc4 = $860f0b5184108148$export$d48d8e6e1487adc4;
const $9cd9b424bab85416$export$971636741d86955 = $860f0b5184108148$export$971636741d86955;
const $9cd9b424bab85416$export$d28b7ae062ff03c5 = $860f0b5184108148$export$d28b7ae062ff03c5;
const $9cd9b424bab85416$export$ab1029bcae9ddb4a = $860f0b5184108148$export$ab1029bcae9ddb4a;
const $9cd9b424bab85416$export$e2acf35f1e805875 = $860f0b5184108148$export$e2acf35f1e805875;
const $9cd9b424bab85416$export$1c37c01eba8ed446 = $860f0b5184108148$export$1c37c01eba8ed446;
const $9cd9b424bab85416$export$a53f1e3778a12d7d = $860f0b5184108148$export$a53f1e3778a12d7d;
const $9cd9b424bab85416$export$a592872ee1129cb4 = $860f0b5184108148$export$a592872ee1129cb4;
const $9cd9b424bab85416$export$4fafbcc8068ef7ca = $860f0b5184108148$export$4fafbcc8068ef7ca;
const $9cd9b424bab85416$export$bacf03850837cc9e = $860f0b5184108148$export$bacf03850837cc9e;
const $9cd9b424bab85416$export$1cd93882633e45f5 = $860f0b5184108148$export$1cd93882633e45f5;
const $9cd9b424bab85416$export$4051a07651545597 = $860f0b5184108148$export$4051a07651545597;
const $9cd9b424bab85416$export$6d59db4903f20f7d = $860f0b5184108148$export$6d59db4903f20f7d;
const $9cd9b424bab85416$export$1f34108aa9eb96ab = $860f0b5184108148$export$1f34108aa9eb96ab;
const $9cd9b424bab85416$export$bef81ba411953b51 = $860f0b5184108148$export$bef81ba411953b51;
const $9cd9b424bab85416$export$ae48fe32cc58ab6f = $860f0b5184108148$export$ae48fe32cc58ab6f;
const $9cd9b424bab85416$export$38e42c68cf43b5d4 = $860f0b5184108148$export$38e42c68cf43b5d4;
const $9cd9b424bab85416$export$b046ea5b29155775 = $860f0b5184108148$export$b046ea5b29155775;
const $9cd9b424bab85416$export$818e7b951c237e5d = $860f0b5184108148$export$818e7b951c237e5d;
const $9cd9b424bab85416$export$f7027d263cc898cc = $860f0b5184108148$export$f7027d263cc898cc;
const $9cd9b424bab85416$export$947c0ccec8fe9e2a = $860f0b5184108148$export$947c0ccec8fe9e2a;
const $9cd9b424bab85416$export$59545aa1378f3baa = $860f0b5184108148$export$59545aa1378f3baa;
const $9cd9b424bab85416$export$e512c40786d058ff = $860f0b5184108148$export$e512c40786d058ff;
const $9cd9b424bab85416$export$1d1349f4eb9a7003 = $860f0b5184108148$export$1d1349f4eb9a7003;
const $9cd9b424bab85416$export$ca9d7e8ef88bd07e = $860f0b5184108148$export$ca9d7e8ef88bd07e;
const $9cd9b424bab85416$export$50a222d9023da98b = $860f0b5184108148$export$50a222d9023da98b;
const $9cd9b424bab85416$export$f24224f1c91d8156 = $860f0b5184108148$export$f24224f1c91d8156;
const $9cd9b424bab85416$export$549ff81930776885 = $860f0b5184108148$export$549ff81930776885;
const $9cd9b424bab85416$export$f1eb63ab5aca5708 = $860f0b5184108148$export$f1eb63ab5aca5708;
const $9cd9b424bab85416$export$a08b701eae9f6dda = $860f0b5184108148$export$a08b701eae9f6dda;
const $9cd9b424bab85416$export$33a1ce7cb4e60d8d = $860f0b5184108148$export$33a1ce7cb4e60d8d;
const $9cd9b424bab85416$export$7a8a2426cba807b6 = $860f0b5184108148$export$7a8a2426cba807b6;
const $9cd9b424bab85416$export$ed96e046486b4b25 = $860f0b5184108148$export$ed96e046486b4b25;
const $9cd9b424bab85416$export$3dc3ed1cd86c68b4 = $860f0b5184108148$export$3dc3ed1cd86c68b4;
const $9cd9b424bab85416$export$4882ae973e0491e = $860f0b5184108148$export$4882ae973e0491e;
const $9cd9b424bab85416$export$b9b4c22e291dd3d9 = $860f0b5184108148$export$b9b4c22e291dd3d9;
const $9cd9b424bab85416$export$bfe96fedbe3c1b3b = $860f0b5184108148$export$bfe96fedbe3c1b3b;
const $9cd9b424bab85416$export$27e01f77e7f7ec20 = $860f0b5184108148$export$27e01f77e7f7ec20;
const $9cd9b424bab85416$export$7ec32827e4221318 = $860f0b5184108148$export$7ec32827e4221318;
const $9cd9b424bab85416$export$83d89fbfd8236492 = $860f0b5184108148$export$83d89fbfd8236492;
const $9cd9b424bab85416$export$3e1eea38d3db9f18 = $860f0b5184108148$export$3e1eea38d3db9f18;
const $9cd9b424bab85416$export$3a1c3ed71012e84e = $860f0b5184108148$export$3a1c3ed71012e84e;
const $9cd9b424bab85416$export$fe63a71268ec44ee = $860f0b5184108148$export$fe63a71268ec44ee;
const $9cd9b424bab85416$export$5af3e22a52b4ea9e = $860f0b5184108148$export$5af3e22a52b4ea9e;
const $9cd9b424bab85416$export$446963a0ea44fb9d = $860f0b5184108148$export$446963a0ea44fb9d;
const $9cd9b424bab85416$export$f3cbeb72a3601eb6 = $860f0b5184108148$export$f3cbeb72a3601eb6;
const $9cd9b424bab85416$export$6880a9e40f87ae65 = $860f0b5184108148$export$6880a9e40f87ae65;
const $9cd9b424bab85416$export$1dbaf4b0a82f5d28 = $860f0b5184108148$export$1dbaf4b0a82f5d28;
const $9cd9b424bab85416$export$e856ca83ff30dbad = $860f0b5184108148$export$e856ca83ff30dbad;
const $9cd9b424bab85416$export$589c9a7ae9a79c5e = $860f0b5184108148$export$589c9a7ae9a79c5e;
const $9cd9b424bab85416$export$9659c395d9de169e = $860f0b5184108148$export$9659c395d9de169e;
const $9cd9b424bab85416$export$7306104bb28d5804 = $860f0b5184108148$export$7306104bb28d5804;
const $9cd9b424bab85416$export$19129109fa742a6f = $860f0b5184108148$export$19129109fa742a6f;
const $9cd9b424bab85416$export$2cef06c20297c17d = $860f0b5184108148$export$2cef06c20297c17d;
const $9cd9b424bab85416$export$150180f5f882de62 = $860f0b5184108148$export$150180f5f882de62;
const $9cd9b424bab85416$export$326bb32b4ec6239b = $860f0b5184108148$export$326bb32b4ec6239b;
const $9cd9b424bab85416$export$5da2c6384bf58746 = $860f0b5184108148$export$5da2c6384bf58746;
const $9cd9b424bab85416$export$e4cdad84c725445 = $860f0b5184108148$export$e4cdad84c725445;
const $9cd9b424bab85416$export$7815706ac4afa67d = $860f0b5184108148$export$7815706ac4afa67d;
const $9cd9b424bab85416$export$cc7fd71f037082e3 = $860f0b5184108148$export$cc7fd71f037082e3;
const $9cd9b424bab85416$export$c16a704080c492f2 = $860f0b5184108148$export$c16a704080c492f2;
const $9cd9b424bab85416$export$e0e12ae5ee640391 = $860f0b5184108148$export$e0e12ae5ee640391;
const $9cd9b424bab85416$export$a60fa1703d7dd487 = $860f0b5184108148$export$a60fa1703d7dd487;
const $9cd9b424bab85416$export$dda3274d649921c8 = $860f0b5184108148$export$dda3274d649921c8;
const $9cd9b424bab85416$export$851d973a43101ae1 = $860f0b5184108148$export$851d973a43101ae1;
const $9cd9b424bab85416$export$5f20c3cdf3b5e8be = $860f0b5184108148$export$5f20c3cdf3b5e8be;
const $9cd9b424bab85416$export$ef26b3900cee0fa3 = $860f0b5184108148$export$ef26b3900cee0fa3;
const $9cd9b424bab85416$export$9010c500bffe71e6 = $860f0b5184108148$export$9010c500bffe71e6;
const $9cd9b424bab85416$export$462f9602534f6121 = $860f0b5184108148$export$462f9602534f6121;
const $9cd9b424bab85416$export$fd98de4d87954f15 = $860f0b5184108148$export$fd98de4d87954f15;
const $9cd9b424bab85416$export$acdbe6200d314ea0 = $860f0b5184108148$export$acdbe6200d314ea0;
const $9cd9b424bab85416$export$4ff6995501858325 = $860f0b5184108148$export$4ff6995501858325;
const $9cd9b424bab85416$export$27063c03e3b4546e = $860f0b5184108148$export$27063c03e3b4546e;


class $38f2fa52cad57bb7$export$2e2bcd8739ae039 {
    constructor(options = {}){
        this._sampleRate = options.sampleRate || 48000;
        this._forceStereo = options.forceStereo !== undefined ? options.forceStereo : false;
        this._onCodec = (codec)=>{
            if (codec !== "opus") throw new Error("ogg-opus-decoder does not support this codec " + codec);
        };
        // instantiate to create static properties
        new (0, $6cc8fed272338330$export$2e2bcd8739ae039)();
        this._decoderClass = (0, $27034431d4d4accd$export$2e2bcd8739ae039);
        this._init();
    }
    _init() {
        if (this._decoder) this._decoder.free();
        this._decoder = null;
        this._ready = Promise.resolve();
        this._codecParser = new (0, $9cd9b424bab85416$export$2e2bcd8739ae039)("application/ogg", {
            onCodec: this._onCodec,
            enableFrameCRC32: false
        });
    }
    async _instantiateDecoder(header) {
        this._totalSamplesDecoded = 0;
        this._preSkip = header[0, $9cd9b424bab85416$export$3dc3ed1cd86c68b4];
        this._channels = this._forceStereo ? 2 : header[0, $9cd9b424bab85416$export$9659c395d9de169e];
        this._beginningSampleOffset = null;
        this._decoder = new this._decoderClass({
            channels: header[0, $9cd9b424bab85416$export$9659c395d9de169e],
            streamCount: header[0, $9cd9b424bab85416$export$ef26b3900cee0fa3],
            coupledStreamCount: header[0, $9cd9b424bab85416$export$a592872ee1129cb4],
            channelMappingTable: header[0, $9cd9b424bab85416$export$e856ca83ff30dbad],
            preSkip: Math.round(this._preSkip / 48000 * this._sampleRate),
            sampleRate: this._sampleRate,
            forceStereo: this._forceStereo
        });
        await this._decoder.ready;
    }
    get ready() {
        return this._ready;
    }
    async reset() {
        this._init();
    }
    free() {
        this._init();
    }
    async _decode(oggPages) {
        let allErrors = [], allChannelData = [], samplesThisDecode = 0;
        for await (const oggPage of oggPages){
            // only decode Ogg pages that have codec frames
            const frames = oggPage[0, $9cd9b424bab85416$export$a53f1e3778a12d7d].map((f)=>f[0, $9cd9b424bab85416$export$4051a07651545597]);
            if (frames.length) {
                // wait until there is an Opus header before instantiating
                if (!this._decoder) await this._instantiateDecoder(oggPage[0, $9cd9b424bab85416$export$a53f1e3778a12d7d][0][0, $9cd9b424bab85416$export$38e42c68cf43b5d4]);
                const { channelData: channelData, samplesDecoded: samplesDecoded, errors: errors } = await this._decoder.decodeFrames(frames);
                this._totalSamplesDecoded += samplesDecoded;
                // record beginning sample offset for absoluteGranulePosition logic
                if (this._beginningSampleOffset === null && Number(oggPage[0, $9cd9b424bab85416$export$b9d4fc21491dc293]) > -1) this._beginningSampleOffset = oggPage[0, $9cd9b424bab85416$export$b9d4fc21491dc293] - BigInt(oggPage[0, $9cd9b424bab85416$export$5f20c3cdf3b5e8be]) + BigInt(this._preSkip);
                if (oggPage[0, $9cd9b424bab85416$export$59545aa1378f3baa]) {
                    // in cases where BigInt isn't supported, don't do any absoluteGranulePosition logic (i.e. old iOS versions)
                    if (oggPage[0, $9cd9b424bab85416$export$b9d4fc21491dc293] !== undefined) {
                        const totalDecodedSamples_48000 = this._totalSamplesDecoded / this._sampleRate * 48000;
                        const totalOggSamples_48000 = Number(oggPage[0, $9cd9b424bab85416$export$b9d4fc21491dc293] - this._beginningSampleOffset);
                        // trim any extra samples that are decoded beyond the absoluteGranulePosition, relative to where we started in the stream
                        const samplesToTrim = Math.round((totalDecodedSamples_48000 - totalOggSamples_48000) / 48000 * this._sampleRate);
                        for(let i = 0; i < channelData.length; i++)channelData[i] = channelData[i].subarray(0, samplesDecoded - samplesToTrim);
                        samplesThisDecode -= samplesToTrim;
                    }
                    // reached the end of an ogg stream, reset the decoder
                    this._init();
                }
                allErrors.push(...errors);
                allChannelData.push(channelData);
                samplesThisDecode += samplesDecoded;
            }
        }
        return [
            allErrors,
            allChannelData,
            this._channels,
            samplesThisDecode,
            this._sampleRate,
            16
        ];
    }
    _parse(oggOpusData) {
        return [
            ...this._codecParser.parseChunk(oggOpusData)
        ];
    }
    _flush() {
        return [
            ...this._codecParser.flush()
        ];
    }
    async decode(oggOpusData) {
        const decoded = await this._decode(this._parse(oggOpusData));
        return (0, $6cc8fed272338330$export$2e2bcd8739ae039).getDecodedAudioMultiChannel(...decoded);
    }
    async decodeFile(oggOpusData) {
        const decoded = await this._decode([
            ...this._parse(oggOpusData),
            ...this._flush()
        ]);
        this._init();
        return (0, $6cc8fed272338330$export$2e2bcd8739ae039).getDecodedAudioMultiChannel(...decoded);
    }
    async flush() {
        const decoded = await this._decode(this._flush());
        this._init();
        return (0, $6cc8fed272338330$export$2e2bcd8739ae039).getDecodedAudioMultiChannel(...decoded);
    }
}




class $8fd7f9fe32fa5ac0$export$2e2bcd8739ae039 extends (0, $38f2fa52cad57bb7$export$2e2bcd8739ae039) {
    constructor(options){
        super(options);
        this._decoderClass = (0, $10073398c294630e$export$2e2bcd8739ae039);
    }
    async free() {
        super.free();
    }
}



(0, $914bc161c46b40a3$export$6915126ba85aae77)((0, $38f2fa52cad57bb7$export$2e2bcd8739ae039), "OggOpusDecoder");
(0, $914bc161c46b40a3$export$6915126ba85aae77)((0, $8fd7f9fe32fa5ac0$export$2e2bcd8739ae039), "OggOpusDecoderWebWorker");


var $00583c9794cbe277$require$OggOpusDecoder = $8fd7f9fe32fa5ac0$export$2e2bcd8739ae039;

var $00583c9794cbe277$require$OpusDecoder = $10073398c294630e$export$2e2bcd8739ae039;
const $00583c9794cbe277$var$codecMap = {
    opus: $00583c9794cbe277$require$OpusDecoder,
    "ogg/opus": $00583c9794cbe277$require$OggOpusDecoder
};
$00583c9794cbe277$exports = (codec)=>{
    if ($00583c9794cbe277$var$codecMap[codec] === undefined) return;
    const decoder = new $00583c9794cbe277$var$codecMap[codec]({
        sampleRate: 24000,
        forceStereo: false
    });
    console.log(decoder);
    const audioCtx = window.audioCtx;
    const player = {
        samples: new Float32Array(0),
        _playing: false,
        _latency: 200,
        _playRealtime: ()=>{
            if (player._playing) return;
            player._playing = true;
            const bufferSize = 256;
            const scriptNode = audioCtx.createScriptProcessor(bufferSize, 0, 1);
            scriptNode.addEventListener("audioprocess", (audioProcessingEvent)=>{
                if (player._playing === false) return;
                const outputBuffer = audioProcessingEvent.outputBuffer;
                const outputData = outputBuffer.getChannelData(0);
                if (player.samples.length === 0) {
                    scriptNode.disconnect(audioCtx.destination);
                    player._playing = false;
                }
                let copied = 0;
                player.samples.slice(0, 256).forEach((val, key)=>{
                    copied++;
                    outputData[key] = val;
                });
                player.samples = player.samples.slice(256);
            });
            scriptNode.connect(audioCtx.destination);
        },
        _playBuffer: (buffer)=>{
            const myArrayBuffer = audioCtx.createBuffer(1, buffer.length, 24000);
            const chan = myArrayBuffer.getChannelData(0);
            buffer.forEach((sample, key)=>{
                chan[key] = sample;
            });
            const source = audioCtx.createBufferSource();
            source.buffer = myArrayBuffer;
            source.connect(audioCtx.destination);
            source.start();
        },
        _concat: (buffer1, buffer2)=>{
            const tmp = new Float32Array(buffer1.length + buffer2.length);
            tmp.set(new Float32Array(buffer1), 0);
            tmp.set(new Float32Array(buffer2), buffer1.length);
            return tmp;
        },
        _decode: (buffer)=>{
            if (codec === "opus") return decoder.decodeFrame(new Uint8Array(buffer));
            else if (codec === "ogg/opus") return decoder.decode(new Uint8Array(buffer));
            else throw new Error("Unknown codec " + codec);
        },
        decode: (data)=>{
            decoder.ready.then(()=>{
                if (!player._playing) setTimeout(()=>{
                    player._playRealtime();
                }, 4 * player._latency);
                player._decode(data).then((data)=>{
                    console.log(data);
                    if (data.channelData[0] === undefined) return;
                    player.samples = player._concat(player.samples, data.channelData[0]);
                    if (!player._playing) setTimeout(()=>{
                        player._playRealtime();
                    }, 4 * player._latency);
                });
            });
        },
        setLatency: (latency)=>player._latency = latency,
        reset: ()=>{
            return decoder.reset();
        }
    };
    return player;
};



$815844dde2cfbfb2$exports.log("Welcome to nemit, press connect to start. ");
const $8e74d3b1bc8de79d$var$ping = (protocol)=>{
    const start = Date.now();
    return protocol.call("echo", "echo").then(()=>{
        const stop = Date.now();
        return stop - start;
    });
};
const $8e74d3b1bc8de79d$var$estimateLatency = (protocol)=>{
    const pings = Array(10).fill().reduce((prev)=>{
        if (prev.length === 0) {
            prev.push($8e74d3b1bc8de79d$var$ping(protocol));
            return prev;
        }
        prev.push(prev.slice(-1)[0].then(()=>$8e74d3b1bc8de79d$var$ping(protocol)));
        return prev;
    }, []);
    return Promise.all(pings).then((pings)=>{
        return pings.reduce((prev, cur)=>prev + cur * (1 / pings.length), 0);
    });
};
const $8e74d3b1bc8de79d$var$openSocket = ()=>{
    return new Promise((resolve, reject)=>{
        const protocol = "ws" + window.location.protocol.slice(4, -1);
        let url = `${protocol}://${window.location.host}/nemit`;
        if (window.location.hostname === "localhost") url = "wss://nemit.pro/nemit";
        const webSocket = new WebSocket(url);
        webSocket.binaryType = "arraybuffer";
        webSocket.addEventListener("open", ()=>{
            resolve(webSocket);
        });
    // Handle error opening
    });
};
const $8e74d3b1bc8de79d$var$openNemit = ()=>{
    return $8e74d3b1bc8de79d$var$openSocket().then((socket)=>{
        const playerInstances = {
            "ogg/opus": $00583c9794cbe277$exports("ogg/opus"),
            "opus": $00583c9794cbe277$exports("opus")
        };
        let lastBroadcastID = undefined;
        const protocol = $fd28d333ad7e5007$exports({
            broadcast: (data)=>{
                if (lastBroadcastID && lastBroadcastID != data.id) playerInstances[data.codec].reset();
                playerInstances[data.codec].decode(data.samples);
                lastBroadcastID = data.id;
            },
            getLock: ()=>{
                $8e74d3b1bc8de79d$var$button.classList.add("ptt-disabled");
            },
            releaseLock: ()=>{
                $8e74d3b1bc8de79d$var$button.classList.remove("ptt-disabled");
            }
        }, (...args)=>socket.send(...args));
        $815844dde2cfbfb2$exports.log("Estimating latency");
        $8e74d3b1bc8de79d$var$estimateLatency(protocol).then((realLatency)=>{
            const latency = Math.round(realLatency);
            Object.values(playerInstances).forEach((el)=>el.setLatency(latency));
            $815844dde2cfbfb2$exports.log(`Latency is around ${latency}ms. `);
        });
        socket.onmessage = (message)=>protocol.readMethod(message.data);
        return protocol;
    });
};
const $8e74d3b1bc8de79d$var$button = document.querySelector("#ptt");
const $8e74d3b1bc8de79d$var$connect = ()=>{
    $8e74d3b1bc8de79d$var$button.removeEventListener("click", $8e74d3b1bc8de79d$var$connect);
    $8e74d3b1bc8de79d$var$button.innerText = "PTT";
    const ctxOption = {
        sampleRate: 24000
    };
    window.audioCtx = new (window.AudioContext || window.webkitAudioContext)(ctxOption);
    $815844dde2cfbfb2$exports.log(`Sample rate will be: ${window.audioCtx.sampleRate}`);
    $8e74d3b1bc8de79d$var$openNemit().then((protocol)=>{
        let pttPressed = false;
        let recorderInstance = false;
        protocol.call("echo", "connected").then((response)=>{
            console.log(response);
            $8e74d3b1bc8de79d$var$button.classList.remove("ptt-disabled");
        });
        $8e74d3b1bc8de79d$var$button.addEventListener("click", ()=>{
            if (!pttPressed) protocol.call("getLock").then((lock)=>{
                console.log(lock);
                if (!lock) {
                    $815844dde2cfbfb2$exports.error("Someone already talking");
                    return;
                }
                pttPressed = !pttPressed;
                $815844dde2cfbfb2$exports.log("You are transmitting");
                recorderInstance = $c53890eb3e021adc$exports();
                const start = Date.now();
                let last = start;
                recorderInstance.on("samples", (samples)=>{
                    samples.arrayBuffer().then((buffer)=>{
                        console.log(Date.now() - start, Date.now() - last, buffer.byteLength);
                        last = Date.now();
                        if (buffer.byteLength === 0) return;
                        protocol.call("broadcast", {
                            codec: "ogg/opus",
                            samples: buffer,
                            id: lock
                        });
                    });
                });
                recorderInstance.record().then(()=>{
                    $8e74d3b1bc8de79d$var$button.classList.add("ptt-pressed");
                    $8e74d3b1bc8de79d$var$button.innerText = "SAMO CQ";
                });
            });
            else {
                $815844dde2cfbfb2$exports.log("You are not transmitting");
                recorderInstance.stop();
                protocol.call("releaseLock");
                $8e74d3b1bc8de79d$var$button.classList.remove("ptt-pressed");
                $8e74d3b1bc8de79d$var$button.innerText = "PTT";
                pttPressed = !pttPressed;
            }
        });
    });
};
$8e74d3b1bc8de79d$var$button.addEventListener("click", $8e74d3b1bc8de79d$var$connect);


//# sourceMappingURL=index.baa2eadf.js.map
